import { Vector3, Color3, Vector2, Color4 } from '@babylonjs/core/Maths/math';
import { VertexBuffer, VertexData, Mesh as Mesh$1, MeshBuilder } from '@babylonjs/core/Meshes';
import { Tools } from '@babylonjs/core/Misc/tools';
import { AbstractScene } from '@babylonjs/core/abstractScene';
import { Node as Node$1 } from '@babylonjs/core/node';
import { Scene as Scene$2 } from '@babylonjs/core/scene';
import { Camera as Camera$1 } from '@babylonjs/core/Cameras/camera';
import { EnvironmentHelper as EnvironmentHelper$1 } from '@babylonjs/core/Helpers/environmentHelper';
import { EffectLayer as EffectLayer$1 } from '@babylonjs/core/Layers/effectLayer';
import { Light as Light$1 } from '@babylonjs/core/Lights/light';
import { Material as Material$1 } from '@babylonjs/core/Materials/material';
import { Mesh as Mesh$2 } from '@babylonjs/core/Meshes/mesh';
import { MeshBuilder as MeshBuilder$1 } from '@babylonjs/core/Meshes/meshBuilder';
import { PhysicsImpostor as PhysicsImpostor$1 } from '@babylonjs/core/Physics/physicsImpostor';
import { AdvancedDynamicTexture as AdvancedDynamicTexture$1 } from '@babylonjs/gui/2D/advancedDynamicTexture';
import { GUI3DManager as GUI3DManager$1 } from '@babylonjs/gui/3D/gui3DManager';
import { AutoRotationBehavior as AutoRotationBehavior$1 } from '@babylonjs/core/Behaviors/Cameras/autoRotationBehavior';
import { BouncingBehavior as BouncingBehavior$1 } from '@babylonjs/core/Behaviors/Cameras/bouncingBehavior';
import { FramingBehavior as FramingBehavior$1 } from '@babylonjs/core/Behaviors/Cameras/framingBehavior';
import { AttachToBoxBehavior as AttachToBoxBehavior$1 } from '@babylonjs/core/Behaviors/Meshes/attachToBoxBehavior';
import { FadeInOutBehavior as FadeInOutBehavior$1 } from '@babylonjs/core/Behaviors/Meshes/fadeInOutBehavior';
import { MultiPointerScaleBehavior as MultiPointerScaleBehavior$1 } from '@babylonjs/core/Behaviors/Meshes/multiPointerScaleBehavior';
import { PointerDragBehavior as PointerDragBehavior$1 } from '@babylonjs/core/Behaviors/Meshes/pointerDragBehavior';
import { SixDofDragBehavior as SixDofDragBehavior$1 } from '@babylonjs/core/Behaviors/Meshes/sixDofDragBehavior';
import { VRExperienceHelper as VRExperienceHelper$1 } from '@babylonjs/core/Cameras/VR/vrExperienceHelper';
import { ShadowGenerator as ShadowGenerator$1 } from '@babylonjs/core/Lights/Shadows/shadowGenerator';
import { BaseTexture as BaseTexture$1 } from '@babylonjs/core/Materials/Textures/baseTexture';
import { Control as Control$1 } from '@babylonjs/gui/2D/controls/control';
import { TextBlock as TextBlock$1 } from '@babylonjs/gui/2D/controls/textBlock';
import { Control3D as Control3D$1 } from '@babylonjs/gui/3D/controls/control3D';
import { TransformNode as TransformNode$1 } from '@babylonjs/core/Meshes/transformNode';
import { AbstractMesh as AbstractMesh$1 } from '@babylonjs/core/Meshes/abstractMesh';
import { RenderTargetTexture as RenderTargetTexture$1 } from '@babylonjs/core/Materials/Textures/renderTargetTexture';
import { TargetCamera as TargetCamera$1 } from '@babylonjs/core/Cameras/targetCamera';
import { FreeCamera as FreeCamera$1 } from '@babylonjs/core/Cameras/freeCamera';
import { TouchCamera as TouchCamera$1 } from '@babylonjs/core/Cameras/touchCamera';
import { UniversalCamera as UniversalCamera$1 } from '@babylonjs/core/Cameras/universalCamera';
import { GamepadCamera as GamepadCamera$1 } from '@babylonjs/core/Cameras/gamepadCamera';
import { AnaglyphGamepadCamera as AnaglyphGamepadCamera$1 } from '@babylonjs/core/Cameras/Stereoscopic/anaglyphGamepadCamera';
import { StereoscopicGamepadCamera as StereoscopicGamepadCamera$1 } from '@babylonjs/core/Cameras/Stereoscopic/stereoscopicGamepadCamera';
import { AnaglyphUniversalCamera as AnaglyphUniversalCamera$1 } from '@babylonjs/core/Cameras/Stereoscopic/anaglyphUniversalCamera';
import { StereoscopicUniversalCamera as StereoscopicUniversalCamera$1 } from '@babylonjs/core/Cameras/Stereoscopic/stereoscopicUniversalCamera';
import { DeviceOrientationCamera as DeviceOrientationCamera$1 } from '@babylonjs/core/Cameras/deviceOrientationCamera';
import { VRDeviceOrientationFreeCamera as VRDeviceOrientationFreeCamera$1 } from '@babylonjs/core/Cameras/VR/vrDeviceOrientationFreeCamera';
import { VRDeviceOrientationGamepadCamera as VRDeviceOrientationGamepadCamera$1 } from '@babylonjs/core/Cameras/VR/vrDeviceOrientationGamepadCamera';
import { AnaglyphFreeCamera as AnaglyphFreeCamera$1 } from '@babylonjs/core/Cameras/Stereoscopic/anaglyphFreeCamera';
import { StereoscopicFreeCamera as StereoscopicFreeCamera$1 } from '@babylonjs/core/Cameras/Stereoscopic/stereoscopicFreeCamera';
import { VirtualJoysticksCamera as VirtualJoysticksCamera$1 } from '@babylonjs/core/Cameras/virtualJoysticksCamera';
import { WebVRFreeCamera as WebVRFreeCamera$1 } from '@babylonjs/core/Cameras/VR/webVRCamera';
import { WebXRCamera as WebXRCamera$1 } from '@babylonjs/core/XR/webXRCamera';
import { ArcRotateCamera as ArcRotateCamera$1 } from '@babylonjs/core/Cameras/arcRotateCamera';
import { AnaglyphArcRotateCamera as AnaglyphArcRotateCamera$1 } from '@babylonjs/core/Cameras/Stereoscopic/anaglyphArcRotateCamera';
import { StereoscopicArcRotateCamera as StereoscopicArcRotateCamera$1 } from '@babylonjs/core/Cameras/Stereoscopic/stereoscopicArcRotateCamera';
import { VRDeviceOrientationArcRotateCamera as VRDeviceOrientationArcRotateCamera$1 } from '@babylonjs/core/Cameras/VR/vrDeviceOrientationArcRotateCamera';
import { FlyCamera as FlyCamera$1 } from '@babylonjs/core/Cameras/flyCamera';
import { FollowCamera as FollowCamera$1, ArcFollowCamera as ArcFollowCamera$1 } from '@babylonjs/core/Cameras/followCamera';
import { ShaderMaterial as ShaderMaterial$1 } from '@babylonjs/core/Materials/shaderMaterial';
import { Texture as Texture$1 } from '@babylonjs/core/Materials/Textures/texture';
import { MultiMaterial as MultiMaterial$1 } from '@babylonjs/core/Materials/multiMaterial';
import { PushMaterial as PushMaterial$1 } from '@babylonjs/core/Materials/pushMaterial';
import { StandardMaterial as StandardMaterial$1 } from '@babylonjs/core/Materials/standardMaterial';
import { BackgroundMaterial as BackgroundMaterial$1 } from '@babylonjs/core/Materials/Background/backgroundMaterial';
import { ShadowLight as ShadowLight$1 } from '@babylonjs/core/Lights/shadowLight';
import { PBRBaseMaterial as PBRBaseMaterial$1 } from '@babylonjs/core/Materials/PBR/pbrBaseMaterial';
import { PBRBaseSimpleMaterial as PBRBaseSimpleMaterial$1 } from '@babylonjs/core/Materials/PBR/pbrBaseSimpleMaterial';
import { PBRMetallicRoughnessMaterial as PBRMetallicRoughnessMaterial$1 } from '@babylonjs/core/Materials/PBR/pbrMetallicRoughnessMaterial';
import { PBRSpecularGlossinessMaterial as PBRSpecularGlossinessMaterial$1 } from '@babylonjs/core/Materials/PBR/pbrSpecularGlossinessMaterial';
import { PBRMaterial as PBRMaterial$1 } from '@babylonjs/core/Materials/PBR/pbrMaterial';
import { NodeMaterial as NodeMaterial$1 } from '@babylonjs/core/Materials/Node/nodeMaterial';
import { FluentMaterial as FluentMaterial$1 } from '@babylonjs/gui/3D/materials/fluentMaterial';
import { DirectionalLight as DirectionalLight$1 } from '@babylonjs/core/Lights/directionalLight';
import { PointLight as PointLight$1 } from '@babylonjs/core/Lights/pointLight';
import { SpotLight as SpotLight$1 } from '@babylonjs/core/Lights/spotLight';
import { HemisphericLight as HemisphericLight$1 } from '@babylonjs/core/Lights/hemisphericLight';
import { Container as Container$1 } from '@babylonjs/gui/2D/controls/container';
import { Rectangle as Rectangle$1 } from '@babylonjs/gui/2D/controls/rectangle';
import { Button as Button$1 } from '@babylonjs/gui/2D/controls/button';
import { SelectionPanel as SelectionPanel$1 } from '@babylonjs/gui/2D/controls/selector';
import { ScrollViewer as ScrollViewer$1 } from '@babylonjs/gui/2D/controls/scrollViewers/scrollViewer';
import { Image as Image$1 } from '@babylonjs/gui/2D/controls/image';
import { StackPanel as StackPanel$1 } from '@babylonjs/gui/2D/controls/stackPanel';
import { VirtualKeyboard as VirtualKeyboard$1 } from '@babylonjs/gui/2D/controls/virtualKeyboard';
import { Ellipse as Ellipse$1 } from '@babylonjs/gui/2D/controls/ellipse';
import { Grid as Grid$1 } from '@babylonjs/gui/2D/controls/grid';
import { _ScrollViewerWindow as _ScrollViewerWindow$1 } from '@babylonjs/gui/2D/controls/scrollViewers/scrollViewerWindow';
import { Checkbox as Checkbox$1 } from '@babylonjs/gui/2D/controls/checkbox';
import { ColorPicker as ColorPicker$1 } from '@babylonjs/gui/2D/controls/colorpicker';
import { InputText as InputText$1 } from '@babylonjs/gui/2D/controls/inputText';
import { InputPassword as InputPassword$1 } from '@babylonjs/gui/2D/controls/inputPassword';
import { Line as Line$1 } from '@babylonjs/gui/2D/controls/line';
import { MultiLine as MultiLine$1 } from '@babylonjs/gui/2D/controls/multiLine';
import { RadioButton as RadioButton$1 } from '@babylonjs/gui/2D/controls/radioButton';
import { BaseSlider as BaseSlider$1 } from '@babylonjs/gui/2D/controls/sliders/baseSlider';
import { ScrollBar as ScrollBar$1 } from '@babylonjs/gui/2D/controls/sliders/scrollBar';
import { ImageScrollBar as ImageScrollBar$1 } from '@babylonjs/gui/2D/controls/sliders/imageScrollBar';
import { Slider as Slider$1 } from '@babylonjs/gui/2D/controls/sliders/slider';
import { ImageBasedSlider as ImageBasedSlider$1 } from '@babylonjs/gui/2D/controls/sliders/imageBasedSlider';
import { DisplayGrid as DisplayGrid$1 } from '@babylonjs/gui/2D/controls/displayGrid';
import { Container3D as Container3D$1 } from '@babylonjs/gui/3D/controls/container3D';
import { VolumeBasedPanel as VolumeBasedPanel$1 } from '@babylonjs/gui/3D/controls/volumeBasedPanel';
import { CylinderPanel as CylinderPanel$1 } from '@babylonjs/gui/3D/controls/cylinderPanel';
import { PlanePanel as PlanePanel$1 } from '@babylonjs/gui/3D/controls/planePanel';
import { ScatterPanel as ScatterPanel$1 } from '@babylonjs/gui/3D/controls/scatterPanel';
import { SpherePanel as SpherePanel$1 } from '@babylonjs/gui/3D/controls/spherePanel';
import { StackPanel3D as StackPanel3D$1 } from '@babylonjs/gui/3D/controls/stackPanel3D';
import { AbstractButton3D as AbstractButton3D$1 } from '@babylonjs/gui/3D/controls/abstractButton3D';
import { Button3D as Button3D$1 } from '@babylonjs/gui/3D/controls/button3D';
import { HolographicButton as HolographicButton$1 } from '@babylonjs/gui/3D/controls/holographicButton';
import { MeshButton3D as MeshButton3D$1 } from '@babylonjs/gui/3D/controls/meshButton3D';
import { GlowLayer as GlowLayer$1 } from '@babylonjs/core/Layers/glowLayer';
import { HighlightLayer as HighlightLayer$1 } from '@babylonjs/core/Layers/highlightLayer';
import { CubeTexture as CubeTexture$1 } from '@babylonjs/core/Materials/Textures/cubeTexture';
import { RawCubeTexture as RawCubeTexture$1 } from '@babylonjs/core/Materials/Textures/rawCubeTexture';
import { RawTexture as RawTexture$1 } from '@babylonjs/core/Materials/Textures/rawTexture';
import { ProceduralTexture as ProceduralTexture$1 } from '@babylonjs/core/Materials/Textures/Procedurals/proceduralTexture';
import { CustomProceduralTexture as CustomProceduralTexture$1 } from '@babylonjs/core/Materials/Textures/Procedurals/customProceduralTexture';
import { NoiseProceduralTexture as NoiseProceduralTexture$1 } from '@babylonjs/core/Materials/Textures/Procedurals/noiseProceduralTexture';
import { MirrorTexture as MirrorTexture$1 } from '@babylonjs/core/Materials/Textures/mirrorTexture';
import { MultiRenderTarget as MultiRenderTarget$1 } from '@babylonjs/core/Materials/Textures/multiRenderTarget';
import { RefractionTexture as RefractionTexture$1 } from '@babylonjs/core/Materials/Textures/refractionTexture';
import { MultiviewRenderTarget as MultiviewRenderTarget$1 } from '@babylonjs/core/Materials/Textures/MultiviewRenderTarget';
import { VideoTexture as VideoTexture$1 } from '@babylonjs/core/Materials/Textures/videoTexture';
import { DynamicTexture as DynamicTexture$1 } from '@babylonjs/core/Materials/Textures/dynamicTexture';
import { RawTexture3D as RawTexture3D$1 } from '@babylonjs/core/Materials/Textures/rawTexture3D';
import { RawTexture2DArray as RawTexture2DArray$1 } from '@babylonjs/core/Materials/Textures/rawTexture2DArray';
import { ColorGradingTexture as ColorGradingTexture$1 } from '@babylonjs/core/Materials/Textures/colorGradingTexture';
import { EquiRectangularCubeTexture as EquiRectangularCubeTexture$1 } from '@babylonjs/core/Materials/Textures/equiRectangularCubeTexture';
import { HDRCubeTexture as HDRCubeTexture$1 } from '@babylonjs/core/Materials/Textures/hdrCubeTexture';
import { HtmlElementTexture as HtmlElementTexture$1 } from '@babylonjs/core/Materials/Textures/htmlElementTexture';
import React, { createContext, useContext, useState, useRef, useEffect } from 'react';
import ReactReconciler from 'react-reconciler';
import { Engine as Engine$1, StandardMaterial as StandardMaterial$2, Color3 as Color3$1, BoundingInfo, Vector3 as Vector3$1, SceneLoader, AbstractMesh as AbstractMesh$2, PhysicsImpostor as PhysicsImpostor$2, ShadowGenerator as ShadowGenerator$2, Scene as Scene$3, PointerEventTypes } from '@babylonjs/core';
import '@babylonjs/loaders';
import { Texture as Texture$2 } from '@babylonjs/core/Materials/Textures';
var PropChangeType;

(function (PropChangeType) {
  PropChangeType["Primitive"] = "Primitive";
  PropChangeType["Vector3"] = "Vector3";
  PropChangeType["Color3"] = "Color3";
  PropChangeType["Color4"] = "Color4";
  PropChangeType["Control"] = "Control";
  PropChangeType["NumericArray"] = "NumericArray";
  PropChangeType["Observable"] = "Observable";
  PropChangeType["Method"] = "Method";
  PropChangeType["LambdaExpression"] = "LambdaExpression";
  PropChangeType["FresnelParameters"] = "FresnelParameters";
  PropChangeType["Texture"] = "Texture";
})(PropChangeType || (PropChangeType = {}));

var checkVector3Diff = function checkVector3Diff(oldProp, newProp, propertyName, propertyType, changedProps) {
  if (newProp && (!oldProp || !oldProp.equals(newProp))) {
    changedProps.push({
      propertyName: propertyName,
      type: propertyType,
      changeType: PropChangeType.Vector3,
      value: newProp
    });
  }
};

var checkColor3Diff = function checkColor3Diff(oldProp, newProp, propertyName, propertyType, changedProps) {
  if (newProp && (!oldProp || !oldProp.equals(newProp))) {
    changedProps.push({
      propertyName: propertyName,
      type: propertyType,
      changeType: PropChangeType.Color3,
      value: newProp
    });
  }
};

var checkColor4Diff = function checkColor4Diff(oldProp, newProp, propertyName, propertyType, changedProps) {
  // Color4.equals() not added until PR #5517
  if (newProp && (!oldProp || oldProp.r !== newProp.r || oldProp.g !== newProp.g || oldProp.b !== newProp.b || oldProp.a !== newProp.a)) {
    changedProps.push({
      propertyName: propertyName,
      type: propertyType,
      changeType: PropChangeType.Color4,
      value: newProp
    });
  }
};

var checkFresnelParametersDiff = function checkFresnelParametersDiff(oldProp, newProp, propertyName, propertyType, changedProps) {
  // FresnelParameters.equals() not added until PR #7818 (https://github.com/BabylonJS/Babylon.js/pull/7818)
  if (newProp
  /* won't clear the property value */
  && (!oldProp || oldProp.bias !== newProp.bias || oldProp.power !== newProp.power || !oldProp.leftColor || !oldProp.leftColor.equals(newProp.leftColor) || !oldProp.rightColor || !oldProp.rightColor.equals(newProp.rightColor) || oldProp.isEnabled !== newProp.isEnabled)) {
    changedProps.push({
      propertyName: propertyName,
      type: propertyType,
      changeType: PropChangeType.FresnelParameters,
      value: newProp
    });
  }
};

var checkLambdaDiff = function checkLambdaDiff(oldProp, newProp, propertyName, propertyType, changedProps) {
  if (newProp !== oldProp) {
    changedProps.push({
      propertyName: propertyName,
      type: propertyType,
      changeType: PropChangeType.LambdaExpression,
      value: newProp
    });
  }
};

var checkControlDiff = function checkControlDiff(oldProp, newProp, propertyName, propertyType, changedProps) {
  // only sets once
  if (newProp && !oldProp) {
    changedProps.push({
      propertyName: propertyName,
      type: propertyType,
      changeType: PropChangeType.Control,
      value: newProp
    });
  }
};

var checkPrimitiveDiff = function checkPrimitiveDiff(oldProp, newProp, propertyName, propertyType, changedProps) {
  if (newProp !== oldProp) {
    changedProps.push({
      propertyName: propertyName,
      type: propertyType,
      changeType: PropChangeType.Primitive,
      value: newProp
    });
  }
};

var checkTextureDiff = function checkTextureDiff(oldProp, newProp, propertyName, propertyType, changedProps) {
  if (newProp !== oldProp) {
    console.log('pushing texture:', propertyName, propertyType);
    changedProps.push({
      propertyName: propertyName,
      type: propertyType,
      changeType: PropChangeType.Texture,
      value: newProp
    });
  }
};

var checkNumericArrayDiff = function checkNumericArrayDiff(oldProp, newProp, propertyName, propertyType, changedProps) {
  // just length - missing loop + indexOf comparison (or deepEquals())
  if (newProp && (!oldProp || oldProp.length !== newProp.length)) {
    changedProps.push({
      propertyName: propertyName,
      type: propertyType,
      changeType: PropChangeType.NumericArray,
      value: newProp
    });
  }
};

var checkObservableDiff = function checkObservableDiff(oldProp, newProp, propertyName, propertyType, changedProps) {
  // if it starts with 'on' then we have different handling.
  if (oldProp === undefined && oldProp !== newProp) {
    changedProps.push({
      propertyName: propertyName,
      type: propertyType,
      changeType: PropChangeType.Observable,
      value: newProp
    });
  }
};
/**
 * This method differs from the rest in that we need to pass in a list of arguments.  Can be done by using:
 * 1. an array to signify each parameter (or Object.values(...)).
 *
 * @param oldProp value of method (array, object, primitive, etc.)
 * @param newProp value of method (array, object, primitive, etc.)
 * @param propertyName name of property for diff
 * @param propertyType signature of method (as string)
 * @param changedProps list to append to when a diff is found
 */


var checkMethodDiff = function checkMethodDiff(oldProp, newProp, propertyName, propertyType, changedProps) {
  if (oldProp !== newProp) {
    changedProps.push({
      propertyName: propertyName,
      type: propertyType,
      changeType: PropChangeType.Method,
      value: newProp
    });
  }
}; // module Extensions {


var DynamicTerrain =
/** @class */
function () {
  /**
   * constructor
   * @param name
   * @param options
   * @param scene
   * @param {*} mapData the array of the map 3D data : x, y, z successive float values
   * @param {*} mapSubX the data map number of x subdivisions : integer
   * @param {*} mapSubZ the data map number of z subdivisions : integer
   * @param {*} terrainSub the wanted terrain number of subdivisions : integer, multiple of 2.
   * @param {*} mapUVs the array of the map UV data (optional) : u,v successive values, each between 0 and 1.
   * @param {*} mapColors the array of the map Color data (optional) : x, y, z successive float values.
   * @param {*} mapNormals the array of the map normal data (optional) : r,g,b successive values, each between 0 and 1.
   * @param {*} invertSide boolean, to invert the terrain mesh upside down. Default false.
   * @param {*} camera the camera to link the terrain to. Optional, by default the scene active camera
   * @param {*} SPmapData an array of arrays or Float32Arrays (one per particle type) of object data (position, rotation, scaling) on the map. Optional.
   * @param {*} sps the Solid Particle System used to manage the particles. Required when used with SPmapData.
   * @param {*} SPcolorData an array of arrays or Float32Arrays (one per particle type) of object colors on the map. One series of r, g, b, a floats per object. Optional, requires a SPmapData and a sps to be passed.
   * @param {*} SPuvData an array of arrays or Float32Arrays (one per particle type) of object uvs on the map. One series of x, y, z, w floats per object. Optional, requires a SPmapData and a sps to be passed.
   */
  function DynamicTerrain(name, scene, options) {
    var _this = this;

    this._particleDataStride = 9; // data stride : position, rotation, scaling : 9 floats

    this._particleColorStride = 4; // color stride : color4 : r, g, b, a : 4 floats

    this._particleUVStride = 4; // uv stride : vector4 : x, y, z, w : 4 floats

    this._subToleranceX = 1 | 0; // hoSPcw many cells flought over thy the camera on the terrain x axis before update

    this._subToleranceZ = 1 | 0; // hoSPcw many cells flought over thy the camera on the terrain z axis before update

    this._LODLimits = []; // arSPcray of LOD limits

    this._initialLOD = 1 | 0; // inSPcitial LOD value (integer > 0)

    this._LODValue = 1 | 0; // cuSPcrrent LOD value : initial + camera correction

    this._cameraLODCorrection = 0 | 0; // LOSPcD correction (integer) according to the camera altitude

    this._LODPositiveX = true; // DoeSPcs LOD apply to the terrain right edge ?

    this._LODNegativeX = true; // DoeSPcs LOD apply to the terrain left edge ?

    this._LODPositiveZ = true; // DoeSPcs LOD apply to the terrain upper edge ?

    this._LODNegativeZ = true; // DoeSPcs LOD apply to the terrain lower edge ?

    this._inverted = false; // is the terrain mesh inverted upside down ?

    this.shiftFromCamera = {
      // terrain center shift from camera position
      x: 0.0,
      z: 0.0
    };
    this._deltaSubX = 0 | 0; // map x subdivision delta : variation in number of map subdivisions

    this._deltaSubZ = 0 | 0; // map z subdivision delta

    this._refreshEveryFrame = false; // boolean : to force the terrain computation every frame

    this._useCustomVertexFunction = false; // boolean : to allow the call to updateVertex()

    this._computeNormals = false; // boolean : to skip or not the normal computation

    this._datamap = false; // boolean : true if an data map is passed as parameter

    this._uvmap = false; // boolean : true if an UV map is passed as parameter

    this._colormap = false; // boolean : true if an color map is passed as parameter

    this._mapSPData = false; // boolean : true if a SPmapData array is passed as parameter

    this._colorSPData = false; // boolean : true if a SPcolorData array is passed as parameter

    this._uvSPData = false; // boolean : true if a SPuvData array is passed as parameter

    this._averageSubSizeX = 0.0; // map cell average x size

    this._averageSubSizeZ = 0.0; // map cell average z size

    this._terrainSizeX = 0.0; // terrain x size

    this._terrainSizeZ = 0.0; // terrain y size

    this._terrainHalfSizeX = 0.0;
    this._terrainHalfSizeZ = 0.0;
    this._centerWorld = Vector3.Zero(); // terrain world center position

    this._centerLocal = Vector3.Zero(); // terrain local center position

    this._mapSizeX = 0.0; // map x size

    this._mapSizeZ = 0.0; // map z size

    this._isAlwaysVisible = false; // is the terrain mesh always selected for rendering

    this._precomputeNormalsFromMap = false; // if the normals must be precomputed from the map data when assigning a new map to the existing terrain

    this.name = name;
    options = options || {};
    this._terrainSub = options.terrainSub || 60;
    this._mapData = options.mapData;
    this._terrainIdx = this._terrainSub + 1;
    this._mapSubX = options.mapSubX || this._terrainIdx;
    this._mapSubZ = options.mapSubZ || this._terrainIdx;
    this._mapUVs = options.mapUVs; // if not defined, it will be still populated by default values

    this._mapColors = options.mapColors;
    this._scene = scene;
    this._terrainCamera = options.camera || scene.activeCamera;
    this._inverted = options.invertSide;
    this._SPmapData = options.SPmapData;
    this._SPcolorData = options.SPcolorData;
    this._SPuvData = options.SPuvData;
    this._sps = options.sps; // initialize the map arrays if not passed as parameters

    this._datamap = this._mapData ? true : false;
    this._uvmap = this._mapUVs ? true : false;
    this._colormap = this._mapColors ? true : false;
    this._mapSPData = this._SPmapData ? true : false;
    this._colorSPData = this._mapSPData && this._SPcolorData ? true : false;
    this._uvSPData = this._mapSPData && this._SPuvData ? true : false;
    this._mapData = this._datamap ? this._mapData : new Float32Array(this._terrainIdx * this._terrainIdx * 3);
    this._mapUVs = this._uvmap ? this._mapUVs : new Float32Array(this._terrainIdx * this._terrainIdx * 2);

    if (this._datamap) {
      this._mapNormals = options.mapNormals || new Float32Array(this._mapSubX * this._mapSubZ * 3);
    } else {
      this._mapNormals = new Float32Array(this._terrainIdx * this._terrainIdx * 3);
    } // Ribbon creation


    var index = 0; // current vertex index in the map array

    var posIndex = 0; // current position (coords) index in the map array

    var colIndex = 0; // current color index in the color array

    var uvIndex = 0; // current uv index in the uv array

    var color; // current color

    var uv; // current uv

    var terIndex = 0; // current index in the terrain array

    var y = 0.0; // current y coordinate

    var terrainPath; // current path

    var u = 0.0; // current u of UV

    var v = 0.0; // current v of UV

    var lg = this._terrainIdx + 1; // augmented length for the UV to finish before

    var terrainData = [];
    var terrainColor = [];
    var terrainUV = [];
    var mapData = this._mapData;
    var mapColors = this._mapColors;
    var mapUVs = this._mapUVs;

    for (var j = 0; j <= this._terrainSub; j++) {
      terrainPath = [];

      for (var i = 0; i <= this._terrainSub; i++) {
        index = this._mod(j * 3, this._mapSubZ) * this._mapSubX + this._mod(i * 3, this._mapSubX);
        posIndex = index * 3;
        colIndex = index * 3;
        uvIndex = index * 2;
        terIndex = j * this._terrainIdx + i; // geometry

        if (this._datamap) {
          y = mapData[posIndex + 1];
        } else {
          y = 0.0;
          mapData[3 * terIndex] = i;
          mapData[3 * terIndex + 1] = y;
          mapData[3 * terIndex + 2] = j;
        }

        terrainPath.push(new Vector3(i, y, j)); // color

        if (this._colormap) {
          color = new Color4(mapColors[colIndex], mapColors[colIndex + 1], mapColors[colIndex + 2], 1.0);
        } else {
          color = new Color4(1.0, 1.0, 1.0, 1.0);
        }

        terrainColor.push(color); // uvs

        if (this._uvmap) {
          uv = new Vector2(mapUVs[uvIndex], mapUVs[uvIndex + 1]);
        } else {
          u = 1.0 - Math.abs(1.0 - 2.0 * i / lg);
          v = 1.0 - Math.abs(1.0 - 2.0 * j / lg);
          mapUVs[2 * terIndex] = u;
          mapUVs[2 * terIndex + 1] = v;
          uv = new Vector2(u, v);
        }

        terrainUV.push(uv);
      }

      terrainData.push(terrainPath);
    }

    this._mapSizeX = Math.abs(mapData[(this._mapSubX - 1) * 3] - mapData[0]);
    this._mapSizeZ = Math.abs(mapData[(this._mapSubZ - 1) * this._mapSubX * 3 + 2] - mapData[2]);
    this._averageSubSizeX = this._mapSizeX / this._mapSubX;
    this._averageSubSizeZ = this._mapSizeZ / this._mapSubZ;
    var ribbonOptions = {
      pathArray: terrainData,
      sideOrientation: options.invertSide ? Mesh$1.FRONTSIDE : Mesh$1.BACKSIDE,
      colors: terrainColor,
      uvs: terrainUV,
      updatable: true
    };
    this._terrain = MeshBuilder.CreateRibbon("terrain", ribbonOptions, this._scene);
    this._indices = this._terrain.getIndices();
    this._positions = this._terrain.getVerticesData(VertexBuffer.PositionKind);
    this._normals = this._terrain.getVerticesData(VertexBuffer.NormalKind);
    this._uvs = this._terrain.getVerticesData(VertexBuffer.UVKind);
    this._colors = this._terrain.getVerticesData(VertexBuffer.ColorKind);
    this.computeNormalsFromMap(); // update it immediatly and register the update callback function in the render loop

    this.update(true);
    this._terrain.position.x = this._terrainCamera.globalPosition.x - this._terrainHalfSizeX + this.shiftFromCamera.x;
    this._terrain.position.z = this._terrainCamera.globalPosition.z - this._terrainHalfSizeZ + this.shiftFromCamera.z; // initialize deltaSub to make on the map

    var deltaNbSubX = (this._terrain.position.x - mapData[0]) / this._averageSubSizeX;
    var deltaNbSubZ = (this._terrain.position.z - mapData[2]) / this._averageSubSizeZ;
    this._deltaSubX = deltaNbSubX > 0 ? Math.floor(deltaNbSubX) : Math.ceil(deltaNbSubX);
    this._deltaSubZ = deltaNbSubZ > 0 ? Math.floor(deltaNbSubZ) : Math.ceil(deltaNbSubZ);

    this._scene.onBeforeRenderObservable.add(function () {
      var refreshEveryFrame = _this._refreshEveryFrame;

      _this.beforeUpdate(refreshEveryFrame);

      _this.update(refreshEveryFrame);

      _this.afterUpdate(refreshEveryFrame);
    }); // if SP data, populate the map quads
    // mapQuads[mapIndex][partType] = [partIdx1 , partIdx2 ...] partIdx are particle indexes in SPmapData


    var SPmapData = this._SPmapData;
    var dataStride = this._particleDataStride;

    if (this._mapSPData) {
      var mapSizeX = this._mapSizeX;
      var mapSizeZ = this._mapSizeZ;
      var mapSubX = this._mapSubX;
      var mapSubZ = this._mapSubZ;
      var quads = [];
      this._mapQuads = quads;
      var x0 = mapData[0];
      var z0 = mapData[2];

      for (var t = 0; t < SPmapData.length; t++) {
        var data = SPmapData[t];
        var nb = data.length / dataStride | 0;

        for (var pIdx = 0; pIdx < nb; pIdx++) {
          // particle position x, z in the map
          var dIdx = pIdx * dataStride;
          var x = data[dIdx];
          var z = data[dIdx + 2];
          x = x - Math.floor((x - x0) / mapSizeX) * mapSizeX;
          z = z - Math.floor((z - z0) / mapSizeZ) * mapSizeZ;
          var col = Math.floor((x - x0) * mapSubX / mapSizeX);
          var row = Math.floor((z - z0) * mapSubZ / mapSizeZ);
          var quadIdx = row * mapSubX + col;

          if (quads[quadIdx] === undefined) {
            quads[quadIdx] = [];
          }

          if (quads[quadIdx][t] === undefined) {
            quads[quadIdx][t] = [];
          }

          var quad = quads[quadIdx][t]; // push the particle index from the SPmapData array into the quads array

          quad.push(pIdx);
        }
      } // update the sps


      var sps = this._sps;
      sps.computeBoundingBox = true;
      sps.isAlwaysVisible = true;

      if (this._colorSPData) {
        sps.computeParticleColor = true;
      }

      if (this._uvSPData) {
        sps.computeParticleTexture = true;
      } // store particle types


      var spsTypeStartIndexes = [];
      this._spsTypeStartIndexes = spsTypeStartIndexes;
      var spsNbPerType = [];
      this._spsNbPerType = spsNbPerType;
      var nbAvailablePerType = [];
      this._nbAvailablePerType = nbAvailablePerType;
      var nbParticles = sps.nbParticles;
      var particles = sps.particles;
      var type = 0;
      spsTypeStartIndexes.push(type);
      nbAvailablePerType.push(0);
      var count = 1;

      for (var p = 1; p < nbParticles; p++) {
        particles[p].isVisible = false;

        if (type != particles[p].shapeId) {
          type++;
          spsTypeStartIndexes.push(p);
          spsNbPerType.push(count);
          nbAvailablePerType.push(count);
          count = 0;
        }

        count++;
      }

      spsNbPerType.push(count);
    }

    this.update(true); // recompute everything once the initial deltas are calculated
  }
  /**
   * Updates the terrain position and shape according to the camera position.
   * `force` : boolean, forces the terrain update even if no camera position change.
   * Returns the terrain.
   */


  DynamicTerrain.prototype.update = function (force) {
    var needsUpdate = false;
    var updateLOD = false;
    var updateForced = force ? true : false;
    var terrainPosition = this._terrain.position;
    var cameraPosition = this._terrainCamera.globalPosition;
    var shiftFromCamera = this.shiftFromCamera;
    var terrainHalfSizeX = this._terrainHalfSizeX;
    var terrainHalfSizeZ = this._terrainHalfSizeZ;
    var deltaX = terrainHalfSizeX + terrainPosition.x - cameraPosition.x - shiftFromCamera.x;
    var deltaZ = terrainHalfSizeZ + terrainPosition.z - cameraPosition.z - shiftFromCamera.z;
    var subToleranceX = this._subToleranceX;
    var subToleranceZ = this._subToleranceZ;
    var mod = this._mod; // current LOD

    var oldCorrection = this._cameraLODCorrection;
    this._cameraLODCorrection = this.updateCameraLOD(this._terrainCamera) | 0;
    updateLOD = oldCorrection == this._cameraLODCorrection ? false : true;
    var LODValue = this._initialLOD + this._cameraLODCorrection;
    LODValue = LODValue > 0 ? LODValue : 1;
    this._LODValue = LODValue; // threshold sizes on each axis to trigger the terrain update

    var mapShiftX = this._averageSubSizeX * subToleranceX * LODValue;
    var mapShiftZ = this._averageSubSizeZ * subToleranceZ * LODValue;
    var mapFlgtNb = 0 | 0; // number of map cells flought over by the camera in the delta shift

    var deltaSubX = this._deltaSubX;
    var deltaSubZ = this._deltaSubZ;

    if (Math.abs(deltaX) > mapShiftX) {
      var signX = deltaX > 0.0 ? -1 : 1;
      mapFlgtNb = Math.abs(deltaX / mapShiftX) | 0;
      terrainPosition.x += mapShiftX * signX * mapFlgtNb;
      deltaSubX += subToleranceX * signX * LODValue * mapFlgtNb;
      needsUpdate = true;
    }

    if (Math.abs(deltaZ) > mapShiftZ) {
      var signZ = deltaZ > 0.0 ? -1 : 1;
      mapFlgtNb = Math.abs(deltaZ / mapShiftZ) | 0;
      terrainPosition.z += mapShiftZ * signZ * mapFlgtNb;
      deltaSubZ += subToleranceZ * signZ * LODValue * mapFlgtNb;
      needsUpdate = true;
    }

    var updateSize = updateLOD || updateForced; // must the terrain size be updated ?

    if (needsUpdate || updateSize) {
      this._deltaSubX = mod(deltaSubX, this._mapSubX);
      this._deltaSubZ = mod(deltaSubZ, this._mapSubZ);

      this._updateTerrain(updateSize);
    }

    terrainHalfSizeX = this._terrainHalfSizeX;
    terrainHalfSizeZ = this._terrainHalfSizeZ;
    this.centerLocal.copyFromFloats(terrainHalfSizeX, 0.0, terrainHalfSizeZ);

    this._centerWorld.copyFromFloats(terrainPosition.x + terrainHalfSizeX, terrainPosition.y, terrainPosition.z + terrainHalfSizeZ);

    return this;
  }; // private : updates the underlying ribbon


  DynamicTerrain.prototype._updateTerrain = function (updateSize) {
    var stepJ = 0 | 0;
    var stepI = 0 | 0;
    var LODLimitDown = 0 | 0;
    var LODLimitUp = 0 | 0;
    var LODValue = this._LODValue; // terrain LOD value

    var axisLODValue = LODValue; // current axis computed LOD value

    var lodI = LODValue; // LOD X

    var lodJ = LODValue; // LOD Z

    var bbMin = DynamicTerrain._bbMin;
    var bbMax = DynamicTerrain._bbMax;
    var terrain = this._terrain;
    var positions = this._positions;
    var normals = this._normals;
    var colors = this._colors;
    var uvs = this._uvs;
    var mapColors = this._mapColors;
    var mapNormals = this._mapNormals;
    var mapData = this._mapData;
    var mapUVs = this._mapUVs;
    var mapSPData = this._mapSPData;
    var quads = this._mapQuads;
    var nbPerType = this._spsNbPerType;
    var SPmapData = this._SPmapData;
    var SPcolorData = this._SPcolorData;
    var SPuvData = this._SPuvData;
    var dataStride = this._particleDataStride;
    var colorStride = this._particleColorStride;
    var uvStride = this._particleUVStride;
    var LODLimits = this._LODLimits;
    var terrainSub = this._terrainSub;
    var mod = this._mod;
    var terrainIdx = this._terrainIdx;
    var mapSubX = this._mapSubX;
    var mapSubZ = this._mapSubZ;
    var deltaSubX = this._deltaSubX;
    var deltaSubZ = this._deltaSubZ;
    var datamap = this._datamap;
    var uvmap = this._uvmap;
    var colormap = this._colormap;
    var useCustomVertexFunction = this._useCustomVertexFunction;
    var updateVertex = this.updateVertex;
    var dontComputeNormals = !this._computeNormals;
    var LODpstvX = this._LODPositiveX;
    var LODngtvX = this._LODNegativeX;
    var LODpstvZ = this._LODPositiveZ;
    var LODngtvZ = this._LODNegativeZ;
    var mapSizeX = this._mapSizeX;
    var mapSizeZ = this._mapSizeZ;
    var averageSubSizeX = this._averageSubSizeX;
    var averageSubSizeZ = this._averageSubSizeZ;
    var particleMap = mapSPData && quads;
    var particleColorMap = particleMap && this._colorSPData;
    var particleUVMap = particleMap && this._uvSPData;
    var l = 0 | 0;
    var index = 0 | 0; // current vertex index in the map data array

    var posIndex1 = 0 | 0; // current position index in the map data array

    var posIndex2 = 0 | 0;
    var posIndex3 = 0 | 0;
    var colIndex = 0 | 0; // current index in the map color array

    var uvIndex = 0 | 0; // current index in the map uv array

    var terIndex = 0 | 0; // current vertex index in the terrain map array when used as a data map

    var ribbonInd = 0 | 0; // current ribbon vertex index

    var ribbonPosInd = 0 | 0; // current ribbon position index (same than normal index)

    var ribbonUVInd = 0 | 0; // current ribbon UV index

    var ribbonColInd = 0 | 0; // current ribbon color index

    var ribbonColInd1 = 0 | 0;
    var ribbonColInd2 = 0 | 0;
    var ribbonColInd3 = 0 | 0;
    var ribbonColInd4 = 0 | 0;
    var ribbonPosInd1 = 0 | 0;
    var ribbonPosInd2 = 0 | 0;
    var ribbonPosInd3 = 0 | 0; // note : all the indexes are explicitly set as integers for the js optimizer (store them all in the stack)

    if (updateSize) {
      this.updateTerrainSize();
    }

    Vector3.FromFloatsToRef(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE, bbMin);
    Vector3.FromFloatsToRef(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE, bbMax);

    if (particleMap) {
      var sps = this._sps;
      var particles = sps.particles;
      var spsTypeStartIndexes = this._spsTypeStartIndexes;
      var nbAvailablePerType = this._nbAvailablePerType;
      var x0 = mapData[0];
      var z0 = mapData[2];
      var terrainPos = terrain.position; // reset all the particles to invisible

      var nbParticles = sps.nbParticles;

      for (var p = 0; p < nbParticles; p++) {
        particles[p].isVisible = false;
      }
    }

    for (var j = 0 | 0; j <= terrainSub; j++) {
      // LOD Z
      axisLODValue = LODValue;

      for (l = 0; l < LODLimits.length; l++) {
        LODLimitDown = LODLimits[l];
        LODLimitUp = terrainSub - LODLimitDown - 1;

        if (LODngtvZ && j < LODLimitDown || LODpstvZ && j > LODLimitUp) {
          axisLODValue = l + 1 + LODValue;
        }

        lodJ = axisLODValue;
      }

      for (var i = 0 | 0; i <= terrainSub; i++) {
        // LOD X
        axisLODValue = LODValue;

        for (l = 0; l < LODLimits.length; l++) {
          LODLimitDown = LODLimits[l];
          LODLimitUp = terrainSub - LODLimitDown - 1;

          if (LODngtvX && i < LODLimitDown || LODpstvX && i > LODLimitUp) {
            axisLODValue = l + 1 + LODValue;
          }

          lodI = axisLODValue;
        } // map current index


        index = mod(deltaSubZ + stepJ, mapSubZ) * mapSubX + mod(deltaSubX + stepI, mapSubX);
        terIndex = mod(deltaSubZ + stepJ, terrainIdx) * terrainIdx + mod(deltaSubX + stepI, terrainIdx); // related index in the array of positions (data map)

        if (datamap) {
          posIndex1 = 3 * index;
        } else {
          posIndex1 = 3 * terIndex;
        } // related index in the UV map


        if (uvmap) {
          uvIndex = 2 * index;
        } else {
          uvIndex = 2 * terIndex;
        } // related index in the color map


        if (colormap) {
          colIndex = 3 * index;
        } else {
          colIndex = 3 * terIndex;
        } //map indexes


        posIndex2 = posIndex1 + 1;
        posIndex3 = posIndex1 + 2; // ribbon indexes

        ribbonPosInd = 3 * ribbonInd;
        ribbonColInd = 4 * ribbonInd;
        ribbonUVInd = 2 * ribbonInd;
        ribbonPosInd1 = ribbonPosInd;
        ribbonPosInd2 = ribbonPosInd + 1;
        ribbonPosInd3 = ribbonPosInd + 2;
        ribbonColInd1 = ribbonColInd;
        ribbonColInd2 = ribbonColInd + 1;
        ribbonColInd3 = ribbonColInd + 2;
        ribbonColInd4 = ribbonColInd + 3;
        ribbonInd += 1; // geometry

        positions[ribbonPosInd1] = averageSubSizeX * stepI;
        positions[ribbonPosInd2] = mapData[posIndex2];
        positions[ribbonPosInd3] = averageSubSizeZ * stepJ;

        if (dontComputeNormals) {
          normals[ribbonPosInd1] = mapNormals[posIndex1];
          normals[ribbonPosInd2] = mapNormals[posIndex2];
          normals[ribbonPosInd3] = mapNormals[posIndex3];
        } // bbox internal update


        if (positions[ribbonPosInd1] < bbMin.x) {
          bbMin.x = positions[ribbonPosInd1];
        }

        if (positions[ribbonPosInd1] > bbMax.x) {
          bbMax.x = positions[ribbonPosInd1];
        }

        if (positions[ribbonPosInd2] < bbMin.y) {
          bbMin.y = positions[ribbonPosInd2];
        }

        if (positions[ribbonPosInd2] > bbMax.y) {
          bbMax.y = positions[ribbonPosInd2];
        }

        if (positions[ribbonPosInd3] < bbMin.z) {
          bbMin.z = positions[ribbonPosInd3];
        }

        if (positions[ribbonPosInd3] > bbMax.z) {
          bbMax.z = positions[ribbonPosInd3];
        } // color


        if (colormap) {
          colors[ribbonColInd1] = mapColors[colIndex];
          colors[ribbonColInd2] = mapColors[colIndex + 1];
          colors[ribbonColInd3] = mapColors[colIndex + 2];
        } // uv : the array _mapUVs is always populated


        uvs[ribbonUVInd] = mapUVs[uvIndex];
        uvs[ribbonUVInd + 1] = mapUVs[uvIndex + 1]; // call to user custom function with the current updated vertex object

        if (useCustomVertexFunction) {
          var vertex = DynamicTerrain._vertex;
          var vertexPosition = vertex.position;
          var vertexWorldPosition = vertex.worldPosition;
          var vertexColor = vertex.color;
          var vertexUvs = vertex.uvs;
          vertexPosition.copyFromFloats(positions[ribbonPosInd1], positions[ribbonPosInd2], positions[ribbonPosInd3]);
          vertexWorldPosition.copyFromFloats(mapData[posIndex1], vertexPosition.y, mapData[posIndex3]);
          vertex.lodX = lodI;
          vertex.lodZ = lodJ;
          vertexColor.copyFromFloats(colors[ribbonColInd1], colors[ribbonColInd2], colors[ribbonColInd3], colors[ribbonColInd4]);
          vertexUvs.copyFromFloats(uvs[ribbonUVInd], uvs[ribbonUVInd + 1]);
          vertex.mapIndex = index;
          updateVertex(vertex, i, j); // the user can modify the array values here

          colors[ribbonColInd1] = vertexColor.r;
          colors[ribbonColInd2] = vertexColor.g;
          colors[ribbonColInd3] = vertexColor.b;
          colors[ribbonColInd4] = vertexColor.a;
          uvs[ribbonUVInd] = vertexUvs.x;
          uvs[ribbonUVInd + 1] = vertexUvs.y;
          positions[ribbonPosInd1] = vertexPosition.x;
          positions[ribbonPosInd2] = vertexPosition.y;
          positions[ribbonPosInd3] = vertexPosition.z;
        } // SPS management


        if (particleMap) {
          var quad = quads[index];

          if (quad) {
            // if a quad contains some particles in the map
            for (var t = 0; t < quad.length; t++) {
              var data = SPmapData[t];
              var partIndexes = quad[t];

              if (particleColorMap) {
                var sp_colorData = SPcolorData[t];
              }

              if (particleUVMap) {
                var sp_uvData = SPuvData[t];
              }

              if (partIndexes) {
                var typeStartIndex = spsTypeStartIndexes[t]; // particle start index for a given type in the SPS

                var nbQuadParticles = partIndexes.length;
                var nbInSPS = nbPerType[t];
                var available = nbAvailablePerType[t];
                var rem = nbInSPS - available;
                var used = rem > 0 ? rem : 0;
                var min = available < nbQuadParticles ? available : nbQuadParticles; // don't iterate beyond possible

                for (var pIdx = 0; pIdx < min; pIdx++) {
                  var px = partIndexes[pIdx];
                  var idm = px * dataStride; // set successive available particles of this type

                  var particle = particles[typeStartIndex + pIdx + used];
                  var pos = particle.position;
                  var rot = particle.rotation;
                  var scl = particle.scaling;
                  var x = data[idm];
                  pos.x = x + Math.floor((terrainPos.x - x - x0) / mapSizeX) * mapSizeX;
                  pos.y = data[idm + 1];
                  var z = data[idm + 2];
                  pos.z = z + Math.floor((terrainPos.z - z - z0) / mapSizeZ) * mapSizeZ;
                  rot.x = data[idm + 3];
                  rot.y = data[idm + 4];
                  rot.z = data[idm + 5];
                  scl.x = data[idm + 6];
                  scl.y = data[idm + 7];
                  scl.z = data[idm + 8];

                  if (particleColorMap) {
                    var idc = px * colorStride;
                    var col = particle.color;
                    col.r = sp_colorData[idc];
                    col.g = sp_colorData[idc + 1];
                    col.b = sp_colorData[idc + 2];
                    col.a = sp_colorData[idc + 3];
                  }

                  if (particleUVMap) {
                    var iduv = px * uvStride;
                    var uvs_1 = particle.uvs;
                    uvs_1.x = sp_uvData[iduv];
                    uvs_1.y = sp_uvData[iduv + 1];
                    uvs_1.z = sp_uvData[iduv + 2];
                    uvs_1.w = sp_uvData[iduv + 3];
                  }

                  particle.isVisible = true;
                  available = available - 1;
                  used = used + 1;
                  min = available < nbQuadParticles ? available : nbQuadParticles;
                }

                available = available > 0 ? available : 0;
                nbAvailablePerType[t] = available;
              }
            }
          }
        }

        stepI += lodI;
      }

      stepI = 0;
      stepJ += lodJ;
    }

    if (particleMap) {
      sps.setParticles();

      for (var c = 0; c < nbAvailablePerType.length; c++) {
        nbAvailablePerType[c] = nbPerType[c];
      }
    } // ribbon update


    terrain.updateVerticesData(VertexBuffer.PositionKind, positions, false, false);

    if (this._computeNormals) {
      VertexData.ComputeNormals(positions, this._indices, normals);
    }

    terrain.updateVerticesData(VertexBuffer.NormalKind, normals, false, false);
    terrain.updateVerticesData(VertexBuffer.UVKind, uvs, false, false);
    terrain.updateVerticesData(VertexBuffer.ColorKind, colors, false, false);

    terrain._boundingInfo.reConstruct(bbMin, bbMax, terrain._worldMatrix);
  }; // private modulo, for dealing with negative indexes


  DynamicTerrain.prototype._mod = function (a, b) {
    return (a % b + b) % b;
  };
  /**
   * Updates the mesh terrain size according to the LOD limits and the camera position.
   * Returns the terrain.
   */


  DynamicTerrain.prototype.updateTerrainSize = function () {
    var remainder = this._terrainSub; // the remaining cells at the general current LOD value

    var nb = 0 | 0; // nb of cells in the current LOD limit interval

    var next = 0 | 0; // next cell index, if it exists

    var LODValue = this._LODValue;
    var lod = LODValue + 1; // lod value in the current LOD limit interval

    var tsx = 0.0; // current sum of cell sizes on x

    var tsz = 0.0; // current sum of cell sizes on z

    var LODLimits = this._LODLimits;
    var averageSubSizeX = this._averageSubSizeX;
    var averageSubSizeZ = this._averageSubSizeZ;

    for (var l = 0 | 0; l < LODLimits.length; l++) {
      lod = LODValue + l + 1;
      next = l >= LODLimits.length - 1 ? 0 : LODLimits[l + 1];
      nb = 2 * (LODLimits[l] - next);
      tsx += averageSubSizeX * lod * nb;
      tsz += averageSubSizeZ * lod * nb;
      remainder -= nb;
    }

    tsx += remainder * averageSubSizeX * LODValue;
    tsz += remainder * averageSubSizeZ * LODValue;
    this._terrainSizeX = tsx;
    this._terrainSizeZ = tsz;
    this._terrainHalfSizeX = tsx * 0.5;
    this._terrainHalfSizeZ = tsz * 0.5;
    return this;
  };
  /**
   * Returns the altitude (float) at the coordinates (x, z) of the map.
   * @param x
   * @param z
   * @param {normal: Vector3} (optional)
   * If the optional object {normal: Vector3} is passed, then its property "normal" is updated with the normal vector value at the coordinates (x, z).
   */


  DynamicTerrain.prototype.getHeightFromMap = function (x, z, options) {
    return DynamicTerrain._GetHeightFromMap(x, z, this._mapData, this._mapSubX, this._mapSubZ, this._mapSizeX, this._mapSizeZ, options, this._inverted);
  };
  /**
   * Static : Returns the altitude (float) at the coordinates (x, z) of the passed map.
   * @param x
   * @param z
   * @param mapSubX the number of points along the map width
   * @param mapSubX the number of points along the map height
   * @param {normal: Vector3} (optional)
   * @param inverted (optional boolean) is the terrain inverted
   * If the optional object {normal: Vector3} is passed, then its property "normal" is updated with the normal vector value at the coordinates (x, z).
   */


  DynamicTerrain.GetHeightFromMap = function (x, z, mapData, mapSubX, mapSubZ, options, inverted) {
    var mapSizeX = Math.abs(mapData[(mapSubX - 1) * 3] - mapData[0]);
    var mapSizeZ = Math.abs(mapData[(mapSubZ - 1) * mapSubX * 3 + 2] - mapData[2]);
    return DynamicTerrain._GetHeightFromMap(x, z, mapData, mapSubX, mapSubZ, mapSizeX, mapSizeZ, options, inverted);
  }; // Computes the height and optionnally the normal at the coordinates (x ,z) from the passed map


  DynamicTerrain._GetHeightFromMap = function (x, z, mapData, mapSubX, mapSubZ, mapSizeX, mapSizeZ, options, inverted) {
    var x0 = mapData[0];
    var z0 = mapData[2]; // reset x and z in the map space so they are between 0 and the map size

    x = x - Math.floor((x - x0) / mapSizeX) * mapSizeX;
    z = z - Math.floor((z - z0) / mapSizeZ) * mapSizeZ;
    var col1 = Math.floor((x - x0) * mapSubX / mapSizeX);
    var row1 = Math.floor((z - z0) * mapSubZ / mapSizeZ);
    var col2 = (col1 + 1) % mapSubX;
    var row2 = (row1 + 1) % mapSubZ; // starting indexes of the positions of 4 vertices defining a quad on the map

    var idx1 = 3 * (row1 * mapSubX + col1);
    var idx2 = 3 * (row1 * mapSubX + col2);
    var idx3 = 3 * (row2 * mapSubX + col1);
    var idx4 = 3 * (row2 * mapSubX + col2);
    var v1 = DynamicTerrain._v1;
    var v2 = DynamicTerrain._v2;
    var v3 = DynamicTerrain._v3;
    var v4 = DynamicTerrain._v4;
    v1.copyFromFloats(mapData[idx1], mapData[idx1 + 1], mapData[idx1 + 2]);
    v2.copyFromFloats(mapData[idx2], mapData[idx2 + 1], mapData[idx2 + 2]);
    v3.copyFromFloats(mapData[idx3], mapData[idx3 + 1], mapData[idx3 + 2]);
    v4.copyFromFloats(mapData[idx4], mapData[idx4 + 1], mapData[idx4 + 2]);
    var vAvB = DynamicTerrain._vAvB;
    var vAvC = DynamicTerrain._vAvC;
    var norm = DynamicTerrain._norm;
    var vA = v1;
    var vB;
    var vC;
    var v;
    var xv4v1 = v4.x - v1.x;
    var zv4v1 = v4.z - v1.z;

    if (xv4v1 == 0 || zv4v1 == 0) {
      return v1.y;
    }

    var cd = zv4v1 / xv4v1;
    var h = v1.z - cd * v1.x;

    if (z < cd * x + h) {
      vB = v4;
      vC = v2;
      v = vA;
    } else {
      vB = v3;
      vC = v4;
      v = vB;
    }

    vB.subtractToRef(vA, vAvB);
    vC.subtractToRef(vA, vAvC);
    Vector3.CrossToRef(vAvB, vAvC, norm);
    norm.normalize();

    if (inverted) {
      norm.scaleInPlace(-1.0);
    }

    if (options && options.normal) {
      options.normal.copyFrom(norm);
    }

    var d = -(norm.x * v.x + norm.y * v.y + norm.z * v.z);
    var y = v.y;

    if (norm.y != 0.0) {
      y = -(norm.x * x + norm.z * z + d) / norm.y;
    }

    return y;
  };
  /**
   * Static : Computes all the normals from the terrain data map  and stores them in the passed Float32Array reference.
   * This passed array must have the same size than the mapData array.
   */


  DynamicTerrain.ComputeNormalsFromMapToRef = function (mapData, mapSubX, mapSubZ, normals, inverted) {
    var mapIndices = [];
    var tmp1 = {
      normal: Vector3.Zero()
    };
    var tmp2 = {
      normal: Vector3.Zero()
    };
    var normal1 = tmp1.normal;
    var normal2 = tmp2.normal;
    var l = mapSubX * (mapSubZ - 1);
    var i = 0;

    for (i = 0; i < l; i++) {
      mapIndices.push(i + 1, i + mapSubX, i);
      mapIndices.push(i + mapSubX, i + 1, i + mapSubX + 1);
    }

    VertexData.ComputeNormals(mapData, mapIndices, normals); // seam process

    var lastIdx = (mapSubX - 1) * 3;
    var colStart = 0;
    var colEnd = 0;
    var getHeightFromMap = DynamicTerrain.GetHeightFromMap;

    for (i = 0; i < mapSubZ; i++) {
      colStart = i * mapSubX * 3;
      colEnd = colStart + lastIdx;
      getHeightFromMap(mapData[colStart], mapData[colStart + 2], mapData, mapSubX, mapSubZ, tmp1);
      getHeightFromMap(mapData[colEnd], mapData[colEnd + 2], mapData, mapSubX, mapSubZ, tmp2);
      normal1.addInPlace(normal2).scaleInPlace(0.5);
      normals[colStart] = normal1.x;
      normals[colStart + 1] = normal1.y;
      normals[colStart + 2] = normal1.z;
      normals[colEnd] = normal1.x;
      normals[colEnd + 1] = normal1.y;
      normals[colEnd + 2] = normal1.z;
    } // inverted terrain


    if (inverted) {
      for (i = 0; i < normals.length; i++) {
        normals[i] = -normals[i];
      }
    }
  };
  /**
   * Computes all the map normals from the current terrain data map and sets them to the terrain.
   * Returns the terrain.
   */


  DynamicTerrain.prototype.computeNormalsFromMap = function () {
    DynamicTerrain.ComputeNormalsFromMapToRef(this._mapData, this._mapSubX, this._mapSubZ, this._mapNormals, this._inverted);
    return this;
  };
  /**
   * Returns true if the World coordinates (x, z) are in the current terrain.
   * @param x
   * @param z
   */


  DynamicTerrain.prototype.contains = function (x, z) {
    var positions = this._positions;
    var meshPosition = this.mesh.position;
    var terrainIdx = this._terrainIdx;

    if (x < positions[0] + meshPosition.x || x > positions[3 * terrainIdx] + meshPosition.x) {
      return false;
    }

    if (z < positions[2] + meshPosition.z || z > positions[3 * terrainIdx * terrainIdx + 2] + meshPosition.z) {
      return false;
    }

    return true;
  };
  /**
         * Static : Returns a new data map from the passed heightmap image file.
         The parameters `width` and `height` (positive floats, default 300) set the map width and height sizes.
        * `subX` is the wanted number of points along the map width (default 100).
        * `subZ` is the wanted number of points along the map height (default 100).
        * The parameter `minHeight` (float, default 0) is the minimum altitude of the map.
        * The parameter `maxHeight` (float, default 1) is the maximum altitude of the map.
        * The parameter `colorFilter` (optional Color3, default (0.3, 0.59, 0.11) ) is the filter to apply to the image pixel colors to compute the height.
        * `onReady` is an optional callback function, called once the map is computed. It's passed the computed map.
        * `scene` is the Scene object whose database will store the downloaded image.
        */


  DynamicTerrain.CreateMapFromHeightMap = function (heightmapURL, options, scene) {
    var subX = options.subX || 100;
    var subZ = options.subZ || 100;
    var data = new Float32Array(subX * subZ * 3);
    DynamicTerrain.CreateMapFromHeightMapToRef(heightmapURL, options, data, scene);
    return data;
  };
  /**
   * Static : Updates the passed array or Float32Array with a data map computed from the passed heightmap image file.
   *  The parameters `width` and `height` (positive floats, default 300) set the map width and height sizes.
   * `subX` is the wanted number of points along the map width (default 100).
   * `subZ` is the wanted number of points along the map height (default 100).
   * The parameter `minHeight` (float, default 0) is the minimum altitude of the map.
   * The parameter `maxHeight` (float, default 1) is the maximum altitude of the map.
   * The parameter `colorFilter` (optional Color3, default (0.3, 0.59, 0.11) ) is the filter to apply to the image pixel colors to compute the height.
   * `onReady` is an optional callback function, called once the map is computed. It's passed the computed map.
   * `scene` is the Scene object whose database will store the downloaded image.
   * The passed Float32Array must be the right size : 3 x subX x subZ.
   */


  DynamicTerrain.CreateMapFromHeightMapToRef = function (heightmapURL, options, data, scene) {
    var width = options.width || 300;
    var height = options.height || 300;
    var subX = options.subX || 100;
    var subZ = options.subZ || 100;
    var minHeight = options.minHeight || 0.0;
    var maxHeight = options.maxHeight || 10.0;
    var offsetX = options.offsetX || 0.0;
    var offsetZ = options.offsetZ || 0.0;
    var filter = options.colorFilter || new Color3(0.3, 0.59, 0.11);
    var onReady = options.onReady;

    var onload = function onload(img) {
      // Getting height map data
      var canvas = document.createElement("canvas");
      var context = canvas.getContext("2d");
      var bufferWidth = img.width;
      var bufferHeight = img.height;
      canvas.width = bufferWidth;
      canvas.height = bufferHeight;
      context.drawImage(img, 0, 0); // Cast is due to wrong definition in lib.d.ts from ts 1.3 - https://github.com/Microsoft/TypeScript/issues/949

      var buffer = context.getImageData(0, 0, bufferWidth, bufferHeight).data;
      var x = 0.0;
      var y = 0.0;
      var z = 0.0;

      for (var row = 0; row < subZ; row++) {
        for (var col = 0; col < subX; col++) {
          x = col * width / subX - width * 0.5;
          z = row * height / subZ - height * 0.5;
          var heightmapX = (x + width * 0.5) / width * (bufferWidth - 1) | 0;
          var heightmapY = bufferHeight - 1 - (z + height * 0.5) / height * (bufferHeight - 1) | 0;
          var pos = (heightmapX + heightmapY * bufferWidth) * 4;
          var gradient = (buffer[pos] * filter.r + buffer[pos + 1] * filter.g + buffer[pos + 2] * filter.b) / 255.0;
          y = minHeight + (maxHeight - minHeight) * gradient;
          var idx = (row * subX + col) * 3;
          data[idx] = x + offsetX;
          data[idx + 1] = y;
          data[idx + 2] = z + offsetZ;
        }
      } // callback function if any


      if (onReady) {
        onReady(data, subX, subZ);
      }
    };

    Tools.LoadImage(heightmapURL, onload, function () {}, scene.offlineProvider);
  };
  /**
   * Static : Updates the passed arrays with UVs values to fit the whole map with subX points along its width and subZ points along its height.
   * The passed array must be the right size : subX x subZ x 2.
   */


  DynamicTerrain.CreateUVMapToRef = function (subX, subZ, mapUVs) {
    for (var h = 0; h < subZ; h++) {
      for (var w = 0; w < subX; w++) {
        mapUVs[(h * subX + w) * 2] = w / subX;
        mapUVs[(h * subX + w) * 2 + 1] = h / subZ;
      }
    }
  };
  /**
   * Static : Returns a new UV array with values to fit the whole map with subX points along its width and subZ points along its height.
   */


  DynamicTerrain.CreateUVMap = function (subX, subZ) {
    var mapUVs = new Float32Array(subX * subZ * 2);
    DynamicTerrain.CreateUVMapToRef(subX, subZ, mapUVs);
    return mapUVs;
  };
  /**
   * Computes and sets the terrain UV map with values to fit the whole map.
   * Returns the terrain.
   */


  DynamicTerrain.prototype.createUVMap = function () {
    this.mapUVs = DynamicTerrain.CreateUVMap(this._mapSubX, this._mapSubZ);
    return this;
  };

  Object.defineProperty(DynamicTerrain.prototype, "refreshEveryFrame", {
    // Getters / Setters

    /**
     * boolean : if the terrain must be recomputed every frame.
     */
    get: function get() {
      return this._refreshEveryFrame;
    },
    set: function set(val) {
      this._refreshEveryFrame = val;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "mesh", {
    /**
     * Mesh : the logical terrain underlying mesh
     */
    get: function get() {
      return this._terrain;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "camera", {
    /**
     * The camera the terrain is linked to
     */
    get: function get() {
      return this._terrainCamera;
    },
    set: function set(val) {
      this._terrainCamera = val;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "subToleranceX", {
    /**
     * Number of cells flought over by the cam on the X axis before the terrain is updated.
     * Integer greater or equal to 1.
     */
    get: function get() {
      return this._subToleranceX;
    },
    set: function set(val) {
      this._subToleranceX = val > 0 ? val : 1;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "subToleranceZ", {
    /**
     * Number of cells flought over by the cam on the Z axis before the terrain is updated.
     * Integer greater or equal to 1. Default 1.
     */
    get: function get() {
      return this._subToleranceZ;
    },
    set: function set(val) {
      this._subToleranceZ = val > 0 ? val : 1;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "initialLOD", {
    /**
     * Initial LOD factor value.
     * Integer greater or equal to 1. Default 1.
     */
    get: function get() {
      return this._initialLOD;
    },
    set: function set(val) {
      this._initialLOD = val > 0 ? val : 1;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "LODValue", {
    /**
     * Current LOD factor value : the lower factor in the terrain.
     * The LOD value is the sum of the initialLOD and the current cameraLODCorrection.
     * Integer greater or equal to 1. Default 1.
     */
    get: function get() {
      return this._LODValue;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "cameraLODCorrection", {
    /**
     * Camera LOD correction : the factor to add to the initial LOD according to the camera position, movement, etc.
     * Positive integer (default 0)
     */
    get: function get() {
      return this._cameraLODCorrection;
    },
    set: function set(val) {
      this._cameraLODCorrection = val >= 0 ? val : 0;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "LODPositiveX", {
    /**
     * Boolean : Does the LOD apply only to the terrain right edge ?
     * Default : true
     */
    get: function get() {
      return this._LODPositiveX;
    },
    set: function set(val) {
      this._LODPositiveX = val;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "LODNegativeX", {
    /**
     * Boolean : Does the LOD apply only to the terrain left edge ?
     * Default : true
     */
    get: function get() {
      return this._LODNegativeX;
    },
    set: function set(val) {
      this._LODNegativeX = val;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "LODPositiveZ", {
    /**
     * Boolean : Does the LOD apply only to the terrain upper edge ?
     * Default : true
     */
    get: function get() {
      return this._LODPositiveZ;
    },
    set: function set(val) {
      this._LODPositiveZ = val;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "LODNegativeZ", {
    /**
     * Boolean : Does the LOD apply only to the terrain lower edge ?
     * Default : true
     */
    get: function get() {
      return this._LODNegativeZ;
    },
    set: function set(val) {
      this._LODNegativeZ = val;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "averageSubSizeX", {
    /**
     * Average map and terrain subdivision size on X axis.
     * Returns a float.
     */
    get: function get() {
      return this._averageSubSizeX;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "averageSubSizeZ", {
    /**
     * Average map and terrain subdivision size on Z axis.
     * Returns a float.
     */
    get: function get() {
      return this._averageSubSizeZ;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "terrainSizeX", {
    /**
     * Current terrain size on the X axis.
     * Returns a float.
     */
    get: function get() {
      return this._terrainSizeX;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "terrainHalfSizeX", {
    /**
     * Current terrain half size on the X axis.
     * Returns a float.
     */
    get: function get() {
      return this._terrainHalfSizeX;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "terrainSizeZ", {
    /**
     * Current terrain size on the Z axis.
     * Returns a float.
     */
    get: function get() {
      return this._terrainSizeZ;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "terrainHalfSizeZ", {
    /**
     * Current terrain half size on the Z axis.
     * Returns a float.
     */
    get: function get() {
      return this._terrainHalfSizeZ;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "centerLocal", {
    /**
     * Current position of terrain center in its local space.
     * Returns a Vector3.
     */
    get: function get() {
      return this._centerLocal;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "centerWorld", {
    /**
     * Current position of terrain center in the World space.
     * Returns a Vector3.
     */
    get: function get() {
      return this._centerWorld;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "LODLimits", {
    /**
     * The array of the limit values to change the LOD factor.
     * Returns an array of integers or an empty array.
     * This array is always sorted in the descending order once set.
     */
    get: function get() {
      return this._LODLimits;
    },
    set: function set(ar) {
      ar.sort(function (a, b) {
        return b - a;
      });
      this._LODLimits = ar;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "mapData", {
    /**
     * The data of the map.
     * A flat array (Float32Array recommeded) of successive 3D float coordinates (x, y, z).
     * This property can be set only if a mapData array was passed at construction time.
     */
    get: function get() {
      return this._mapData;
    },
    set: function set(val) {
      this._mapData = val;
      this._datamap = true;
      var mapSubX = this._mapSubX;
      var mapSubZ = this._mapSubZ;
      this._mapSizeX = Math.abs(val[(mapSubX - 1) * 3] - val[0]);
      this._mapSizeZ = Math.abs(val[(mapSubZ - 1) * mapSubX * 3 + 2] - val[2]);
      this._averageSubSizeX = this._mapSizeX / mapSubX;
      this._averageSubSizeZ = this._mapSizeZ / mapSubZ;

      if (this._precomputeNormalsFromMap) {
        this.computeNormalsFromMap();
      }

      this.update(true);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "mapSubX", {
    /**
     * The number of points on the map width.
     * Positive Integer.
     */
    get: function get() {
      return this._mapSubX;
    },
    set: function set(val) {
      this._mapSubX = val;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "mapSubZ", {
    /**
     * The number of points on the map height .
     * Positive Integer.
     */
    get: function get() {
      return this._mapSubZ;
    },
    set: function set(val) {
      this._mapSubZ = val;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "mapColors", {
    /**
     * The map of colors.
     * A flat array of successive floats between 0 and 1 as r,g,b values.
     * This property can be set only if a mapColors array was passed at construction time.
     */
    get: function get() {
      return this._mapColors;
    },
    set: function set(val) {
      this._colormap = true;
      this._mapColors = val;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "mapUVs", {
    /**
     * The map of UVs.
     * A flat array of successive floats between 0 and 1 as (u, v) values.
     * This property can be set only if a mapUVs array was passed at construction time.
     */
    get: function get() {
      return this._mapUVs;
    },
    set: function set(val) {
      this._uvmap = true;
      this._mapUVs = val;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "mapNormals", {
    /**
     * The map of normals.
     * A flat array of successive floats as normal vector coordinates (x, y, z) on each map point.
     */
    get: function get() {
      return this._mapNormals;
    },
    set: function set(val) {
      this._mapNormals = val;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "computeNormals", {
    /**
     * Boolean : must the normals be recomputed on each terrain update (default : false).
     * By default, all the map normals are pre-computed on terrain creation.
     */
    get: function get() {
      return this._computeNormals;
    },
    set: function set(val) {
      this._computeNormals = val;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "useCustomVertexFunction", {
    /**
     * Boolean : will the custom function updateVertex() be called on each terrain update ?
     * Default false
     */
    get: function get() {
      return this._useCustomVertexFunction;
    },
    set: function set(val) {
      this._useCustomVertexFunction = val;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "isAlwaysVisible", {
    /**
     * Boolean : is the terrain always directly selected for rendering ?
     */
    get: function get() {
      return this._isAlwaysVisible;
    },
    set: function set(val) {
      this.mesh.alwaysSelectAsActiveMesh = val;
      this._isAlwaysVisible = val;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DynamicTerrain.prototype, "precomputeNormalsFromMap", {
    /**
     * Boolean : when assigning a new data map to the existing, shall the normals be automatically precomputed once ?
     * Default false.
     */
    get: function get() {
      return this._precomputeNormalsFromMap;
    },
    set: function set(val) {
      this._precomputeNormalsFromMap = val;
    },
    enumerable: true,
    configurable: true
  }); // ===============================================================
  // User custom functions.
  // These following can be overwritten bu the user to fit his needs.

  /**
   * Custom function called for each terrain vertex and passed the :
   * - current vertex {position: Vector3, uvs: Vector2, color: Color4, lodX: integer, lodZ: integer, worldPosition: Vector3, mapIndex: integer}
   * - i : the vertex index on the terrain x axis
   * - j : the vertex index on the terrain x axis
   * This function is called only if the property useCustomVertexFunction is set to true.
   */

  DynamicTerrain.prototype.updateVertex = function (vertex, i, j) {
    return;
  };
  /**
   * Custom function called each frame and passed the terrain camera reference.
   * This should return a positive integer or zero.
   * Returns zero by default.
   */


  DynamicTerrain.prototype.updateCameraLOD = function (terrainCamera) {
    // LOD value increases with camera altitude
    var camLOD = 0;
    return camLOD;
  };
  /**
   * Custom function called before each terrain update.
   * The value of reference is passed.
   * Does nothing by default.
   */


  DynamicTerrain.prototype.beforeUpdate = function (refreshEveryFrame) {
    return;
  };
  /**
   * Custom function called after each terrain update.
   * The value of refreshEveryFrame is passed.
   * Does nothing by default.
   */


  DynamicTerrain.prototype.afterUpdate = function (refreshEveryFrame) {
    return;
  };

  DynamicTerrain._vertex = {
    // current vertex object passed to the user custom function
    position: Vector3.Zero(),
    uvs: Vector2.Zero(),
    color: new Color4(1.0, 1.0, 1.0, 1.0),
    lodX: 1 | 0,
    lodZ: 1 | 0,
    worldPosition: Vector3.Zero(),
    mapIndex: 0 | 0 // current map index

  }; // tmp vectors

  DynamicTerrain._v1 = Vector3.Zero();
  DynamicTerrain._v2 = Vector3.Zero();
  DynamicTerrain._v3 = Vector3.Zero();
  DynamicTerrain._v4 = Vector3.Zero();
  DynamicTerrain._vAvB = Vector3.Zero();
  DynamicTerrain._vAvC = Vector3.Zero();
  DynamicTerrain._norm = Vector3.Zero();
  DynamicTerrain._bbMin = Vector3.Zero();
  DynamicTerrain._bbMax = Vector3.Zero();
  return DynamicTerrain;
}(); // }


var FiberNodePropsHandler =
/** @class */
function () {
  function FiberNodePropsHandler() {}

  FiberNodePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = []; // type: 'BabylonjsCoreAnimationPropertiesOverride' property (not coded) BabylonjsCoreNode.animationPropertiesOverride.
    // type: 'BabylonjsCoreAnimation[]' property (not coded) BabylonjsCoreNode.animations.

    checkPrimitiveDiff(oldProps.doNotSerialize, newProps.doNotSerialize, 'doNotSerialize', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.id, newProps.id, 'id', 'string', changedProps); // type: 'BabylonjsCoreIInspectable[]' property (not coded) BabylonjsCoreNode.inspectableCustomProperties.
    // type: 'any' property (not coded) BabylonjsCoreNode.metadata.

    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkLambdaDiff(oldProps.onDispose, newProps.onDispose, 'onDispose', '() => void', changedProps);
    checkObservableDiff(oldProps.onDisposeObservable, newProps.onDisposeObservable, 'onDisposeObservable', 'BabylonjsCoreObservable<BabylonjsCoreNode>', changedProps);
    checkLambdaDiff(oldProps.onReady, newProps.onReady, 'onReady', '(node: BabylonjsCoreNode) => void', changedProps); // type: 'BabylonjsCoreNode' property (not coded) BabylonjsCoreNode.parent.
    // type: 'any' property (not coded) BabylonjsCoreNode.reservedDataStore.

    checkPrimitiveDiff(oldProps.state, newProps.state, 'state', 'string', changedProps);
    checkPrimitiveDiff(oldProps.uniqueId, newProps.uniqueId, 'uniqueId', 'number', changedProps);
    checkMethodDiff(oldProps.addBehavior, newProps.addBehavior, 'addBehavior', '(behavior?: BabylonjsCoreBehavior<BabylonjsCoreNode>, attachImmediately?: boolean) => BabylonjsCoreNode', changedProps);
    checkMethodDiff(oldProps.setEnabled, newProps.setEnabled, 'setEnabled', '(value?: boolean) => void', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberNodePropsHandler;
}();
/**
 * Node is the basic class for all scene objects (Mesh, Light, Camera.)
 *
 * This code has been generated
 */


var FiberNode =
/** @class */
function () {
  function FiberNode() {
    this.propsHandlers = [new FiberNodePropsHandler()];
  }

  FiberNode.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberNode.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberNode.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "Node",
    "namespace": "@babylonjs/core/Meshes/mesh",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberNode.Metadata = {
    "isNode": true,
    "className": "FiberNode"
  };
  return FiberNode;
}();

var FiberTransformNodePropsHandler =
/** @class */
function () {
  function FiberTransformNodePropsHandler() {}

  FiberTransformNodePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.billboardMode, newProps.billboardMode, 'billboardMode', 'number', changedProps);
    checkPrimitiveDiff(oldProps.ignoreNonUniformScaling, newProps.ignoreNonUniformScaling, 'ignoreNonUniformScaling', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.infiniteDistance, newProps.infiniteDistance, 'infiniteDistance', 'boolean', changedProps);
    checkObservableDiff(oldProps.onAfterWorldMatrixUpdateObservable, newProps.onAfterWorldMatrixUpdateObservable, 'onAfterWorldMatrixUpdateObservable', 'BabylonjsCoreObservable<BabylonjsCoreTransformNode>', changedProps);
    checkVector3Diff(oldProps.position, newProps.position, 'position', 'BabylonjsCoreVector3', changedProps);
    checkPrimitiveDiff(oldProps.preserveParentRotationForBillboard, newProps.preserveParentRotationForBillboard, 'preserveParentRotationForBillboard', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.reIntegrateRotationIntoRotationQuaternion, newProps.reIntegrateRotationIntoRotationQuaternion, 'reIntegrateRotationIntoRotationQuaternion', 'boolean', changedProps);
    checkVector3Diff(oldProps.rotation, newProps.rotation, 'rotation', 'BabylonjsCoreVector3', changedProps); // type: 'BabylonjsCoreQuaternion' property (not coded) BabylonjsCoreTransformNode.rotationQuaternion.

    checkVector3Diff(oldProps.scaling, newProps.scaling, 'scaling', 'BabylonjsCoreVector3', changedProps);
    checkPrimitiveDiff(oldProps.scalingDeterminant, newProps.scalingDeterminant, 'scalingDeterminant', 'number', changedProps);
    checkMethodDiff(oldProps.addRotation, newProps.addRotation, 'addRotation', '(x?: number, y?: number, z?: number) => BabylonjsCoreTransformNode', changedProps);
    checkMethodDiff(oldProps.setAbsolutePosition, newProps.setAbsolutePosition, 'setAbsolutePosition', '(absolutePosition?: BabylonjsCoreVector3) => BabylonjsCoreTransformNode', changedProps);
    checkMethodDiff(oldProps.setDirection, newProps.setDirection, 'setDirection', '(localAxis?: BabylonjsCoreVector3, yawCor?: number, pitchCor?: number, rollCor?: number) => BabylonjsCoreTransformNode', changedProps);
    checkMethodDiff(oldProps.setParent, newProps.setParent, 'setParent', '(node?: BabylonjsCoreNode) => BabylonjsCoreTransformNode', changedProps);
    checkMethodDiff(oldProps.setPivotMatrix, newProps.setPivotMatrix, 'setPivotMatrix', '(matrix?: BabylonjsCoreDeepImmutableObject<BabylonjsCoreMatrix>, postMultiplyPivotMatrix?: boolean) => BabylonjsCoreTransformNode', changedProps);
    checkMethodDiff(oldProps.setPivotPoint, newProps.setPivotPoint, 'setPivotPoint', '(point?: BabylonjsCoreVector3, space?: BabylonjsCoreSpace) => BabylonjsCoreTransformNode', changedProps);
    checkMethodDiff(oldProps.setPositionWithLocalVector, newProps.setPositionWithLocalVector, 'setPositionWithLocalVector', '(vector3?: BabylonjsCoreVector3) => BabylonjsCoreTransformNode', changedProps);
    checkMethodDiff(oldProps.setPreTransformMatrix, newProps.setPreTransformMatrix, 'setPreTransformMatrix', '(matrix?: BabylonjsCoreMatrix) => BabylonjsCoreTransformNode', changedProps);
    checkMethodDiff(oldProps.translate, newProps.translate, 'translate', '(axis?: BabylonjsCoreVector3, distance?: number, space?: BabylonjsCoreSpace) => BabylonjsCoreTransformNode', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberTransformNodePropsHandler;
}();
/**
 * A TransformNode is an object that is not rendered but can be used as a center of transformation. This can decrease memory usage and increase rendering speed compared to using an empty mesh as a parent and is less complicated than using a pivot matrix.
 *
 * This code has been generated
 */


var FiberTransformNode =
/** @class */
function () {
  function FiberTransformNode() {
    this.propsHandlers = [new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberTransformNode.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberTransformNode.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberTransformNode.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "TransformNode",
    "namespace": "@babylonjs/core/Meshes/mesh",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }, {
      "name": "isPure",
      "type": "boolean",
      "optional": true
    }]
  };
  FiberTransformNode.Metadata = {
    "isNode": true,
    "className": "FiberTransformNode"
  };
  return FiberTransformNode;
}();

var FiberAbstractMeshPropsHandler =
/** @class */
function () {
  function FiberAbstractMeshPropsHandler() {}

  FiberAbstractMeshPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = []; // type: 'BabylonjsCoreAbstractActionManager' property (not coded) BabylonjsCoreAbstractMesh.actionManager.

    checkPrimitiveDiff(oldProps.alphaIndex, newProps.alphaIndex, 'alphaIndex', 'number', changedProps);
    checkPrimitiveDiff(oldProps.alwaysSelectAsActiveMesh, newProps.alwaysSelectAsActiveMesh, 'alwaysSelectAsActiveMesh', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.applyFog, newProps.applyFog, 'applyFog', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.checkCollisions, newProps.checkCollisions, 'checkCollisions', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.collisionGroup, newProps.collisionGroup, 'collisionGroup', 'number', changedProps);
    checkPrimitiveDiff(oldProps.collisionMask, newProps.collisionMask, 'collisionMask', 'number', changedProps);
    checkPrimitiveDiff(oldProps.computeBonesUsingShaders, newProps.computeBonesUsingShaders, 'computeBonesUsingShaders', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.cullingStrategy, newProps.cullingStrategy, 'cullingStrategy', 'number', changedProps);
    checkPrimitiveDiff(oldProps.definedFacingForward, newProps.definedFacingForward, 'definedFacingForward', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.doNotSyncBoundingInfo, newProps.doNotSyncBoundingInfo, 'doNotSyncBoundingInfo', 'boolean', changedProps);
    checkColor4Diff(oldProps.edgesColor, newProps.edgesColor, 'edgesColor', 'BabylonjsCoreColor4', changedProps);
    checkPrimitiveDiff(oldProps.edgesWidth, newProps.edgesWidth, 'edgesWidth', 'number', changedProps);
    checkVector3Diff(oldProps.ellipsoid, newProps.ellipsoid, 'ellipsoid', 'BabylonjsCoreVector3', changedProps);
    checkVector3Diff(oldProps.ellipsoidOffset, newProps.ellipsoidOffset, 'ellipsoidOffset', 'BabylonjsCoreVector3', changedProps);
    checkPrimitiveDiff(oldProps.enablePointerMoveEvents, newProps.enablePointerMoveEvents, 'enablePointerMoveEvents', 'boolean', changedProps);
    checkVector3Diff(oldProps.facetDepthSortFrom, newProps.facetDepthSortFrom, 'facetDepthSortFrom', 'BabylonjsCoreVector3', changedProps);
    checkPrimitiveDiff(oldProps.hasVertexAlpha, newProps.hasVertexAlpha, 'hasVertexAlpha', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.isBlocker, newProps.isBlocker, 'isBlocker', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.isPickable, newProps.isPickable, 'isPickable', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.isVisible, newProps.isVisible, 'isVisible', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.layerMask, newProps.layerMask, 'layerMask', 'number', changedProps); // type: 'BabylonjsCoreMaterial' property (not coded) BabylonjsCoreAbstractMesh.material.

    checkPrimitiveDiff(oldProps.mustDepthSortFacets, newProps.mustDepthSortFacets, 'mustDepthSortFacets', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.numBoneInfluencers, newProps.numBoneInfluencers, 'numBoneInfluencers', 'number', changedProps);
    checkLambdaDiff(oldProps.onCollide, newProps.onCollide, 'onCollide', '() => void', changedProps);
    checkObservableDiff(oldProps.onCollideObservable, newProps.onCollideObservable, 'onCollideObservable', 'BabylonjsCoreObservable<BabylonjsCoreAbstractMesh>', changedProps);
    checkLambdaDiff(oldProps.onCollisionPositionChange, newProps.onCollisionPositionChange, 'onCollisionPositionChange', '() => void', changedProps);
    checkObservableDiff(oldProps.onCollisionPositionChangeObservable, newProps.onCollisionPositionChangeObservable, 'onCollisionPositionChangeObservable', 'BabylonjsCoreObservable<BabylonjsCoreVector3>', changedProps);
    checkObservableDiff(oldProps.onMaterialChangedObservable, newProps.onMaterialChangedObservable, 'onMaterialChangedObservable', 'BabylonjsCoreObservable<BabylonjsCoreAbstractMesh>', changedProps);
    checkObservableDiff(oldProps.onRebuildObservable, newProps.onRebuildObservable, 'onRebuildObservable', 'BabylonjsCoreObservable<BabylonjsCoreAbstractMesh>', changedProps);
    checkColor3Diff(oldProps.outlineColor, newProps.outlineColor, 'outlineColor', 'BabylonjsCoreColor3', changedProps);
    checkPrimitiveDiff(oldProps.outlineWidth, newProps.outlineWidth, 'outlineWidth', 'number', changedProps);
    checkPrimitiveDiff(oldProps.overlayAlpha, newProps.overlayAlpha, 'overlayAlpha', 'number', changedProps);
    checkColor3Diff(oldProps.overlayColor, newProps.overlayColor, 'overlayColor', 'BabylonjsCoreColor3', changedProps);
    checkPrimitiveDiff(oldProps.partitioningBBoxRatio, newProps.partitioningBBoxRatio, 'partitioningBBoxRatio', 'number', changedProps);
    checkPrimitiveDiff(oldProps.partitioningSubdivisions, newProps.partitioningSubdivisions, 'partitioningSubdivisions', 'number', changedProps);
    checkPrimitiveDiff(oldProps.receiveShadows, newProps.receiveShadows, 'receiveShadows', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.renderingGroupId, newProps.renderingGroupId, 'renderingGroupId', 'number', changedProps);
    checkVector3Diff(oldProps.scaling, newProps.scaling, 'scaling', 'BabylonjsCoreVector3', changedProps);
    checkPrimitiveDiff(oldProps.showSubMeshesBoundingBox, newProps.showSubMeshesBoundingBox, 'showSubMeshesBoundingBox', 'boolean', changedProps); // type: 'BabylonjsCoreSkeleton' property (not coded) BabylonjsCoreAbstractMesh.skeleton.
    // type: 'BabylonjsCoreSubMesh[]' property (not coded) BabylonjsCoreAbstractMesh.subMeshes.

    checkPrimitiveDiff(oldProps.useOctreeForCollisions, newProps.useOctreeForCollisions, 'useOctreeForCollisions', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useOctreeForPicking, newProps.useOctreeForPicking, 'useOctreeForPicking', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useOctreeForRenderingSelection, newProps.useOctreeForRenderingSelection, 'useOctreeForRenderingSelection', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useVertexColors, newProps.useVertexColors, 'useVertexColors', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.visibility, newProps.visibility, 'visibility', 'number', changedProps);
    checkMethodDiff(oldProps.addChild, newProps.addChild, 'addChild', '(mesh?: BabylonjsCoreAbstractMesh) => BabylonjsCoreAbstractMesh', changedProps);
    checkMethodDiff(oldProps.setBoundingInfo, newProps.setBoundingInfo, 'setBoundingInfo', '(boundingInfo?: BabylonjsCoreBoundingInfo) => BabylonjsCoreAbstractMesh', changedProps);
    checkMethodDiff(oldProps.setIndices, newProps.setIndices, 'setIndices', '(indices?: BabylonjsCoreIndicesArray, totalVertices?: number) => BabylonjsCoreAbstractMesh', changedProps);
    checkMethodDiff(oldProps.setVerticesData, newProps.setVerticesData, 'setVerticesData', '(kind?: string, data?: BabylonjsCoreFloatArray, updatable?: boolean, stride?: number) => BabylonjsCoreAbstractMesh', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberAbstractMeshPropsHandler;
}();
/**
 * Class used to store all common mesh properties
 *
 * This code has been generated
 */


var FiberAbstractMesh =
/** @class */
function () {
  function FiberAbstractMesh() {
    this.propsHandlers = [new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberAbstractMesh.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberAbstractMesh.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberAbstractMesh.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "AbstractMesh",
    "namespace": "@babylonjs/core/Meshes/mesh",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberAbstractMesh.Metadata = {
    "isNode": true,
    "className": "FiberAbstractMesh"
  };
  return FiberAbstractMesh;
}();

var FiberMeshPropsHandler =
/** @class */
function () {
  function FiberMeshPropsHandler() {}

  FiberMeshPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.delayLoadingFile, newProps.delayLoadingFile, 'delayLoadingFile', 'string', changedProps);
    checkPrimitiveDiff(oldProps.delayLoadState, newProps.delayLoadState, 'delayLoadState', 'number', changedProps); // type: 'BabylonjsCoreInstancedMesh[]' property (not coded) BabylonjsCoreMesh.instances.

    checkPrimitiveDiff(oldProps.isUnIndexed, newProps.isUnIndexed, 'isUnIndexed', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.manualUpdateOfWorldMatrixInstancedBuffer, newProps.manualUpdateOfWorldMatrixInstancedBuffer, 'manualUpdateOfWorldMatrixInstancedBuffer', 'boolean', changedProps); // type: 'BabylonjsCoreMorphTargetManager' property (not coded) BabylonjsCoreMesh.morphTargetManager.
    // type: 'any' property (not coded) BabylonjsCoreMesh.normalizeSkinFourWeights.
    // type: 'any' property (not coded) BabylonjsCoreMesh.normalizeSkinWeightsAndExtra.

    checkLambdaDiff(oldProps.onBeforeDraw, newProps.onBeforeDraw, 'onBeforeDraw', '() => void', changedProps);
    checkLambdaDiff(oldProps.onLODLevelSelection, newProps.onLODLevelSelection, 'onLODLevelSelection', '(distance: number, mesh: BabylonjsCoreMesh, selectedLevel: BabylonjsCoreMesh) => void', changedProps);
    checkPrimitiveDiff(oldProps.overrideMaterialSideOrientation, newProps.overrideMaterialSideOrientation, 'overrideMaterialSideOrientation', 'number', changedProps);
    checkPrimitiveDiff(oldProps.overridenInstanceCount, newProps.overridenInstanceCount, 'overridenInstanceCount', 'number', changedProps);
    checkMethodDiff(oldProps.addInstance, newProps.addInstance, 'addInstance', '(instance?: BabylonjsCoreInstancedMesh) => void', changedProps);
    checkMethodDiff(oldProps.addLODLevel, newProps.addLODLevel, 'addLODLevel', '(distance?: number, mesh?: BabylonjsCoreMesh) => BabylonjsCoreMesh', changedProps);
    checkMethodDiff(oldProps.setIndices, newProps.setIndices, 'setIndices', '(indices?: BabylonjsCoreIndicesArray, totalVertices?: number, updatable?: boolean) => BabylonjsCoreAbstractMesh', changedProps);
    checkMethodDiff(oldProps.setMaterialByID, newProps.setMaterialByID, 'setMaterialByID', '(id?: string) => BabylonjsCoreMesh', changedProps);
    checkMethodDiff(oldProps.setVerticesBuffer, newProps.setVerticesBuffer, 'setVerticesBuffer', '(buffer?: BabylonjsCoreVertexBuffer) => BabylonjsCoreMesh', changedProps);
    checkMethodDiff(oldProps.setVerticesData, newProps.setVerticesData, 'setVerticesData', '(kind?: string, data?: BabylonjsCoreFloatArray, updatable?: boolean, stride?: number) => BabylonjsCoreAbstractMesh', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberMeshPropsHandler;
}();
/**
 * Class used to represent renderable models
 *
 * This code has been generated
 */


var FiberMesh =
/** @class */
function () {
  function FiberMesh() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberMesh.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberMesh.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberMesh.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "Mesh",
    "namespace": "@babylonjs/core/Meshes/mesh",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }, {
      "name": "parent",
      "type": "BabylonjsCoreNode",
      "optional": true
    }, {
      "name": "source",
      "type": "BabylonjsCoreMesh",
      "optional": true
    }, {
      "name": "doNotCloneChildren",
      "type": "boolean",
      "optional": true
    }, {
      "name": "clonePhysicsImpostor",
      "type": "boolean",
      "optional": true
    }]
  };
  FiberMesh.Metadata = {
    "isNode": true,
    "className": "FiberMesh"
  };
  return FiberMesh;
}();

var FiberCameraPropsHandler =
/** @class */
function () {
  function FiberCameraPropsHandler() {}

  FiberCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.cameraRigMode, newProps.cameraRigMode, 'cameraRigMode', 'number', changedProps); // type: 'BabylonjsCoreRenderTargetTexture[]' property (not coded) BabylonjsCoreCamera.customRenderTargets.

    checkPrimitiveDiff(oldProps.fov, newProps.fov, 'fov', 'number', changedProps);
    checkPrimitiveDiff(oldProps.fovMode, newProps.fovMode, 'fovMode', 'number', changedProps);
    checkPrimitiveDiff(oldProps.inertia, newProps.inertia, 'inertia', 'number', changedProps); // type: 'BabylonjsCoreCameraInputsManager<BabylonjsCoreCamera>' property (not coded) BabylonjsCoreCamera.inputs.

    checkPrimitiveDiff(oldProps.interaxialDistance, newProps.interaxialDistance, 'interaxialDistance', 'number', changedProps);
    checkPrimitiveDiff(oldProps.isIntermediate, newProps.isIntermediate, 'isIntermediate', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.isRigCamera, newProps.isRigCamera, 'isRigCamera', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.isStereoscopicSideBySide, newProps.isStereoscopicSideBySide, 'isStereoscopicSideBySide', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.layerMask, newProps.layerMask, 'layerMask', 'number', changedProps);
    checkPrimitiveDiff(oldProps.maxZ, newProps.maxZ, 'maxZ', 'number', changedProps);
    checkPrimitiveDiff(oldProps.minZ, newProps.minZ, 'minZ', 'number', changedProps);
    checkPrimitiveDiff(oldProps.mode, newProps.mode, 'mode', 'number', changedProps);
    checkObservableDiff(oldProps.onAfterCheckInputsObservable, newProps.onAfterCheckInputsObservable, 'onAfterCheckInputsObservable', 'BabylonjsCoreObservable<BabylonjsCoreCamera>', changedProps);
    checkObservableDiff(oldProps.onProjectionMatrixChangedObservable, newProps.onProjectionMatrixChangedObservable, 'onProjectionMatrixChangedObservable', 'BabylonjsCoreObservable<BabylonjsCoreCamera>', changedProps);
    checkObservableDiff(oldProps.onRestoreStateObservable, newProps.onRestoreStateObservable, 'onRestoreStateObservable', 'BabylonjsCoreObservable<BabylonjsCoreCamera>', changedProps);
    checkObservableDiff(oldProps.onViewMatrixChangedObservable, newProps.onViewMatrixChangedObservable, 'onViewMatrixChangedObservable', 'BabylonjsCoreObservable<BabylonjsCoreCamera>', changedProps);
    checkPrimitiveDiff(oldProps.orthoBottom, newProps.orthoBottom, 'orthoBottom', 'number', changedProps);
    checkPrimitiveDiff(oldProps.orthoLeft, newProps.orthoLeft, 'orthoLeft', 'number', changedProps);
    checkPrimitiveDiff(oldProps.orthoRight, newProps.orthoRight, 'orthoRight', 'number', changedProps);
    checkPrimitiveDiff(oldProps.orthoTop, newProps.orthoTop, 'orthoTop', 'number', changedProps); // type: 'BabylonjsCoreRenderTargetTexture' property (not coded) BabylonjsCoreCamera.outputRenderTarget.

    checkVector3Diff(oldProps.position, newProps.position, 'position', 'BabylonjsCoreVector3', changedProps); // type: 'BabylonjsCoreCamera' property (not coded) BabylonjsCoreCamera.rigParent.

    checkVector3Diff(oldProps.upVector, newProps.upVector, 'upVector', 'BabylonjsCoreVector3', changedProps); // type: 'BabylonjsCoreViewport' property (not coded) BabylonjsCoreCamera.viewport.

    checkMethodDiff(oldProps.setCameraRigMode, newProps.setCameraRigMode, 'setCameraRigMode', '(mode?: number, rigParams?: any) => void', changedProps);
    checkMethodDiff(oldProps.setCameraRigParameter, newProps.setCameraRigParameter, 'setCameraRigParameter', '(name?: string, value?: any) => void', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberCameraPropsHandler;
}();
/**
 * This is the base class of all the camera used in the application.
 *
 * This code has been generated
 */


var FiberCamera =
/** @class */
function () {
  function FiberCamera() {
    this.isTargetable = false;
    this.propsHandlers = [new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "Camera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "position",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "setActiveOnSceneIfNoneActive",
      "type": "boolean",
      "optional": true
    }]
  };
  FiberCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberCamera"
  };
  return FiberCamera;
}();

var FiberTargetCameraPropsHandler =
/** @class */
function () {
  function FiberTargetCameraPropsHandler() {}

  FiberTargetCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkVector3Diff(oldProps.cameraDirection, newProps.cameraDirection, 'cameraDirection', 'BabylonjsCoreVector3', changedProps); // type: 'BabylonjsCoreVector2' property (not coded) BabylonjsCoreTargetCamera.cameraRotation.
    // type: 'any' property (not coded) BabylonjsCoreTargetCamera.lockedTarget.

    checkPrimitiveDiff(oldProps.noRotationConstraint, newProps.noRotationConstraint, 'noRotationConstraint', 'boolean', changedProps);
    checkVector3Diff(oldProps.rotation, newProps.rotation, 'rotation', 'BabylonjsCoreVector3', changedProps); // type: 'BabylonjsCoreQuaternion' property (not coded) BabylonjsCoreTargetCamera.rotationQuaternion.

    checkPrimitiveDiff(oldProps.speed, newProps.speed, 'speed', 'number', changedProps);
    checkPrimitiveDiff(oldProps.updateUpVectorFromRotation, newProps.updateUpVectorFromRotation, 'updateUpVectorFromRotation', 'boolean', changedProps);
    checkMethodDiff(oldProps.setTarget, newProps.setTarget, 'setTarget', '(target?: BabylonjsCoreVector3) => void', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberTargetCameraPropsHandler;
}();
/**
 * A target camera takes a mesh or position as a target and continues to look at it while it moves.
 * This is the base of the follow, arc rotate cameras and Free camera
 *
 * This code has been generated
 */


var FiberTargetCamera =
/** @class */
function () {
  function FiberTargetCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberTargetCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberTargetCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberTargetCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "TargetCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "position",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "setActiveOnSceneIfNoneActive",
      "type": "boolean",
      "optional": true
    }]
  };
  FiberTargetCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberTargetCamera"
  };
  return FiberTargetCamera;
}();

var FiberFreeCameraPropsHandler =
/** @class */
function () {
  function FiberFreeCameraPropsHandler() {}

  FiberFreeCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.angularSensibility, newProps.angularSensibility, 'angularSensibility', 'number', changedProps);
    checkPrimitiveDiff(oldProps.applyGravity, newProps.applyGravity, 'applyGravity', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.checkCollisions, newProps.checkCollisions, 'checkCollisions', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.collisionMask, newProps.collisionMask, 'collisionMask', 'number', changedProps);
    checkVector3Diff(oldProps.ellipsoid, newProps.ellipsoid, 'ellipsoid', 'BabylonjsCoreVector3', changedProps);
    checkVector3Diff(oldProps.ellipsoidOffset, newProps.ellipsoidOffset, 'ellipsoidOffset', 'BabylonjsCoreVector3', changedProps); // type: 'BabylonjsCoreFreeCameraInputsManager' property (not coded) BabylonjsCoreFreeCamera.inputs.

    checkNumericArrayDiff(oldProps.keysDown, newProps.keysDown, 'keysDown', 'number[]', changedProps);
    checkNumericArrayDiff(oldProps.keysLeft, newProps.keysLeft, 'keysLeft', 'number[]', changedProps);
    checkNumericArrayDiff(oldProps.keysRight, newProps.keysRight, 'keysRight', 'number[]', changedProps);
    checkNumericArrayDiff(oldProps.keysUp, newProps.keysUp, 'keysUp', 'number[]', changedProps);
    checkLambdaDiff(oldProps.onCollide, newProps.onCollide, 'onCollide', '(collidedMesh: BabylonjsCoreAbstractMesh) => void', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberFreeCameraPropsHandler;
}();
/**
 * This represents a free type of camera. It can be useful in First Person Shooter game for instance.
 * Please consider using the new UniversalCamera instead as it adds more functionality like the gamepad.
 *
 * This code has been generated
 */


var FiberFreeCamera =
/** @class */
function () {
  function FiberFreeCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberFreeCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberFreeCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberFreeCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "FreeCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "position",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "setActiveOnSceneIfNoneActive",
      "type": "boolean",
      "optional": true
    }]
  };
  FiberFreeCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberFreeCamera"
  };
  return FiberFreeCamera;
}();

var FiberTouchCameraPropsHandler =
/** @class */
function () {
  function FiberTouchCameraPropsHandler() {}

  FiberTouchCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.touchAngularSensibility, newProps.touchAngularSensibility, 'touchAngularSensibility', 'number', changedProps);
    checkPrimitiveDiff(oldProps.touchMoveSensibility, newProps.touchMoveSensibility, 'touchMoveSensibility', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberTouchCameraPropsHandler;
}();
/**
 * This represents a FPS type of camera controlled by touch.
 * This is like a universal camera minus the Gamepad controls.
 *
 * This code has been generated
 */


var FiberTouchCamera =
/** @class */
function () {
  function FiberTouchCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberTouchCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberTouchCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberTouchCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberTouchCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "TouchCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "position",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberTouchCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberTouchCamera"
  };
  return FiberTouchCamera;
}();

var FiberUniversalCameraPropsHandler =
/** @class */
function () {
  function FiberUniversalCameraPropsHandler() {}

  FiberUniversalCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.gamepadAngularSensibility, newProps.gamepadAngularSensibility, 'gamepadAngularSensibility', 'number', changedProps);
    checkPrimitiveDiff(oldProps.gamepadMoveSensibility, newProps.gamepadMoveSensibility, 'gamepadMoveSensibility', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberUniversalCameraPropsHandler;
}();
/**
 * The Universal Camera is the one to choose for first person shooter type games, and works with all the keyboard, mouse, touch and gamepads. This replaces the earlier Free Camera,
 * which still works and will still be found in many Playgrounds.
 *
 * This code has been generated
 */


var FiberUniversalCamera =
/** @class */
function () {
  function FiberUniversalCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberUniversalCameraPropsHandler(), new FiberTouchCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberUniversalCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberUniversalCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberUniversalCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "UniversalCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "position",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberUniversalCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberUniversalCamera"
  };
  return FiberUniversalCamera;
}();

var FiberGamepadCameraPropsHandler =
/** @class */
function () {
  function FiberGamepadCameraPropsHandler() {}

  FiberGamepadCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    return null; // no props to check
  };

  return FiberGamepadCameraPropsHandler;
}();
/**
 * This represents a FPS type of camera. This is only here for back compat purpose.
 * Please use the UniversalCamera instead as both are identical.
 *
 * This code has been generated
 */


var FiberGamepadCamera =
/** @class */
function () {
  function FiberGamepadCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberGamepadCameraPropsHandler(), new FiberUniversalCameraPropsHandler(), new FiberTouchCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberGamepadCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberGamepadCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberGamepadCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "GamepadCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "position",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberGamepadCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberGamepadCamera"
  };
  return FiberGamepadCamera;
}();

var FiberAnaglyphGamepadCameraPropsHandler =
/** @class */
function () {
  function FiberAnaglyphGamepadCameraPropsHandler() {}

  FiberAnaglyphGamepadCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    return null; // no props to check
  };

  return FiberAnaglyphGamepadCameraPropsHandler;
}();
/**
 * Camera used to simulate anaglyphic rendering (based on GamepadCamera)
 *
 * This code has been generated
 */


var FiberAnaglyphGamepadCamera =
/** @class */
function () {
  function FiberAnaglyphGamepadCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberAnaglyphGamepadCameraPropsHandler(), new FiberGamepadCameraPropsHandler(), new FiberUniversalCameraPropsHandler(), new FiberTouchCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberAnaglyphGamepadCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberAnaglyphGamepadCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberAnaglyphGamepadCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "AnaglyphGamepadCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "position",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "interaxialDistance",
      "type": "number",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberAnaglyphGamepadCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberAnaglyphGamepadCamera"
  };
  return FiberAnaglyphGamepadCamera;
}();

var FiberStereoscopicGamepadCameraPropsHandler =
/** @class */
function () {
  function FiberStereoscopicGamepadCameraPropsHandler() {}

  FiberStereoscopicGamepadCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    return null; // no props to check
  };

  return FiberStereoscopicGamepadCameraPropsHandler;
}();
/**
 * Camera used to simulate stereoscopic rendering (based on GamepadCamera)
 *
 * This code has been generated
 */


var FiberStereoscopicGamepadCamera =
/** @class */
function () {
  function FiberStereoscopicGamepadCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberStereoscopicGamepadCameraPropsHandler(), new FiberGamepadCameraPropsHandler(), new FiberUniversalCameraPropsHandler(), new FiberTouchCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberStereoscopicGamepadCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberStereoscopicGamepadCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberStereoscopicGamepadCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "StereoscopicGamepadCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "position",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "interaxialDistance",
      "type": "number",
      "optional": false
    }, {
      "name": "isStereoscopicSideBySide",
      "type": "boolean",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberStereoscopicGamepadCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberStereoscopicGamepadCamera"
  };
  return FiberStereoscopicGamepadCamera;
}();

var FiberAnaglyphUniversalCameraPropsHandler =
/** @class */
function () {
  function FiberAnaglyphUniversalCameraPropsHandler() {}

  FiberAnaglyphUniversalCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    return null; // no props to check
  };

  return FiberAnaglyphUniversalCameraPropsHandler;
}();
/**
 * Camera used to simulate anaglyphic rendering (based on UniversalCamera)
 *
 * This code has been generated
 */


var FiberAnaglyphUniversalCamera =
/** @class */
function () {
  function FiberAnaglyphUniversalCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberAnaglyphUniversalCameraPropsHandler(), new FiberUniversalCameraPropsHandler(), new FiberTouchCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberAnaglyphUniversalCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberAnaglyphUniversalCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberAnaglyphUniversalCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "AnaglyphUniversalCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "position",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "interaxialDistance",
      "type": "number",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberAnaglyphUniversalCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberAnaglyphUniversalCamera"
  };
  return FiberAnaglyphUniversalCamera;
}();

var FiberStereoscopicUniversalCameraPropsHandler =
/** @class */
function () {
  function FiberStereoscopicUniversalCameraPropsHandler() {}

  FiberStereoscopicUniversalCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    return null; // no props to check
  };

  return FiberStereoscopicUniversalCameraPropsHandler;
}();
/**
 * Camera used to simulate stereoscopic rendering (based on UniversalCamera)
 *
 * This code has been generated
 */


var FiberStereoscopicUniversalCamera =
/** @class */
function () {
  function FiberStereoscopicUniversalCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberStereoscopicUniversalCameraPropsHandler(), new FiberUniversalCameraPropsHandler(), new FiberTouchCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberStereoscopicUniversalCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberStereoscopicUniversalCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberStereoscopicUniversalCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "StereoscopicUniversalCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "position",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "interaxialDistance",
      "type": "number",
      "optional": false
    }, {
      "name": "isStereoscopicSideBySide",
      "type": "boolean",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberStereoscopicUniversalCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberStereoscopicUniversalCamera"
  };
  return FiberStereoscopicUniversalCamera;
}();

var FiberDeviceOrientationCameraPropsHandler =
/** @class */
function () {
  function FiberDeviceOrientationCameraPropsHandler() {}

  FiberDeviceOrientationCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.disablePointerInputWhenUsingDeviceOrientation, newProps.disablePointerInputWhenUsingDeviceOrientation, 'disablePointerInputWhenUsingDeviceOrientation', 'boolean', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberDeviceOrientationCameraPropsHandler;
}();
/**
 * This is a camera specifically designed to react to device orientation events such as a modern mobile device
 * being tilted forward or back and left or right.
 *
 * This code has been generated
 */


var FiberDeviceOrientationCamera =
/** @class */
function () {
  function FiberDeviceOrientationCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberDeviceOrientationCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberDeviceOrientationCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberDeviceOrientationCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberDeviceOrientationCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "DeviceOrientationCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "position",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberDeviceOrientationCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberDeviceOrientationCamera"
  };
  return FiberDeviceOrientationCamera;
}();

var FiberVRDeviceOrientationFreeCameraPropsHandler =
/** @class */
function () {
  function FiberVRDeviceOrientationFreeCameraPropsHandler() {}

  FiberVRDeviceOrientationFreeCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    return null; // no props to check
  };

  return FiberVRDeviceOrientationFreeCameraPropsHandler;
}();
/**
 * Camera used to simulate VR rendering (based on FreeCamera)
 *
 * This code has been generated
 */


var FiberVRDeviceOrientationFreeCamera =
/** @class */
function () {
  function FiberVRDeviceOrientationFreeCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberVRDeviceOrientationFreeCameraPropsHandler(), new FiberDeviceOrientationCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberVRDeviceOrientationFreeCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberVRDeviceOrientationFreeCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberVRDeviceOrientationFreeCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "VRDeviceOrientationFreeCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "position",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "compensateDistortion",
      "type": "boolean",
      "optional": true
    }, {
      "name": "vrCameraMetrics",
      "type": "BabylonjsCoreVRCameraMetrics",
      "optional": true
    }]
  };
  FiberVRDeviceOrientationFreeCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberVRDeviceOrientationFreeCamera"
  };
  return FiberVRDeviceOrientationFreeCamera;
}();

var FiberVRDeviceOrientationGamepadCameraPropsHandler =
/** @class */
function () {
  function FiberVRDeviceOrientationGamepadCameraPropsHandler() {}

  FiberVRDeviceOrientationGamepadCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    return null; // no props to check
  };

  return FiberVRDeviceOrientationGamepadCameraPropsHandler;
}();
/**
 * Camera used to simulate VR rendering (based on VRDeviceOrientationFreeCamera)
 *
 * This code has been generated
 */


var FiberVRDeviceOrientationGamepadCamera =
/** @class */
function () {
  function FiberVRDeviceOrientationGamepadCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberVRDeviceOrientationGamepadCameraPropsHandler(), new FiberVRDeviceOrientationFreeCameraPropsHandler(), new FiberDeviceOrientationCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberVRDeviceOrientationGamepadCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberVRDeviceOrientationGamepadCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberVRDeviceOrientationGamepadCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "VRDeviceOrientationGamepadCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "position",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "compensateDistortion",
      "type": "boolean",
      "optional": true
    }, {
      "name": "vrCameraMetrics",
      "type": "BabylonjsCoreVRCameraMetrics",
      "optional": true
    }]
  };
  FiberVRDeviceOrientationGamepadCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberVRDeviceOrientationGamepadCamera"
  };
  return FiberVRDeviceOrientationGamepadCamera;
}();

var FiberAnaglyphFreeCameraPropsHandler =
/** @class */
function () {
  function FiberAnaglyphFreeCameraPropsHandler() {}

  FiberAnaglyphFreeCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    return null; // no props to check
  };

  return FiberAnaglyphFreeCameraPropsHandler;
}();
/**
 * Camera used to simulate anaglyphic rendering (based on FreeCamera)
 *
 * This code has been generated
 */


var FiberAnaglyphFreeCamera =
/** @class */
function () {
  function FiberAnaglyphFreeCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberAnaglyphFreeCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberAnaglyphFreeCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberAnaglyphFreeCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberAnaglyphFreeCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "AnaglyphFreeCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "position",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "interaxialDistance",
      "type": "number",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberAnaglyphFreeCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberAnaglyphFreeCamera"
  };
  return FiberAnaglyphFreeCamera;
}();

var FiberStereoscopicFreeCameraPropsHandler =
/** @class */
function () {
  function FiberStereoscopicFreeCameraPropsHandler() {}

  FiberStereoscopicFreeCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    return null; // no props to check
  };

  return FiberStereoscopicFreeCameraPropsHandler;
}();
/**
 * Camera used to simulate stereoscopic rendering (based on FreeCamera)
 *
 * This code has been generated
 */


var FiberStereoscopicFreeCamera =
/** @class */
function () {
  function FiberStereoscopicFreeCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberStereoscopicFreeCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberStereoscopicFreeCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberStereoscopicFreeCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberStereoscopicFreeCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "StereoscopicFreeCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "position",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "interaxialDistance",
      "type": "number",
      "optional": false
    }, {
      "name": "isStereoscopicSideBySide",
      "type": "boolean",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberStereoscopicFreeCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberStereoscopicFreeCamera"
  };
  return FiberStereoscopicFreeCamera;
}();

var FiberVirtualJoysticksCameraPropsHandler =
/** @class */
function () {
  function FiberVirtualJoysticksCameraPropsHandler() {}

  FiberVirtualJoysticksCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    return null; // no props to check
  };

  return FiberVirtualJoysticksCameraPropsHandler;
}();
/**
 * This represents a free type of camera. It can be useful in First Person Shooter game for instance.
 * It is identical to the Free Camera and simply adds by default a virtual joystick.
 * Virtual Joysticks are on-screen 2D graphics that are used to control the camera or other scene items.
 *
 * This code has been generated
 */


var FiberVirtualJoysticksCamera =
/** @class */
function () {
  function FiberVirtualJoysticksCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberVirtualJoysticksCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberVirtualJoysticksCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberVirtualJoysticksCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberVirtualJoysticksCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "VirtualJoysticksCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "position",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberVirtualJoysticksCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberVirtualJoysticksCamera"
  };
  return FiberVirtualJoysticksCamera;
}();

var FiberWebVRFreeCameraPropsHandler =
/** @class */
function () {
  function FiberWebVRFreeCameraPropsHandler() {}

  FiberWebVRFreeCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = []; // type: 'BabylonjsCoreWebVRController[]' property (not coded) BabylonjsCoreWebVRFreeCamera.controllers.

    checkVector3Diff(oldProps.devicePosition, newProps.devicePosition, 'devicePosition', 'BabylonjsCoreVector3', changedProps); // type: 'BabylonjsCoreQuaternion' property (not coded) BabylonjsCoreWebVRFreeCamera.deviceRotationQuaternion.

    checkPrimitiveDiff(oldProps.deviceScaleFactor, newProps.deviceScaleFactor, 'deviceScaleFactor', 'number', changedProps);
    checkObservableDiff(oldProps.onControllerMeshLoadedObservable, newProps.onControllerMeshLoadedObservable, 'onControllerMeshLoadedObservable', 'BabylonjsCoreObservable<BabylonjsCoreWebVRController>', changedProps);
    checkObservableDiff(oldProps.onControllersAttachedObservable, newProps.onControllersAttachedObservable, 'onControllersAttachedObservable', 'BabylonjsCoreObservable<BabylonjsCoreWebVRController[]>', changedProps);
    checkObservableDiff(oldProps.onPoseUpdatedFromDeviceObservable, newProps.onPoseUpdatedFromDeviceObservable, 'onPoseUpdatedFromDeviceObservable', 'BabylonjsCoreObservable<any>', changedProps); // type: 'BabylonjsCoreDevicePose' property (not coded) BabylonjsCoreWebVRFreeCamera.rawPose.

    checkPrimitiveDiff(oldProps.rigParenting, newProps.rigParenting, 'rigParenting', 'boolean', changedProps); // type: 'any' property (not coded) BabylonjsCoreWebVRFreeCamera.updateCacheCalled.
    // type: 'any' property (not coded) BabylonjsCoreWebVRFreeCamera.webVROptions.

    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberWebVRFreeCameraPropsHandler;
}();
/**
 * This represents a WebVR camera.
 * The WebVR camera is Babylon's simple interface to interaction with Windows Mixed Reality, HTC Vive and Oculus Rift.
 *
 * This code has been generated
 */


var FiberWebVRFreeCamera =
/** @class */
function () {
  function FiberWebVRFreeCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberWebVRFreeCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberWebVRFreeCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberWebVRFreeCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberWebVRFreeCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "WebVRFreeCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "position",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "webVROptions",
      "type": "BabylonjsCoreWebVROptions",
      "optional": true
    }]
  };
  FiberWebVRFreeCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberWebVRFreeCamera"
  };
  return FiberWebVRFreeCamera;
}();

var FiberWebXRCameraPropsHandler =
/** @class */
function () {
  function FiberWebXRCameraPropsHandler() {}

  FiberWebXRCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.compensateOnFirstFrame, newProps.compensateOnFirstFrame, 'compensateOnFirstFrame', 'boolean', changedProps);
    checkMethodDiff(oldProps.setTransformationFromNonVRCamera, newProps.setTransformationFromNonVRCamera, 'setTransformationFromNonVRCamera', '(otherCamera?: BabylonjsCoreCamera, resetToBaseReferenceSpace?: boolean) => void', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberWebXRCameraPropsHandler;
}();
/**
 * WebXR Camera which holds the views for the xrSession
 *
 * This code has been generated
 */


var FiberWebXRCamera =
/** @class */
function () {
  function FiberWebXRCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberWebXRCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberWebXRCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberWebXRCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberWebXRCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "WebXRCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "_xrSessionManager",
      "type": "BabylonjsCoreWebXRSessionManager",
      "optional": false
    }]
  };
  FiberWebXRCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberWebXRCamera"
  };
  return FiberWebXRCamera;
}();

var FiberArcRotateCameraPropsHandler =
/** @class */
function () {
  function FiberArcRotateCameraPropsHandler() {}

  FiberArcRotateCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.allowUpsideDown, newProps.allowUpsideDown, 'allowUpsideDown', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.alpha, newProps.alpha, 'alpha', 'number', changedProps);
    checkPrimitiveDiff(oldProps.angularSensibilityX, newProps.angularSensibilityX, 'angularSensibilityX', 'number', changedProps);
    checkPrimitiveDiff(oldProps.angularSensibilityY, newProps.angularSensibilityY, 'angularSensibilityY', 'number', changedProps);
    checkPrimitiveDiff(oldProps.beta, newProps.beta, 'beta', 'number', changedProps);
    checkPrimitiveDiff(oldProps.checkCollisions, newProps.checkCollisions, 'checkCollisions', 'boolean', changedProps);
    checkVector3Diff(oldProps.collisionRadius, newProps.collisionRadius, 'collisionRadius', 'BabylonjsCoreVector3', changedProps);
    checkPrimitiveDiff(oldProps.inertialAlphaOffset, newProps.inertialAlphaOffset, 'inertialAlphaOffset', 'number', changedProps);
    checkPrimitiveDiff(oldProps.inertialBetaOffset, newProps.inertialBetaOffset, 'inertialBetaOffset', 'number', changedProps);
    checkPrimitiveDiff(oldProps.inertialPanningX, newProps.inertialPanningX, 'inertialPanningX', 'number', changedProps);
    checkPrimitiveDiff(oldProps.inertialPanningY, newProps.inertialPanningY, 'inertialPanningY', 'number', changedProps);
    checkPrimitiveDiff(oldProps.inertialRadiusOffset, newProps.inertialRadiusOffset, 'inertialRadiusOffset', 'number', changedProps); // type: 'BabylonjsCoreArcRotateCameraInputsManager' property (not coded) BabylonjsCoreArcRotateCamera.inputs.

    checkNumericArrayDiff(oldProps.keysDown, newProps.keysDown, 'keysDown', 'number[]', changedProps);
    checkNumericArrayDiff(oldProps.keysLeft, newProps.keysLeft, 'keysLeft', 'number[]', changedProps);
    checkNumericArrayDiff(oldProps.keysRight, newProps.keysRight, 'keysRight', 'number[]', changedProps);
    checkNumericArrayDiff(oldProps.keysUp, newProps.keysUp, 'keysUp', 'number[]', changedProps);
    checkPrimitiveDiff(oldProps.lowerAlphaLimit, newProps.lowerAlphaLimit, 'lowerAlphaLimit', 'number', changedProps);
    checkPrimitiveDiff(oldProps.lowerBetaLimit, newProps.lowerBetaLimit, 'lowerBetaLimit', 'number', changedProps);
    checkPrimitiveDiff(oldProps.lowerRadiusLimit, newProps.lowerRadiusLimit, 'lowerRadiusLimit', 'number', changedProps);
    checkLambdaDiff(oldProps.onCollide, newProps.onCollide, 'onCollide', '(collidedMesh: BabylonjsCoreAbstractMesh) => void', changedProps);
    checkObservableDiff(oldProps.onMeshTargetChangedObservable, newProps.onMeshTargetChangedObservable, 'onMeshTargetChangedObservable', 'BabylonjsCoreObservable<BabylonjsCoreAbstractMesh>', changedProps);
    checkVector3Diff(oldProps.panningAxis, newProps.panningAxis, 'panningAxis', 'BabylonjsCoreVector3', changedProps);
    checkPrimitiveDiff(oldProps.panningDistanceLimit, newProps.panningDistanceLimit, 'panningDistanceLimit', 'number', changedProps);
    checkPrimitiveDiff(oldProps.panningInertia, newProps.panningInertia, 'panningInertia', 'number', changedProps);
    checkVector3Diff(oldProps.panningOriginTarget, newProps.panningOriginTarget, 'panningOriginTarget', 'BabylonjsCoreVector3', changedProps);
    checkPrimitiveDiff(oldProps.panningSensibility, newProps.panningSensibility, 'panningSensibility', 'number', changedProps);
    checkPrimitiveDiff(oldProps.pinchDeltaPercentage, newProps.pinchDeltaPercentage, 'pinchDeltaPercentage', 'number', changedProps);
    checkPrimitiveDiff(oldProps.pinchPrecision, newProps.pinchPrecision, 'pinchPrecision', 'number', changedProps);
    checkPrimitiveDiff(oldProps.pinchToPanMaxDistance, newProps.pinchToPanMaxDistance, 'pinchToPanMaxDistance', 'number', changedProps);
    checkVector3Diff(oldProps.position, newProps.position, 'position', 'BabylonjsCoreVector3', changedProps);
    checkPrimitiveDiff(oldProps.radius, newProps.radius, 'radius', 'number', changedProps);
    checkVector3Diff(oldProps.target, newProps.target, 'target', 'BabylonjsCoreVector3', changedProps); // type: 'BabylonjsCoreVector2' property (not coded) BabylonjsCoreArcRotateCamera.targetScreenOffset.

    checkPrimitiveDiff(oldProps.upperAlphaLimit, newProps.upperAlphaLimit, 'upperAlphaLimit', 'number', changedProps);
    checkPrimitiveDiff(oldProps.upperBetaLimit, newProps.upperBetaLimit, 'upperBetaLimit', 'number', changedProps);
    checkPrimitiveDiff(oldProps.upperRadiusLimit, newProps.upperRadiusLimit, 'upperRadiusLimit', 'number', changedProps);
    checkVector3Diff(oldProps.upVector, newProps.upVector, 'upVector', 'BabylonjsCoreVector3', changedProps);
    checkPrimitiveDiff(oldProps.useAutoRotationBehavior, newProps.useAutoRotationBehavior, 'useAutoRotationBehavior', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useBouncingBehavior, newProps.useBouncingBehavior, 'useBouncingBehavior', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useFramingBehavior, newProps.useFramingBehavior, 'useFramingBehavior', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useInputToRestoreState, newProps.useInputToRestoreState, 'useInputToRestoreState', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useNaturalPinchZoom, newProps.useNaturalPinchZoom, 'useNaturalPinchZoom', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.wheelDeltaPercentage, newProps.wheelDeltaPercentage, 'wheelDeltaPercentage', 'number', changedProps);
    checkPrimitiveDiff(oldProps.wheelPrecision, newProps.wheelPrecision, 'wheelPrecision', 'number', changedProps);
    checkPrimitiveDiff(oldProps.zoomOnFactor, newProps.zoomOnFactor, 'zoomOnFactor', 'number', changedProps);
    checkMethodDiff(oldProps.setPosition, newProps.setPosition, 'setPosition', '(position?: BabylonjsCoreVector3) => void', changedProps);
    checkMethodDiff(oldProps.setTarget, newProps.setTarget, 'setTarget', '(target?: BabylonjsCoreAbstractMesh | BabylonjsCoreVector3, toBoundingCenter?: boolean, allowSamePosition?: boolean) => void', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberArcRotateCameraPropsHandler;
}();
/**
 * This represents an orbital type of camera.
 *
 * This camera always points towards a given target position and can be rotated around that target with the target as the centre of rotation. It can be controlled with cursors and mouse, or with touch events.
 * Think of this camera as one orbiting its target position, or more imaginatively as a spy satellite orbiting the earth. Its position relative to the target (earth) can be set by three parameters, alpha (radians) the longitudinal rotation, beta (radians) the latitudinal rotation and radius the distance from the target position.
 *
 * This code has been generated
 */


var FiberArcRotateCamera =
/** @class */
function () {
  function FiberArcRotateCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberArcRotateCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberArcRotateCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberArcRotateCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberArcRotateCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "ArcRotateCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "alpha",
      "type": "number",
      "optional": false
    }, {
      "name": "beta",
      "type": "number",
      "optional": false
    }, {
      "name": "radius",
      "type": "number",
      "optional": false
    }, {
      "name": "target",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "setActiveOnSceneIfNoneActive",
      "type": "boolean",
      "optional": true
    }]
  };
  FiberArcRotateCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberArcRotateCamera"
  };
  return FiberArcRotateCamera;
}();

var FiberAnaglyphArcRotateCameraPropsHandler =
/** @class */
function () {
  function FiberAnaglyphArcRotateCameraPropsHandler() {}

  FiberAnaglyphArcRotateCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    return null; // no props to check
  };

  return FiberAnaglyphArcRotateCameraPropsHandler;
}();
/**
 * Camera used to simulate anaglyphic rendering (based on ArcRotateCamera)
 *
 * This code has been generated
 */


var FiberAnaglyphArcRotateCamera =
/** @class */
function () {
  function FiberAnaglyphArcRotateCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberAnaglyphArcRotateCameraPropsHandler(), new FiberArcRotateCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberAnaglyphArcRotateCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberAnaglyphArcRotateCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberAnaglyphArcRotateCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "AnaglyphArcRotateCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "alpha",
      "type": "number",
      "optional": false
    }, {
      "name": "beta",
      "type": "number",
      "optional": false
    }, {
      "name": "radius",
      "type": "number",
      "optional": false
    }, {
      "name": "target",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "interaxialDistance",
      "type": "number",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberAnaglyphArcRotateCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberAnaglyphArcRotateCamera"
  };
  return FiberAnaglyphArcRotateCamera;
}();

var FiberStereoscopicArcRotateCameraPropsHandler =
/** @class */
function () {
  function FiberStereoscopicArcRotateCameraPropsHandler() {}

  FiberStereoscopicArcRotateCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    return null; // no props to check
  };

  return FiberStereoscopicArcRotateCameraPropsHandler;
}();
/**
 * Camera used to simulate stereoscopic rendering (based on ArcRotateCamera)
 *
 * This code has been generated
 */


var FiberStereoscopicArcRotateCamera =
/** @class */
function () {
  function FiberStereoscopicArcRotateCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberStereoscopicArcRotateCameraPropsHandler(), new FiberArcRotateCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberStereoscopicArcRotateCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberStereoscopicArcRotateCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberStereoscopicArcRotateCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "StereoscopicArcRotateCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "alpha",
      "type": "number",
      "optional": false
    }, {
      "name": "beta",
      "type": "number",
      "optional": false
    }, {
      "name": "radius",
      "type": "number",
      "optional": false
    }, {
      "name": "target",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "interaxialDistance",
      "type": "number",
      "optional": false
    }, {
      "name": "isStereoscopicSideBySide",
      "type": "boolean",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberStereoscopicArcRotateCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberStereoscopicArcRotateCamera"
  };
  return FiberStereoscopicArcRotateCamera;
}();

var FiberVRDeviceOrientationArcRotateCameraPropsHandler =
/** @class */
function () {
  function FiberVRDeviceOrientationArcRotateCameraPropsHandler() {}

  FiberVRDeviceOrientationArcRotateCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    return null; // no props to check
  };

  return FiberVRDeviceOrientationArcRotateCameraPropsHandler;
}();
/**
 * Camera used to simulate VR rendering (based on ArcRotateCamera)
 *
 * This code has been generated
 */


var FiberVRDeviceOrientationArcRotateCamera =
/** @class */
function () {
  function FiberVRDeviceOrientationArcRotateCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberVRDeviceOrientationArcRotateCameraPropsHandler(), new FiberArcRotateCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberVRDeviceOrientationArcRotateCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberVRDeviceOrientationArcRotateCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberVRDeviceOrientationArcRotateCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "VRDeviceOrientationArcRotateCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "alpha",
      "type": "number",
      "optional": false
    }, {
      "name": "beta",
      "type": "number",
      "optional": false
    }, {
      "name": "radius",
      "type": "number",
      "optional": false
    }, {
      "name": "target",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "compensateDistortion",
      "type": "boolean",
      "optional": true
    }, {
      "name": "vrCameraMetrics",
      "type": "BabylonjsCoreVRCameraMetrics",
      "optional": true
    }]
  };
  FiberVRDeviceOrientationArcRotateCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberVRDeviceOrientationArcRotateCamera"
  };
  return FiberVRDeviceOrientationArcRotateCamera;
}();

var FiberFlyCameraPropsHandler =
/** @class */
function () {
  function FiberFlyCameraPropsHandler() {}

  FiberFlyCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.angularSensibility, newProps.angularSensibility, 'angularSensibility', 'number', changedProps);
    checkPrimitiveDiff(oldProps.applyGravity, newProps.applyGravity, 'applyGravity', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.bankedTurn, newProps.bankedTurn, 'bankedTurn', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.bankedTurnLimit, newProps.bankedTurnLimit, 'bankedTurnLimit', 'number', changedProps);
    checkPrimitiveDiff(oldProps.bankedTurnMultiplier, newProps.bankedTurnMultiplier, 'bankedTurnMultiplier', 'number', changedProps);
    checkVector3Diff(oldProps.cameraDirection, newProps.cameraDirection, 'cameraDirection', 'BabylonjsCoreVector3', changedProps);
    checkPrimitiveDiff(oldProps.checkCollisions, newProps.checkCollisions, 'checkCollisions', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.collisionMask, newProps.collisionMask, 'collisionMask', 'number', changedProps);
    checkVector3Diff(oldProps.ellipsoid, newProps.ellipsoid, 'ellipsoid', 'BabylonjsCoreVector3', changedProps);
    checkVector3Diff(oldProps.ellipsoidOffset, newProps.ellipsoidOffset, 'ellipsoidOffset', 'BabylonjsCoreVector3', changedProps); // type: 'BabylonjsCoreFlyCameraInputsManager' property (not coded) BabylonjsCoreFlyCamera.inputs.

    checkNumericArrayDiff(oldProps.keysBackward, newProps.keysBackward, 'keysBackward', 'number[]', changedProps);
    checkNumericArrayDiff(oldProps.keysDown, newProps.keysDown, 'keysDown', 'number[]', changedProps);
    checkNumericArrayDiff(oldProps.keysForward, newProps.keysForward, 'keysForward', 'number[]', changedProps);
    checkNumericArrayDiff(oldProps.keysLeft, newProps.keysLeft, 'keysLeft', 'number[]', changedProps);
    checkNumericArrayDiff(oldProps.keysRight, newProps.keysRight, 'keysRight', 'number[]', changedProps);
    checkNumericArrayDiff(oldProps.keysUp, newProps.keysUp, 'keysUp', 'number[]', changedProps);
    checkLambdaDiff(oldProps.onCollide, newProps.onCollide, 'onCollide', '(collidedMesh: BabylonjsCoreAbstractMesh) => void', changedProps);
    checkPrimitiveDiff(oldProps.rollCorrect, newProps.rollCorrect, 'rollCorrect', 'number', changedProps); // type: 'BabylonjsCoreQuaternion' property (not coded) BabylonjsCoreFlyCamera.rotationQuaternion.

    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberFlyCameraPropsHandler;
}();
/**
 * This is a flying camera, designed for 3D movement and rotation in all directions,
 * such as in a 3D Space Shooter or a Flight Simulator.
 *
 * This code has been generated
 */


var FiberFlyCamera =
/** @class */
function () {
  function FiberFlyCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberFlyCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberFlyCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberFlyCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberFlyCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "FlyCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "position",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "setActiveOnSceneIfNoneActive",
      "type": "boolean",
      "optional": true
    }]
  };
  FiberFlyCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberFlyCamera"
  };
  return FiberFlyCamera;
}();

var FiberFollowCameraPropsHandler =
/** @class */
function () {
  function FiberFollowCameraPropsHandler() {}

  FiberFollowCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.cameraAcceleration, newProps.cameraAcceleration, 'cameraAcceleration', 'number', changedProps);
    checkPrimitiveDiff(oldProps.heightOffset, newProps.heightOffset, 'heightOffset', 'number', changedProps); // type: 'BabylonjsCoreFollowCameraInputsManager' property (not coded) BabylonjsCoreFollowCamera.inputs.
    // type: 'BabylonjsCoreAbstractMesh' property (not coded) BabylonjsCoreFollowCamera.lockedTarget.

    checkPrimitiveDiff(oldProps.lowerHeightOffsetLimit, newProps.lowerHeightOffsetLimit, 'lowerHeightOffsetLimit', 'number', changedProps);
    checkPrimitiveDiff(oldProps.lowerRadiusLimit, newProps.lowerRadiusLimit, 'lowerRadiusLimit', 'number', changedProps);
    checkPrimitiveDiff(oldProps.lowerRotationOffsetLimit, newProps.lowerRotationOffsetLimit, 'lowerRotationOffsetLimit', 'number', changedProps);
    checkPrimitiveDiff(oldProps.maxCameraSpeed, newProps.maxCameraSpeed, 'maxCameraSpeed', 'number', changedProps);
    checkPrimitiveDiff(oldProps.radius, newProps.radius, 'radius', 'number', changedProps);
    checkPrimitiveDiff(oldProps.rotationOffset, newProps.rotationOffset, 'rotationOffset', 'number', changedProps);
    checkPrimitiveDiff(oldProps.upperHeightOffsetLimit, newProps.upperHeightOffsetLimit, 'upperHeightOffsetLimit', 'number', changedProps);
    checkPrimitiveDiff(oldProps.upperRadiusLimit, newProps.upperRadiusLimit, 'upperRadiusLimit', 'number', changedProps);
    checkPrimitiveDiff(oldProps.upperRotationOffsetLimit, newProps.upperRotationOffsetLimit, 'upperRotationOffsetLimit', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberFollowCameraPropsHandler;
}();
/**
 * A follow camera takes a mesh as a target and follows it as it moves. Both a free camera version followCamera and
 * an arc rotate version arcFollowCamera are available.
 *
 * This code has been generated
 */


var FiberFollowCamera =
/** @class */
function () {
  function FiberFollowCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberFollowCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberFollowCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberFollowCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberFollowCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "FollowCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "position",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "lockedTarget",
      "type": "BabylonjsCoreAbstractMesh",
      "optional": true
    }]
  };
  FiberFollowCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberFollowCamera"
  };
  return FiberFollowCamera;
}();

var FiberArcFollowCameraPropsHandler =
/** @class */
function () {
  function FiberArcFollowCameraPropsHandler() {}

  FiberArcFollowCameraPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.alpha, newProps.alpha, 'alpha', 'number', changedProps);
    checkPrimitiveDiff(oldProps.beta, newProps.beta, 'beta', 'number', changedProps);
    checkPrimitiveDiff(oldProps.radius, newProps.radius, 'radius', 'number', changedProps); // type: 'BabylonjsCoreAbstractMesh' property (not coded) BabylonjsCoreArcFollowCamera.target.

    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberArcFollowCameraPropsHandler;
}();
/**
 * Arc Rotate version of the follow camera.
 * It still follows a Defined mesh but in an Arc Rotate Camera fashion.
 *
 * This code has been generated
 */


var FiberArcFollowCamera =
/** @class */
function () {
  function FiberArcFollowCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberArcFollowCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberArcFollowCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberArcFollowCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberArcFollowCamera.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "ArcFollowCamera",
    "namespace": "@babylonjs/core/Cameras/camera",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "alpha",
      "type": "number",
      "optional": false
    }, {
      "name": "beta",
      "type": "number",
      "optional": false
    }, {
      "name": "radius",
      "type": "number",
      "optional": false
    }, {
      "name": "target",
      "type": "BabylonjsCoreAbstractMesh",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberArcFollowCamera.Metadata = {
    "isCamera": true,
    "isNode": true,
    "className": "FiberArcFollowCamera"
  };
  return FiberArcFollowCamera;
}();
/**
 * Creates a box mesh
 * * The parameter `size` sets the size (float) of each box side (default 1)
 * * You can set some different box dimensions by using the parameters `width`, `height` and `depth` (all by default have the same value of `size`)
 * * You can set different colors and different images to each box side by using the parameters `faceColors` (an array of 6 Color3 elements) and `faceUV` (an array of 6 Vector4 elements)
 * * Please read this tutorial : https://doc.babylonjs.com/how_to/createbox_per_face_textures_and_colors
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberBox =
/** @class */
function () {
  function FiberBox() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberBox.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberBox.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberBox.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreateBox",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "size",
        "type": "number",
        "optional": true
      }, {
        "name": "width",
        "type": "number",
        "optional": true
      }, {
        "name": "height",
        "type": "number",
        "optional": true
      }, {
        "name": "depth",
        "type": "number",
        "optional": true
      }, {
        "name": "faceUV",
        "type": "BabylonjsCoreVector4[]",
        "optional": true
      }, {
        "name": "faceColors",
        "type": "BabylonjsCoreColor4[]",
        "optional": true
      }, {
        "name": "sideOrientation",
        "type": "number",
        "optional": true
      }, {
        "name": "frontUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "backUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberBox.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberBox"
  };
  return FiberBox;
}();
/**
 * Creates a tiled box mesh
 * * faceTiles sets the pattern, tile size and number of tiles for a face
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberTiledBox =
/** @class */
function () {
  function FiberTiledBox() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberTiledBox.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberTiledBox.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberTiledBox.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreateTiledBox",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "pattern",
        "type": "number",
        "optional": true
      }, {
        "name": "size",
        "type": "number",
        "optional": true
      }, {
        "name": "width",
        "type": "number",
        "optional": true
      }, {
        "name": "height",
        "type": "number",
        "optional": true
      }, {
        "name": "depth",
        "type": "number",
        "optional": false
      }, {
        "name": "tileSize",
        "type": "number",
        "optional": true
      }, {
        "name": "tileWidth",
        "type": "number",
        "optional": true
      }, {
        "name": "tileHeight",
        "type": "number",
        "optional": true
      }, {
        "name": "faceUV",
        "type": "BabylonjsCoreVector4[]",
        "optional": true
      }, {
        "name": "faceColors",
        "type": "BabylonjsCoreColor4[]",
        "optional": true
      }, {
        "name": "alignHorizontal",
        "type": "number",
        "optional": true
      }, {
        "name": "alignVertical",
        "type": "number",
        "optional": true
      }, {
        "name": "sideOrientation",
        "type": "number",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberTiledBox.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberTiledBox"
  };
  return FiberTiledBox;
}();
/**
 * Creates a sphere mesh
 * * The parameter `diameter` sets the diameter size (float) of the sphere (default 1)
 * * You can set some different sphere dimensions, for instance to build an ellipsoid, by using the parameters `diameterX`, `diameterY` and `diameterZ` (all by default have the same value of `diameter`)
 * * The parameter `segments` sets the sphere number of horizontal stripes (positive integer, default 32)
 * * You can create an unclosed sphere with the parameter `arc` (positive float, default 1), valued between 0 and 1, what is the ratio of the circumference (latitude) : 2 x PI x ratio
 * * You can create an unclosed sphere on its height with the parameter `slice` (positive float, default1), valued between 0 and 1, what is the height ratio (longitude)
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberSphere =
/** @class */
function () {
  function FiberSphere() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberSphere.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberSphere.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberSphere.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreateSphere",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "segments",
        "type": "number",
        "optional": true
      }, {
        "name": "diameter",
        "type": "number",
        "optional": true
      }, {
        "name": "diameterX",
        "type": "number",
        "optional": true
      }, {
        "name": "diameterY",
        "type": "number",
        "optional": true
      }, {
        "name": "diameterZ",
        "type": "number",
        "optional": true
      }, {
        "name": "arc",
        "type": "number",
        "optional": true
      }, {
        "name": "slice",
        "type": "number",
        "optional": true
      }, {
        "name": "sideOrientation",
        "type": "number",
        "optional": true
      }, {
        "name": "frontUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "backUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberSphere.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberSphere"
  };
  return FiberSphere;
}();
/**
 * Creates a plane polygonal mesh.  By default, this is a disc
 * * The parameter `radius` sets the radius size (float) of the polygon (default 0.5)
 * * The parameter `tessellation` sets the number of polygon sides (positive integer, default 64). So a tessellation valued to 3 will build a triangle, to 4 a square, etc
 * * You can create an unclosed polygon with the parameter `arc` (positive float, default 1), valued between 0 and 1, what is the ratio of the circumference : 2 x PI x ratio
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberDisc =
/** @class */
function () {
  function FiberDisc() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberDisc.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberDisc.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberDisc.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreateDisc",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "radius",
        "type": "number",
        "optional": true
      }, {
        "name": "tessellation",
        "type": "number",
        "optional": true
      }, {
        "name": "arc",
        "type": "number",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }, {
        "name": "sideOrientation",
        "type": "number",
        "optional": true
      }, {
        "name": "frontUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "backUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberDisc.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberDisc"
  };
  return FiberDisc;
}();
/**
 * Creates a sphere based upon an icosahedron with 20 triangular faces which can be subdivided
 * * The parameter `radius` sets the radius size (float) of the icosphere (default 1)
 * * You can set some different icosphere dimensions, for instance to build an ellipsoid, by using the parameters `radiusX`, `radiusY` and `radiusZ` (all by default have the same value of `radius`)
 * * The parameter `subdivisions` sets the number of subdivisions (postive integer, default 4). The more subdivisions, the more faces on the icosphere whatever its size
 * * The parameter `flat` (boolean, default true) gives each side its own normals. Set it to false to get a smooth continuous light reflection on the surface
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberIcoSphere =
/** @class */
function () {
  function FiberIcoSphere() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberIcoSphere.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberIcoSphere.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberIcoSphere.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreateIcoSphere",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "radius",
        "type": "number",
        "optional": true
      }, {
        "name": "radiusX",
        "type": "number",
        "optional": true
      }, {
        "name": "radiusY",
        "type": "number",
        "optional": true
      }, {
        "name": "radiusZ",
        "type": "number",
        "optional": true
      }, {
        "name": "flat",
        "type": "boolean",
        "optional": true
      }, {
        "name": "subdivisions",
        "type": "number",
        "optional": true
      }, {
        "name": "sideOrientation",
        "type": "number",
        "optional": true
      }, {
        "name": "frontUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "backUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberIcoSphere.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberIcoSphere"
  };
  return FiberIcoSphere;
}();
/**
 * Creates a ribbon mesh. The ribbon is a parametric shape.  It has no predefined shape. Its final shape will depend on the input parameters
 * * The parameter `pathArray` is a required array of paths, what are each an array of successive Vector3. The pathArray parameter depicts the ribbon geometry
 * * The parameter `closeArray` (boolean, default false) creates a seam between the first and the last paths of the path array
 * * The parameter `closePath` (boolean, default false) creates a seam between the first and the last points of each path of the path array
 * * The parameter `offset` (positive integer, default : rounded half size of the pathArray length), is taken in account only if the `pathArray` is containing a single path
 * * It's the offset to join the points from the same path. Ex : offset = 10 means the point 1 is joined to the point 11
 * * The optional parameter `instance` is an instance of an existing Ribbon object to be updated with the passed `pathArray` parameter : https://doc.babylonjs.com/how_to/how_to_dynamically_morph_a_mesh#ribbon
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The optional parameter `invertUV` (boolean, default false) swaps in the geometry the U and V coordinates to apply a texture
 * * The parameter `uvs` is an optional flat array of `Vector2` to update/set each ribbon vertex with its own custom UV values instead of the computed ones
 * * The parameters `colors` is an optional flat array of `Color4` to set/update each ribbon vertex with its own custom color values
 * * Note that if you use the parameters `uvs` or `colors`, the passed arrays must be populated with the right number of elements, it is to say the number of ribbon vertices. Remember that if you set `closePath` to `true`, there's one extra vertex per path in the geometry
 * * Moreover, you can use the parameter `color` with `instance` (to update the ribbon), only if you previously used it at creation time
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberRibbon =
/** @class */
function () {
  function FiberRibbon() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberRibbon.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberRibbon.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberRibbon.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreateRibbon",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "pathArray",
        "type": "BabylonjsCoreVector3[][]",
        "optional": false
      }, {
        "name": "closeArray",
        "type": "boolean",
        "optional": true
      }, {
        "name": "closePath",
        "type": "boolean",
        "optional": true
      }, {
        "name": "offset",
        "type": "number",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }, {
        "name": "sideOrientation",
        "type": "number",
        "optional": true
      }, {
        "name": "frontUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "backUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "instance",
        "type": "BabylonjsCoreMesh",
        "optional": true
      }, {
        "name": "invertUV",
        "type": "boolean",
        "optional": true
      }, {
        "name": "uvs",
        "type": "BabylonjsCoreVector2[]",
        "optional": true
      }, {
        "name": "colors",
        "type": "BabylonjsCoreColor4[]",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberRibbon.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberRibbon"
  };
  return FiberRibbon;
}();
/**
 * Creates a cylinder or a cone mesh
 * * The parameter `height` sets the height size (float) of the cylinder/cone (float, default 2).
 * * The parameter `diameter` sets the diameter of the top and bottom cap at once (float, default 1).
 * * The parameters `diameterTop` and `diameterBottom` overwrite the parameter `diameter` and set respectively the top cap and bottom cap diameter (floats, default 1). The parameter "diameterBottom" can't be zero.
 * * The parameter `tessellation` sets the number of cylinder sides (positive integer, default 24). Set it to 3 to get a prism for instance.
 * * The parameter `subdivisions` sets the number of rings along the cylinder height (positive integer, default 1).
 * * The parameter `hasRings` (boolean, default false) makes the subdivisions independent from each other, so they become different faces.
 * * The parameter `enclose`  (boolean, default false) adds two extra faces per subdivision to a sliced cylinder to close it around its height axis.
 * * The parameter `cap` sets the way the cylinder is capped. Possible values : BABYLON.Mesh.NO_CAP, BABYLON.Mesh.CAP_START, BABYLON.Mesh.CAP_END, BABYLON.Mesh.CAP_ALL (default).
 * * The parameter `arc` (float, default 1) is the ratio (max 1) to apply to the circumference to slice the cylinder.
 * * You can set different colors and different images to each box side by using the parameters `faceColors` (an array of n Color3 elements) and `faceUV` (an array of n Vector4 elements).
 * * The value of n is the number of cylinder faces. If the cylinder has only 1 subdivisions, n equals : top face + cylinder surface + bottom face = 3
 * * Now, if the cylinder has 5 independent subdivisions (hasRings = true), n equals : top face + 5 stripe surfaces + bottom face = 2 + 5 = 7
 * * Finally, if the cylinder has 5 independent subdivisions and is enclose, n equals : top face + 5 x (stripe surface + 2 closing faces) + bottom face = 2 + 5 * 3 = 17
 * * Each array (color or UVs) is always ordered the same way : the first element is the bottom cap, the last element is the top cap. The other elements are each a ring surface.
 * * If `enclose` is false, a ring surface is one element.
 * * If `enclose` is true, a ring surface is 3 successive elements in the array : the tubular surface, then the two closing faces.
 * * Example how to set colors and textures on a sliced cylinder : https://www.html5gamedevs.com/topic/17945-creating-a-closed-slice-of-a-cylinder/#comment-106379
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
 *
 * This code has been generated
 */


var FiberCylinder =
/** @class */
function () {
  function FiberCylinder() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberCylinder.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberCylinder.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberCylinder.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreateCylinder",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "height",
        "type": "number",
        "optional": true
      }, {
        "name": "diameterTop",
        "type": "number",
        "optional": true
      }, {
        "name": "diameterBottom",
        "type": "number",
        "optional": true
      }, {
        "name": "diameter",
        "type": "number",
        "optional": true
      }, {
        "name": "tessellation",
        "type": "number",
        "optional": true
      }, {
        "name": "subdivisions",
        "type": "number",
        "optional": true
      }, {
        "name": "arc",
        "type": "number",
        "optional": true
      }, {
        "name": "faceColors",
        "type": "BabylonjsCoreColor4[]",
        "optional": true
      }, {
        "name": "faceUV",
        "type": "BabylonjsCoreVector4[]",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }, {
        "name": "hasRings",
        "type": "boolean",
        "optional": true
      }, {
        "name": "enclose",
        "type": "boolean",
        "optional": true
      }, {
        "name": "cap",
        "type": "number",
        "optional": true
      }, {
        "name": "sideOrientation",
        "type": "number",
        "optional": true
      }, {
        "name": "frontUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "backUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberCylinder.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberCylinder"
  };
  return FiberCylinder;
}();
/**
 * Creates a torus mesh
 * * The parameter `diameter` sets the diameter size (float) of the torus (default 1)
 * * The parameter `thickness` sets the diameter size of the tube of the torus (float, default 0.5)
 * * The parameter `tessellation` sets the number of torus sides (postive integer, default 16)
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
 *
 * This code has been generated
 */


var FiberTorus =
/** @class */
function () {
  function FiberTorus() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberTorus.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberTorus.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberTorus.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreateTorus",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "diameter",
        "type": "number",
        "optional": true
      }, {
        "name": "thickness",
        "type": "number",
        "optional": true
      }, {
        "name": "tessellation",
        "type": "number",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }, {
        "name": "sideOrientation",
        "type": "number",
        "optional": true
      }, {
        "name": "frontUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "backUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberTorus.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberTorus"
  };
  return FiberTorus;
}();
/**
 * Creates a torus knot mesh
 * * The parameter `radius` sets the global radius size (float) of the torus knot (default 2)
 * * The parameter `radialSegments` sets the number of sides on each tube segments (positive integer, default 32)
 * * The parameter `tubularSegments` sets the number of tubes to decompose the knot into (positive integer, default 32)
 * * The parameters `p` and `q` are the number of windings on each axis (positive integers, default 2 and 3)
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
 *
 * This code has been generated
 */


var FiberTorusKnot =
/** @class */
function () {
  function FiberTorusKnot() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberTorusKnot.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberTorusKnot.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberTorusKnot.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreateTorusKnot",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "radius",
        "type": "number",
        "optional": true
      }, {
        "name": "tube",
        "type": "number",
        "optional": true
      }, {
        "name": "radialSegments",
        "type": "number",
        "optional": true
      }, {
        "name": "tubularSegments",
        "type": "number",
        "optional": true
      }, {
        "name": "p",
        "type": "number",
        "optional": true
      }, {
        "name": "q",
        "type": "number",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }, {
        "name": "sideOrientation",
        "type": "number",
        "optional": true
      }, {
        "name": "frontUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "backUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberTorusKnot.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberTorusKnot"
  };
  return FiberTorusKnot;
}();
/**
 * Creates a line system mesh. A line system is a pool of many lines gathered in a single mesh
 * * A line system mesh is considered as a parametric shape since it has no predefined original shape. Its shape is determined by the passed array of lines as an input parameter
 * * Like every other parametric shape, it is dynamically updatable by passing an existing instance of LineSystem to this static function
 * * The parameter `lines` is an array of lines, each line being an array of successive Vector3
 * * The optional parameter `instance` is an instance of an existing LineSystem object to be updated with the passed `lines` parameter
 * * The optional parameter `colors` is an array of line colors, each line colors being an array of successive Color4, one per line point
 * * The optional parameter `useVertexAlpha` is to be set to `false` (default `true`) when you don't need the alpha blending (faster)
 * * Updating a simple Line mesh, you just need to update every line in the `lines` array : https://doc.babylonjs.com/how_to/how_to_dynamically_morph_a_mesh#lines-and-dashedlines
 * * When updating an instance, remember that only line point positions can change, not the number of points, neither the number of lines
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberLineSystem =
/** @class */
function () {
  function FiberLineSystem() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberLineSystem.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberLineSystem.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberLineSystem.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreateLineSystem",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "lines",
        "type": "BabylonjsCoreVector3[][]",
        "optional": false
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }, {
        "name": "instance",
        "type": "BabylonjsCoreLinesMesh",
        "optional": true
      }, {
        "name": "colors",
        "type": "BabylonjsCoreColor4[][]",
        "optional": true
      }, {
        "name": "useVertexAlpha",
        "type": "boolean",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberLineSystem.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberLineSystem"
  };
  return FiberLineSystem;
}();
/**
 * Creates a line mesh
 * A line mesh is considered as a parametric shape since it has no predefined original shape. Its shape is determined by the passed array of points as an input parameter
 * * Like every other parametric shape, it is dynamically updatable by passing an existing instance of LineMesh to this static function
 * * The parameter `points` is an array successive Vector3
 * * The optional parameter `instance` is an instance of an existing LineMesh object to be updated with the passed `points` parameter : https://doc.babylonjs.com/how_to/how_to_dynamically_morph_a_mesh#lines-and-dashedlines
 * * The optional parameter `colors` is an array of successive Color4, one per line point
 * * The optional parameter `useVertexAlpha` is to be set to `false` (default `true`) when you don't need alpha blending (faster)
 * * When updating an instance, remember that only point positions can change, not the number of points
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberLines =
/** @class */
function () {
  function FiberLines() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberLines.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberLines.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberLines.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreateLines",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "points",
        "type": "BabylonjsCoreVector3[]",
        "optional": false
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }, {
        "name": "instance",
        "type": "BabylonjsCoreLinesMesh",
        "optional": true
      }, {
        "name": "colors",
        "type": "BabylonjsCoreColor4[]",
        "optional": true
      }, {
        "name": "useVertexAlpha",
        "type": "boolean",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberLines.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberLines"
  };
  return FiberLines;
}();
/**
 * Creates a dashed line mesh
 * * A dashed line mesh is considered as a parametric shape since it has no predefined original shape. Its shape is determined by the passed array of points as an input parameter
 * * Like every other parametric shape, it is dynamically updatable by passing an existing instance of LineMesh to this static function
 * * The parameter `points` is an array successive Vector3
 * * The parameter `dashNb` is the intended total number of dashes (positive integer, default 200)
 * * The parameter `dashSize` is the size of the dashes relatively the dash number (positive float, default 3)
 * * The parameter `gapSize` is the size of the gap between two successive dashes relatively the dash number (positive float, default 1)
 * * The optional parameter `instance` is an instance of an existing LineMesh object to be updated with the passed `points` parameter : https://doc.babylonjs.com/how_to/how_to_dynamically_morph_a_mesh#lines-and-dashedlines
 * * When updating an instance, remember that only point positions can change, not the number of points
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberDashedLines =
/** @class */
function () {
  function FiberDashedLines() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberDashedLines.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberDashedLines.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberDashedLines.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreateDashedLines",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "points",
        "type": "BabylonjsCoreVector3[]",
        "optional": false
      }, {
        "name": "dashSize",
        "type": "number",
        "optional": true
      }, {
        "name": "gapSize",
        "type": "number",
        "optional": true
      }, {
        "name": "dashNb",
        "type": "number",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }, {
        "name": "instance",
        "type": "BabylonjsCoreLinesMesh",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberDashedLines.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberDashedLines"
  };
  return FiberDashedLines;
}();
/**
 * Creates an extruded shape mesh. The extrusion is a parametric shape. It has no predefined shape. Its final shape will depend on the input parameters.
 * * The parameter `shape` is a required array of successive Vector3. This array depicts the shape to be extruded in its local space : the shape must be designed in the xOy plane and will be extruded along the Z axis.
 * * The parameter `path` is a required array of successive Vector3. This is the axis curve the shape is extruded along.
 * * The parameter `rotation` (float, default 0 radians) is the angle value to rotate the shape each step (each path point), from the former step (so rotation added each step) along the curve.
 * * The parameter `scale` (float, default 1) is the value to scale the shape.
 * * The parameter `cap` sets the way the extruded shape is capped. Possible values : BABYLON.Mesh.NO_CAP (default), BABYLON.Mesh.CAP_START, BABYLON.Mesh.CAP_END, BABYLON.Mesh.CAP_ALL
 * * The optional parameter `instance` is an instance of an existing ExtrudedShape object to be updated with the passed `shape`, `path`, `scale` or `rotation` parameters : https://doc.babylonjs.com/how_to/how_to_dynamically_morph_a_mesh#extruded-shape
 * * Remember you can only change the shape or path point positions, not their number when updating an extruded shape.
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The optional parameter `invertUV` (boolean, default false) swaps in the geometry the U and V coordinates to apply a texture.
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
 *
 * This code has been generated
 */


var FiberExtrudeShape =
/** @class */
function () {
  function FiberExtrudeShape() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberExtrudeShape.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberExtrudeShape.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberExtrudeShape.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "ExtrudeShape",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "shape",
        "type": "BabylonjsCoreVector3[]",
        "optional": false
      }, {
        "name": "path",
        "type": "BabylonjsCoreVector3[]",
        "optional": false
      }, {
        "name": "scale",
        "type": "number",
        "optional": true
      }, {
        "name": "rotation",
        "type": "number",
        "optional": true
      }, {
        "name": "cap",
        "type": "number",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }, {
        "name": "sideOrientation",
        "type": "number",
        "optional": true
      }, {
        "name": "frontUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "backUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "instance",
        "type": "BabylonjsCoreMesh",
        "optional": true
      }, {
        "name": "invertUV",
        "type": "boolean",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberExtrudeShape.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberExtrudeShape"
  };
  return FiberExtrudeShape;
}();
/**
 * Creates an custom extruded shape mesh.
 * The custom extrusion is a parametric shape. It has no predefined shape. Its final shape will depend on the input parameters.
 * * The parameter `shape` is a required array of successive Vector3. This array depicts the shape to be extruded in its local space : the shape must be designed in the xOy plane and will be extruded along the Z axis.
 * * The parameter `path` is a required array of successive Vector3. This is the axis curve the shape is extruded along.
 * * The parameter `rotationFunction` (JS function) is a custom Javascript function called on each path point. This function is passed the position i of the point in the path and the distance of this point from the begining of the path
 * * It must returns a float value that will be the rotation in radians applied to the shape on each path point.
 * * The parameter `scaleFunction` (JS function) is a custom Javascript function called on each path point. This function is passed the position i of the point in the path and the distance of this point from the begining of the path
 * * It must returns a float value that will be the scale value applied to the shape on each path point
 * * The parameter `ribbonClosePath` (boolean, default false) forces the extrusion underlying ribbon to close all the paths in its `pathArray`
 * * The parameter `ribbonCloseArray` (boolean, default false) forces the extrusion underlying ribbon to close its `pathArray`
 * * The parameter `cap` sets the way the extruded shape is capped. Possible values : BABYLON.Mesh.NO_CAP (default), BABYLON.Mesh.CAP_START, BABYLON.Mesh.CAP_END, BABYLON.Mesh.CAP_ALL
 * * The optional parameter `instance` is an instance of an existing ExtrudedShape object to be updated with the passed `shape`, `path`, `scale` or `rotation` parameters : https://doc.babylonjs.com/how_to/how_to_dynamically_morph_a_mesh#extruded-shape
 * * Remember you can only change the shape or path point positions, not their number when updating an extruded shape
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The optional parameter `invertUV` (boolean, default false) swaps in the geometry the U and V coordinates to apply a texture
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberExtrudeShapeCustom =
/** @class */
function () {
  function FiberExtrudeShapeCustom() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberExtrudeShapeCustom.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberExtrudeShapeCustom.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberExtrudeShapeCustom.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "ExtrudeShapeCustom",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "shape",
        "type": "BabylonjsCoreVector3[]",
        "optional": false
      }, {
        "name": "path",
        "type": "BabylonjsCoreVector3[]",
        "optional": false
      }, {
        "name": "scaleFunction",
        "type": "any",
        "optional": true
      }, {
        "name": "rotationFunction",
        "type": "any",
        "optional": true
      }, {
        "name": "ribbonCloseArray",
        "type": "boolean",
        "optional": true
      }, {
        "name": "ribbonClosePath",
        "type": "boolean",
        "optional": true
      }, {
        "name": "cap",
        "type": "number",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }, {
        "name": "sideOrientation",
        "type": "number",
        "optional": true
      }, {
        "name": "frontUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "backUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "instance",
        "type": "BabylonjsCoreMesh",
        "optional": true
      }, {
        "name": "invertUV",
        "type": "boolean",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberExtrudeShapeCustom.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberExtrudeShapeCustom"
  };
  return FiberExtrudeShapeCustom;
}();
/**
 * Creates lathe mesh.
 * The lathe is a shape with a symetry axis : a 2D model shape is rotated around this axis to design the lathe
 * * The parameter `shape` is a required array of successive Vector3. This array depicts the shape to be rotated in its local space : the shape must be designed in the xOy plane and will be rotated around the Y axis. It's usually a 2D shape, so the Vector3 z coordinates are often set to zero
 * * The parameter `radius` (positive float, default 1) is the radius value of the lathe
 * * The parameter `tessellation` (positive integer, default 64) is the side number of the lathe
 * * The parameter `clip` (positive integer, default 0) is the number of sides to not create without effecting the general shape of the sides
 * * The parameter `arc` (positive float, default 1) is the ratio of the lathe. 0.5 builds for instance half a lathe, so an opened shape
 * * The parameter `closed` (boolean, default true) opens/closes the lathe circumference. This should be set to false when used with the parameter "arc"
 * * The parameter `cap` sets the way the extruded shape is capped. Possible values : BABYLON.Mesh.NO_CAP (default), BABYLON.Mesh.CAP_START, BABYLON.Mesh.CAP_END, BABYLON.Mesh.CAP_ALL
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The optional parameter `invertUV` (boolean, default false) swaps in the geometry the U and V coordinates to apply a texture
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberLathe =
/** @class */
function () {
  function FiberLathe() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberLathe.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberLathe.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberLathe.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreateLathe",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "shape",
        "type": "BabylonjsCoreVector3[]",
        "optional": false
      }, {
        "name": "radius",
        "type": "number",
        "optional": true
      }, {
        "name": "tessellation",
        "type": "number",
        "optional": true
      }, {
        "name": "clip",
        "type": "number",
        "optional": true
      }, {
        "name": "arc",
        "type": "number",
        "optional": true
      }, {
        "name": "closed",
        "type": "boolean",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }, {
        "name": "sideOrientation",
        "type": "number",
        "optional": true
      }, {
        "name": "frontUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "backUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "cap",
        "type": "number",
        "optional": true
      }, {
        "name": "invertUV",
        "type": "boolean",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberLathe.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberLathe"
  };
  return FiberLathe;
}();
/**
 * Creates a tiled plane mesh
 * * You can set a limited pattern arrangement with the tiles
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberTiledPlane =
/** @class */
function () {
  function FiberTiledPlane() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberTiledPlane.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberTiledPlane.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberTiledPlane.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreateTiledPlane",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "pattern",
        "type": "number",
        "optional": true
      }, {
        "name": "tileSize",
        "type": "number",
        "optional": true
      }, {
        "name": "tileWidth",
        "type": "number",
        "optional": true
      }, {
        "name": "tileHeight",
        "type": "number",
        "optional": true
      }, {
        "name": "size",
        "type": "number",
        "optional": true
      }, {
        "name": "width",
        "type": "number",
        "optional": true
      }, {
        "name": "height",
        "type": "number",
        "optional": true
      }, {
        "name": "alignHorizontal",
        "type": "number",
        "optional": true
      }, {
        "name": "alignVertical",
        "type": "number",
        "optional": true
      }, {
        "name": "sideOrientation",
        "type": "number",
        "optional": true
      }, {
        "name": "frontUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "backUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberTiledPlane.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberTiledPlane"
  };
  return FiberTiledPlane;
}();
/**
 * Creates a plane mesh
 * * The parameter `size` sets the size (float) of both sides of the plane at once (default 1)
 * * You can set some different plane dimensions by using the parameters `width` and `height` (both by default have the same value of `size`)
 * * The parameter `sourcePlane` is a Plane instance. It builds a mesh plane from a Math plane
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberPlane =
/** @class */
function () {
  function FiberPlane() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberPlane.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPlane.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPlane.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreatePlane",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "size",
        "type": "number",
        "optional": true
      }, {
        "name": "width",
        "type": "number",
        "optional": true
      }, {
        "name": "height",
        "type": "number",
        "optional": true
      }, {
        "name": "sideOrientation",
        "type": "number",
        "optional": true
      }, {
        "name": "frontUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "backUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }, {
        "name": "sourcePlane",
        "type": "BabylonjsCorePlane",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberPlane.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberPlane"
  };
  return FiberPlane;
}();
/**
 * Creates a ground mesh
 * * The parameters `width` and `height` (floats, default 1) set the width and height sizes of the ground
 * * The parameter `subdivisions` (positive integer) sets the number of subdivisions per side
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberGround =
/** @class */
function () {
  function FiberGround() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberGround.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberGround.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberGround.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreateGround",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "width",
        "type": "number",
        "optional": true
      }, {
        "name": "height",
        "type": "number",
        "optional": true
      }, {
        "name": "subdivisions",
        "type": "number",
        "optional": true
      }, {
        "name": "subdivisionsX",
        "type": "number",
        "optional": true
      }, {
        "name": "subdivisionsY",
        "type": "number",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberGround.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberGround"
  };
  return FiberGround;
}();
/**
 * Creates a tiled ground mesh
 * * The parameters `xmin` and `xmax` (floats, default -1 and 1) set the ground minimum and maximum X coordinates
 * * The parameters `zmin` and `zmax` (floats, default -1 and 1) set the ground minimum and maximum Z coordinates
 * * The parameter `subdivisions` is a javascript object `{w: positive integer, h: positive integer}` (default `{w: 6, h: 6}`). `w` and `h` are the numbers of subdivisions on the ground width and height. Each subdivision is called a tile
 * * The parameter `precision` is a javascript object `{w: positive integer, h: positive integer}` (default `{w: 2, h: 2}`). `w` and `h` are the numbers of subdivisions on the ground width and height of each tile
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
 *
 * This code has been generated
 */


var FiberTiledGround =
/** @class */
function () {
  function FiberTiledGround() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberTiledGround.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberTiledGround.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberTiledGround.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreateTiledGround",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "xmin",
        "type": "number",
        "optional": false
      }, {
        "name": "zmin",
        "type": "number",
        "optional": false
      }, {
        "name": "xmax",
        "type": "number",
        "optional": false
      }, {
        "name": "zmax",
        "type": "number",
        "optional": false
      }, {
        "name": "subdivisions",
        "type": "{ w: number; h: number; }",
        "optional": true
      }, {
        "name": "precision",
        "type": "{ w: number; h: number; }",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberTiledGround.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberTiledGround"
  };
  return FiberTiledGround;
}();
/**
 * Creates a ground mesh from a height map
 * * The parameter `url` sets the URL of the height map image resource.
 * * The parameters `width` and `height` (positive floats, default 10) set the ground width and height sizes.
 * * The parameter `subdivisions` (positive integer, default 1) sets the number of subdivision per side.
 * * The parameter `minHeight` (float, default 0) is the minimum altitude on the ground.
 * * The parameter `maxHeight` (float, default 1) is the maximum altitude on the ground.
 * * The parameter `colorFilter` (optional Color3, default (0.3, 0.59, 0.11) ) is the filter to apply to the image pixel colors to compute the height.
 * * The parameter `onReady` is a javascript callback function that will be called  once the mesh is just built (the height map download can last some time).
 * * The parameter `alphaFilter` will filter any data where the alpha channel is below this value, defaults 0 (all data visible)
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
 *
 * This code has been generated
 */


var FiberGroundFromHeightMap =
/** @class */
function () {
  function FiberGroundFromHeightMap() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberGroundFromHeightMap.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberGroundFromHeightMap.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberGroundFromHeightMap.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreateGroundFromHeightMap",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "url",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "width",
        "type": "number",
        "optional": true
      }, {
        "name": "height",
        "type": "number",
        "optional": true
      }, {
        "name": "subdivisions",
        "type": "number",
        "optional": true
      }, {
        "name": "minHeight",
        "type": "number",
        "optional": true
      }, {
        "name": "maxHeight",
        "type": "number",
        "optional": true
      }, {
        "name": "colorFilter",
        "type": "BabylonjsCoreColor3",
        "optional": true
      }, {
        "name": "alphaFilter",
        "type": "number",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }, {
        "name": "onReady",
        "type": "(mesh: BabylonjsCoreGroundMesh) => void",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberGroundFromHeightMap.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberGroundFromHeightMap"
  };
  return FiberGroundFromHeightMap;
}();
/**
 * Creates a polygon mesh
 * The polygon's shape will depend on the input parameters and is constructed parallel to a ground mesh
 * * The parameter `shape` is a required array of successive Vector3 representing the corners of the polygon in th XoZ plane, that is y = 0 for all vectors
 * * You can set the mesh side orientation with the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4)
 * * Remember you can only change the shape positions, not their number when updating a polygon
 *
 * This code has been generated
 */


var FiberPolygon =
/** @class */
function () {
  function FiberPolygon() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberPolygon.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPolygon.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPolygon.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreatePolygon",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "shape",
        "type": "BabylonjsCoreVector3[]",
        "optional": false
      }, {
        "name": "holes",
        "type": "BabylonjsCoreVector3[][]",
        "optional": true
      }, {
        "name": "depth",
        "type": "number",
        "optional": true
      }, {
        "name": "faceUV",
        "type": "BabylonjsCoreVector4[]",
        "optional": true
      }, {
        "name": "faceColors",
        "type": "BabylonjsCoreColor4[]",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }, {
        "name": "sideOrientation",
        "type": "number",
        "optional": true
      }, {
        "name": "frontUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "backUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }, {
      "name": "earcutInjection",
      "type": "any",
      "optional": true
    }]
  };
  FiberPolygon.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberPolygon"
  };
  return FiberPolygon;
}();
/**
 * Creates an extruded polygon mesh, with depth in the Y direction.
 * * You can set different colors and different images to the top, bottom and extruded side by using the parameters `faceColors` (an array of 3 Color3 elements) and `faceUV` (an array of 3 Vector4 elements)
 *
 * This code has been generated
 */


var FiberExtrudePolygon =
/** @class */
function () {
  function FiberExtrudePolygon() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberExtrudePolygon.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberExtrudePolygon.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberExtrudePolygon.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "ExtrudePolygon",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "shape",
        "type": "BabylonjsCoreVector3[]",
        "optional": false
      }, {
        "name": "holes",
        "type": "BabylonjsCoreVector3[][]",
        "optional": true
      }, {
        "name": "depth",
        "type": "number",
        "optional": true
      }, {
        "name": "faceUV",
        "type": "BabylonjsCoreVector4[]",
        "optional": true
      }, {
        "name": "faceColors",
        "type": "BabylonjsCoreColor4[]",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }, {
        "name": "sideOrientation",
        "type": "number",
        "optional": true
      }, {
        "name": "frontUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "backUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }, {
      "name": "earcutInjection",
      "type": "any",
      "optional": true
    }]
  };
  FiberExtrudePolygon.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberExtrudePolygon"
  };
  return FiberExtrudePolygon;
}();
/**
 * Creates a tube mesh.
 * The tube is a parametric shape. It has no predefined shape. Its final shape will depend on the input parameters
 * * The parameter `path` is a required array of successive Vector3. It is the curve used as the axis of the tube
 * * The parameter `radius` (positive float, default 1) sets the tube radius size
 * * The parameter `tessellation` (positive float, default 64) is the number of sides on the tubular surface
 * * The parameter `radiusFunction` (javascript function, default null) is a vanilla javascript function. If it is not null, it overwrittes the parameter `radius`
 * * This function is called on each point of the tube path and is passed the index `i` of the i-th point and the distance of this point from the first point of the path. It must return a radius value (positive float)
 * * The parameter `arc` (positive float, maximum 1, default 1) is the ratio to apply to the tube circumference : 2 x PI x arc
 * * The parameter `cap` sets the way the extruded shape is capped. Possible values : BABYLON.Mesh.NO_CAP (default), BABYLON.Mesh.CAP_START, BABYLON.Mesh.CAP_END, BABYLON.Mesh.CAP_ALL
 * * The optional parameter `instance` is an instance of an existing Tube object to be updated with the passed `pathArray` parameter : https://doc.babylonjs.com/how_to/how_to_dynamically_morph_a_mesh#tube
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The optional parameter `invertUV` (boolean, default false) swaps in the geometry the U and V coordinates to apply a texture
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberTube =
/** @class */
function () {
  function FiberTube() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberTube.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberTube.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberTube.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreateTube",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "path",
        "type": "BabylonjsCoreVector3[]",
        "optional": false
      }, {
        "name": "radius",
        "type": "number",
        "optional": true
      }, {
        "name": "tessellation",
        "type": "number",
        "optional": true
      }, {
        "name": "radiusFunction",
        "type": "(i: number, distance: number) => number",
        "optional": true
      }, {
        "name": "cap",
        "type": "number",
        "optional": true
      }, {
        "name": "arc",
        "type": "number",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }, {
        "name": "sideOrientation",
        "type": "number",
        "optional": true
      }, {
        "name": "frontUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "backUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "instance",
        "type": "BabylonjsCoreMesh",
        "optional": true
      }, {
        "name": "invertUV",
        "type": "boolean",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberTube.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberTube"
  };
  return FiberTube;
}();
/**
 * Creates a polyhedron mesh
 * * The parameter `type` (positive integer, max 14, default 0) sets the polyhedron type to build among the 15 embbeded types. Please refer to the type sheet in the tutorial to choose the wanted type
 * * The parameter `size` (positive float, default 1) sets the polygon size
 * * You can overwrite the `size` on each dimension bu using the parameters `sizeX`, `sizeY` or `sizeZ` (positive floats, default to `size` value)
 * * You can build other polyhedron types than the 15 embbeded ones by setting the parameter `custom` (`polyhedronObject`, default null). If you set the parameter `custom`, this overwrittes the parameter `type`
 * * A `polyhedronObject` is a formatted javascript object. You'll find a full file with pre-set polyhedra here : https://github.com/BabylonJS/Extensions/tree/master/Polyhedron
 * * You can set the color and the UV of each side of the polyhedron with the parameters `faceColors` (Color4, default `(1, 1, 1, 1)`) and faceUV (Vector4, default `(0, 0, 1, 1)`)
 * * To understand how to set `faceUV` or `faceColors`, please read this by considering the right number of faces of your polyhedron, instead of only 6 for the box : https://doc.babylonjs.com/how_to/createbox_per_face_textures_and_colors
 * * The parameter `flat` (boolean, default true). If set to false, it gives the polyhedron a single global face, so less vertices and shared normals. In this case, `faceColors` and `faceUV` are ignored
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberPolyhedron =
/** @class */
function () {
  function FiberPolyhedron() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberPolyhedron.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPolyhedron.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPolyhedron.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreatePolyhedron",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "type",
        "type": "number",
        "optional": true
      }, {
        "name": "size",
        "type": "number",
        "optional": true
      }, {
        "name": "sizeX",
        "type": "number",
        "optional": true
      }, {
        "name": "sizeY",
        "type": "number",
        "optional": true
      }, {
        "name": "sizeZ",
        "type": "number",
        "optional": true
      }, {
        "name": "custom",
        "type": "any",
        "optional": true
      }, {
        "name": "faceUV",
        "type": "BabylonjsCoreVector4[]",
        "optional": true
      }, {
        "name": "faceColors",
        "type": "BabylonjsCoreColor4[]",
        "optional": true
      }, {
        "name": "flat",
        "type": "boolean",
        "optional": true
      }, {
        "name": "updatable",
        "type": "boolean",
        "optional": true
      }, {
        "name": "sideOrientation",
        "type": "number",
        "optional": true
      }, {
        "name": "frontUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }, {
        "name": "backUVs",
        "type": "BabylonjsCoreVector4",
        "optional": true
      }],
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberPolyhedron.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberPolyhedron"
  };
  return FiberPolyhedron;
}();
/**
 * Creates a decal mesh.
 * A decal is a mesh usually applied as a model onto the surface of another mesh. So don't forget the parameter `sourceMesh` depicting the decal
 * * The parameter `position` (Vector3, default `(0, 0, 0)`) sets the position of the decal in World coordinates
 * * The parameter `normal` (Vector3, default `Vector3.Up`) sets the normal of the mesh where the decal is applied onto in World coordinates
 * * The parameter `size` (Vector3, default `(1, 1, 1)`) sets the decal scaling
 * * The parameter `angle` (float in radian, default 0) sets the angle to rotate the decal
 *
 * This code has been generated
 */


var FiberDecal =
/** @class */
function () {
  function FiberDecal() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberDecal.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberDecal.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberDecal.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "meshBuilder",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreateDecal",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "sourceMesh",
      "type": "BabylonjsCoreAbstractMesh",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "position",
        "type": "BabylonjsCoreVector3",
        "optional": true
      }, {
        "name": "normal",
        "type": "BabylonjsCoreVector3",
        "optional": true
      }, {
        "name": "size",
        "type": "BabylonjsCoreVector3",
        "optional": true
      }, {
        "name": "angle",
        "type": "number",
        "optional": true
      }],
      "optional": false
    }]
  };
  FiberDecal.Metadata = {
    "acceptsMaterials": true,
    "isNode": true,
    "className": "FiberDecal"
  };
  return FiberDecal;
}();

var FiberMaterialPropsHandler =
/** @class */
function () {
  function FiberMaterialPropsHandler() {}

  FiberMaterialPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.alpha, newProps.alpha, 'alpha', 'number', changedProps);
    checkPrimitiveDiff(oldProps.alphaMode, newProps.alphaMode, 'alphaMode', 'number', changedProps); // type: 'BabylonjsCoreAnimation[]' property (not coded) BabylonjsCoreMaterial.animations.

    checkPrimitiveDiff(oldProps.backFaceCulling, newProps.backFaceCulling, 'backFaceCulling', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.checkReadyOnEveryCall, newProps.checkReadyOnEveryCall, 'checkReadyOnEveryCall', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.checkReadyOnlyOnce, newProps.checkReadyOnlyOnce, 'checkReadyOnlyOnce', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.depthFunction, newProps.depthFunction, 'depthFunction', 'number', changedProps);
    checkPrimitiveDiff(oldProps.disableDepthWrite, newProps.disableDepthWrite, 'disableDepthWrite', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.doNotSerialize, newProps.doNotSerialize, 'doNotSerialize', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.fillMode, newProps.fillMode, 'fillMode', 'number', changedProps);
    checkPrimitiveDiff(oldProps.fogEnabled, newProps.fogEnabled, 'fogEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.forceDepthWrite, newProps.forceDepthWrite, 'forceDepthWrite', 'boolean', changedProps);
    checkLambdaDiff(oldProps.getRenderTargetTextures, newProps.getRenderTargetTextures, 'getRenderTargetTextures', '() => BabylonjsCoreSmartArray<BabylonjsCoreRenderTargetTexture>', changedProps);
    checkPrimitiveDiff(oldProps.id, newProps.id, 'id', 'string', changedProps); // type: 'BabylonjsCoreIInspectable[]' property (not coded) BabylonjsCoreMaterial.inspectableCustomProperties.
    // type: '{ [id: string]: BabylonjsCoreAbstractMesh; }' property (not coded) BabylonjsCoreMaterial.meshMap.
    // type: 'any' property (not coded) BabylonjsCoreMaterial.metadata.

    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkPrimitiveDiff(oldProps.needDepthPrePass, newProps.needDepthPrePass, 'needDepthPrePass', 'boolean', changedProps);
    checkLambdaDiff(oldProps.onBind, newProps.onBind, 'onBind', '(Mesh: BabylonjsCoreAbstractMesh) => void', changedProps);
    checkLambdaDiff(oldProps.onCompiled, newProps.onCompiled, 'onCompiled', '(effect: BabylonjsCoreEffect) => void', changedProps);
    checkLambdaDiff(oldProps.onDispose, newProps.onDispose, 'onDispose', '() => void', changedProps);
    checkObservableDiff(oldProps.onDisposeObservable, newProps.onDisposeObservable, 'onDisposeObservable', 'BabylonjsCoreObservable<BabylonjsCoreMaterial>', changedProps);
    checkLambdaDiff(oldProps.onError, newProps.onError, 'onError', '(effect: BabylonjsCoreEffect, errors: string) => void', changedProps);
    checkPrimitiveDiff(oldProps.pointsCloud, newProps.pointsCloud, 'pointsCloud', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.pointSize, newProps.pointSize, 'pointSize', 'number', changedProps); // type: 'any' property (not coded) BabylonjsCoreMaterial.releaseVertexArrayObject.
    // type: 'any' property (not coded) BabylonjsCoreMaterial.reservedDataStore.

    checkPrimitiveDiff(oldProps.separateCullingPass, newProps.separateCullingPass, 'separateCullingPass', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.sideOrientation, newProps.sideOrientation, 'sideOrientation', 'number', changedProps);
    checkPrimitiveDiff(oldProps.state, newProps.state, 'state', 'string', changedProps);
    checkPrimitiveDiff(oldProps.uniqueId, newProps.uniqueId, 'uniqueId', 'number', changedProps);
    checkPrimitiveDiff(oldProps.wireframe, newProps.wireframe, 'wireframe', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.zOffset, newProps.zOffset, 'zOffset', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberMaterialPropsHandler;
}();
/**
 * Base class for the main features of a material in Babylon.js
 *
 * This code has been generated
 */


var FiberMaterial =
/** @class */
function () {
  function FiberMaterial() {
    this.propsHandlers = [new FiberMaterialPropsHandler()];
  }

  FiberMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberMaterial.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "Material",
    "namespace": "@babylonjs/core/Materials/material",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "doNotAdd",
      "type": "boolean",
      "optional": true
    }]
  };
  FiberMaterial.Metadata = {
    "isMaterial": true,
    "className": "FiberMaterial"
  };
  return FiberMaterial;
}();

var FiberShaderMaterialPropsHandler =
/** @class */
function () {
  function FiberShaderMaterialPropsHandler() {}

  FiberShaderMaterialPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = []; // type: 'any' property (not coded) BabylonjsCoreShaderMaterial.shaderPath.

    checkMethodDiff(oldProps.setArray2, newProps.setArray2, 'setArray2', '(name?: string, value?: number[]) => BabylonjsCoreShaderMaterial', changedProps);
    checkMethodDiff(oldProps.setArray3, newProps.setArray3, 'setArray3', '(name?: string, value?: number[]) => BabylonjsCoreShaderMaterial', changedProps);
    checkMethodDiff(oldProps.setArray4, newProps.setArray4, 'setArray4', '(name?: string, value?: number[]) => BabylonjsCoreShaderMaterial', changedProps);
    checkMethodDiff(oldProps.setColor3, newProps.setColor3, 'setColor3', '(name?: string, value?: BabylonjsCoreColor3) => BabylonjsCoreShaderMaterial', changedProps);
    checkMethodDiff(oldProps.setColor3Array, newProps.setColor3Array, 'setColor3Array', '(name?: string, value?: BabylonjsCoreColor3[]) => BabylonjsCoreShaderMaterial', changedProps);
    checkMethodDiff(oldProps.setColor4, newProps.setColor4, 'setColor4', '(name?: string, value?: BabylonjsCoreColor4) => BabylonjsCoreShaderMaterial', changedProps);
    checkMethodDiff(oldProps.setColor4Array, newProps.setColor4Array, 'setColor4Array', '(name?: string, value?: BabylonjsCoreColor4[]) => BabylonjsCoreShaderMaterial', changedProps);
    checkMethodDiff(oldProps.setFloat, newProps.setFloat, 'setFloat', '(name?: string, value?: number) => BabylonjsCoreShaderMaterial', changedProps);
    checkMethodDiff(oldProps.setFloats, newProps.setFloats, 'setFloats', '(name?: string, value?: number[]) => BabylonjsCoreShaderMaterial', changedProps);
    checkMethodDiff(oldProps.setInt, newProps.setInt, 'setInt', '(name?: string, value?: number) => BabylonjsCoreShaderMaterial', changedProps);
    checkMethodDiff(oldProps.setMatrices, newProps.setMatrices, 'setMatrices', '(name?: string, value?: BabylonjsCoreMatrix[]) => BabylonjsCoreShaderMaterial', changedProps);
    checkMethodDiff(oldProps.setMatrix, newProps.setMatrix, 'setMatrix', '(name?: string, value?: BabylonjsCoreMatrix) => BabylonjsCoreShaderMaterial', changedProps);
    checkMethodDiff(oldProps.setMatrix2x2, newProps.setMatrix2x2, 'setMatrix2x2', '(name?: string, value?: Float32Array) => BabylonjsCoreShaderMaterial', changedProps);
    checkMethodDiff(oldProps.setMatrix3x3, newProps.setMatrix3x3, 'setMatrix3x3', '(name?: string, value?: Float32Array) => BabylonjsCoreShaderMaterial', changedProps);
    checkMethodDiff(oldProps.setTexture, newProps.setTexture, 'setTexture', '(name?: string, texture?: BabylonjsCoreTexture) => BabylonjsCoreShaderMaterial', changedProps);
    checkMethodDiff(oldProps.setTextureArray, newProps.setTextureArray, 'setTextureArray', '(name?: string, textures?: BabylonjsCoreTexture[]) => BabylonjsCoreShaderMaterial', changedProps);
    checkMethodDiff(oldProps.setVector2, newProps.setVector2, 'setVector2', '(name?: string, value?: BabylonjsCoreVector2) => BabylonjsCoreShaderMaterial', changedProps);
    checkMethodDiff(oldProps.setVector3, newProps.setVector3, 'setVector3', '(name?: string, value?: BabylonjsCoreVector3) => BabylonjsCoreShaderMaterial', changedProps);
    checkMethodDiff(oldProps.setVector4, newProps.setVector4, 'setVector4', '(name?: string, value?: BabylonjsCoreVector4) => BabylonjsCoreShaderMaterial', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberShaderMaterialPropsHandler;
}();
/**
 * The ShaderMaterial object has the necessary methods to pass data from your scene to the Vertex and Fragment Shaders and returns a material that can be applied to any mesh.
 *
 * This returned material effects how the mesh will look based on the code in the shaders.
 *
 * This code has been generated
 */


var FiberShaderMaterial =
/** @class */
function () {
  function FiberShaderMaterial() {
    this.propsHandlers = [new FiberShaderMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberShaderMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberShaderMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberShaderMaterial.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "ShaderMaterial",
    "namespace": "@babylonjs/core/Materials/material",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "shaderPath",
      "type": "any",
      "optional": false
    }, {
      "name": "options",
      "type": "Partial<BabylonjsCoreIShaderMaterialOptions>",
      "optional": true
    }]
  };
  FiberShaderMaterial.Metadata = {
    "isMaterial": true,
    "className": "FiberShaderMaterial"
  };
  return FiberShaderMaterial;
}();

var FiberMultiMaterialPropsHandler =
/** @class */
function () {
  function FiberMultiMaterialPropsHandler() {}

  FiberMultiMaterialPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    // skipping type: 'BabylonjsCoreMaterial[]' property (not coded) BabylonjsCoreMultiMaterial.subMaterials.
    return null; // no props to check
  };

  return FiberMultiMaterialPropsHandler;
}();
/**
 * A multi-material is used to apply different materials to different parts of the same object without the need of
 * separate meshes. This can be use to improve performances.
 *
 * This code has been generated
 */


var FiberMultiMaterial =
/** @class */
function () {
  function FiberMultiMaterial() {
    this.propsHandlers = [new FiberMultiMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberMultiMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberMultiMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberMultiMaterial.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "MultiMaterial",
    "namespace": "@babylonjs/core/Materials/material",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberMultiMaterial.Metadata = {
    "isMaterial": true,
    "className": "FiberMultiMaterial"
  };
  return FiberMultiMaterial;
}();

var FiberPushMaterialPropsHandler =
/** @class */
function () {
  function FiberPushMaterialPropsHandler() {}

  FiberPushMaterialPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.allowShaderHotSwapping, newProps.allowShaderHotSwapping, 'allowShaderHotSwapping', 'boolean', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberPushMaterialPropsHandler;
}();
/**
 * Base class of materials working in push mode in babylon JS
 *
 * This code has been generated
 */


var FiberPushMaterial =
/** @class */
function () {
  function FiberPushMaterial() {
    this.propsHandlers = [new FiberPushMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberPushMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPushMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPushMaterial.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "PushMaterial",
    "namespace": "@babylonjs/core/Materials/material",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberPushMaterial.Metadata = {
    "isMaterial": true,
    "className": "FiberPushMaterial"
  };
  return FiberPushMaterial;
}();

var FiberStandardMaterialPropsHandler =
/** @class */
function () {
  function FiberStandardMaterialPropsHandler() {}

  FiberStandardMaterialPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.alphaCutOff, newProps.alphaCutOff, 'alphaCutOff', 'number', changedProps);
    checkColor3Diff(oldProps.ambientColor, newProps.ambientColor, 'ambientColor', 'BabylonjsCoreColor3', changedProps);
    checkTextureDiff(oldProps.ambientTexture, newProps.ambientTexture, 'ambientTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCoreStandardMaterial.ambientTexture.

    checkPrimitiveDiff(oldProps.AmbientTextureEnabled, newProps.AmbientTextureEnabled, 'AmbientTextureEnabled', 'boolean', changedProps);
    checkTextureDiff(oldProps.bumpTexture, newProps.bumpTexture, 'bumpTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCoreStandardMaterial.bumpTexture.

    checkPrimitiveDiff(oldProps.BumpTextureEnabled, newProps.BumpTextureEnabled, 'BumpTextureEnabled', 'boolean', changedProps); // type: 'BabylonjsCoreColorCurves' property (not coded) BabylonjsCoreStandardMaterial.cameraColorCurves.

    checkPrimitiveDiff(oldProps.cameraColorCurvesEnabled, newProps.cameraColorCurvesEnabled, 'cameraColorCurvesEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.cameraColorGradingEnabled, newProps.cameraColorGradingEnabled, 'cameraColorGradingEnabled', 'boolean', changedProps);
    checkTextureDiff(oldProps.cameraColorGradingTexture, newProps.cameraColorGradingTexture, 'cameraColorGradingTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCoreStandardMaterial.cameraColorGradingTexture.

    checkPrimitiveDiff(oldProps.cameraContrast, newProps.cameraContrast, 'cameraContrast', 'number', changedProps);
    checkPrimitiveDiff(oldProps.cameraExposure, newProps.cameraExposure, 'cameraExposure', 'number', changedProps);
    checkPrimitiveDiff(oldProps.cameraToneMappingEnabled, newProps.cameraToneMappingEnabled, 'cameraToneMappingEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.ColorGradingTextureEnabled, newProps.ColorGradingTextureEnabled, 'ColorGradingTextureEnabled', 'boolean', changedProps);
    checkLambdaDiff(oldProps.customShaderNameResolve, newProps.customShaderNameResolve, 'customShaderNameResolve', '(shaderName: string, uniforms: string[], uniformBuffers: string[], samplers: string[], defines: BabylonjsCoreStandardMaterialDefines) => string', changedProps);
    checkColor3Diff(oldProps.diffuseColor, newProps.diffuseColor, 'diffuseColor', 'BabylonjsCoreColor3', changedProps);
    checkFresnelParametersDiff(oldProps.diffuseFresnelParameters, newProps.diffuseFresnelParameters, 'diffuseFresnelParameters', 'BabylonjsCoreFresnelParameters', changedProps);
    checkTextureDiff(oldProps.diffuseTexture, newProps.diffuseTexture, 'diffuseTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCoreStandardMaterial.diffuseTexture.

    checkPrimitiveDiff(oldProps.DiffuseTextureEnabled, newProps.DiffuseTextureEnabled, 'DiffuseTextureEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.disableLighting, newProps.disableLighting, 'disableLighting', 'boolean', changedProps);
    checkColor3Diff(oldProps.emissiveColor, newProps.emissiveColor, 'emissiveColor', 'BabylonjsCoreColor3', changedProps);
    checkFresnelParametersDiff(oldProps.emissiveFresnelParameters, newProps.emissiveFresnelParameters, 'emissiveFresnelParameters', 'BabylonjsCoreFresnelParameters', changedProps);
    checkTextureDiff(oldProps.emissiveTexture, newProps.emissiveTexture, 'emissiveTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCoreStandardMaterial.emissiveTexture.

    checkPrimitiveDiff(oldProps.EmissiveTextureEnabled, newProps.EmissiveTextureEnabled, 'EmissiveTextureEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.FresnelEnabled, newProps.FresnelEnabled, 'FresnelEnabled', 'boolean', changedProps); // type: 'BabylonjsCoreImageProcessingConfiguration' property (not coded) BabylonjsCoreStandardMaterial.imageProcessingConfiguration.

    checkPrimitiveDiff(oldProps.indexOfRefraction, newProps.indexOfRefraction, 'indexOfRefraction', 'number', changedProps);
    checkPrimitiveDiff(oldProps.invertNormalMapX, newProps.invertNormalMapX, 'invertNormalMapX', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.invertNormalMapY, newProps.invertNormalMapY, 'invertNormalMapY', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.invertRefractionY, newProps.invertRefractionY, 'invertRefractionY', 'boolean', changedProps);
    checkTextureDiff(oldProps.lightmapTexture, newProps.lightmapTexture, 'lightmapTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCoreStandardMaterial.lightmapTexture.

    checkPrimitiveDiff(oldProps.LightmapTextureEnabled, newProps.LightmapTextureEnabled, 'LightmapTextureEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.linkEmissiveWithDiffuse, newProps.linkEmissiveWithDiffuse, 'linkEmissiveWithDiffuse', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.maxSimultaneousLights, newProps.maxSimultaneousLights, 'maxSimultaneousLights', 'number', changedProps);
    checkFresnelParametersDiff(oldProps.opacityFresnelParameters, newProps.opacityFresnelParameters, 'opacityFresnelParameters', 'BabylonjsCoreFresnelParameters', changedProps);
    checkTextureDiff(oldProps.opacityTexture, newProps.opacityTexture, 'opacityTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCoreStandardMaterial.opacityTexture.

    checkPrimitiveDiff(oldProps.OpacityTextureEnabled, newProps.OpacityTextureEnabled, 'OpacityTextureEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.parallaxScaleBias, newProps.parallaxScaleBias, 'parallaxScaleBias', 'number', changedProps);
    checkFresnelParametersDiff(oldProps.reflectionFresnelParameters, newProps.reflectionFresnelParameters, 'reflectionFresnelParameters', 'BabylonjsCoreFresnelParameters', changedProps);
    checkTextureDiff(oldProps.reflectionTexture, newProps.reflectionTexture, 'reflectionTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCoreStandardMaterial.reflectionTexture.

    checkPrimitiveDiff(oldProps.ReflectionTextureEnabled, newProps.ReflectionTextureEnabled, 'ReflectionTextureEnabled', 'boolean', changedProps);
    checkFresnelParametersDiff(oldProps.refractionFresnelParameters, newProps.refractionFresnelParameters, 'refractionFresnelParameters', 'BabylonjsCoreFresnelParameters', changedProps);
    checkTextureDiff(oldProps.refractionTexture, newProps.refractionTexture, 'refractionTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCoreStandardMaterial.refractionTexture.

    checkPrimitiveDiff(oldProps.RefractionTextureEnabled, newProps.RefractionTextureEnabled, 'RefractionTextureEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.roughness, newProps.roughness, 'roughness', 'number', changedProps);
    checkColor3Diff(oldProps.specularColor, newProps.specularColor, 'specularColor', 'BabylonjsCoreColor3', changedProps);
    checkPrimitiveDiff(oldProps.specularPower, newProps.specularPower, 'specularPower', 'number', changedProps);
    checkTextureDiff(oldProps.specularTexture, newProps.specularTexture, 'specularTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCoreStandardMaterial.specularTexture.

    checkPrimitiveDiff(oldProps.SpecularTextureEnabled, newProps.SpecularTextureEnabled, 'SpecularTextureEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.twoSidedLighting, newProps.twoSidedLighting, 'twoSidedLighting', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useAlphaFromDiffuseTexture, newProps.useAlphaFromDiffuseTexture, 'useAlphaFromDiffuseTexture', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useEmissiveAsIllumination, newProps.useEmissiveAsIllumination, 'useEmissiveAsIllumination', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useGlossinessFromSpecularMapAlpha, newProps.useGlossinessFromSpecularMapAlpha, 'useGlossinessFromSpecularMapAlpha', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useLightmapAsShadowmap, newProps.useLightmapAsShadowmap, 'useLightmapAsShadowmap', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useLogarithmicDepth, newProps.useLogarithmicDepth, 'useLogarithmicDepth', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useObjectSpaceNormalMap, newProps.useObjectSpaceNormalMap, 'useObjectSpaceNormalMap', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useParallax, newProps.useParallax, 'useParallax', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useParallaxOcclusion, newProps.useParallaxOcclusion, 'useParallaxOcclusion', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useReflectionFresnelFromSpecular, newProps.useReflectionFresnelFromSpecular, 'useReflectionFresnelFromSpecular', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useReflectionOverAlpha, newProps.useReflectionOverAlpha, 'useReflectionOverAlpha', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useSpecularOverAlpha, newProps.useSpecularOverAlpha, 'useSpecularOverAlpha', 'boolean', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberStandardMaterialPropsHandler;
}();
/**
 * This is the default material used in Babylon. It is the best trade off between quality
 * and performances.
 *
 * This code has been generated
 */


var FiberStandardMaterial =
/** @class */
function () {
  function FiberStandardMaterial() {
    this.propsHandlers = [new FiberStandardMaterialPropsHandler(), new FiberPushMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberStandardMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberStandardMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberStandardMaterial.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "StandardMaterial",
    "namespace": "@babylonjs/core/Materials/material",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberStandardMaterial.Metadata = {
    "isMaterial": true,
    "className": "FiberStandardMaterial"
  };
  return FiberStandardMaterial;
}();

var FiberBackgroundMaterialPropsHandler =
/** @class */
function () {
  function FiberBackgroundMaterialPropsHandler() {}

  FiberBackgroundMaterialPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkColor3Diff(oldProps._perceptualColor, newProps._perceptualColor, '_perceptualColor', 'BabylonjsCoreColor3', changedProps); // type: 'BabylonjsCoreColorCurves' property (not coded) BabylonjsCoreBackgroundMaterial.cameraColorCurves.

    checkPrimitiveDiff(oldProps.cameraColorCurvesEnabled, newProps.cameraColorCurvesEnabled, 'cameraColorCurvesEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.cameraColorGradingEnabled, newProps.cameraColorGradingEnabled, 'cameraColorGradingEnabled', 'boolean', changedProps);
    checkTextureDiff(oldProps.cameraColorGradingTexture, newProps.cameraColorGradingTexture, 'cameraColorGradingTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCoreBackgroundMaterial.cameraColorGradingTexture.

    checkPrimitiveDiff(oldProps.cameraContrast, newProps.cameraContrast, 'cameraContrast', 'number', changedProps);
    checkPrimitiveDiff(oldProps.cameraExposure, newProps.cameraExposure, 'cameraExposure', 'number', changedProps);
    checkPrimitiveDiff(oldProps.cameraToneMappingEnabled, newProps.cameraToneMappingEnabled, 'cameraToneMappingEnabled', 'boolean', changedProps);
    checkTextureDiff(oldProps.diffuseTexture, newProps.diffuseTexture, 'diffuseTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCoreBackgroundMaterial.diffuseTexture.

    checkPrimitiveDiff(oldProps.enableNoise, newProps.enableNoise, 'enableNoise', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.fovMultiplier, newProps.fovMultiplier, 'fovMultiplier', 'number', changedProps); // type: 'BabylonjsCoreImageProcessingConfiguration' property (not coded) BabylonjsCoreBackgroundMaterial.imageProcessingConfiguration.

    checkPrimitiveDiff(oldProps.maxSimultaneousLights, newProps.maxSimultaneousLights, 'maxSimultaneousLights', 'number', changedProps);
    checkPrimitiveDiff(oldProps.opacityFresnel, newProps.opacityFresnel, 'opacityFresnel', 'boolean', changedProps);
    checkColor3Diff(oldProps.primaryColor, newProps.primaryColor, 'primaryColor', 'BabylonjsCoreColor3', changedProps);
    checkPrimitiveDiff(oldProps.primaryColorHighlightLevel, newProps.primaryColorHighlightLevel, 'primaryColorHighlightLevel', 'number', changedProps);
    checkPrimitiveDiff(oldProps.primaryColorShadowLevel, newProps.primaryColorShadowLevel, 'primaryColorShadowLevel', 'number', changedProps);
    checkPrimitiveDiff(oldProps.reflectionAmount, newProps.reflectionAmount, 'reflectionAmount', 'number', changedProps);
    checkPrimitiveDiff(oldProps.reflectionBlur, newProps.reflectionBlur, 'reflectionBlur', 'number', changedProps);
    checkPrimitiveDiff(oldProps.reflectionFalloffDistance, newProps.reflectionFalloffDistance, 'reflectionFalloffDistance', 'number', changedProps);
    checkPrimitiveDiff(oldProps.reflectionFresnel, newProps.reflectionFresnel, 'reflectionFresnel', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.reflectionReflectance0, newProps.reflectionReflectance0, 'reflectionReflectance0', 'number', changedProps);
    checkPrimitiveDiff(oldProps.reflectionReflectance90, newProps.reflectionReflectance90, 'reflectionReflectance90', 'number', changedProps);
    checkPrimitiveDiff(oldProps.reflectionStandardFresnelWeight, newProps.reflectionStandardFresnelWeight, 'reflectionStandardFresnelWeight', 'number', changedProps);
    checkTextureDiff(oldProps.reflectionTexture, newProps.reflectionTexture, 'reflectionTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCoreBackgroundMaterial.reflectionTexture.

    checkVector3Diff(oldProps.sceneCenter, newProps.sceneCenter, 'sceneCenter', 'BabylonjsCoreVector3', changedProps);
    checkPrimitiveDiff(oldProps.shadowLevel, newProps.shadowLevel, 'shadowLevel', 'number', changedProps); // type: 'BabylonjsCoreIShadowLight[]' property (not coded) BabylonjsCoreBackgroundMaterial.shadowLights.

    checkPrimitiveDiff(oldProps.switchToBGR, newProps.switchToBGR, 'switchToBGR', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useEquirectangularFOV, newProps.useEquirectangularFOV, 'useEquirectangularFOV', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useRGBColor, newProps.useRGBColor, 'useRGBColor', 'boolean', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberBackgroundMaterialPropsHandler;
}();
/**
 * Background material used to create an efficient environement around your scene.
 *
 * This code has been generated
 */


var FiberBackgroundMaterial =
/** @class */
function () {
  function FiberBackgroundMaterial() {
    this.propsHandlers = [new FiberBackgroundMaterialPropsHandler(), new FiberPushMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberBackgroundMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberBackgroundMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberBackgroundMaterial.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "BackgroundMaterial",
    "namespace": "@babylonjs/core/Materials/material",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberBackgroundMaterial.Metadata = {
    "isMaterial": true,
    "className": "FiberBackgroundMaterial"
  };
  return FiberBackgroundMaterial;
}();

var FiberPBRBaseMaterialPropsHandler =
/** @class */
function () {
  function FiberPBRBaseMaterialPropsHandler() {}

  FiberPBRBaseMaterialPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkLambdaDiff(oldProps.customShaderNameResolve, newProps.customShaderNameResolve, 'customShaderNameResolve', '(shaderName: string, uniforms: string[], uniformBuffers: string[], samplers: string[], defines: BabylonjsCorePBRMaterialDefines) => string', changedProps); // type: 'any' property (not coded) BabylonjsCorePBRBaseMaterial.debugFactor.
    // type: 'any' property (not coded) BabylonjsCorePBRBaseMaterial.debugLimit.

    checkPrimitiveDiff(oldProps.debugMode, newProps.debugMode, 'debugMode', 'number', changedProps);
    checkPrimitiveDiff(oldProps.transparencyMode, newProps.transparencyMode, 'transparencyMode', 'number', changedProps);
    checkPrimitiveDiff(oldProps.useLogarithmicDepth, newProps.useLogarithmicDepth, 'useLogarithmicDepth', 'boolean', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberPBRBaseMaterialPropsHandler;
}();
/**
 * The Physically based material base class of BJS.
 *
 * This offers the main features of a standard PBR material.
 * For more information, please refer to the documentation :
 * https://doc.babylonjs.com/how_to/physically_based_rendering
 *
 * This code has been generated
 */


var FiberPBRBaseMaterial =
/** @class */
function () {
  function FiberPBRBaseMaterial() {
    this.propsHandlers = [new FiberPBRBaseMaterialPropsHandler(), new FiberPushMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberPBRBaseMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPBRBaseMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPBRBaseMaterial.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "PBRBaseMaterial",
    "namespace": "@babylonjs/core/Materials/material",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberPBRBaseMaterial.Metadata = {
    "isMaterial": true,
    "className": "FiberPBRBaseMaterial"
  };
  return FiberPBRBaseMaterial;
}();

var FiberPBRBaseSimpleMaterialPropsHandler =
/** @class */
function () {
  function FiberPBRBaseSimpleMaterialPropsHandler() {}

  FiberPBRBaseSimpleMaterialPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.alphaCutOff, newProps.alphaCutOff, 'alphaCutOff', 'number', changedProps);
    checkPrimitiveDiff(oldProps.disableLighting, newProps.disableLighting, 'disableLighting', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.doubleSided, newProps.doubleSided, 'doubleSided', 'boolean', changedProps);
    checkColor3Diff(oldProps.emissiveColor, newProps.emissiveColor, 'emissiveColor', 'BabylonjsCoreColor3', changedProps);
    checkTextureDiff(oldProps.emissiveTexture, newProps.emissiveTexture, 'emissiveTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRBaseSimpleMaterial.emissiveTexture.

    checkTextureDiff(oldProps.environmentTexture, newProps.environmentTexture, 'environmentTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRBaseSimpleMaterial.environmentTexture.

    checkPrimitiveDiff(oldProps.invertNormalMapX, newProps.invertNormalMapX, 'invertNormalMapX', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.invertNormalMapY, newProps.invertNormalMapY, 'invertNormalMapY', 'boolean', changedProps);
    checkTextureDiff(oldProps.lightmapTexture, newProps.lightmapTexture, 'lightmapTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRBaseSimpleMaterial.lightmapTexture.

    checkPrimitiveDiff(oldProps.maxSimultaneousLights, newProps.maxSimultaneousLights, 'maxSimultaneousLights', 'number', changedProps);
    checkTextureDiff(oldProps.normalTexture, newProps.normalTexture, 'normalTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRBaseSimpleMaterial.normalTexture.

    checkPrimitiveDiff(oldProps.occlusionStrength, newProps.occlusionStrength, 'occlusionStrength', 'number', changedProps);
    checkTextureDiff(oldProps.occlusionTexture, newProps.occlusionTexture, 'occlusionTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRBaseSimpleMaterial.occlusionTexture.

    checkPrimitiveDiff(oldProps.useLightmapAsShadowmap, newProps.useLightmapAsShadowmap, 'useLightmapAsShadowmap', 'boolean', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberPBRBaseSimpleMaterialPropsHandler;
}();
/**
 * The Physically based simple base material of BJS.
 *
 * This enables better naming and convention enforcements on top of the pbrMaterial.
 * It is used as the base class for both the specGloss and metalRough conventions.
 *
 * This code has been generated
 */


var FiberPBRBaseSimpleMaterial =
/** @class */
function () {
  function FiberPBRBaseSimpleMaterial() {
    this.propsHandlers = [new FiberPBRBaseSimpleMaterialPropsHandler(), new FiberPBRBaseMaterialPropsHandler(), new FiberPushMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberPBRBaseSimpleMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPBRBaseSimpleMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPBRBaseSimpleMaterial.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "PBRBaseSimpleMaterial",
    "namespace": "@babylonjs/core/Materials/material",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberPBRBaseSimpleMaterial.Metadata = {
    "isMaterial": true,
    "className": "FiberPBRBaseSimpleMaterial"
  };
  return FiberPBRBaseSimpleMaterial;
}();

var FiberPBRMetallicRoughnessMaterialPropsHandler =
/** @class */
function () {
  function FiberPBRMetallicRoughnessMaterialPropsHandler() {}

  FiberPBRMetallicRoughnessMaterialPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkColor3Diff(oldProps.baseColor, newProps.baseColor, 'baseColor', 'BabylonjsCoreColor3', changedProps);
    checkTextureDiff(oldProps.baseTexture, newProps.baseTexture, 'baseTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRMetallicRoughnessMaterial.baseTexture.

    checkPrimitiveDiff(oldProps.metallic, newProps.metallic, 'metallic', 'number', changedProps);
    checkTextureDiff(oldProps.metallicRoughnessTexture, newProps.metallicRoughnessTexture, 'metallicRoughnessTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRMetallicRoughnessMaterial.metallicRoughnessTexture.

    checkPrimitiveDiff(oldProps.roughness, newProps.roughness, 'roughness', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberPBRMetallicRoughnessMaterialPropsHandler;
}();
/**
 * The PBR material of BJS following the metal roughness convention.
 *
 * This fits to the PBR convention in the GLTF definition:
 * https://github.com/KhronosGroup/glTF/tree/2.0/specification/2.0
 *
 * This code has been generated
 */


var FiberPBRMetallicRoughnessMaterial =
/** @class */
function () {
  function FiberPBRMetallicRoughnessMaterial() {
    this.propsHandlers = [new FiberPBRMetallicRoughnessMaterialPropsHandler(), new FiberPBRBaseSimpleMaterialPropsHandler(), new FiberPBRBaseMaterialPropsHandler(), new FiberPushMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberPBRMetallicRoughnessMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPBRMetallicRoughnessMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPBRMetallicRoughnessMaterial.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "PBRMetallicRoughnessMaterial",
    "namespace": "@babylonjs/core/Materials/material",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberPBRMetallicRoughnessMaterial.Metadata = {
    "isMaterial": true,
    "className": "FiberPBRMetallicRoughnessMaterial"
  };
  return FiberPBRMetallicRoughnessMaterial;
}();

var FiberPBRSpecularGlossinessMaterialPropsHandler =
/** @class */
function () {
  function FiberPBRSpecularGlossinessMaterialPropsHandler() {}

  FiberPBRSpecularGlossinessMaterialPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkColor3Diff(oldProps.diffuseColor, newProps.diffuseColor, 'diffuseColor', 'BabylonjsCoreColor3', changedProps);
    checkTextureDiff(oldProps.diffuseTexture, newProps.diffuseTexture, 'diffuseTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRSpecularGlossinessMaterial.diffuseTexture.

    checkPrimitiveDiff(oldProps.glossiness, newProps.glossiness, 'glossiness', 'number', changedProps);
    checkColor3Diff(oldProps.specularColor, newProps.specularColor, 'specularColor', 'BabylonjsCoreColor3', changedProps);
    checkTextureDiff(oldProps.specularGlossinessTexture, newProps.specularGlossinessTexture, 'specularGlossinessTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRSpecularGlossinessMaterial.specularGlossinessTexture.

    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberPBRSpecularGlossinessMaterialPropsHandler;
}();
/**
 * The PBR material of BJS following the specular glossiness convention.
 *
 * This fits to the PBR convention in the GLTF definition:
 * https://github.com/KhronosGroup/glTF/tree/2.0/extensions/Khronos/KHR_materials_pbrSpecularGlossiness
 *
 * This code has been generated
 */


var FiberPBRSpecularGlossinessMaterial =
/** @class */
function () {
  function FiberPBRSpecularGlossinessMaterial() {
    this.propsHandlers = [new FiberPBRSpecularGlossinessMaterialPropsHandler(), new FiberPBRBaseSimpleMaterialPropsHandler(), new FiberPBRBaseMaterialPropsHandler(), new FiberPushMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberPBRSpecularGlossinessMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPBRSpecularGlossinessMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPBRSpecularGlossinessMaterial.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "PBRSpecularGlossinessMaterial",
    "namespace": "@babylonjs/core/Materials/material",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberPBRSpecularGlossinessMaterial.Metadata = {
    "isMaterial": true,
    "className": "FiberPBRSpecularGlossinessMaterial"
  };
  return FiberPBRSpecularGlossinessMaterial;
}();

var FiberPBRMaterialPropsHandler =
/** @class */
function () {
  function FiberPBRMaterialPropsHandler() {}

  FiberPBRMaterialPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkColor3Diff(oldProps.albedoColor, newProps.albedoColor, 'albedoColor', 'BabylonjsCoreColor3', changedProps);
    checkTextureDiff(oldProps.albedoTexture, newProps.albedoTexture, 'albedoTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRMaterial.albedoTexture.

    checkPrimitiveDiff(oldProps.alphaCutOff, newProps.alphaCutOff, 'alphaCutOff', 'number', changedProps);
    checkColor3Diff(oldProps.ambientColor, newProps.ambientColor, 'ambientColor', 'BabylonjsCoreColor3', changedProps);
    checkTextureDiff(oldProps.ambientTexture, newProps.ambientTexture, 'ambientTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRMaterial.ambientTexture.

    checkPrimitiveDiff(oldProps.ambientTextureImpactOnAnalyticalLights, newProps.ambientTextureImpactOnAnalyticalLights, 'ambientTextureImpactOnAnalyticalLights', 'number', changedProps);
    checkPrimitiveDiff(oldProps.ambientTextureStrength, newProps.ambientTextureStrength, 'ambientTextureStrength', 'number', changedProps);
    checkTextureDiff(oldProps.bumpTexture, newProps.bumpTexture, 'bumpTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRMaterial.bumpTexture.
    // type: 'BabylonjsCoreColorCurves' property (not coded) BabylonjsCorePBRMaterial.cameraColorCurves.

    checkPrimitiveDiff(oldProps.cameraColorCurvesEnabled, newProps.cameraColorCurvesEnabled, 'cameraColorCurvesEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.cameraColorGradingEnabled, newProps.cameraColorGradingEnabled, 'cameraColorGradingEnabled', 'boolean', changedProps);
    checkTextureDiff(oldProps.cameraColorGradingTexture, newProps.cameraColorGradingTexture, 'cameraColorGradingTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRMaterial.cameraColorGradingTexture.

    checkPrimitiveDiff(oldProps.cameraContrast, newProps.cameraContrast, 'cameraContrast', 'number', changedProps);
    checkPrimitiveDiff(oldProps.cameraExposure, newProps.cameraExposure, 'cameraExposure', 'number', changedProps);
    checkPrimitiveDiff(oldProps.cameraToneMappingEnabled, newProps.cameraToneMappingEnabled, 'cameraToneMappingEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.directIntensity, newProps.directIntensity, 'directIntensity', 'number', changedProps);
    checkPrimitiveDiff(oldProps.disableBumpMap, newProps.disableBumpMap, 'disableBumpMap', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.disableLighting, newProps.disableLighting, 'disableLighting', 'boolean', changedProps);
    checkColor3Diff(oldProps.emissiveColor, newProps.emissiveColor, 'emissiveColor', 'BabylonjsCoreColor3', changedProps);
    checkPrimitiveDiff(oldProps.emissiveIntensity, newProps.emissiveIntensity, 'emissiveIntensity', 'number', changedProps);
    checkTextureDiff(oldProps.emissiveTexture, newProps.emissiveTexture, 'emissiveTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRMaterial.emissiveTexture.

    checkPrimitiveDiff(oldProps.enableSpecularAntiAliasing, newProps.enableSpecularAntiAliasing, 'enableSpecularAntiAliasing', 'boolean', changedProps);
    checkTextureDiff(oldProps.environmentBRDFTexture, newProps.environmentBRDFTexture, 'environmentBRDFTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRMaterial.environmentBRDFTexture.

    checkPrimitiveDiff(oldProps.environmentIntensity, newProps.environmentIntensity, 'environmentIntensity', 'number', changedProps);
    checkPrimitiveDiff(oldProps.forceAlphaTest, newProps.forceAlphaTest, 'forceAlphaTest', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.forceIrradianceInFragment, newProps.forceIrradianceInFragment, 'forceIrradianceInFragment', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.forceNormalForward, newProps.forceNormalForward, 'forceNormalForward', 'boolean', changedProps); // type: 'BabylonjsCoreImageProcessingConfiguration' property (not coded) BabylonjsCorePBRMaterial.imageProcessingConfiguration.

    checkPrimitiveDiff(oldProps.indexOfRefraction, newProps.indexOfRefraction, 'indexOfRefraction', 'number', changedProps);
    checkPrimitiveDiff(oldProps.invertNormalMapX, newProps.invertNormalMapX, 'invertNormalMapX', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.invertNormalMapY, newProps.invertNormalMapY, 'invertNormalMapY', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.invertRefractionY, newProps.invertRefractionY, 'invertRefractionY', 'boolean', changedProps);
    checkTextureDiff(oldProps.lightmapTexture, newProps.lightmapTexture, 'lightmapTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRMaterial.lightmapTexture.

    checkPrimitiveDiff(oldProps.linkRefractionWithTransparency, newProps.linkRefractionWithTransparency, 'linkRefractionWithTransparency', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.maxSimultaneousLights, newProps.maxSimultaneousLights, 'maxSimultaneousLights', 'number', changedProps);
    checkPrimitiveDiff(oldProps.metallic, newProps.metallic, 'metallic', 'number', changedProps);
    checkPrimitiveDiff(oldProps.metallicF0Factor, newProps.metallicF0Factor, 'metallicF0Factor', 'number', changedProps);
    checkTextureDiff(oldProps.metallicTexture, newProps.metallicTexture, 'metallicTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRMaterial.metallicTexture.

    checkPrimitiveDiff(oldProps.microSurface, newProps.microSurface, 'microSurface', 'number', changedProps);
    checkTextureDiff(oldProps.microSurfaceTexture, newProps.microSurfaceTexture, 'microSurfaceTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRMaterial.microSurfaceTexture.

    checkTextureDiff(oldProps.opacityTexture, newProps.opacityTexture, 'opacityTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRMaterial.opacityTexture.

    checkPrimitiveDiff(oldProps.parallaxScaleBias, newProps.parallaxScaleBias, 'parallaxScaleBias', 'number', changedProps);
    checkColor3Diff(oldProps.reflectionColor, newProps.reflectionColor, 'reflectionColor', 'BabylonjsCoreColor3', changedProps);
    checkTextureDiff(oldProps.reflectionTexture, newProps.reflectionTexture, 'reflectionTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRMaterial.reflectionTexture.

    checkColor3Diff(oldProps.reflectivityColor, newProps.reflectivityColor, 'reflectivityColor', 'BabylonjsCoreColor3', changedProps);
    checkTextureDiff(oldProps.reflectivityTexture, newProps.reflectivityTexture, 'reflectivityTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRMaterial.reflectivityTexture.

    checkTextureDiff(oldProps.refractionTexture, newProps.refractionTexture, 'refractionTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCorePBRMaterial.refractionTexture.

    checkPrimitiveDiff(oldProps.roughness, newProps.roughness, 'roughness', 'number', changedProps);
    checkPrimitiveDiff(oldProps.specularIntensity, newProps.specularIntensity, 'specularIntensity', 'number', changedProps);
    checkPrimitiveDiff(oldProps.twoSidedLighting, newProps.twoSidedLighting, 'twoSidedLighting', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.unlit, newProps.unlit, 'unlit', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useAlphaFresnel, newProps.useAlphaFresnel, 'useAlphaFresnel', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useAlphaFromAlbedoTexture, newProps.useAlphaFromAlbedoTexture, 'useAlphaFromAlbedoTexture', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useAmbientInGrayScale, newProps.useAmbientInGrayScale, 'useAmbientInGrayScale', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useAmbientOcclusionFromMetallicTextureRed, newProps.useAmbientOcclusionFromMetallicTextureRed, 'useAmbientOcclusionFromMetallicTextureRed', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useAutoMicroSurfaceFromReflectivityMap, newProps.useAutoMicroSurfaceFromReflectivityMap, 'useAutoMicroSurfaceFromReflectivityMap', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useGLTFLightFalloff, newProps.useGLTFLightFalloff, 'useGLTFLightFalloff', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useHorizonOcclusion, newProps.useHorizonOcclusion, 'useHorizonOcclusion', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useLightmapAsShadowmap, newProps.useLightmapAsShadowmap, 'useLightmapAsShadowmap', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useLinearAlphaFresnel, newProps.useLinearAlphaFresnel, 'useLinearAlphaFresnel', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useMetallicF0FactorFromMetallicTexture, newProps.useMetallicF0FactorFromMetallicTexture, 'useMetallicF0FactorFromMetallicTexture', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useMetallnessFromMetallicTextureBlue, newProps.useMetallnessFromMetallicTextureBlue, 'useMetallnessFromMetallicTextureBlue', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useMicroSurfaceFromReflectivityMapAlpha, newProps.useMicroSurfaceFromReflectivityMapAlpha, 'useMicroSurfaceFromReflectivityMapAlpha', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useObjectSpaceNormalMap, newProps.useObjectSpaceNormalMap, 'useObjectSpaceNormalMap', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useParallax, newProps.useParallax, 'useParallax', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useParallaxOcclusion, newProps.useParallaxOcclusion, 'useParallaxOcclusion', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.usePhysicalLightFalloff, newProps.usePhysicalLightFalloff, 'usePhysicalLightFalloff', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useRadianceOcclusion, newProps.useRadianceOcclusion, 'useRadianceOcclusion', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useRadianceOverAlpha, newProps.useRadianceOverAlpha, 'useRadianceOverAlpha', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useRoughnessFromMetallicTextureAlpha, newProps.useRoughnessFromMetallicTextureAlpha, 'useRoughnessFromMetallicTextureAlpha', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useRoughnessFromMetallicTextureGreen, newProps.useRoughnessFromMetallicTextureGreen, 'useRoughnessFromMetallicTextureGreen', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useSpecularOverAlpha, newProps.useSpecularOverAlpha, 'useSpecularOverAlpha', 'boolean', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberPBRMaterialPropsHandler;
}();
/**
 * The Physically based material of BJS.
 *
 * This offers the main features of a standard PBR material.
 * For more information, please refer to the documentation :
 * https://doc.babylonjs.com/how_to/physically_based_rendering
 *
 * This code has been generated
 */


var FiberPBRMaterial =
/** @class */
function () {
  function FiberPBRMaterial() {
    this.propsHandlers = [new FiberPBRMaterialPropsHandler(), new FiberPBRBaseMaterialPropsHandler(), new FiberPushMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberPBRMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPBRMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPBRMaterial.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "PBRMaterial",
    "namespace": "@babylonjs/core/Materials/material",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberPBRMaterial.Metadata = {
    "isMaterial": true,
    "className": "FiberPBRMaterial"
  };
  return FiberPBRMaterial;
}();

var FiberNodeMaterialPropsHandler =
/** @class */
function () {
  function FiberNodeMaterialPropsHandler() {}

  FiberNodeMaterialPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = []; // type: 'BabylonjsCoreNodeMaterialBlock[]' property (not coded) BabylonjsCoreNodeMaterial.attachedBlocks.
    // type: 'any' property (not coded) BabylonjsCoreNodeMaterial.BJSNODEMATERIALEDITOR.
    // type: 'any' property (not coded) BabylonjsCoreNodeMaterial.editorData.

    checkPrimitiveDiff(oldProps.ignoreAlpha, newProps.ignoreAlpha, 'ignoreAlpha', 'boolean', changedProps); // type: 'BabylonjsCoreImageProcessingConfiguration' property (not coded) BabylonjsCoreNodeMaterial.imageProcessingConfiguration.

    checkPrimitiveDiff(oldProps.maxSimultaneousLights, newProps.maxSimultaneousLights, 'maxSimultaneousLights', 'number', changedProps);
    checkObservableDiff(oldProps.onBuildObservable, newProps.onBuildObservable, 'onBuildObservable', 'BabylonjsCoreObservable<BabylonjsCoreNodeMaterial>', changedProps); // type: 'BabylonjsCoreINodeMaterialOptions' property (not coded) BabylonjsCoreNodeMaterial.options.

    checkMethodDiff(oldProps.addOutputNode, newProps.addOutputNode, 'addOutputNode', '(node?: BabylonjsCoreNodeMaterialBlock) => this', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberNodeMaterialPropsHandler;
}();
/**
 * Class used to create a node based material built by assembling shader blocks
 *
 * This code has been generated
 */


var FiberNodeMaterial =
/** @class */
function () {
  function FiberNodeMaterial() {
    this.propsHandlers = [new FiberNodeMaterialPropsHandler(), new FiberPushMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberNodeMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberNodeMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberNodeMaterial.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "NodeMaterial",
    "namespace": "@babylonjs/core/Materials/material",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }, {
      "name": "options",
      "type": "Partial<BabylonjsCoreINodeMaterialOptions>",
      "optional": true
    }]
  };
  FiberNodeMaterial.Metadata = {
    "isMaterial": true,
    "className": "FiberNodeMaterial"
  };
  return FiberNodeMaterial;
}();

var FiberFluentMaterialPropsHandler =
/** @class */
function () {
  function FiberFluentMaterialPropsHandler() {}

  FiberFluentMaterialPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkColor3Diff(oldProps.albedoColor, newProps.albedoColor, 'albedoColor', 'BabylonjsCoreColor3', changedProps);
    checkTextureDiff(oldProps.albedoTexture, newProps.albedoTexture, 'albedoTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsGuiFluentMaterial.albedoTexture.

    checkPrimitiveDiff(oldProps.alpha, newProps.alpha, 'alpha', 'number', changedProps);
    checkPrimitiveDiff(oldProps.borderMinValue, newProps.borderMinValue, 'borderMinValue', 'number', changedProps);
    checkPrimitiveDiff(oldProps.borderWidth, newProps.borderWidth, 'borderWidth', 'number', changedProps);
    checkPrimitiveDiff(oldProps.edgeSmoothingValue, newProps.edgeSmoothingValue, 'edgeSmoothingValue', 'number', changedProps);
    checkColor4Diff(oldProps.hoverColor, newProps.hoverColor, 'hoverColor', 'BabylonjsCoreColor4', changedProps);
    checkVector3Diff(oldProps.hoverPosition, newProps.hoverPosition, 'hoverPosition', 'BabylonjsCoreVector3', changedProps);
    checkPrimitiveDiff(oldProps.hoverRadius, newProps.hoverRadius, 'hoverRadius', 'number', changedProps);
    checkColor3Diff(oldProps.innerGlowColor, newProps.innerGlowColor, 'innerGlowColor', 'BabylonjsCoreColor3', changedProps);
    checkPrimitiveDiff(oldProps.innerGlowColorIntensity, newProps.innerGlowColorIntensity, 'innerGlowColorIntensity', 'number', changedProps);
    checkPrimitiveDiff(oldProps.renderBorders, newProps.renderBorders, 'renderBorders', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.renderHoverLight, newProps.renderHoverLight, 'renderHoverLight', 'boolean', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberFluentMaterialPropsHandler;
}();
/**
 * Class used to render controls with fluent desgin
 *
 * This code has been generated
 */


var FiberFluentMaterial =
/** @class */
function () {
  function FiberFluentMaterial() {
    this.propsHandlers = [new FiberFluentMaterialPropsHandler(), new FiberPushMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberFluentMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberFluentMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberFluentMaterial.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "FluentMaterial",
    "namespace": "@babylonjs/core/Materials/material",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberFluentMaterial.Metadata = {
    "isMaterial": true,
    "className": "FiberFluentMaterial"
  };
  return FiberFluentMaterial;
}();

var FiberLightPropsHandler =
/** @class */
function () {
  function FiberLightPropsHandler() {}

  FiberLightPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkColor3Diff(oldProps.diffuse, newProps.diffuse, 'diffuse', 'BabylonjsCoreColor3', changedProps); // type: 'BabylonjsCoreAbstractMesh[]' property (not coded) BabylonjsCoreLight.excludedMeshes.

    checkPrimitiveDiff(oldProps.excludeWithLayerMask, newProps.excludeWithLayerMask, 'excludeWithLayerMask', 'number', changedProps);
    checkPrimitiveDiff(oldProps.falloffType, newProps.falloffType, 'falloffType', 'number', changedProps); // type: 'BabylonjsCoreAbstractMesh[]' property (not coded) BabylonjsCoreLight.includedOnlyMeshes.

    checkPrimitiveDiff(oldProps.includeOnlyWithLayerMask, newProps.includeOnlyWithLayerMask, 'includeOnlyWithLayerMask', 'number', changedProps);
    checkPrimitiveDiff(oldProps.intensity, newProps.intensity, 'intensity', 'number', changedProps);
    checkPrimitiveDiff(oldProps.intensityMode, newProps.intensityMode, 'intensityMode', 'number', changedProps);
    checkPrimitiveDiff(oldProps.lightmapMode, newProps.lightmapMode, 'lightmapMode', 'number', changedProps);
    checkPrimitiveDiff(oldProps.radius, newProps.radius, 'radius', 'number', changedProps);
    checkPrimitiveDiff(oldProps.range, newProps.range, 'range', 'number', changedProps);
    checkPrimitiveDiff(oldProps.renderPriority, newProps.renderPriority, 'renderPriority', 'number', changedProps);
    checkPrimitiveDiff(oldProps.shadowEnabled, newProps.shadowEnabled, 'shadowEnabled', 'boolean', changedProps);
    checkColor3Diff(oldProps.specular, newProps.specular, 'specular', 'BabylonjsCoreColor3', changedProps);
    checkMethodDiff(oldProps.setEnabled, newProps.setEnabled, 'setEnabled', '(value?: boolean) => void', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberLightPropsHandler;
}();
/**
 * Base class of all the lights in Babylon. It groups all the generic information about lights.
 * Lights are used, as you would expect, to affect how meshes are seen, in terms of both illumination and colour.
 * All meshes allow light to pass through them unless shadow generation is activated. The default number of lights allowed is four but this can be increased.
 *
 * This code has been generated
 */


var FiberLight =
/** @class */
function () {
  function FiberLight() {
    this.propsHandlers = [new FiberLightPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberLight.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberLight.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberLight.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "Light",
    "namespace": "@babylonjs/core/Lights/light",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberLight.Metadata = {
    "isNode": true,
    "className": "FiberLight"
  };
  return FiberLight;
}();

var FiberShadowLightPropsHandler =
/** @class */
function () {
  function FiberShadowLightPropsHandler() {}

  FiberShadowLightPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkLambdaDiff(oldProps.customProjectionMatrixBuilder, newProps.customProjectionMatrixBuilder, 'customProjectionMatrixBuilder', '(viewMatrix: BabylonjsCoreMatrix, renderList: BabylonjsCoreAbstractMesh[], result: BabylonjsCoreMatrix) => void', changedProps);
    checkVector3Diff(oldProps.direction, newProps.direction, 'direction', 'BabylonjsCoreVector3', changedProps);
    checkVector3Diff(oldProps.position, newProps.position, 'position', 'BabylonjsCoreVector3', changedProps);
    checkPrimitiveDiff(oldProps.shadowMaxZ, newProps.shadowMaxZ, 'shadowMaxZ', 'number', changedProps);
    checkPrimitiveDiff(oldProps.shadowMinZ, newProps.shadowMinZ, 'shadowMinZ', 'number', changedProps);
    checkVector3Diff(oldProps.transformedDirection, newProps.transformedDirection, 'transformedDirection', 'BabylonjsCoreVector3', changedProps);
    checkVector3Diff(oldProps.transformedPosition, newProps.transformedPosition, 'transformedPosition', 'BabylonjsCoreVector3', changedProps);
    checkMethodDiff(oldProps.setDirectionToTarget, newProps.setDirectionToTarget, 'setDirectionToTarget', '(target?: BabylonjsCoreVector3) => BabylonjsCoreVector3', changedProps);
    checkMethodDiff(oldProps.setShadowProjectionMatrix, newProps.setShadowProjectionMatrix, 'setShadowProjectionMatrix', '(matrix?: BabylonjsCoreMatrix, viewMatrix?: BabylonjsCoreMatrix, renderList?: BabylonjsCoreAbstractMesh[]) => BabylonjsCoreIShadowLight', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberShadowLightPropsHandler;
}();
/**
 * Base implementation IShadowLight
 * It groups all the common behaviour in order to reduce dupplication and better follow the DRY pattern.
 *
 * This code has been generated
 */


var FiberShadowLight =
/** @class */
function () {
  function FiberShadowLight() {
    this.propsHandlers = [new FiberShadowLightPropsHandler(), new FiberLightPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberShadowLight.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberShadowLight.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberShadowLight.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "ShadowLight",
    "namespace": "@babylonjs/core/Lights/light",
    "parameters": []
  };
  FiberShadowLight.Metadata = {
    "isNode": true,
    "isShadowLight": true,
    "className": "FiberShadowLight"
  };
  return FiberShadowLight;
}();

var FiberDirectionalLightPropsHandler =
/** @class */
function () {
  function FiberDirectionalLightPropsHandler() {}

  FiberDirectionalLightPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.autoCalcShadowZBounds, newProps.autoCalcShadowZBounds, 'autoCalcShadowZBounds', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.autoUpdateExtends, newProps.autoUpdateExtends, 'autoUpdateExtends', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.shadowFrustumSize, newProps.shadowFrustumSize, 'shadowFrustumSize', 'number', changedProps);
    checkPrimitiveDiff(oldProps.shadowOrthoScale, newProps.shadowOrthoScale, 'shadowOrthoScale', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberDirectionalLightPropsHandler;
}();
/**
 * A directional light is defined by a direction (what a surprise!).
 * The light is emitted from everywhere in the specified direction, and has an infinite range.
 * An example of a directional light is when a distance planet is lit by the apparently parallel lines of light from its sun. Light in a downward direction will light the top of an object.
 * Documentation: https://doc.babylonjs.com/babylon101/lights
 *
 * This code has been generated
 */


var FiberDirectionalLight =
/** @class */
function () {
  function FiberDirectionalLight() {
    this.propsHandlers = [new FiberDirectionalLightPropsHandler(), new FiberShadowLightPropsHandler(), new FiberLightPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberDirectionalLight.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberDirectionalLight.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberDirectionalLight.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "DirectionalLight",
    "namespace": "@babylonjs/core/Lights/light",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "direction",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberDirectionalLight.Metadata = {
    "isNode": true,
    "isShadowLight": true,
    "className": "FiberDirectionalLight"
  };
  return FiberDirectionalLight;
}();

var FiberPointLightPropsHandler =
/** @class */
function () {
  function FiberPointLightPropsHandler() {}

  FiberPointLightPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkVector3Diff(oldProps.direction, newProps.direction, 'direction', 'BabylonjsCoreVector3', changedProps);
    checkPrimitiveDiff(oldProps.shadowAngle, newProps.shadowAngle, 'shadowAngle', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberPointLightPropsHandler;
}();
/**
 * A point light is a light defined by an unique point in world space.
 * The light is emitted in every direction from this point.
 * A good example of a point light is a standard light bulb.
 * Documentation: https://doc.babylonjs.com/babylon101/lights
 *
 * This code has been generated
 */


var FiberPointLight =
/** @class */
function () {
  function FiberPointLight() {
    this.propsHandlers = [new FiberPointLightPropsHandler(), new FiberShadowLightPropsHandler(), new FiberLightPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberPointLight.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPointLight.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPointLight.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "PointLight",
    "namespace": "@babylonjs/core/Lights/light",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "position",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberPointLight.Metadata = {
    "isNode": true,
    "isShadowLight": true,
    "className": "FiberPointLight"
  };
  return FiberPointLight;
}();

var FiberSpotLightPropsHandler =
/** @class */
function () {
  function FiberSpotLightPropsHandler() {}

  FiberSpotLightPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.angle, newProps.angle, 'angle', 'number', changedProps);
    checkPrimitiveDiff(oldProps.exponent, newProps.exponent, 'exponent', 'number', changedProps);
    checkPrimitiveDiff(oldProps.innerAngle, newProps.innerAngle, 'innerAngle', 'number', changedProps);
    checkTextureDiff(oldProps.projectionTexture, newProps.projectionTexture, 'projectionTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCoreSpotLight.projectionTexture.

    checkPrimitiveDiff(oldProps.projectionTextureLightFar, newProps.projectionTextureLightFar, 'projectionTextureLightFar', 'number', changedProps);
    checkPrimitiveDiff(oldProps.projectionTextureLightNear, newProps.projectionTextureLightNear, 'projectionTextureLightNear', 'number', changedProps);
    checkVector3Diff(oldProps.projectionTextureUpDirection, newProps.projectionTextureUpDirection, 'projectionTextureUpDirection', 'BabylonjsCoreVector3', changedProps);
    checkPrimitiveDiff(oldProps.shadowAngleScale, newProps.shadowAngleScale, 'shadowAngleScale', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberSpotLightPropsHandler;
}();
/**
 * A spot light is defined by a position, a direction, an angle, and an exponent.
 * These values define a cone of light starting from the position, emitting toward the direction.
 * The angle, in radians, defines the size (field of illumination) of the spotlight's conical beam,
 * and the exponent defines the speed of the decay of the light with distance (reach).
 * Documentation: https://doc.babylonjs.com/babylon101/lights
 *
 * This code has been generated
 */


var FiberSpotLight =
/** @class */
function () {
  function FiberSpotLight() {
    this.propsHandlers = [new FiberSpotLightPropsHandler(), new FiberShadowLightPropsHandler(), new FiberLightPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberSpotLight.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberSpotLight.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberSpotLight.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "SpotLight",
    "namespace": "@babylonjs/core/Lights/light",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "position",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "direction",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "angle",
      "type": "number",
      "optional": false
    }, {
      "name": "exponent",
      "type": "number",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberSpotLight.Metadata = {
    "isNode": true,
    "isShadowLight": true,
    "className": "FiberSpotLight"
  };
  return FiberSpotLight;
}();

var FiberHemisphericLightPropsHandler =
/** @class */
function () {
  function FiberHemisphericLightPropsHandler() {}

  FiberHemisphericLightPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkVector3Diff(oldProps.direction, newProps.direction, 'direction', 'BabylonjsCoreVector3', changedProps);
    checkColor3Diff(oldProps.groundColor, newProps.groundColor, 'groundColor', 'BabylonjsCoreColor3', changedProps);
    checkMethodDiff(oldProps.setDirectionToTarget, newProps.setDirectionToTarget, 'setDirectionToTarget', '(target?: BabylonjsCoreVector3) => BabylonjsCoreVector3', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberHemisphericLightPropsHandler;
}();
/**
 * The HemisphericLight simulates the ambient environment light,
 * so the passed direction is the light reflection direction, not the incoming direction.
 *
 * This code has been generated
 */


var FiberHemisphericLight =
/** @class */
function () {
  function FiberHemisphericLight() {
    this.propsHandlers = [new FiberHemisphericLightPropsHandler(), new FiberLightPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberHemisphericLight.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberHemisphericLight.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberHemisphericLight.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "HemisphericLight",
    "namespace": "@babylonjs/core/Lights/light",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "direction",
      "type": "BabylonjsCoreVector3",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberHemisphericLight.Metadata = {
    "isNode": true,
    "className": "FiberHemisphericLight"
  };
  return FiberHemisphericLight;
}();

var FiberControlPropsHandler =
/** @class */
function () {
  function FiberControlPropsHandler() {}

  FiberControlPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.alpha, newProps.alpha, 'alpha', 'number', changedProps);
    checkPrimitiveDiff(oldProps.clipChildren, newProps.clipChildren, 'clipChildren', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.clipContent, newProps.clipContent, 'clipContent', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.color, newProps.color, 'color', 'string', changedProps);
    checkPrimitiveDiff(oldProps.disabledColor, newProps.disabledColor, 'disabledColor', 'string', changedProps);
    checkPrimitiveDiff(oldProps.disabledColorItem, newProps.disabledColorItem, 'disabledColorItem', 'string', changedProps);
    checkPrimitiveDiff(oldProps.fontFamily, newProps.fontFamily, 'fontFamily', 'string', changedProps); // type: '{ ascent: number; height: number; descent: number; }' property (not coded) BabylonjsGuiControl.fontOffset.

    checkPrimitiveDiff(oldProps.fontSize, newProps.fontSize, 'fontSize', 'string | number', changedProps);
    checkPrimitiveDiff(oldProps.fontSizeInPixels, newProps.fontSizeInPixels, 'fontSizeInPixels', 'number', changedProps);
    checkPrimitiveDiff(oldProps.fontStyle, newProps.fontStyle, 'fontStyle', 'string', changedProps);
    checkPrimitiveDiff(oldProps.fontWeight, newProps.fontWeight, 'fontWeight', 'string', changedProps);
    checkPrimitiveDiff(oldProps.height, newProps.height, 'height', 'string | number', changedProps);
    checkPrimitiveDiff(oldProps.heightInPixels, newProps.heightInPixels, 'heightInPixels', 'number', changedProps);
    checkPrimitiveDiff(oldProps.horizontalAlignment, newProps.horizontalAlignment, 'horizontalAlignment', 'number', changedProps);
    checkPrimitiveDiff(oldProps.hoverCursor, newProps.hoverCursor, 'hoverCursor', 'string', changedProps);
    checkPrimitiveDiff(oldProps.isEnabled, newProps.isEnabled, 'isEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.isFocusInvisible, newProps.isFocusInvisible, 'isFocusInvisible', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.isHighlighted, newProps.isHighlighted, 'isHighlighted', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.isHitTestVisible, newProps.isHitTestVisible, 'isHitTestVisible', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.isPointerBlocker, newProps.isPointerBlocker, 'isPointerBlocker', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.isVisible, newProps.isVisible, 'isVisible', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.left, newProps.left, 'left', 'string | number', changedProps);
    checkPrimitiveDiff(oldProps.leftInPixels, newProps.leftInPixels, 'leftInPixels', 'number', changedProps);
    checkPrimitiveDiff(oldProps.linkOffsetX, newProps.linkOffsetX, 'linkOffsetX', 'string | number', changedProps);
    checkPrimitiveDiff(oldProps.linkOffsetXInPixels, newProps.linkOffsetXInPixels, 'linkOffsetXInPixels', 'number', changedProps);
    checkPrimitiveDiff(oldProps.linkOffsetY, newProps.linkOffsetY, 'linkOffsetY', 'string | number', changedProps);
    checkPrimitiveDiff(oldProps.linkOffsetYInPixels, newProps.linkOffsetYInPixels, 'linkOffsetYInPixels', 'number', changedProps); // type: 'any' property (not coded) BabylonjsGuiControl.metadata.

    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkPrimitiveDiff(oldProps.notRenderable, newProps.notRenderable, 'notRenderable', 'boolean', changedProps);
    checkObservableDiff(oldProps.onAfterDrawObservable, newProps.onAfterDrawObservable, 'onAfterDrawObservable', 'BabylonjsCoreObservable<BabylonjsGuiControl>', changedProps);
    checkObservableDiff(oldProps.onBeforeDrawObservable, newProps.onBeforeDrawObservable, 'onBeforeDrawObservable', 'BabylonjsCoreObservable<BabylonjsGuiControl>', changedProps);
    checkObservableDiff(oldProps.onDirtyObservable, newProps.onDirtyObservable, 'onDirtyObservable', 'BabylonjsCoreObservable<BabylonjsGuiControl>', changedProps);
    checkObservableDiff(oldProps.onPointerClickObservable, newProps.onPointerClickObservable, 'onPointerClickObservable', 'BabylonjsCoreObservable<BabylonjsGuiVector2WithInfo>', changedProps);
    checkObservableDiff(oldProps.onPointerDownObservable, newProps.onPointerDownObservable, 'onPointerDownObservable', 'BabylonjsCoreObservable<BabylonjsGuiVector2WithInfo>', changedProps);
    checkObservableDiff(oldProps.onPointerEnterObservable, newProps.onPointerEnterObservable, 'onPointerEnterObservable', 'BabylonjsCoreObservable<BabylonjsGuiControl>', changedProps);
    checkObservableDiff(oldProps.onPointerMoveObservable, newProps.onPointerMoveObservable, 'onPointerMoveObservable', 'BabylonjsCoreObservable<BabylonjsCoreVector2>', changedProps);
    checkObservableDiff(oldProps.onPointerOutObservable, newProps.onPointerOutObservable, 'onPointerOutObservable', 'BabylonjsCoreObservable<BabylonjsGuiControl>', changedProps);
    checkObservableDiff(oldProps.onPointerUpObservable, newProps.onPointerUpObservable, 'onPointerUpObservable', 'BabylonjsCoreObservable<BabylonjsGuiVector2WithInfo>', changedProps);
    checkObservableDiff(oldProps.onWheelObservable, newProps.onWheelObservable, 'onWheelObservable', 'BabylonjsCoreObservable<BabylonjsCoreVector2>', changedProps);
    checkPrimitiveDiff(oldProps.paddingBottom, newProps.paddingBottom, 'paddingBottom', 'string | number', changedProps);
    checkPrimitiveDiff(oldProps.paddingBottomInPixels, newProps.paddingBottomInPixels, 'paddingBottomInPixels', 'number', changedProps);
    checkPrimitiveDiff(oldProps.paddingLeft, newProps.paddingLeft, 'paddingLeft', 'string | number', changedProps);
    checkPrimitiveDiff(oldProps.paddingLeftInPixels, newProps.paddingLeftInPixels, 'paddingLeftInPixels', 'number', changedProps);
    checkPrimitiveDiff(oldProps.paddingRight, newProps.paddingRight, 'paddingRight', 'string | number', changedProps);
    checkPrimitiveDiff(oldProps.paddingRightInPixels, newProps.paddingRightInPixels, 'paddingRightInPixels', 'number', changedProps);
    checkPrimitiveDiff(oldProps.paddingTop, newProps.paddingTop, 'paddingTop', 'string | number', changedProps);
    checkPrimitiveDiff(oldProps.paddingTopInPixels, newProps.paddingTopInPixels, 'paddingTopInPixels', 'number', changedProps); // type: 'BabylonjsGuiContainer' property (not coded) BabylonjsGuiControl.parent.

    checkPrimitiveDiff(oldProps.rotation, newProps.rotation, 'rotation', 'number', changedProps);
    checkPrimitiveDiff(oldProps.scaleX, newProps.scaleX, 'scaleX', 'number', changedProps);
    checkPrimitiveDiff(oldProps.scaleY, newProps.scaleY, 'scaleY', 'number', changedProps);
    checkPrimitiveDiff(oldProps.shadowBlur, newProps.shadowBlur, 'shadowBlur', 'number', changedProps);
    checkPrimitiveDiff(oldProps.shadowColor, newProps.shadowColor, 'shadowColor', 'string', changedProps);
    checkPrimitiveDiff(oldProps.shadowOffsetX, newProps.shadowOffsetX, 'shadowOffsetX', 'number', changedProps);
    checkPrimitiveDiff(oldProps.shadowOffsetY, newProps.shadowOffsetY, 'shadowOffsetY', 'number', changedProps); // type: 'BabylonjsGuiStyle' property (not coded) BabylonjsGuiControl.style.

    checkPrimitiveDiff(oldProps.top, newProps.top, 'top', 'string | number', changedProps);
    checkPrimitiveDiff(oldProps.topInPixels, newProps.topInPixels, 'topInPixels', 'number', changedProps);
    checkPrimitiveDiff(oldProps.transformCenterX, newProps.transformCenterX, 'transformCenterX', 'number', changedProps);
    checkPrimitiveDiff(oldProps.transformCenterY, newProps.transformCenterY, 'transformCenterY', 'number', changedProps);
    checkPrimitiveDiff(oldProps.uniqueId, newProps.uniqueId, 'uniqueId', 'number', changedProps);
    checkPrimitiveDiff(oldProps.useBitmapCache, newProps.useBitmapCache, 'useBitmapCache', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.verticalAlignment, newProps.verticalAlignment, 'verticalAlignment', 'number', changedProps);
    checkPrimitiveDiff(oldProps.width, newProps.width, 'width', 'string | number', changedProps);
    checkPrimitiveDiff(oldProps.widthInPixels, newProps.widthInPixels, 'widthInPixels', 'number', changedProps);
    checkPrimitiveDiff(oldProps.zIndex, newProps.zIndex, 'zIndex', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberControlPropsHandler;
}();
/**
 * Root class used for all 2D controls
 *
 * This code has been generated
 */


var FiberControl =
/** @class */
function () {
  function FiberControl() {
    this.propsHandlers = [new FiberControlPropsHandler()];
  }

  FiberControl.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberControl.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberControl.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "Control",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberControl.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberControl"
  };
  return FiberControl;
}();

var FiberContainerPropsHandler =
/** @class */
function () {
  function FiberContainerPropsHandler() {}

  FiberContainerPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.adaptHeightToChildren, newProps.adaptHeightToChildren, 'adaptHeightToChildren', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.adaptWidthToChildren, newProps.adaptWidthToChildren, 'adaptWidthToChildren', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.background, newProps.background, 'background', 'string', changedProps);
    checkPrimitiveDiff(oldProps.logLayoutCycleErrors, newProps.logLayoutCycleErrors, 'logLayoutCycleErrors', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.maxLayoutCycle, newProps.maxLayoutCycle, 'maxLayoutCycle', 'number', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkMethodDiff(oldProps.addControl, newProps.addControl, 'addControl', '(control?: BabylonjsGuiControl) => BabylonjsGuiContainer', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberContainerPropsHandler;
}();
/**
 * Root class for 2D containers
 *
 * This code has been generated
 */


var FiberContainer =
/** @class */
function () {
  function FiberContainer() {
    this.propsHandlers = [new FiberContainerPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberContainer.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberContainer.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberContainer.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "Container",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberContainer.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberContainer"
  };
  return FiberContainer;
}();

var FiberRectanglePropsHandler =
/** @class */
function () {
  function FiberRectanglePropsHandler() {}

  FiberRectanglePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.cornerRadius, newProps.cornerRadius, 'cornerRadius', 'number', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkPrimitiveDiff(oldProps.thickness, newProps.thickness, 'thickness', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberRectanglePropsHandler;
}();
/**
 * Class used to create rectangle container
 *
 * This code has been generated
 */


var FiberRectangle =
/** @class */
function () {
  function FiberRectangle() {
    this.propsHandlers = [new FiberRectanglePropsHandler(), new FiberContainerPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberRectangle.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberRectangle.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberRectangle.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "Rectangle",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberRectangle.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberRectangle"
  };
  return FiberRectangle;
}();

var FiberButtonPropsHandler =
/** @class */
function () {
  function FiberButtonPropsHandler() {}

  FiberButtonPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.delegatePickingToChildren, newProps.delegatePickingToChildren, 'delegatePickingToChildren', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkLambdaDiff(oldProps.pointerDownAnimation, newProps.pointerDownAnimation, 'pointerDownAnimation', '() => void', changedProps);
    checkLambdaDiff(oldProps.pointerEnterAnimation, newProps.pointerEnterAnimation, 'pointerEnterAnimation', '() => void', changedProps);
    checkLambdaDiff(oldProps.pointerOutAnimation, newProps.pointerOutAnimation, 'pointerOutAnimation', '() => void', changedProps);
    checkLambdaDiff(oldProps.pointerUpAnimation, newProps.pointerUpAnimation, 'pointerUpAnimation', '() => void', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberButtonPropsHandler;
}();
/**
 * Class used to create 2D buttons
 *
 * This code has been generated
 */


var FiberButton =
/** @class */
function () {
  function FiberButton() {
    this.propsHandlers = [new FiberButtonPropsHandler(), new FiberRectanglePropsHandler(), new FiberContainerPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberButton.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberButton.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberButton.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "Button",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberButton.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberButton"
  };
  return FiberButton;
}();

var FiberSelectionPanelPropsHandler =
/** @class */
function () {
  function FiberSelectionPanelPropsHandler() {}

  FiberSelectionPanelPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.barColor, newProps.barColor, 'barColor', 'string', changedProps);
    checkPrimitiveDiff(oldProps.barHeight, newProps.barHeight, 'barHeight', 'string', changedProps);
    checkPrimitiveDiff(oldProps.buttonBackground, newProps.buttonBackground, 'buttonBackground', 'string', changedProps);
    checkPrimitiveDiff(oldProps.buttonColor, newProps.buttonColor, 'buttonColor', 'string', changedProps); // type: 'BabylonjsGuiSelectorGroup[]' property (not coded) BabylonjsGuiSelectionPanel.groups.

    checkPrimitiveDiff(oldProps.headerColor, newProps.headerColor, 'headerColor', 'string', changedProps);
    checkPrimitiveDiff(oldProps.labelColor, newProps.labelColor, 'labelColor', 'string', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkPrimitiveDiff(oldProps.spacerHeight, newProps.spacerHeight, 'spacerHeight', 'string', changedProps);
    checkMethodDiff(oldProps.addGroup, newProps.addGroup, 'addGroup', '(group?: BabylonjsGuiSelectorGroup) => void', changedProps);
    checkMethodDiff(oldProps.addToGroupCheckbox, newProps.addToGroupCheckbox, 'addToGroupCheckbox', '(groupNb?: number, label?: string, func?: () => void, checked?: boolean) => void', changedProps);
    checkMethodDiff(oldProps.addToGroupRadio, newProps.addToGroupRadio, 'addToGroupRadio', '(groupNb?: number, label?: string, func?: () => void, checked?: boolean) => void', changedProps);
    checkMethodDiff(oldProps.addToGroupSlider, newProps.addToGroupSlider, 'addToGroupSlider', '(groupNb?: number, label?: string, func?: () => void, unit?: string, min?: number, max?: number, value?: number, onVal?: (v: number) => number) => void', changedProps);
    checkMethodDiff(oldProps.setHeaderName, newProps.setHeaderName, 'setHeaderName', '(label?: string, groupNb?: number) => void', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberSelectionPanelPropsHandler;
}();
/**
 * Class used to hold the controls for the checkboxes, radio buttons and sliders
 *
 * This code has been generated
 */


var FiberSelectionPanel =
/** @class */
function () {
  function FiberSelectionPanel() {
    this.propsHandlers = [new FiberSelectionPanelPropsHandler(), new FiberRectanglePropsHandler(), new FiberContainerPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberSelectionPanel.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberSelectionPanel.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberSelectionPanel.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "SelectionPanel",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "groups",
      "type": "BabylonjsGuiSelectorGroup[]",
      "optional": true
    }]
  };
  FiberSelectionPanel.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberSelectionPanel"
  };
  return FiberSelectionPanel;
}();

var FiberScrollViewerPropsHandler =
/** @class */
function () {
  function FiberScrollViewerPropsHandler() {}

  FiberScrollViewerPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.barBackground, newProps.barBackground, 'barBackground', 'string', changedProps);
    checkPrimitiveDiff(oldProps.barColor, newProps.barColor, 'barColor', 'string', changedProps); // type: 'BabylonjsGuiImage' property (not coded) BabylonjsGuiScrollViewer.barImage.

    checkPrimitiveDiff(oldProps.barImageHeight, newProps.barImageHeight, 'barImageHeight', 'number', changedProps);
    checkPrimitiveDiff(oldProps.barSize, newProps.barSize, 'barSize', 'number', changedProps);
    checkPrimitiveDiff(oldProps.forceHorizontalBar, newProps.forceHorizontalBar, 'forceHorizontalBar', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.forceVerticalBar, newProps.forceVerticalBar, 'forceVerticalBar', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.freezeControls, newProps.freezeControls, 'freezeControls', 'boolean', changedProps); // type: 'BabylonjsGuiImage' property (not coded) BabylonjsGuiScrollViewer.horizontalBarImage.

    checkPrimitiveDiff(oldProps.horizontalBarImageHeight, newProps.horizontalBarImageHeight, 'horizontalBarImageHeight', 'number', changedProps); // type: 'BabylonjsGuiImage' property (not coded) BabylonjsGuiScrollViewer.horizontalThumbImage.

    checkPrimitiveDiff(oldProps.scrollBackground, newProps.scrollBackground, 'scrollBackground', 'string', changedProps);
    checkPrimitiveDiff(oldProps.thumbHeight, newProps.thumbHeight, 'thumbHeight', 'number', changedProps); // type: 'BabylonjsGuiImage' property (not coded) BabylonjsGuiScrollViewer.thumbImage.

    checkPrimitiveDiff(oldProps.thumbLength, newProps.thumbLength, 'thumbLength', 'number', changedProps); // type: 'BabylonjsGuiImage' property (not coded) BabylonjsGuiScrollViewer.verticalBarImage.

    checkPrimitiveDiff(oldProps.verticalBarImageHeight, newProps.verticalBarImageHeight, 'verticalBarImageHeight', 'number', changedProps); // type: 'BabylonjsGuiImage' property (not coded) BabylonjsGuiScrollViewer.verticalThumbImage.

    checkPrimitiveDiff(oldProps.wheelPrecision, newProps.wheelPrecision, 'wheelPrecision', 'number', changedProps);
    checkMethodDiff(oldProps.addControl, newProps.addControl, 'addControl', '(control?: BabylonjsGuiControl) => BabylonjsGuiContainer', changedProps);
    checkMethodDiff(oldProps.setBucketSizes, newProps.setBucketSizes, 'setBucketSizes', '(width?: number, height?: number) => void', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberScrollViewerPropsHandler;
}();
/**
 * Class used to hold a viewer window and sliders in a grid
 *
 * This code has been generated
 */


var FiberScrollViewer =
/** @class */
function () {
  function FiberScrollViewer() {
    this.propsHandlers = [new FiberScrollViewerPropsHandler(), new FiberRectanglePropsHandler(), new FiberContainerPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberScrollViewer.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberScrollViewer.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberScrollViewer.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "ScrollViewer",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }, {
      "name": "isImageBased",
      "type": "boolean",
      "optional": true
    }]
  };
  FiberScrollViewer.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberScrollViewer"
  };
  return FiberScrollViewer;
}();

var FiberStackPanelPropsHandler =
/** @class */
function () {
  function FiberStackPanelPropsHandler() {}

  FiberStackPanelPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.height, newProps.height, 'height', 'string | number', changedProps);
    checkPrimitiveDiff(oldProps.ignoreLayoutWarnings, newProps.ignoreLayoutWarnings, 'ignoreLayoutWarnings', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.isVertical, newProps.isVertical, 'isVertical', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkPrimitiveDiff(oldProps.width, newProps.width, 'width', 'string | number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberStackPanelPropsHandler;
}();
/**
 * Class used to create a 2D stack panel container
 *
 * This code has been generated
 */


var FiberStackPanel =
/** @class */
function () {
  function FiberStackPanel() {
    this.propsHandlers = [new FiberStackPanelPropsHandler(), new FiberContainerPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberStackPanel.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberStackPanel.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberStackPanel.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "StackPanel",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberStackPanel.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberStackPanel"
  };
  return FiberStackPanel;
}();

var FiberVirtualKeyboardPropsHandler =
/** @class */
function () {
  function FiberVirtualKeyboardPropsHandler() {}

  FiberVirtualKeyboardPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.defaultButtonBackground, newProps.defaultButtonBackground, 'defaultButtonBackground', 'string', changedProps);
    checkPrimitiveDiff(oldProps.defaultButtonColor, newProps.defaultButtonColor, 'defaultButtonColor', 'string', changedProps);
    checkPrimitiveDiff(oldProps.defaultButtonHeight, newProps.defaultButtonHeight, 'defaultButtonHeight', 'string', changedProps);
    checkPrimitiveDiff(oldProps.defaultButtonPaddingBottom, newProps.defaultButtonPaddingBottom, 'defaultButtonPaddingBottom', 'string', changedProps);
    checkPrimitiveDiff(oldProps.defaultButtonPaddingLeft, newProps.defaultButtonPaddingLeft, 'defaultButtonPaddingLeft', 'string', changedProps);
    checkPrimitiveDiff(oldProps.defaultButtonPaddingRight, newProps.defaultButtonPaddingRight, 'defaultButtonPaddingRight', 'string', changedProps);
    checkPrimitiveDiff(oldProps.defaultButtonPaddingTop, newProps.defaultButtonPaddingTop, 'defaultButtonPaddingTop', 'string', changedProps);
    checkPrimitiveDiff(oldProps.defaultButtonWidth, newProps.defaultButtonWidth, 'defaultButtonWidth', 'string', changedProps);
    checkObservableDiff(oldProps.onKeyPressObservable, newProps.onKeyPressObservable, 'onKeyPressObservable', 'BabylonjsCoreObservable<string>', changedProps);
    checkPrimitiveDiff(oldProps.selectedShiftThickness, newProps.selectedShiftThickness, 'selectedShiftThickness', 'number', changedProps);
    checkPrimitiveDiff(oldProps.shiftButtonColor, newProps.shiftButtonColor, 'shiftButtonColor', 'string', changedProps);
    checkPrimitiveDiff(oldProps.shiftState, newProps.shiftState, 'shiftState', 'number', changedProps);
    checkMethodDiff(oldProps.addKeysRow, newProps.addKeysRow, 'addKeysRow', '(keys?: string[], propertySets?: BabylonjsGuiKeyPropertySet[]) => void', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberVirtualKeyboardPropsHandler;
}();
/**
 * Class used to create virtual keyboard
 *
 * This code has been generated
 */


var FiberVirtualKeyboard =
/** @class */
function () {
  function FiberVirtualKeyboard() {
    this.propsHandlers = [new FiberVirtualKeyboardPropsHandler(), new FiberStackPanelPropsHandler(), new FiberContainerPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberVirtualKeyboard.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberVirtualKeyboard.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberVirtualKeyboard.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "VirtualKeyboard",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": []
  };
  FiberVirtualKeyboard.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberVirtualKeyboard"
  };
  return FiberVirtualKeyboard;
}();

var FiberEllipsePropsHandler =
/** @class */
function () {
  function FiberEllipsePropsHandler() {}

  FiberEllipsePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkPrimitiveDiff(oldProps.thickness, newProps.thickness, 'thickness', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberEllipsePropsHandler;
}();
/**
 * Class used to create 2D ellipse containers
 *
 * This code has been generated
 */


var FiberEllipse =
/** @class */
function () {
  function FiberEllipse() {
    this.propsHandlers = [new FiberEllipsePropsHandler(), new FiberContainerPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberEllipse.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberEllipse.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberEllipse.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "Ellipse",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberEllipse.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberEllipse"
  };
  return FiberEllipse;
}();

var FiberGridPropsHandler =
/** @class */
function () {
  function FiberGridPropsHandler() {}

  FiberGridPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkMethodDiff(oldProps.addColumnDefinition, newProps.addColumnDefinition, 'addColumnDefinition', '(width?: number, isPixel?: boolean) => BabylonjsGuiGrid', changedProps);
    checkMethodDiff(oldProps.addControl, newProps.addControl, 'addControl', '(control?: BabylonjsGuiControl, row?: number, column?: number) => BabylonjsGuiGrid', changedProps);
    checkMethodDiff(oldProps.addRowDefinition, newProps.addRowDefinition, 'addRowDefinition', '(height?: number, isPixel?: boolean) => BabylonjsGuiGrid', changedProps);
    checkMethodDiff(oldProps.setColumnDefinition, newProps.setColumnDefinition, 'setColumnDefinition', '(index?: number, width?: number, isPixel?: boolean) => BabylonjsGuiGrid', changedProps);
    checkMethodDiff(oldProps.setRowDefinition, newProps.setRowDefinition, 'setRowDefinition', '(index?: number, height?: number, isPixel?: boolean) => BabylonjsGuiGrid', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberGridPropsHandler;
}();
/**
 * Class used to create a 2D grid container
 *
 * This code has been generated
 */


var FiberGrid =
/** @class */
function () {
  function FiberGrid() {
    this.propsHandlers = [new FiberGridPropsHandler(), new FiberContainerPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberGrid.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberGrid.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberGrid.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "Grid",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberGrid.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberGrid"
  };
  return FiberGrid;
}();

var Fiber_ScrollViewerWindowPropsHandler =
/** @class */
function () {
  function Fiber_ScrollViewerWindowPropsHandler() {}

  Fiber_ScrollViewerWindowPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.freezeControls, newProps.freezeControls, 'freezeControls', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.parentClientHeight, newProps.parentClientHeight, 'parentClientHeight', 'number', changedProps);
    checkPrimitiveDiff(oldProps.parentClientWidth, newProps.parentClientWidth, 'parentClientWidth', 'number', changedProps);
    checkMethodDiff(oldProps.setBucketSizes, newProps.setBucketSizes, 'setBucketSizes', '(width?: number, height?: number) => void', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return Fiber_ScrollViewerWindowPropsHandler;
}();
/**
 * Class used to hold a the container for ScrollViewer
 *
 * This code has been generated
 */


var Fiber_ScrollViewerWindow =
/** @class */
function () {
  function Fiber_ScrollViewerWindow() {
    this.propsHandlers = [new Fiber_ScrollViewerWindowPropsHandler(), new FiberContainerPropsHandler(), new FiberControlPropsHandler()];
  }

  Fiber_ScrollViewerWindow.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  Fiber_ScrollViewerWindow.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  Fiber_ScrollViewerWindow.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "_ScrollViewerWindow",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  Fiber_ScrollViewerWindow.Metadata = {
    "isGUI2DControl": true,
    "className": "Fiber_ScrollViewerWindow"
  };
  return Fiber_ScrollViewerWindow;
}();

var FiberTextBlockPropsHandler =
/** @class */
function () {
  function FiberTextBlockPropsHandler() {}

  FiberTextBlockPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.lineSpacing, newProps.lineSpacing, 'lineSpacing', 'string | number', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkObservableDiff(oldProps.onLinesReadyObservable, newProps.onLinesReadyObservable, 'onLinesReadyObservable', 'BabylonjsCoreObservable<BabylonjsGuiTextBlock>', changedProps);
    checkObservableDiff(oldProps.onTextChangedObservable, newProps.onTextChangedObservable, 'onTextChangedObservable', 'BabylonjsCoreObservable<BabylonjsGuiTextBlock>', changedProps);
    checkPrimitiveDiff(oldProps.outlineColor, newProps.outlineColor, 'outlineColor', 'string', changedProps);
    checkPrimitiveDiff(oldProps.outlineWidth, newProps.outlineWidth, 'outlineWidth', 'number', changedProps);
    checkPrimitiveDiff(oldProps.resizeToFit, newProps.resizeToFit, 'resizeToFit', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.text, newProps.text, 'text', 'string', changedProps);
    checkPrimitiveDiff(oldProps.textHorizontalAlignment, newProps.textHorizontalAlignment, 'textHorizontalAlignment', 'number', changedProps);
    checkPrimitiveDiff(oldProps.textVerticalAlignment, newProps.textVerticalAlignment, 'textVerticalAlignment', 'number', changedProps); // type: 'boolean | BabylonjsGuiTextWrapping' property (not coded) BabylonjsGuiTextBlock.textWrapping.

    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberTextBlockPropsHandler;
}();
/**
 * Class used to create text block control
 *
 * This code has been generated
 */


var FiberTextBlock =
/** @class */
function () {
  function FiberTextBlock() {
    this.propsHandlers = [new FiberTextBlockPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberTextBlock.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberTextBlock.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberTextBlock.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "TextBlock",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }, {
      "name": "text",
      "type": "string",
      "optional": true
    }]
  };
  FiberTextBlock.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberTextBlock"
  };
  return FiberTextBlock;
}();

var FiberImagePropsHandler =
/** @class */
function () {
  function FiberImagePropsHandler() {}

  FiberImagePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.autoScale, newProps.autoScale, 'autoScale', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.cellHeight, newProps.cellHeight, 'cellHeight', 'number', changedProps);
    checkPrimitiveDiff(oldProps.cellId, newProps.cellId, 'cellId', 'number', changedProps);
    checkPrimitiveDiff(oldProps.cellWidth, newProps.cellWidth, 'cellWidth', 'number', changedProps);
    checkPrimitiveDiff(oldProps.detectPointerOnOpaqueOnly, newProps.detectPointerOnOpaqueOnly, 'detectPointerOnOpaqueOnly', 'boolean', changedProps); // type: 'HTMLImageElement' property (not coded) BabylonjsGuiImage.domImage.

    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkObservableDiff(oldProps.onImageLoadedObservable, newProps.onImageLoadedObservable, 'onImageLoadedObservable', 'BabylonjsCoreObservable<BabylonjsGuiImage>', changedProps);
    checkObservableDiff(oldProps.onSVGAttributesComputedObservable, newProps.onSVGAttributesComputedObservable, 'onSVGAttributesComputedObservable', 'BabylonjsCoreObservable<BabylonjsGuiImage>', changedProps);
    checkPrimitiveDiff(oldProps.populateNinePatchSlicesFromImage, newProps.populateNinePatchSlicesFromImage, 'populateNinePatchSlicesFromImage', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.sliceBottom, newProps.sliceBottom, 'sliceBottom', 'number', changedProps);
    checkPrimitiveDiff(oldProps.sliceLeft, newProps.sliceLeft, 'sliceLeft', 'number', changedProps);
    checkPrimitiveDiff(oldProps.sliceRight, newProps.sliceRight, 'sliceRight', 'number', changedProps);
    checkPrimitiveDiff(oldProps.sliceTop, newProps.sliceTop, 'sliceTop', 'number', changedProps);
    checkPrimitiveDiff(oldProps.source, newProps.source, 'source', 'string', changedProps);
    checkPrimitiveDiff(oldProps.sourceHeight, newProps.sourceHeight, 'sourceHeight', 'number', changedProps);
    checkPrimitiveDiff(oldProps.sourceLeft, newProps.sourceLeft, 'sourceLeft', 'number', changedProps);
    checkPrimitiveDiff(oldProps.sourceTop, newProps.sourceTop, 'sourceTop', 'number', changedProps);
    checkPrimitiveDiff(oldProps.sourceWidth, newProps.sourceWidth, 'sourceWidth', 'number', changedProps);
    checkPrimitiveDiff(oldProps.stretch, newProps.stretch, 'stretch', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberImagePropsHandler;
}();
/**
 * Class used to create 2D images
 *
 * This code has been generated
 */


var FiberImage =
/** @class */
function () {
  function FiberImage() {
    this.propsHandlers = [new FiberImagePropsHandler(), new FiberControlPropsHandler()];
  }

  FiberImage.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberImage.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberImage.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "Image",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }, {
      "name": "url",
      "type": "string",
      "optional": true
    }]
  };
  FiberImage.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberImage"
  };
  return FiberImage;
}();

var FiberCheckboxPropsHandler =
/** @class */
function () {
  function FiberCheckboxPropsHandler() {}

  FiberCheckboxPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.background, newProps.background, 'background', 'string', changedProps);
    checkPrimitiveDiff(oldProps.checkSizeRatio, newProps.checkSizeRatio, 'checkSizeRatio', 'number', changedProps);
    checkPrimitiveDiff(oldProps.isChecked, newProps.isChecked, 'isChecked', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkObservableDiff(oldProps.onIsCheckedChangedObservable, newProps.onIsCheckedChangedObservable, 'onIsCheckedChangedObservable', 'BabylonjsCoreObservable<boolean>', changedProps);
    checkPrimitiveDiff(oldProps.thickness, newProps.thickness, 'thickness', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberCheckboxPropsHandler;
}();
/**
 * Class used to represent a 2D checkbox
 *
 * This code has been generated
 */


var FiberCheckbox =
/** @class */
function () {
  function FiberCheckbox() {
    this.propsHandlers = [new FiberCheckboxPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberCheckbox.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberCheckbox.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberCheckbox.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "Checkbox",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberCheckbox.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberCheckbox"
  };
  return FiberCheckbox;
}();

var FiberColorPickerPropsHandler =
/** @class */
function () {
  function FiberColorPickerPropsHandler() {}

  FiberColorPickerPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.height, newProps.height, 'height', 'string | number', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkObservableDiff(oldProps.onValueChangedObservable, newProps.onValueChangedObservable, 'onValueChangedObservable', 'BabylonjsCoreObservable<BabylonjsCoreColor3>', changedProps);
    checkPrimitiveDiff(oldProps.size, newProps.size, 'size', 'string | number', changedProps);
    checkColor3Diff(oldProps.value, newProps.value, 'value', 'BabylonjsCoreColor3', changedProps);
    checkPrimitiveDiff(oldProps.width, newProps.width, 'width', 'string | number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberColorPickerPropsHandler;
}();
/**
 * Class used to create color pickers
 *
 * This code has been generated
 */


var FiberColorPicker =
/** @class */
function () {
  function FiberColorPicker() {
    this.propsHandlers = [new FiberColorPickerPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberColorPicker.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberColorPicker.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberColorPicker.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "ColorPicker",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberColorPicker.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberColorPicker"
  };
  return FiberColorPicker;
}();

var FiberInputTextPropsHandler =
/** @class */
function () {
  function FiberInputTextPropsHandler() {}

  FiberInputTextPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.addKey, newProps.addKey, 'addKey', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.autoStretchWidth, newProps.autoStretchWidth, 'autoStretchWidth', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.background, newProps.background, 'background', 'string', changedProps);
    checkPrimitiveDiff(oldProps.currentKey, newProps.currentKey, 'currentKey', 'string', changedProps);
    checkPrimitiveDiff(oldProps.deadKey, newProps.deadKey, 'deadKey', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.disableMobilePrompt, newProps.disableMobilePrompt, 'disableMobilePrompt', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.focusedBackground, newProps.focusedBackground, 'focusedBackground', 'string', changedProps);
    checkPrimitiveDiff(oldProps.focusedColor, newProps.focusedColor, 'focusedColor', 'string', changedProps);
    checkPrimitiveDiff(oldProps.highligherOpacity, newProps.highligherOpacity, 'highligherOpacity', 'number', changedProps);
    checkPrimitiveDiff(oldProps.highlightedText, newProps.highlightedText, 'highlightedText', 'string', changedProps);
    checkPrimitiveDiff(oldProps.margin, newProps.margin, 'margin', 'string', changedProps);
    checkPrimitiveDiff(oldProps.maxWidth, newProps.maxWidth, 'maxWidth', 'string | number', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkObservableDiff(oldProps.onBeforeKeyAddObservable, newProps.onBeforeKeyAddObservable, 'onBeforeKeyAddObservable', 'BabylonjsCoreObservable<BabylonjsGuiInputText>', changedProps);
    checkObservableDiff(oldProps.onBlurObservable, newProps.onBlurObservable, 'onBlurObservable', 'BabylonjsCoreObservable<BabylonjsGuiInputText>', changedProps);
    checkObservableDiff(oldProps.onFocusObservable, newProps.onFocusObservable, 'onFocusObservable', 'BabylonjsCoreObservable<BabylonjsGuiInputText>', changedProps);
    checkPrimitiveDiff(oldProps.onFocusSelectAll, newProps.onFocusSelectAll, 'onFocusSelectAll', 'boolean', changedProps);
    checkObservableDiff(oldProps.onKeyboardEventProcessedObservable, newProps.onKeyboardEventProcessedObservable, 'onKeyboardEventProcessedObservable', 'BabylonjsCoreObservable<KeyboardEvent>', changedProps);
    checkObservableDiff(oldProps.onTextChangedObservable, newProps.onTextChangedObservable, 'onTextChangedObservable', 'BabylonjsCoreObservable<BabylonjsGuiInputText>', changedProps);
    checkObservableDiff(oldProps.onTextCopyObservable, newProps.onTextCopyObservable, 'onTextCopyObservable', 'BabylonjsCoreObservable<BabylonjsGuiInputText>', changedProps);
    checkObservableDiff(oldProps.onTextCutObservable, newProps.onTextCutObservable, 'onTextCutObservable', 'BabylonjsCoreObservable<BabylonjsGuiInputText>', changedProps);
    checkObservableDiff(oldProps.onTextHighlightObservable, newProps.onTextHighlightObservable, 'onTextHighlightObservable', 'BabylonjsCoreObservable<BabylonjsGuiInputText>', changedProps);
    checkObservableDiff(oldProps.onTextPasteObservable, newProps.onTextPasteObservable, 'onTextPasteObservable', 'BabylonjsCoreObservable<BabylonjsGuiInputText>', changedProps);
    checkPrimitiveDiff(oldProps.placeholderColor, newProps.placeholderColor, 'placeholderColor', 'string', changedProps);
    checkPrimitiveDiff(oldProps.placeholderText, newProps.placeholderText, 'placeholderText', 'string', changedProps);
    checkPrimitiveDiff(oldProps.promptMessage, newProps.promptMessage, 'promptMessage', 'string', changedProps);
    checkPrimitiveDiff(oldProps.text, newProps.text, 'text', 'string', changedProps);
    checkPrimitiveDiff(oldProps.textHighlightColor, newProps.textHighlightColor, 'textHighlightColor', 'string', changedProps);
    checkPrimitiveDiff(oldProps.thickness, newProps.thickness, 'thickness', 'number', changedProps);
    checkPrimitiveDiff(oldProps.width, newProps.width, 'width', 'string | number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberInputTextPropsHandler;
}();
/**
 * Class used to create input text control
 *
 * This code has been generated
 */


var FiberInputText =
/** @class */
function () {
  function FiberInputText() {
    this.propsHandlers = [new FiberInputTextPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberInputText.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberInputText.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberInputText.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "InputText",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }, {
      "name": "text",
      "type": "string",
      "optional": true
    }]
  };
  FiberInputText.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberInputText"
  };
  return FiberInputText;
}();

var FiberInputPasswordPropsHandler =
/** @class */
function () {
  function FiberInputPasswordPropsHandler() {}

  FiberInputPasswordPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    return null; // no props to check
  };

  return FiberInputPasswordPropsHandler;
}();
/**
 * Class used to create a password control
 *
 * This code has been generated
 */


var FiberInputPassword =
/** @class */
function () {
  function FiberInputPassword() {
    this.propsHandlers = [new FiberInputPasswordPropsHandler(), new FiberInputTextPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberInputPassword.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberInputPassword.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberInputPassword.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "InputPassword",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": []
  };
  FiberInputPassword.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberInputPassword"
  };
  return FiberInputPassword;
}();

var FiberLinePropsHandler =
/** @class */
function () {
  function FiberLinePropsHandler() {}

  FiberLinePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkControlDiff(oldProps.connectedControl, newProps.connectedControl, 'connectedControl', 'BabylonjsGuiControl', changedProps);
    checkNumericArrayDiff(oldProps.dash, newProps.dash, 'dash', 'number[]', changedProps);
    checkPrimitiveDiff(oldProps.horizontalAlignment, newProps.horizontalAlignment, 'horizontalAlignment', 'number', changedProps);
    checkPrimitiveDiff(oldProps.lineWidth, newProps.lineWidth, 'lineWidth', 'number', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkPrimitiveDiff(oldProps.verticalAlignment, newProps.verticalAlignment, 'verticalAlignment', 'number', changedProps);
    checkPrimitiveDiff(oldProps.x1, newProps.x1, 'x1', 'string | number', changedProps);
    checkPrimitiveDiff(oldProps.x2, newProps.x2, 'x2', 'string | number', changedProps);
    checkPrimitiveDiff(oldProps.y1, newProps.y1, 'y1', 'string | number', changedProps);
    checkPrimitiveDiff(oldProps.y2, newProps.y2, 'y2', 'string | number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberLinePropsHandler;
}();
/**
 * Class used to render 2D lines
 *
 * This code has been generated
 */


var FiberLine =
/** @class */
function () {
  function FiberLine() {
    this.propsHandlers = [new FiberLinePropsHandler(), new FiberControlPropsHandler()];
  }

  FiberLine.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberLine.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberLine.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "Line",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberLine.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberLine"
  };
  return FiberLine;
}();

var FiberMultiLinePropsHandler =
/** @class */
function () {
  function FiberMultiLinePropsHandler() {}

  FiberMultiLinePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkNumericArrayDiff(oldProps.dash, newProps.dash, 'dash', 'number[]', changedProps);
    checkPrimitiveDiff(oldProps.horizontalAlignment, newProps.horizontalAlignment, 'horizontalAlignment', 'number', changedProps);
    checkPrimitiveDiff(oldProps.lineWidth, newProps.lineWidth, 'lineWidth', 'number', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkLambdaDiff(oldProps.onPointUpdate, newProps.onPointUpdate, 'onPointUpdate', '() => void', changedProps);
    checkPrimitiveDiff(oldProps.verticalAlignment, newProps.verticalAlignment, 'verticalAlignment', 'number', changedProps);
    checkMethodDiff(oldProps.add, newProps.add, 'add', '(items?: (BabylonjsCoreAbstractMesh | BabylonjsGuiControl | { x: string | number; y: string | number; })[]) => BabylonjsGuiMultiLinePoint[]', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberMultiLinePropsHandler;
}();
/**
 * Class used to create multi line control
 *
 * This code has been generated
 */


var FiberMultiLine =
/** @class */
function () {
  function FiberMultiLine() {
    this.propsHandlers = [new FiberMultiLinePropsHandler(), new FiberControlPropsHandler()];
  }

  FiberMultiLine.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberMultiLine.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberMultiLine.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "MultiLine",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberMultiLine.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberMultiLine"
  };
  return FiberMultiLine;
}();

var FiberRadioButtonPropsHandler =
/** @class */
function () {
  function FiberRadioButtonPropsHandler() {}

  FiberRadioButtonPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.background, newProps.background, 'background', 'string', changedProps);
    checkPrimitiveDiff(oldProps.checkSizeRatio, newProps.checkSizeRatio, 'checkSizeRatio', 'number', changedProps);
    checkPrimitiveDiff(oldProps.group, newProps.group, 'group', 'string', changedProps);
    checkPrimitiveDiff(oldProps.isChecked, newProps.isChecked, 'isChecked', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkObservableDiff(oldProps.onIsCheckedChangedObservable, newProps.onIsCheckedChangedObservable, 'onIsCheckedChangedObservable', 'BabylonjsCoreObservable<boolean>', changedProps);
    checkPrimitiveDiff(oldProps.thickness, newProps.thickness, 'thickness', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberRadioButtonPropsHandler;
}();
/**
 * Class used to create radio button controls
 *
 * This code has been generated
 */


var FiberRadioButton =
/** @class */
function () {
  function FiberRadioButton() {
    this.propsHandlers = [new FiberRadioButtonPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberRadioButton.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberRadioButton.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberRadioButton.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "RadioButton",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberRadioButton.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberRadioButton"
  };
  return FiberRadioButton;
}();

var FiberBaseSliderPropsHandler =
/** @class */
function () {
  function FiberBaseSliderPropsHandler() {}

  FiberBaseSliderPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.barOffset, newProps.barOffset, 'barOffset', 'string | number', changedProps);
    checkPrimitiveDiff(oldProps.displayThumb, newProps.displayThumb, 'displayThumb', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.isThumbClamped, newProps.isThumbClamped, 'isThumbClamped', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.isVertical, newProps.isVertical, 'isVertical', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.maximum, newProps.maximum, 'maximum', 'number', changedProps);
    checkPrimitiveDiff(oldProps.minimum, newProps.minimum, 'minimum', 'number', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkObservableDiff(oldProps.onValueChangedObservable, newProps.onValueChangedObservable, 'onValueChangedObservable', 'BabylonjsCoreObservable<number>', changedProps);
    checkPrimitiveDiff(oldProps.step, newProps.step, 'step', 'number', changedProps);
    checkPrimitiveDiff(oldProps.thumbWidth, newProps.thumbWidth, 'thumbWidth', 'string | number', changedProps);
    checkPrimitiveDiff(oldProps.value, newProps.value, 'value', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberBaseSliderPropsHandler;
}();
/**
 * Class used to create slider controls
 *
 * This code has been generated
 */


var FiberBaseSlider =
/** @class */
function () {
  function FiberBaseSlider() {
    this.propsHandlers = [new FiberBaseSliderPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberBaseSlider.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberBaseSlider.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberBaseSlider.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "BaseSlider",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberBaseSlider.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberBaseSlider"
  };
  return FiberBaseSlider;
}();

var FiberScrollBarPropsHandler =
/** @class */
function () {
  function FiberScrollBarPropsHandler() {}

  FiberScrollBarPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.background, newProps.background, 'background', 'string', changedProps);
    checkPrimitiveDiff(oldProps.borderColor, newProps.borderColor, 'borderColor', 'string', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberScrollBarPropsHandler;
}();
/**
 * Class used to create slider controls
 *
 * This code has been generated
 */


var FiberScrollBar =
/** @class */
function () {
  function FiberScrollBar() {
    this.propsHandlers = [new FiberScrollBarPropsHandler(), new FiberBaseSliderPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberScrollBar.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberScrollBar.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberScrollBar.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "ScrollBar",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberScrollBar.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberScrollBar"
  };
  return FiberScrollBar;
}();

var FiberImageScrollBarPropsHandler =
/** @class */
function () {
  function FiberImageScrollBarPropsHandler() {}

  FiberImageScrollBarPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = []; // type: 'BabylonjsGuiImage' property (not coded) BabylonjsGuiImageScrollBar.backgroundImage.

    checkPrimitiveDiff(oldProps.barImageHeight, newProps.barImageHeight, 'barImageHeight', 'number', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkPrimitiveDiff(oldProps.num90RotationInVerticalMode, newProps.num90RotationInVerticalMode, 'num90RotationInVerticalMode', 'number', changedProps);
    checkPrimitiveDiff(oldProps.thumbHeight, newProps.thumbHeight, 'thumbHeight', 'number', changedProps); // type: 'BabylonjsGuiImage' property (not coded) BabylonjsGuiImageScrollBar.thumbImage.

    checkPrimitiveDiff(oldProps.thumbLength, newProps.thumbLength, 'thumbLength', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberImageScrollBarPropsHandler;
}();
/**
 * Class used to create slider controls
 *
 * This code has been generated
 */


var FiberImageScrollBar =
/** @class */
function () {
  function FiberImageScrollBar() {
    this.propsHandlers = [new FiberImageScrollBarPropsHandler(), new FiberBaseSliderPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberImageScrollBar.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberImageScrollBar.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberImageScrollBar.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "ImageScrollBar",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberImageScrollBar.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberImageScrollBar"
  };
  return FiberImageScrollBar;
}();

var FiberSliderPropsHandler =
/** @class */
function () {
  function FiberSliderPropsHandler() {}

  FiberSliderPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.background, newProps.background, 'background', 'string', changedProps);
    checkPrimitiveDiff(oldProps.borderColor, newProps.borderColor, 'borderColor', 'string', changedProps);
    checkPrimitiveDiff(oldProps.displayValueBar, newProps.displayValueBar, 'displayValueBar', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.isThumbCircle, newProps.isThumbCircle, 'isThumbCircle', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberSliderPropsHandler;
}();
/**
 * Class used to create slider controls
 *
 * This code has been generated
 */


var FiberSlider =
/** @class */
function () {
  function FiberSlider() {
    this.propsHandlers = [new FiberSliderPropsHandler(), new FiberBaseSliderPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberSlider.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberSlider.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberSlider.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "Slider",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberSlider.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberSlider"
  };
  return FiberSlider;
}();

var FiberImageBasedSliderPropsHandler =
/** @class */
function () {
  function FiberImageBasedSliderPropsHandler() {}

  FiberImageBasedSliderPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = []; // type: 'BabylonjsGuiImage' property (not coded) BabylonjsGuiImageBasedSlider.backgroundImage.

    checkPrimitiveDiff(oldProps.displayThumb, newProps.displayThumb, 'displayThumb', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps); // type: 'BabylonjsGuiImage' property (not coded) BabylonjsGuiImageBasedSlider.thumbImage.
    // type: 'BabylonjsGuiImage' property (not coded) BabylonjsGuiImageBasedSlider.valueBarImage.

    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberImageBasedSliderPropsHandler;
}();
/**
 * Class used to create slider controls based on images
 *
 * This code has been generated
 */


var FiberImageBasedSlider =
/** @class */
function () {
  function FiberImageBasedSlider() {
    this.propsHandlers = [new FiberImageBasedSliderPropsHandler(), new FiberBaseSliderPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberImageBasedSlider.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberImageBasedSlider.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberImageBasedSlider.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "ImageBasedSlider",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberImageBasedSlider.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberImageBasedSlider"
  };
  return FiberImageBasedSlider;
}();

var FiberDisplayGridPropsHandler =
/** @class */
function () {
  function FiberDisplayGridPropsHandler() {}

  FiberDisplayGridPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.background, newProps.background, 'background', 'string', changedProps);
    checkPrimitiveDiff(oldProps.cellHeight, newProps.cellHeight, 'cellHeight', 'number', changedProps);
    checkPrimitiveDiff(oldProps.cellWidth, newProps.cellWidth, 'cellWidth', 'number', changedProps);
    checkPrimitiveDiff(oldProps.displayMajorLines, newProps.displayMajorLines, 'displayMajorLines', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.displayMinorLines, newProps.displayMinorLines, 'displayMinorLines', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.majorLineColor, newProps.majorLineColor, 'majorLineColor', 'string', changedProps);
    checkPrimitiveDiff(oldProps.majorLineFrequency, newProps.majorLineFrequency, 'majorLineFrequency', 'number', changedProps);
    checkPrimitiveDiff(oldProps.majorLineTickness, newProps.majorLineTickness, 'majorLineTickness', 'number', changedProps);
    checkPrimitiveDiff(oldProps.minorLineColor, newProps.minorLineColor, 'minorLineColor', 'string', changedProps);
    checkPrimitiveDiff(oldProps.minorLineTickness, newProps.minorLineTickness, 'minorLineTickness', 'number', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberDisplayGridPropsHandler;
}();
/**
 * Class used to render a grid
 *
 * This code has been generated
 */


var FiberDisplayGrid =
/** @class */
function () {
  function FiberDisplayGrid() {
    this.propsHandlers = [new FiberDisplayGridPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberDisplayGrid.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberDisplayGrid.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberDisplayGrid.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "DisplayGrid",
    "namespace": "@babylonjs/gui/2D/controls/control",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberDisplayGrid.Metadata = {
    "isGUI2DControl": true,
    "className": "FiberDisplayGrid"
  };
  return FiberDisplayGrid;
}();

var FiberControl3DPropsHandler =
/** @class */
function () {
  function FiberControl3DPropsHandler() {}

  FiberControl3DPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.isVisible, newProps.isVisible, 'isVisible', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkObservableDiff(oldProps.onPointerClickObservable, newProps.onPointerClickObservable, 'onPointerClickObservable', 'BabylonjsCoreObservable<BabylonjsGuiVector3WithInfo>', changedProps);
    checkObservableDiff(oldProps.onPointerDownObservable, newProps.onPointerDownObservable, 'onPointerDownObservable', 'BabylonjsCoreObservable<BabylonjsGuiVector3WithInfo>', changedProps);
    checkObservableDiff(oldProps.onPointerEnterObservable, newProps.onPointerEnterObservable, 'onPointerEnterObservable', 'BabylonjsCoreObservable<BabylonjsGuiControl3D>', changedProps);
    checkObservableDiff(oldProps.onPointerMoveObservable, newProps.onPointerMoveObservable, 'onPointerMoveObservable', 'BabylonjsCoreObservable<BabylonjsCoreVector3>', changedProps);
    checkObservableDiff(oldProps.onPointerOutObservable, newProps.onPointerOutObservable, 'onPointerOutObservable', 'BabylonjsCoreObservable<BabylonjsGuiControl3D>', changedProps);
    checkObservableDiff(oldProps.onPointerUpObservable, newProps.onPointerUpObservable, 'onPointerUpObservable', 'BabylonjsCoreObservable<BabylonjsGuiVector3WithInfo>', changedProps); // type: 'BabylonjsGuiContainer3D' property (not coded) BabylonjsGuiControl3D.parent.

    checkLambdaDiff(oldProps.pointerDownAnimation, newProps.pointerDownAnimation, 'pointerDownAnimation', '() => void', changedProps);
    checkLambdaDiff(oldProps.pointerEnterAnimation, newProps.pointerEnterAnimation, 'pointerEnterAnimation', '() => void', changedProps);
    checkLambdaDiff(oldProps.pointerOutAnimation, newProps.pointerOutAnimation, 'pointerOutAnimation', '() => void', changedProps);
    checkLambdaDiff(oldProps.pointerUpAnimation, newProps.pointerUpAnimation, 'pointerUpAnimation', '() => void', changedProps);
    checkVector3Diff(oldProps.position, newProps.position, 'position', 'BabylonjsCoreVector3', changedProps);
    checkVector3Diff(oldProps.scaling, newProps.scaling, 'scaling', 'BabylonjsCoreVector3', changedProps);
    checkMethodDiff(oldProps.addBehavior, newProps.addBehavior, 'addBehavior', '(behavior?: BabylonjsCoreBehavior<BabylonjsGuiControl3D>) => BabylonjsGuiControl3D', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberControl3DPropsHandler;
}();
/**
 * Class used as base class for controls
 *
 * This code has been generated
 */


var FiberControl3D =
/** @class */
function () {
  function FiberControl3D() {
    this.propsHandlers = [new FiberControl3DPropsHandler()];
  }

  FiberControl3D.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberControl3D.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberControl3D.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "Control3D",
    "namespace": "@babylonjs/gui/3D/controls/control3D",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberControl3D.Metadata = {
    "isGUI3DControl": true,
    "className": "FiberControl3D"
  };
  return FiberControl3D;
}();

var FiberContainer3DPropsHandler =
/** @class */
function () {
  function FiberContainer3DPropsHandler() {}

  FiberContainer3DPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.blockLayout, newProps.blockLayout, 'blockLayout', 'boolean', changedProps);
    checkMethodDiff(oldProps.addControl, newProps.addControl, 'addControl', '(control?: BabylonjsGuiControl3D) => BabylonjsGuiContainer3D', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberContainer3DPropsHandler;
}();
/**
 * Class used to create containers for controls
 *
 * This code has been generated
 */


var FiberContainer3D =
/** @class */
function () {
  function FiberContainer3D() {
    this.propsHandlers = [new FiberContainer3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberContainer3D.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberContainer3D.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberContainer3D.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "Container3D",
    "namespace": "@babylonjs/gui/3D/controls/control3D",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberContainer3D.Metadata = {
    "isGUI3DControl": true,
    "className": "FiberContainer3D"
  };
  return FiberContainer3D;
}();

var FiberVolumeBasedPanelPropsHandler =
/** @class */
function () {
  function FiberVolumeBasedPanelPropsHandler() {}

  FiberVolumeBasedPanelPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.columns, newProps.columns, 'columns', 'number', changedProps);
    checkPrimitiveDiff(oldProps.margin, newProps.margin, 'margin', 'number', changedProps);
    checkPrimitiveDiff(oldProps.orientation, newProps.orientation, 'orientation', 'number', changedProps);
    checkPrimitiveDiff(oldProps.rows, newProps.rows, 'rows', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberVolumeBasedPanelPropsHandler;
}();
/**
 * Abstract class used to create a container panel deployed on the surface of a volume
 *
 * This code has been generated
 */


var FiberVolumeBasedPanel =
/** @class */
function () {
  function FiberVolumeBasedPanel() {
    this.propsHandlers = [new FiberVolumeBasedPanelPropsHandler(), new FiberContainer3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberVolumeBasedPanel.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberVolumeBasedPanel.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberVolumeBasedPanel.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "VolumeBasedPanel",
    "namespace": "@babylonjs/gui/3D/controls/control3D",
    "parameters": []
  };
  FiberVolumeBasedPanel.Metadata = {
    "isGUI3DControl": true,
    "className": "FiberVolumeBasedPanel"
  };
  return FiberVolumeBasedPanel;
}();

var FiberCylinderPanelPropsHandler =
/** @class */
function () {
  function FiberCylinderPanelPropsHandler() {}

  FiberCylinderPanelPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.radius, newProps.radius, 'radius', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberCylinderPanelPropsHandler;
}();
/**
 * Class used to create a container panel deployed on the surface of a cylinder
 *
 * This code has been generated
 */


var FiberCylinderPanel =
/** @class */
function () {
  function FiberCylinderPanel() {
    this.propsHandlers = [new FiberCylinderPanelPropsHandler(), new FiberVolumeBasedPanelPropsHandler(), new FiberContainer3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberCylinderPanel.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberCylinderPanel.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberCylinderPanel.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "CylinderPanel",
    "namespace": "@babylonjs/gui/3D/controls/control3D",
    "parameters": []
  };
  FiberCylinderPanel.Metadata = {
    "isGUI3DControl": true,
    "className": "FiberCylinderPanel"
  };
  return FiberCylinderPanel;
}();

var FiberPlanePanelPropsHandler =
/** @class */
function () {
  function FiberPlanePanelPropsHandler() {}

  FiberPlanePanelPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    return null; // no props to check
  };

  return FiberPlanePanelPropsHandler;
}();
/**
 * Class used to create a container panel deployed on the surface of a plane
 *
 * This code has been generated
 */


var FiberPlanePanel =
/** @class */
function () {
  function FiberPlanePanel() {
    this.propsHandlers = [new FiberPlanePanelPropsHandler(), new FiberVolumeBasedPanelPropsHandler(), new FiberContainer3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberPlanePanel.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPlanePanel.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPlanePanel.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "PlanePanel",
    "namespace": "@babylonjs/gui/3D/controls/control3D",
    "parameters": []
  };
  FiberPlanePanel.Metadata = {
    "isGUI3DControl": true,
    "className": "FiberPlanePanel"
  };
  return FiberPlanePanel;
}();

var FiberScatterPanelPropsHandler =
/** @class */
function () {
  function FiberScatterPanelPropsHandler() {}

  FiberScatterPanelPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.iteration, newProps.iteration, 'iteration', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberScatterPanelPropsHandler;
}();
/**
 * Class used to create a container panel where items get randomized planar mapping
 *
 * This code has been generated
 */


var FiberScatterPanel =
/** @class */
function () {
  function FiberScatterPanel() {
    this.propsHandlers = [new FiberScatterPanelPropsHandler(), new FiberVolumeBasedPanelPropsHandler(), new FiberContainer3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberScatterPanel.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberScatterPanel.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberScatterPanel.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "ScatterPanel",
    "namespace": "@babylonjs/gui/3D/controls/control3D",
    "parameters": []
  };
  FiberScatterPanel.Metadata = {
    "isGUI3DControl": true,
    "className": "FiberScatterPanel"
  };
  return FiberScatterPanel;
}();

var FiberSpherePanelPropsHandler =
/** @class */
function () {
  function FiberSpherePanelPropsHandler() {}

  FiberSpherePanelPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.radius, newProps.radius, 'radius', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberSpherePanelPropsHandler;
}();
/**
 * Class used to create a container panel deployed on the surface of a sphere
 *
 * This code has been generated
 */


var FiberSpherePanel =
/** @class */
function () {
  function FiberSpherePanel() {
    this.propsHandlers = [new FiberSpherePanelPropsHandler(), new FiberVolumeBasedPanelPropsHandler(), new FiberContainer3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberSpherePanel.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberSpherePanel.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberSpherePanel.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "SpherePanel",
    "namespace": "@babylonjs/gui/3D/controls/control3D",
    "parameters": []
  };
  FiberSpherePanel.Metadata = {
    "isGUI3DControl": true,
    "className": "FiberSpherePanel"
  };
  return FiberSpherePanel;
}();

var FiberStackPanel3DPropsHandler =
/** @class */
function () {
  function FiberStackPanel3DPropsHandler() {}

  FiberStackPanel3DPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.isVertical, newProps.isVertical, 'isVertical', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.margin, newProps.margin, 'margin', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberStackPanel3DPropsHandler;
}();
/**
 * Class used to create a stack panel in 3D on XY plane
 *
 * This code has been generated
 */


var FiberStackPanel3D =
/** @class */
function () {
  function FiberStackPanel3D() {
    this.propsHandlers = [new FiberStackPanel3DPropsHandler(), new FiberContainer3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberStackPanel3D.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberStackPanel3D.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberStackPanel3D.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "StackPanel3D",
    "namespace": "@babylonjs/gui/3D/controls/control3D",
    "parameters": [{
      "name": "isVertical",
      "type": "boolean",
      "optional": true
    }]
  };
  FiberStackPanel3D.Metadata = {
    "isGUI3DControl": true,
    "className": "FiberStackPanel3D"
  };
  return FiberStackPanel3D;
}();

var FiberAbstractButton3DPropsHandler =
/** @class */
function () {
  function FiberAbstractButton3DPropsHandler() {}

  FiberAbstractButton3DPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    return null; // no props to check
  };

  return FiberAbstractButton3DPropsHandler;
}();
/**
 * Class used as a root to all buttons
 *
 * This code has been generated
 */


var FiberAbstractButton3D =
/** @class */
function () {
  function FiberAbstractButton3D() {
    this.propsHandlers = [new FiberAbstractButton3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberAbstractButton3D.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberAbstractButton3D.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberAbstractButton3D.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "AbstractButton3D",
    "namespace": "@babylonjs/gui/3D/controls/control3D",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberAbstractButton3D.Metadata = {
    "isGUI3DControl": true,
    "className": "FiberAbstractButton3D"
  };
  return FiberAbstractButton3D;
}();

var FiberButton3DPropsHandler =
/** @class */
function () {
  function FiberButton3DPropsHandler() {}

  FiberButton3DPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkControlDiff(oldProps.content, newProps.content, 'content', 'BabylonjsGuiControl', changedProps);
    checkPrimitiveDiff(oldProps.contentResolution, newProps.contentResolution, 'contentResolution', 'number', changedProps);
    checkPrimitiveDiff(oldProps.contentScaleRatio, newProps.contentScaleRatio, 'contentScaleRatio', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberButton3DPropsHandler;
}();
/**
 * Class used to create a button in 3D
 *
 * This code has been generated
 */


var FiberButton3D =
/** @class */
function () {
  function FiberButton3D() {
    this.propsHandlers = [new FiberButton3DPropsHandler(), new FiberAbstractButton3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberButton3D.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberButton3D.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberButton3D.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "Button3D",
    "namespace": "@babylonjs/gui/3D/controls/control3D",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberButton3D.Metadata = {
    "isGUI3DControl": true,
    "className": "FiberButton3D"
  };
  return FiberButton3D;
}();

var FiberHolographicButtonPropsHandler =
/** @class */
function () {
  function FiberHolographicButtonPropsHandler() {}

  FiberHolographicButtonPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.imageUrl, newProps.imageUrl, 'imageUrl', 'string', changedProps);
    checkPrimitiveDiff(oldProps.renderingGroupId, newProps.renderingGroupId, 'renderingGroupId', 'number', changedProps);
    checkPrimitiveDiff(oldProps.text, newProps.text, 'text', 'string', changedProps);
    checkPrimitiveDiff(oldProps.tooltipText, newProps.tooltipText, 'tooltipText', 'string', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberHolographicButtonPropsHandler;
}();
/**
 * Class used to create a holographic button in 3D
 *
 * This code has been generated
 */


var FiberHolographicButton =
/** @class */
function () {
  function FiberHolographicButton() {
    this.propsHandlers = [new FiberHolographicButtonPropsHandler(), new FiberButton3DPropsHandler(), new FiberAbstractButton3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberHolographicButton.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberHolographicButton.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberHolographicButton.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "HolographicButton",
    "namespace": "@babylonjs/gui/3D/controls/control3D",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": true
    }, {
      "name": "shareMaterials",
      "type": "boolean",
      "optional": true
    }]
  };
  FiberHolographicButton.Metadata = {
    "isGUI3DControl": true,
    "className": "FiberHolographicButton"
  };
  return FiberHolographicButton;
}();

var FiberMeshButton3DPropsHandler =
/** @class */
function () {
  function FiberMeshButton3DPropsHandler() {}

  FiberMeshButton3DPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    return null; // no props to check
  };

  return FiberMeshButton3DPropsHandler;
}();
/**
 * Class used to create an interactable object. It's a 3D button using a mesh coming from the current scene
 *
 * This code has been generated
 */


var FiberMeshButton3D =
/** @class */
function () {
  function FiberMeshButton3D() {
    this.propsHandlers = [new FiberMeshButton3DPropsHandler(), new FiberButton3DPropsHandler(), new FiberAbstractButton3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberMeshButton3D.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberMeshButton3D.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberMeshButton3D.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "MeshButton3D",
    "namespace": "@babylonjs/gui/3D/controls/control3D",
    "parameters": [{
      "name": "mesh",
      "type": "BabylonjsCoreMesh",
      "optional": false
    }, {
      "name": "name",
      "type": "string",
      "optional": true
    }]
  };
  FiberMeshButton3D.Metadata = {
    "isGUI3DControl": true,
    "className": "FiberMeshButton3D"
  };
  return FiberMeshButton3D;
}();

var FiberEffectLayerPropsHandler =
/** @class */
function () {
  function FiberEffectLayerPropsHandler() {}

  FiberEffectLayerPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.isEnabled, newProps.isEnabled, 'isEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkColor4Diff(oldProps.neutralColor, newProps.neutralColor, 'neutralColor', 'BabylonjsCoreColor4', changedProps);
    checkObservableDiff(oldProps.onAfterComposeObservable, newProps.onAfterComposeObservable, 'onAfterComposeObservable', 'BabylonjsCoreObservable<BabylonjsCoreEffectLayer>', changedProps);
    checkObservableDiff(oldProps.onAfterRenderMeshToEffect, newProps.onAfterRenderMeshToEffect, 'onAfterRenderMeshToEffect', 'BabylonjsCoreObservable<BabylonjsCoreAbstractMesh>', changedProps);
    checkObservableDiff(oldProps.onBeforeComposeObservable, newProps.onBeforeComposeObservable, 'onBeforeComposeObservable', 'BabylonjsCoreObservable<BabylonjsCoreEffectLayer>', changedProps);
    checkObservableDiff(oldProps.onBeforeRenderMainTextureObservable, newProps.onBeforeRenderMainTextureObservable, 'onBeforeRenderMainTextureObservable', 'BabylonjsCoreObservable<BabylonjsCoreEffectLayer>', changedProps);
    checkObservableDiff(oldProps.onBeforeRenderMeshToEffect, newProps.onBeforeRenderMeshToEffect, 'onBeforeRenderMeshToEffect', 'BabylonjsCoreObservable<BabylonjsCoreAbstractMesh>', changedProps);
    checkObservableDiff(oldProps.onDisposeObservable, newProps.onDisposeObservable, 'onDisposeObservable', 'BabylonjsCoreObservable<BabylonjsCoreEffectLayer>', changedProps);
    checkObservableDiff(oldProps.onSizeChangedObservable, newProps.onSizeChangedObservable, 'onSizeChangedObservable', 'BabylonjsCoreObservable<BabylonjsCoreEffectLayer>', changedProps);
    checkPrimitiveDiff(oldProps.renderingGroupId, newProps.renderingGroupId, 'renderingGroupId', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberEffectLayerPropsHandler;
}();
/**
 * The effect layer Helps adding post process effect blended with the main pass.
 *
 * This can be for instance use to generate glow or higlight effects on the scene.
 *
 * The effect layer class can not be used directly and is intented to inherited from to be
 * customized per effects.
 *
 * This code has been generated
 */


var FiberEffectLayer =
/** @class */
function () {
  function FiberEffectLayer() {
    this.propsHandlers = [new FiberEffectLayerPropsHandler()];
  }

  FiberEffectLayer.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberEffectLayer.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberEffectLayer.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "EffectLayer",
    "namespace": "@babylonjs/core/Layers/effectLayer",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberEffectLayer.Metadata = {
    "isEffectLayer": true,
    "className": "FiberEffectLayer"
  };
  return FiberEffectLayer;
}();

var FiberGlowLayerPropsHandler =
/** @class */
function () {
  function FiberGlowLayerPropsHandler() {}

  FiberGlowLayerPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.blurKernelSize, newProps.blurKernelSize, 'blurKernelSize', 'number', changedProps);
    checkLambdaDiff(oldProps.customEmissiveColorSelector, newProps.customEmissiveColorSelector, 'customEmissiveColorSelector', '(mesh: BabylonjsCoreMesh, subMesh: BabylonjsCoreSubMesh, material: BabylonjsCoreMaterial, result: BabylonjsCoreColor4) => void', changedProps);
    checkLambdaDiff(oldProps.customEmissiveTextureSelector, newProps.customEmissiveTextureSelector, 'customEmissiveTextureSelector', '(mesh: BabylonjsCoreMesh, subMesh: BabylonjsCoreSubMesh, material: BabylonjsCoreMaterial) => BabylonjsCoreTexture', changedProps);
    checkPrimitiveDiff(oldProps.intensity, newProps.intensity, 'intensity', 'number', changedProps);
    checkMethodDiff(oldProps.addExcludedMesh, newProps.addExcludedMesh, 'addExcludedMesh', '(mesh?: BabylonjsCoreMesh) => void', changedProps);
    checkMethodDiff(oldProps.addIncludedOnlyMesh, newProps.addIncludedOnlyMesh, 'addIncludedOnlyMesh', '(mesh?: BabylonjsCoreMesh) => void', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberGlowLayerPropsHandler;
}();
/**
 * The glow layer Helps adding a glow effect around the emissive parts of a mesh.
 *
 * Once instantiated in a scene, by default, all the emissive meshes will glow.
 *
 * Documentation: https://doc.babylonjs.com/how_to/glow_layer
 *
 * This code has been generated
 */


var FiberGlowLayer =
/** @class */
function () {
  function FiberGlowLayer() {
    this.propsHandlers = [new FiberGlowLayerPropsHandler(), new FiberEffectLayerPropsHandler()];
  }

  FiberGlowLayer.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberGlowLayer.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberGlowLayer.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "GlowLayer",
    "namespace": "@babylonjs/core/Layers/effectLayer",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "options",
      "type": "Partial<BabylonjsCoreIGlowLayerOptions>",
      "optional": true
    }]
  };
  FiberGlowLayer.Metadata = {
    "isEffectLayer": true,
    "className": "FiberGlowLayer"
  };
  return FiberGlowLayer;
}();

var FiberHighlightLayerPropsHandler =
/** @class */
function () {
  function FiberHighlightLayerPropsHandler() {}

  FiberHighlightLayerPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.blurHorizontalSize, newProps.blurHorizontalSize, 'blurHorizontalSize', 'number', changedProps);
    checkPrimitiveDiff(oldProps.blurVerticalSize, newProps.blurVerticalSize, 'blurVerticalSize', 'number', changedProps);
    checkPrimitiveDiff(oldProps.innerGlow, newProps.innerGlow, 'innerGlow', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkObservableDiff(oldProps.onAfterBlurObservable, newProps.onAfterBlurObservable, 'onAfterBlurObservable', 'BabylonjsCoreObservable<BabylonjsCoreHighlightLayer>', changedProps);
    checkObservableDiff(oldProps.onBeforeBlurObservable, newProps.onBeforeBlurObservable, 'onBeforeBlurObservable', 'BabylonjsCoreObservable<BabylonjsCoreHighlightLayer>', changedProps);
    checkPrimitiveDiff(oldProps.outerGlow, newProps.outerGlow, 'outerGlow', 'boolean', changedProps);
    checkMethodDiff(oldProps.addExcludedMesh, newProps.addExcludedMesh, 'addExcludedMesh', '(mesh?: BabylonjsCoreMesh) => void', changedProps);
    checkMethodDiff(oldProps.addMesh, newProps.addMesh, 'addMesh', '(mesh?: BabylonjsCoreMesh, color?: BabylonjsCoreColor3, glowEmissiveOnly?: boolean) => void', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberHighlightLayerPropsHandler;
}();
/**
 * The highlight layer Helps adding a glow effect around a mesh.
 *
 * Once instantiated in a scene, simply use the addMesh or removeMesh method to add or remove
 * glowy meshes to your scene.
 *
 * !!! THIS REQUIRES AN ACTIVE STENCIL BUFFER ON THE CANVAS !!!
 *
 * This code has been generated
 */


var FiberHighlightLayer =
/** @class */
function () {
  function FiberHighlightLayer() {
    this.propsHandlers = [new FiberHighlightLayerPropsHandler(), new FiberEffectLayerPropsHandler()];
  }

  FiberHighlightLayer.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberHighlightLayer.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberHighlightLayer.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "HighlightLayer",
    "namespace": "@babylonjs/core/Layers/effectLayer",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "options",
      "type": "Partial<BabylonjsCoreIHighlightLayerOptions>",
      "optional": true
    }]
  };
  FiberHighlightLayer.Metadata = {
    "isEffectLayer": true,
    "className": "FiberHighlightLayer"
  };
  return FiberHighlightLayer;
}();

var FiberBaseTexturePropsHandler =
/** @class */
function () {
  function FiberBaseTexturePropsHandler() {}

  FiberBaseTexturePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = []; // type: 'BabylonjsCoreAnimation[]' property (not coded) BabylonjsCoreBaseTexture.animations.

    checkPrimitiveDiff(oldProps.anisotropicFilteringLevel, newProps.anisotropicFilteringLevel, 'anisotropicFilteringLevel', 'number', changedProps);
    checkPrimitiveDiff(oldProps.coordinatesIndex, newProps.coordinatesIndex, 'coordinatesIndex', 'number', changedProps);
    checkPrimitiveDiff(oldProps.coordinatesMode, newProps.coordinatesMode, 'coordinatesMode', 'number', changedProps);
    checkPrimitiveDiff(oldProps.delayLoadState, newProps.delayLoadState, 'delayLoadState', 'number', changedProps);
    checkPrimitiveDiff(oldProps.gammaSpace, newProps.gammaSpace, 'gammaSpace', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.getAlphaFromRGB, newProps.getAlphaFromRGB, 'getAlphaFromRGB', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.hasAlpha, newProps.hasAlpha, 'hasAlpha', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.invertZ, newProps.invertZ, 'invertZ', 'boolean', changedProps);
    checkTextureDiff(oldProps.irradianceTexture, newProps.irradianceTexture, 'irradianceTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCoreBaseTexture.irradianceTexture.

    checkPrimitiveDiff(oldProps.is2DArray, newProps.is2DArray, 'is2DArray', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.is3D, newProps.is3D, 'is3D', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.isCube, newProps.isCube, 'isCube', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.isRenderTarget, newProps.isRenderTarget, 'isRenderTarget', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.isRGBD, newProps.isRGBD, 'isRGBD', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.level, newProps.level, 'level', 'number', changedProps);
    checkPrimitiveDiff(oldProps.linearSpecularLOD, newProps.linearSpecularLOD, 'linearSpecularLOD', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.lodGenerationOffset, newProps.lodGenerationOffset, 'lodGenerationOffset', 'number', changedProps);
    checkPrimitiveDiff(oldProps.lodGenerationScale, newProps.lodGenerationScale, 'lodGenerationScale', 'number', changedProps);
    checkPrimitiveDiff(oldProps.lodLevelInAlpha, newProps.lodLevelInAlpha, 'lodLevelInAlpha', 'boolean', changedProps); // type: 'any' property (not coded) BabylonjsCoreBaseTexture.metadata.

    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkLambdaDiff(oldProps.onDispose, newProps.onDispose, 'onDispose', '() => void', changedProps);
    checkObservableDiff(oldProps.onDisposeObservable, newProps.onDisposeObservable, 'onDisposeObservable', 'BabylonjsCoreObservable<BabylonjsCoreBaseTexture>', changedProps); // type: 'any' property (not coded) BabylonjsCoreBaseTexture.reservedDataStore.

    checkPrimitiveDiff(oldProps.uniqueId, newProps.uniqueId, 'uniqueId', 'number', changedProps);
    checkPrimitiveDiff(oldProps.wrapR, newProps.wrapR, 'wrapR', 'number', changedProps);
    checkPrimitiveDiff(oldProps.wrapU, newProps.wrapU, 'wrapU', 'number', changedProps);
    checkPrimitiveDiff(oldProps.wrapV, newProps.wrapV, 'wrapV', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberBaseTexturePropsHandler;
}();
/**
 * Base class of all the textures in babylon.
 * It groups all the common properties the materials, post process, lights... might need
 * in order to make a correct use of the texture.
 *
 * This code has been generated
 */


var FiberBaseTexture =
/** @class */
function () {
  function FiberBaseTexture() {
    this.propsHandlers = [new FiberBaseTexturePropsHandler()];
  }

  FiberBaseTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberBaseTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberBaseTexture.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "BaseTexture",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberBaseTexture.Metadata = {
    "isTexture": true,
    "className": "FiberBaseTexture"
  };
  return FiberBaseTexture;
}();

var FiberCubeTexturePropsHandler =
/** @class */
function () {
  function FiberCubeTexturePropsHandler() {}

  FiberCubeTexturePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkVector3Diff(oldProps.boundingBoxPosition, newProps.boundingBoxPosition, 'boundingBoxPosition', 'BabylonjsCoreVector3', changedProps);
    checkVector3Diff(oldProps.boundingBoxSize, newProps.boundingBoxSize, 'boundingBoxSize', 'BabylonjsCoreVector3', changedProps);
    checkObservableDiff(oldProps.onLoadObservable, newProps.onLoadObservable, 'onLoadObservable', 'BabylonjsCoreObservable<BabylonjsCoreCubeTexture>', changedProps);
    checkPrimitiveDiff(oldProps.rotationY, newProps.rotationY, 'rotationY', 'number', changedProps);
    checkPrimitiveDiff(oldProps.url, newProps.url, 'url', 'string', changedProps);
    checkMethodDiff(oldProps.setReflectionTextureMatrix, newProps.setReflectionTextureMatrix, 'setReflectionTextureMatrix', '(value?: BabylonjsCoreMatrix) => void', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberCubeTexturePropsHandler;
}();
/**
 * Class for creating a cube texture
 *
 * This code has been generated
 */


var FiberCubeTexture =
/** @class */
function () {
  function FiberCubeTexture() {
    this.propsHandlers = [new FiberCubeTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberCubeTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberCubeTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberCubeTexture.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "CubeTexture",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "rootUrl",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "extensions",
      "type": "string[]",
      "optional": true
    }, {
      "name": "noMipmap",
      "type": "boolean",
      "optional": true
    }, {
      "name": "files",
      "type": "string[]",
      "optional": true
    }, {
      "name": "onLoad",
      "type": "() => void",
      "optional": true
    }, {
      "name": "onError",
      "type": "(message?: string, exception?: any) => void",
      "optional": true
    }, {
      "name": "format",
      "type": "number",
      "optional": true
    }, {
      "name": "prefiltered",
      "type": "boolean",
      "optional": true
    }, {
      "name": "forcedExtension",
      "type": "any",
      "optional": true
    }, {
      "name": "createPolynomials",
      "type": "boolean",
      "optional": true
    }, {
      "name": "lodScale",
      "type": "number",
      "optional": true
    }, {
      "name": "lodOffset",
      "type": "number",
      "optional": true
    }]
  };
  FiberCubeTexture.Metadata = {
    "isTexture": true,
    "className": "FiberCubeTexture"
  };
  return FiberCubeTexture;
}();

var FiberRawCubeTexturePropsHandler =
/** @class */
function () {
  function FiberRawCubeTexturePropsHandler() {}

  FiberRawCubeTexturePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    return null; // no props to check
  };

  return FiberRawCubeTexturePropsHandler;
}();
/**
 * Raw cube texture where the raw buffers are passed in
 *
 * This code has been generated
 */


var FiberRawCubeTexture =
/** @class */
function () {
  function FiberRawCubeTexture() {
    this.propsHandlers = [new FiberRawCubeTexturePropsHandler(), new FiberCubeTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberRawCubeTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberRawCubeTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberRawCubeTexture.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "RawCubeTexture",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "data",
      "type": "ArrayBufferView[]",
      "optional": false
    }, {
      "name": "size",
      "type": "number",
      "optional": false
    }, {
      "name": "format",
      "type": "number",
      "optional": true
    }, {
      "name": "type",
      "type": "number",
      "optional": true
    }, {
      "name": "generateMipMaps",
      "type": "boolean",
      "optional": true
    }, {
      "name": "invertY",
      "type": "boolean",
      "optional": true
    }, {
      "name": "samplingMode",
      "type": "number",
      "optional": true
    }, {
      "name": "compression",
      "type": "string",
      "optional": true
    }]
  };
  FiberRawCubeTexture.Metadata = {
    "isTexture": true,
    "className": "FiberRawCubeTexture"
  };
  return FiberRawCubeTexture;
}();

var FiberTexturePropsHandler =
/** @class */
function () {
  function FiberTexturePropsHandler() {}

  FiberTexturePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = []; // type: 'BabylonjsCoreIInspectable[]' property (not coded) BabylonjsCoreTexture.inspectableCustomProperties.

    checkPrimitiveDiff(oldProps.isBlocking, newProps.isBlocking, 'isBlocking', 'boolean', changedProps);
    checkObservableDiff(oldProps.onLoadObservable, newProps.onLoadObservable, 'onLoadObservable', 'BabylonjsCoreObservable<BabylonjsCoreTexture>', changedProps);
    checkPrimitiveDiff(oldProps.uAng, newProps.uAng, 'uAng', 'number', changedProps);
    checkPrimitiveDiff(oldProps.uOffset, newProps.uOffset, 'uOffset', 'number', changedProps);
    checkPrimitiveDiff(oldProps.url, newProps.url, 'url', 'string', changedProps);
    checkPrimitiveDiff(oldProps.uRotationCenter, newProps.uRotationCenter, 'uRotationCenter', 'number', changedProps);
    checkPrimitiveDiff(oldProps.uScale, newProps.uScale, 'uScale', 'number', changedProps);
    checkPrimitiveDiff(oldProps.vAng, newProps.vAng, 'vAng', 'number', changedProps);
    checkPrimitiveDiff(oldProps.vOffset, newProps.vOffset, 'vOffset', 'number', changedProps);
    checkPrimitiveDiff(oldProps.vRotationCenter, newProps.vRotationCenter, 'vRotationCenter', 'number', changedProps);
    checkPrimitiveDiff(oldProps.vScale, newProps.vScale, 'vScale', 'number', changedProps);
    checkPrimitiveDiff(oldProps.wAng, newProps.wAng, 'wAng', 'number', changedProps);
    checkPrimitiveDiff(oldProps.wRotationCenter, newProps.wRotationCenter, 'wRotationCenter', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberTexturePropsHandler;
}();
/**
 * This represents a texture in babylon. It can be easily loaded from a network, base64 or html input.
 *
 * This code has been generated
 */


var FiberTexture =
/** @class */
function () {
  function FiberTexture() {
    this.propsHandlers = [new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberTexture.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "Texture",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "url",
      "type": "string",
      "optional": false
    }, {
      "name": "sceneOrEngine",
      "type": "BabylonjsCoreScene | BabylonjsCoreThinEngine",
      "optional": false
    }, {
      "name": "noMipmap",
      "type": "boolean",
      "optional": true
    }, {
      "name": "invertY",
      "type": "boolean",
      "optional": true
    }, {
      "name": "samplingMode",
      "type": "number",
      "optional": true
    }, {
      "name": "onLoad",
      "type": "() => void",
      "optional": true
    }, {
      "name": "onError",
      "type": "(message?: string, exception?: any) => void",
      "optional": true
    }, {
      "name": "buffer",
      "type": "string | HTMLImageElement | ArrayBufferView | ArrayBuffer | Blob | ImageBitmap",
      "optional": true
    }, {
      "name": "deleteBuffer",
      "type": "boolean",
      "optional": true
    }, {
      "name": "format",
      "type": "number",
      "optional": true
    }, {
      "name": "mimeType",
      "type": "string",
      "optional": true
    }]
  };
  FiberTexture.Metadata = {
    "isTexture": true,
    "className": "FiberTexture"
  };
  return FiberTexture;
}();

var FiberRawTexturePropsHandler =
/** @class */
function () {
  function FiberRawTexturePropsHandler() {}

  FiberRawTexturePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.format, newProps.format, 'format', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberRawTexturePropsHandler;
}();
/**
 * Raw texture can help creating a texture directly from an array of data.
 * This can be super useful if you either get the data from an uncompressed source or
 * if you wish to create your texture pixel by pixel.
 *
 * This code has been generated
 */


var FiberRawTexture =
/** @class */
function () {
  function FiberRawTexture() {
    this.propsHandlers = [new FiberRawTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberRawTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberRawTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberRawTexture.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "RawTexture",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "data",
      "type": "ArrayBufferView",
      "optional": false
    }, {
      "name": "width",
      "type": "number",
      "optional": false
    }, {
      "name": "height",
      "type": "number",
      "optional": false
    }, {
      "name": "format",
      "type": "number",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "generateMipMaps",
      "type": "boolean",
      "optional": true
    }, {
      "name": "invertY",
      "type": "boolean",
      "optional": true
    }, {
      "name": "samplingMode",
      "type": "number",
      "optional": true
    }, {
      "name": "type",
      "type": "number",
      "optional": true
    }]
  };
  FiberRawTexture.Metadata = {
    "isTexture": true,
    "className": "FiberRawTexture"
  };
  return FiberRawTexture;
}();

var FiberProceduralTexturePropsHandler =
/** @class */
function () {
  function FiberProceduralTexturePropsHandler() {}

  FiberProceduralTexturePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.autoClear, newProps.autoClear, 'autoClear', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.isCube, newProps.isCube, 'isCube', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.isEnabled, newProps.isEnabled, 'isEnabled', 'boolean', changedProps);
    checkLambdaDiff(oldProps.onGenerated, newProps.onGenerated, 'onGenerated', '() => void', changedProps);
    checkObservableDiff(oldProps.onGeneratedObservable, newProps.onGeneratedObservable, 'onGeneratedObservable', 'BabylonjsCoreObservable<BabylonjsCoreProceduralTexture>', changedProps);
    checkPrimitiveDiff(oldProps.refreshRate, newProps.refreshRate, 'refreshRate', 'number', changedProps);
    checkMethodDiff(oldProps.setColor3, newProps.setColor3, 'setColor3', '(name?: string, value?: BabylonjsCoreColor3) => BabylonjsCoreProceduralTexture', changedProps);
    checkMethodDiff(oldProps.setColor4, newProps.setColor4, 'setColor4', '(name?: string, value?: BabylonjsCoreColor4) => BabylonjsCoreProceduralTexture', changedProps);
    checkMethodDiff(oldProps.setFloat, newProps.setFloat, 'setFloat', '(name?: string, value?: number) => BabylonjsCoreProceduralTexture', changedProps);
    checkMethodDiff(oldProps.setFloats, newProps.setFloats, 'setFloats', '(name?: string, value?: number[]) => BabylonjsCoreProceduralTexture', changedProps);
    checkMethodDiff(oldProps.setFragment, newProps.setFragment, 'setFragment', '(fragment?: any) => void', changedProps);
    checkMethodDiff(oldProps.setInt, newProps.setInt, 'setInt', '(name?: string, value?: number) => BabylonjsCoreProceduralTexture', changedProps);
    checkMethodDiff(oldProps.setMatrix, newProps.setMatrix, 'setMatrix', '(name?: string, value?: BabylonjsCoreMatrix) => BabylonjsCoreProceduralTexture', changedProps);
    checkMethodDiff(oldProps.setTexture, newProps.setTexture, 'setTexture', '(name?: string, texture?: BabylonjsCoreTexture) => BabylonjsCoreProceduralTexture', changedProps);
    checkMethodDiff(oldProps.setVector2, newProps.setVector2, 'setVector2', '(name?: string, value?: BabylonjsCoreVector2) => BabylonjsCoreProceduralTexture', changedProps);
    checkMethodDiff(oldProps.setVector3, newProps.setVector3, 'setVector3', '(name?: string, value?: BabylonjsCoreVector3) => BabylonjsCoreProceduralTexture', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberProceduralTexturePropsHandler;
}();
/**
 * Procedural texturing is a way to programmatically create a texture. There are 2 types of procedural textures: code-only, and code that references some classic 2D images, sometimes calmpler' images.
 * This is the base class of any Procedural texture and contains most of the shareable code.
 *
 * This code has been generated
 */


var FiberProceduralTexture =
/** @class */
function () {
  function FiberProceduralTexture() {
    this.propsHandlers = [new FiberProceduralTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberProceduralTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberProceduralTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberProceduralTexture.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "ProceduralTexture",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "size",
      "type": "any",
      "optional": false
    }, {
      "name": "fragment",
      "type": "any",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "fallbackTexture",
      "type": "BabylonjsCoreTexture",
      "optional": true
    }, {
      "name": "generateMipMaps",
      "type": "boolean",
      "optional": true
    }, {
      "name": "isCube",
      "type": "boolean",
      "optional": true
    }]
  };
  FiberProceduralTexture.Metadata = {
    "isTexture": true,
    "className": "FiberProceduralTexture"
  };
  return FiberProceduralTexture;
}();

var FiberCustomProceduralTexturePropsHandler =
/** @class */
function () {
  function FiberCustomProceduralTexturePropsHandler() {}

  FiberCustomProceduralTexturePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.animate, newProps.animate, 'animate', 'boolean', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberCustomProceduralTexturePropsHandler;
}();
/**
 * Procedural texturing is a way to programmatically create a texture. There are 2 types of procedural textures: code-only, and code that references some classic 2D images, sometimes called 'refMaps' or 'sampler' images.
 * Custom Procedural textures are the easiest way to create your own procedural in your application.
 *
 * This code has been generated
 */


var FiberCustomProceduralTexture =
/** @class */
function () {
  function FiberCustomProceduralTexture() {
    this.propsHandlers = [new FiberCustomProceduralTexturePropsHandler(), new FiberProceduralTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberCustomProceduralTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberCustomProceduralTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberCustomProceduralTexture.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "CustomProceduralTexture",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "texturePath",
      "type": "string",
      "optional": false
    }, {
      "name": "size",
      "type": "number",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "fallbackTexture",
      "type": "BabylonjsCoreTexture",
      "optional": true
    }, {
      "name": "generateMipMaps",
      "type": "boolean",
      "optional": true
    }]
  };
  FiberCustomProceduralTexture.Metadata = {
    "isTexture": true,
    "className": "FiberCustomProceduralTexture"
  };
  return FiberCustomProceduralTexture;
}();

var FiberNoiseProceduralTexturePropsHandler =
/** @class */
function () {
  function FiberNoiseProceduralTexturePropsHandler() {}

  FiberNoiseProceduralTexturePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.animationSpeedFactor, newProps.animationSpeedFactor, 'animationSpeedFactor', 'number', changedProps);
    checkPrimitiveDiff(oldProps.brightness, newProps.brightness, 'brightness', 'number', changedProps);
    checkPrimitiveDiff(oldProps.octaves, newProps.octaves, 'octaves', 'number', changedProps);
    checkPrimitiveDiff(oldProps.persistence, newProps.persistence, 'persistence', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberNoiseProceduralTexturePropsHandler;
}();
/**
 * Class used to generate noise procedural textures
 *
 * This code has been generated
 */


var FiberNoiseProceduralTexture =
/** @class */
function () {
  function FiberNoiseProceduralTexture() {
    this.propsHandlers = [new FiberNoiseProceduralTexturePropsHandler(), new FiberProceduralTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberNoiseProceduralTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberNoiseProceduralTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberNoiseProceduralTexture.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "NoiseProceduralTexture",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "size",
      "type": "number",
      "optional": true
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }, {
      "name": "fallbackTexture",
      "type": "BabylonjsCoreTexture",
      "optional": true
    }, {
      "name": "generateMipMaps",
      "type": "boolean",
      "optional": true
    }]
  };
  FiberNoiseProceduralTexture.Metadata = {
    "isTexture": true,
    "className": "FiberNoiseProceduralTexture"
  };
  return FiberNoiseProceduralTexture;
}();

var FiberRenderTargetTexturePropsHandler =
/** @class */
function () {
  function FiberRenderTargetTexturePropsHandler() {}

  FiberRenderTargetTexturePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = []; // type: 'BabylonjsCoreCamera' property (not coded) BabylonjsCoreRenderTargetTexture.activeCamera.

    checkVector3Diff(oldProps.boundingBoxPosition, newProps.boundingBoxPosition, 'boundingBoxPosition', 'BabylonjsCoreVector3', changedProps);
    checkVector3Diff(oldProps.boundingBoxSize, newProps.boundingBoxSize, 'boundingBoxSize', 'BabylonjsCoreVector3', changedProps);
    checkColor4Diff(oldProps.clearColor, newProps.clearColor, 'clearColor', 'BabylonjsCoreColor4', changedProps);
    checkPrimitiveDiff(oldProps.coordinatesMode, newProps.coordinatesMode, 'coordinatesMode', 'number', changedProps);
    checkLambdaDiff(oldProps.customRenderFunction, newProps.customRenderFunction, 'customRenderFunction', '(opaqueSubMeshes: BabylonjsCoreSmartArray<BabylonjsCoreSubMesh>, alphaTestSubMeshes: BabylonjsCoreSmartArray<BabylonjsCoreSubMesh>, transparentSubMeshes: BabylonjsCoreSmartArray<BabylonjsCoreSubMesh>, depthOnlySubMeshes: BabylonjsCoreSmartArray<BabylonjsCoreSubMesh>, beforeTransparents?: () => void) => void', changedProps);
    checkLambdaDiff(oldProps.getCustomRenderList, newProps.getCustomRenderList, 'getCustomRenderList', '(layerOrFace: number, renderList: readonly BabylonjsCoreAbstractMesh[], renderListLength: number) => BabylonjsCoreAbstractMesh[]', changedProps);
    checkPrimitiveDiff(oldProps.ignoreCameraViewport, newProps.ignoreCameraViewport, 'ignoreCameraViewport', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.isCube, newProps.isCube, 'isCube', 'boolean', changedProps);
    checkLambdaDiff(oldProps.onAfterRender, newProps.onAfterRender, 'onAfterRender', '(faceIndex: number) => void', changedProps);
    checkObservableDiff(oldProps.onAfterRenderObservable, newProps.onAfterRenderObservable, 'onAfterRenderObservable', 'BabylonjsCoreObservable<number>', changedProps);
    checkLambdaDiff(oldProps.onAfterUnbind, newProps.onAfterUnbind, 'onAfterUnbind', '() => void', changedProps);
    checkObservableDiff(oldProps.onAfterUnbindObservable, newProps.onAfterUnbindObservable, 'onAfterUnbindObservable', 'BabylonjsCoreObservable<BabylonjsCoreRenderTargetTexture>', changedProps);
    checkObservableDiff(oldProps.onBeforeBindObservable, newProps.onBeforeBindObservable, 'onBeforeBindObservable', 'BabylonjsCoreObservable<BabylonjsCoreRenderTargetTexture>', changedProps);
    checkLambdaDiff(oldProps.onBeforeRender, newProps.onBeforeRender, 'onBeforeRender', '(faceIndex: number) => void', changedProps);
    checkObservableDiff(oldProps.onBeforeRenderObservable, newProps.onBeforeRenderObservable, 'onBeforeRenderObservable', 'BabylonjsCoreObservable<number>', changedProps);
    checkLambdaDiff(oldProps.onClear, newProps.onClear, 'onClear', '(Engine: BabylonjsCoreEngine) => void', changedProps);
    checkObservableDiff(oldProps.onClearObservable, newProps.onClearObservable, 'onClearObservable', 'BabylonjsCoreObservable<BabylonjsCoreEngine>', changedProps);
    checkObservableDiff(oldProps.onResizeObservable, newProps.onResizeObservable, 'onResizeObservable', 'BabylonjsCoreObservable<BabylonjsCoreRenderTargetTexture>', changedProps);
    checkPrimitiveDiff(oldProps.refreshRate, newProps.refreshRate, 'refreshRate', 'number', changedProps); // type: 'BabylonjsCoreAbstractMesh[]' property (not coded) BabylonjsCoreRenderTargetTexture.renderList.

    checkLambdaDiff(oldProps.renderListPredicate, newProps.renderListPredicate, 'renderListPredicate', '(AbstractMesh: BabylonjsCoreAbstractMesh) => boolean', changedProps);
    checkPrimitiveDiff(oldProps.renderParticles, newProps.renderParticles, 'renderParticles', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.renderSprites, newProps.renderSprites, 'renderSprites', 'boolean', changedProps); // type: 'any' property (not coded) BabylonjsCoreRenderTargetTexture.renderToTarget.

    checkPrimitiveDiff(oldProps.samples, newProps.samples, 'samples', 'number', changedProps);
    checkPrimitiveDiff(oldProps.useCameraPostProcesses, newProps.useCameraPostProcesses, 'useCameraPostProcesses', 'boolean', changedProps);
    checkMethodDiff(oldProps.addPostProcess, newProps.addPostProcess, 'addPostProcess', '(postProcess?: BabylonjsCorePostProcess) => void', changedProps);
    checkMethodDiff(oldProps.setRenderingAutoClearDepthStencil, newProps.setRenderingAutoClearDepthStencil, 'setRenderingAutoClearDepthStencil', '(renderingGroupId?: number, autoClearDepthStencil?: boolean) => void', changedProps);
    checkMethodDiff(oldProps.setRenderingOrder, newProps.setRenderingOrder, 'setRenderingOrder', '(renderingGroupId?: number, opaqueSortCompareFn?: (a: BabylonjsCoreSubMesh, b: BabylonjsCoreSubMesh) => number, alphaTestSortCompareFn?: (a: BabylonjsCoreSubMesh, b: BabylonjsCoreSubMesh) => number, transparentSortCompareFn?: (a: BabylonjsCoreSubMesh, b: BabylonjsCoreSubMesh) => number) => void', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberRenderTargetTexturePropsHandler;
}();
/**
 * This Helps creating a texture that will be created from a camera in your scene.
 * It is basically a dynamic texture that could be used to create special effects for instance.
 * Actually, It is the base of lot of effects in the framework like post process, shadows, effect layers and rendering pipelines...
 *
 * This code has been generated
 */


var FiberRenderTargetTexture =
/** @class */
function () {
  function FiberRenderTargetTexture() {
    this.propsHandlers = [new FiberRenderTargetTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberRenderTargetTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberRenderTargetTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberRenderTargetTexture.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "RenderTargetTexture",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "size",
      "type": "number | { width: number; height: number; layers?: number; } | { ratio: number; }",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "generateMipMaps",
      "type": "boolean",
      "optional": true
    }, {
      "name": "doNotChangeAspectRatio",
      "type": "boolean",
      "optional": true
    }, {
      "name": "type",
      "type": "number",
      "optional": true
    }, {
      "name": "isCube",
      "type": "boolean",
      "optional": true
    }, {
      "name": "samplingMode",
      "type": "number",
      "optional": true
    }, {
      "name": "generateDepthBuffer",
      "type": "boolean",
      "optional": true
    }, {
      "name": "generateStencilBuffer",
      "type": "boolean",
      "optional": true
    }, {
      "name": "isMulti",
      "type": "boolean",
      "optional": true
    }, {
      "name": "format",
      "type": "number",
      "optional": true
    }, {
      "name": "delayAllocation",
      "type": "boolean",
      "optional": true
    }]
  };
  FiberRenderTargetTexture.Metadata = {
    "isTexture": true,
    "className": "FiberRenderTargetTexture"
  };
  return FiberRenderTargetTexture;
}();

var FiberMirrorTexturePropsHandler =
/** @class */
function () {
  function FiberMirrorTexturePropsHandler() {}

  FiberMirrorTexturePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.adaptiveBlurKernel, newProps.adaptiveBlurKernel, 'adaptiveBlurKernel', 'number', changedProps);
    checkPrimitiveDiff(oldProps.blurKernel, newProps.blurKernel, 'blurKernel', 'number', changedProps);
    checkPrimitiveDiff(oldProps.blurKernelX, newProps.blurKernelX, 'blurKernelX', 'number', changedProps);
    checkPrimitiveDiff(oldProps.blurKernelY, newProps.blurKernelY, 'blurKernelY', 'number', changedProps);
    checkPrimitiveDiff(oldProps.blurRatio, newProps.blurRatio, 'blurRatio', 'number', changedProps); // type: 'BabylonjsCorePlane' property (not coded) BabylonjsCoreMirrorTexture.mirrorPlane.
    // type: 'any' property (not coded) BabylonjsCoreMirrorTexture.scene.

    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberMirrorTexturePropsHandler;
}();
/**
 * Mirror texture can be used to simulate the view from a mirror in a scene.
 * It will dynamically be rendered every frame to adapt to the camera point of view.
 * You can then easily use it as a reflectionTexture on a flat surface.
 * In case the surface is not a plane, please consider relying on reflection probes.
 *
 * This code has been generated
 */


var FiberMirrorTexture =
/** @class */
function () {
  function FiberMirrorTexture() {
    this.propsHandlers = [new FiberMirrorTexturePropsHandler(), new FiberRenderTargetTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberMirrorTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberMirrorTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberMirrorTexture.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "MirrorTexture",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "size",
      "type": "number | { width: number; height: number; } | { ratio: number; }",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "generateMipMaps",
      "type": "boolean",
      "optional": true
    }, {
      "name": "type",
      "type": "number",
      "optional": true
    }, {
      "name": "samplingMode",
      "type": "number",
      "optional": true
    }, {
      "name": "generateDepthBuffer",
      "type": "boolean",
      "optional": true
    }]
  };
  FiberMirrorTexture.Metadata = {
    "isTexture": true,
    "className": "FiberMirrorTexture"
  };
  return FiberMirrorTexture;
}();

var FiberMultiRenderTargetPropsHandler =
/** @class */
function () {
  function FiberMultiRenderTargetPropsHandler() {}

  FiberMultiRenderTargetPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.samples, newProps.samples, 'samples', 'number', changedProps);
    checkPrimitiveDiff(oldProps.wrapU, newProps.wrapU, 'wrapU', 'number', changedProps);
    checkPrimitiveDiff(oldProps.wrapV, newProps.wrapV, 'wrapV', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberMultiRenderTargetPropsHandler;
}();
/**
 * A multi render target, like a render target provides the ability to render to a texture.
 * Unlike the render target, it can render to several draw buffers in one draw.
 * This is specially interesting in deferred rendering or for any effects requiring more than
 * just one color from a single pass.
 *
 * This code has been generated
 */


var FiberMultiRenderTarget =
/** @class */
function () {
  function FiberMultiRenderTarget() {
    this.propsHandlers = [new FiberMultiRenderTargetPropsHandler(), new FiberRenderTargetTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberMultiRenderTarget.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberMultiRenderTarget.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberMultiRenderTarget.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "MultiRenderTarget",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "size",
      "type": "any",
      "optional": false
    }, {
      "name": "count",
      "type": "number",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "options",
      "type": "BabylonjsCoreIMultiRenderTargetOptions",
      "optional": true
    }]
  };
  FiberMultiRenderTarget.Metadata = {
    "isTexture": true,
    "className": "FiberMultiRenderTarget"
  };
  return FiberMultiRenderTarget;
}();

var FiberRefractionTexturePropsHandler =
/** @class */
function () {
  function FiberRefractionTexturePropsHandler() {}

  FiberRefractionTexturePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.depth, newProps.depth, 'depth', 'number', changedProps); // type: 'BabylonjsCorePlane' property (not coded) BabylonjsCoreRefractionTexture.refractionPlane.

    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberRefractionTexturePropsHandler;
}();
/**
 * Creates a refraction texture used by refraction channel of the standard material.
 * It is like a mirror but to see through a material.
 *
 * This code has been generated
 */


var FiberRefractionTexture =
/** @class */
function () {
  function FiberRefractionTexture() {
    this.propsHandlers = [new FiberRefractionTexturePropsHandler(), new FiberRenderTargetTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberRefractionTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberRefractionTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberRefractionTexture.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "RefractionTexture",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "size",
      "type": "number",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "generateMipMaps",
      "type": "boolean",
      "optional": true
    }]
  };
  FiberRefractionTexture.Metadata = {
    "isTexture": true,
    "className": "FiberRefractionTexture"
  };
  return FiberRefractionTexture;
}();

var FiberMultiviewRenderTargetPropsHandler =
/** @class */
function () {
  function FiberMultiviewRenderTargetPropsHandler() {}

  FiberMultiviewRenderTargetPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    return null; // no props to check
  };

  return FiberMultiviewRenderTargetPropsHandler;
}();
/**
 * Renders to multiple views with a single draw call
 *
 * This code has been generated
 */


var FiberMultiviewRenderTarget =
/** @class */
function () {
  function FiberMultiviewRenderTarget() {
    this.propsHandlers = [new FiberMultiviewRenderTargetPropsHandler(), new FiberRenderTargetTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberMultiviewRenderTarget.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberMultiviewRenderTarget.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberMultiviewRenderTarget.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "MultiviewRenderTarget",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "size",
      "type": "number | { width: number; height: number; } | { ratio: number; }",
      "optional": true
    }]
  };
  FiberMultiviewRenderTarget.Metadata = {
    "isTexture": true,
    "className": "FiberMultiviewRenderTarget"
  };
  return FiberMultiviewRenderTarget;
}();

var FiberVideoTexturePropsHandler =
/** @class */
function () {
  function FiberVideoTexturePropsHandler() {}

  FiberVideoTexturePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    // skipping type: 'any' property (not coded) BabylonjsCoreVideoTexture.reset.
    return null; // no props to check
  };

  return FiberVideoTexturePropsHandler;
}();
/**
 * If you want to display a video in your scene, this is the special texture for that.
 * This special texture works similar to other textures, with the exception of a few parameters.
 *
 * This code has been generated
 */


var FiberVideoTexture =
/** @class */
function () {
  function FiberVideoTexture() {
    this.propsHandlers = [new FiberVideoTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberVideoTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberVideoTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberVideoTexture.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "VideoTexture",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "src",
      "type": "string | string[] | HTMLVideoElement",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "generateMipMaps",
      "type": "boolean",
      "optional": true
    }, {
      "name": "invertY",
      "type": "boolean",
      "optional": true
    }, {
      "name": "samplingMode",
      "type": "number",
      "optional": true
    }, {
      "name": "settings",
      "type": "BabylonjsCoreVideoTextureSettings",
      "optional": true
    }]
  };
  FiberVideoTexture.Metadata = {
    "isTexture": true,
    "className": "FiberVideoTexture"
  };
  return FiberVideoTexture;
}();

var FiberDynamicTexturePropsHandler =
/** @class */
function () {
  function FiberDynamicTexturePropsHandler() {}

  FiberDynamicTexturePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    return null; // no props to check
  };

  return FiberDynamicTexturePropsHandler;
}();
/**
 * A class extending Texture allowing drawing on a texture
 *
 * This code has been generated
 */


var FiberDynamicTexture =
/** @class */
function () {
  function FiberDynamicTexture() {
    this.propsHandlers = [new FiberDynamicTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberDynamicTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberDynamicTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberDynamicTexture.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "DynamicTexture",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "options",
      "type": "any",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "generateMipMaps",
      "type": "boolean",
      "optional": false
    }, {
      "name": "samplingMode",
      "type": "number",
      "optional": true
    }, {
      "name": "format",
      "type": "number",
      "optional": true
    }]
  };
  FiberDynamicTexture.Metadata = {
    "isTexture": true,
    "className": "FiberDynamicTexture"
  };
  return FiberDynamicTexture;
}();

var FiberAdvancedDynamicTexturePropsHandler =
/** @class */
function () {
  function FiberAdvancedDynamicTexturePropsHandler() {}

  FiberAdvancedDynamicTexturePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.background, newProps.background, 'background', 'string', changedProps);
    checkPrimitiveDiff(oldProps.clipboardData, newProps.clipboardData, 'clipboardData', 'string', changedProps); // type: 'BabylonjsGuiIFocusableControl' property (not coded) BabylonjsGuiAdvancedDynamicTexture.focusedControl.

    checkPrimitiveDiff(oldProps.idealHeight, newProps.idealHeight, 'idealHeight', 'number', changedProps);
    checkPrimitiveDiff(oldProps.idealWidth, newProps.idealWidth, 'idealWidth', 'number', changedProps);
    checkPrimitiveDiff(oldProps.isForeground, newProps.isForeground, 'isForeground', 'boolean', changedProps);
    checkObservableDiff(oldProps.onBeginLayoutObservable, newProps.onBeginLayoutObservable, 'onBeginLayoutObservable', 'BabylonjsCoreObservable<BabylonjsGuiAdvancedDynamicTexture>', changedProps);
    checkObservableDiff(oldProps.onBeginRenderObservable, newProps.onBeginRenderObservable, 'onBeginRenderObservable', 'BabylonjsCoreObservable<BabylonjsGuiAdvancedDynamicTexture>', changedProps); // type: 'any' property (not coded) BabylonjsGuiAdvancedDynamicTexture.onClipboardCopy.
    // type: 'any' property (not coded) BabylonjsGuiAdvancedDynamicTexture.onClipboardCut.

    checkObservableDiff(oldProps.onClipboardObservable, newProps.onClipboardObservable, 'onClipboardObservable', 'BabylonjsCoreObservable<BabylonjsCoreClipboardInfo>', changedProps); // type: 'any' property (not coded) BabylonjsGuiAdvancedDynamicTexture.onClipboardPaste.

    checkObservableDiff(oldProps.onControlPickedObservable, newProps.onControlPickedObservable, 'onControlPickedObservable', 'BabylonjsCoreObservable<BabylonjsGuiControl>', changedProps);
    checkObservableDiff(oldProps.onEndLayoutObservable, newProps.onEndLayoutObservable, 'onEndLayoutObservable', 'BabylonjsCoreObservable<BabylonjsGuiAdvancedDynamicTexture>', changedProps);
    checkObservableDiff(oldProps.onEndRenderObservable, newProps.onEndRenderObservable, 'onEndRenderObservable', 'BabylonjsCoreObservable<BabylonjsGuiAdvancedDynamicTexture>', changedProps);
    checkPrimitiveDiff(oldProps.premulAlpha, newProps.premulAlpha, 'premulAlpha', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.renderAtIdealSize, newProps.renderAtIdealSize, 'renderAtIdealSize', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.renderScale, newProps.renderScale, 'renderScale', 'number', changedProps);
    checkPrimitiveDiff(oldProps.useInvalidateRectOptimization, newProps.useInvalidateRectOptimization, 'useInvalidateRectOptimization', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useSmallestIdeal, newProps.useSmallestIdeal, 'useSmallestIdeal', 'boolean', changedProps);
    checkMethodDiff(oldProps.addControl, newProps.addControl, 'addControl', '(control?: BabylonjsGuiControl) => BabylonjsGuiAdvancedDynamicTexture', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberAdvancedDynamicTexturePropsHandler;
}();
/**
 * Class used to create texture to support 2D GUI elements
 *
 * This code has been generated
 */


var FiberAdvancedDynamicTexture =
/** @class */
function () {
  function FiberAdvancedDynamicTexture() {
    this.propsHandlers = [new FiberAdvancedDynamicTexturePropsHandler(), new FiberDynamicTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberAdvancedDynamicTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberAdvancedDynamicTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberAdvancedDynamicTexture.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "AdvancedDynamicTexture",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "width",
      "type": "number",
      "optional": false
    }, {
      "name": "height",
      "type": "number",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "generateMipMaps",
      "type": "boolean",
      "optional": true
    }, {
      "name": "samplingMode",
      "type": "number",
      "optional": true
    }]
  };
  FiberAdvancedDynamicTexture.Metadata = {
    "isTexture": true,
    "className": "FiberAdvancedDynamicTexture"
  };
  return FiberAdvancedDynamicTexture;
}();
/**
 * Creates a new AdvancedDynamicTexture in projected mode (ie. attached to a mesh)
 *
 * This code has been generated
 */


var FiberADTForMesh =
/** @class */
function () {
  function FiberADTForMesh() {
    this.propsHandlers = [new FiberAdvancedDynamicTexturePropsHandler(), new FiberDynamicTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberADTForMesh.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberADTForMesh.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberADTForMesh.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "advancedDynamicTexture",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreateForMesh",
    "parameters": [{
      "name": "mesh",
      "type": "BabylonjsCoreAbstractMesh",
      "optional": false
    }, {
      "name": "width",
      "type": "number",
      "optional": true
    }, {
      "name": "height",
      "type": "number",
      "optional": true
    }, {
      "name": "supportPointerMove",
      "type": "boolean",
      "optional": true
    }, {
      "name": "onlyAlphaTesting",
      "type": "boolean",
      "optional": true
    }]
  };
  FiberADTForMesh.Metadata = {
    "isTexture": true,
    "className": "FiberADTForMesh"
  };
  return FiberADTForMesh;
}();
/**
 * Creates a new AdvancedDynamicTexture in fullscreen mode.
 * In this mode the texture will rely on a layer for its rendering.
 * This allows it to be treated like any other layer.
 * As such, if you have a multi camera setup, you can set the layerMask on the GUI as well.
 * LayerMask is set through advancedTexture.layer.layerMask
 *
 * This code has been generated
 */


var FiberADTFullscreenUI =
/** @class */
function () {
  function FiberADTFullscreenUI() {
    this.propsHandlers = [new FiberAdvancedDynamicTexturePropsHandler(), new FiberDynamicTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberADTFullscreenUI.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberADTFullscreenUI.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberADTFullscreenUI.CreateInfo = {
    "creationType": "FactoryMethod",
    "libraryLocation": "advancedDynamicTexture",
    "namespace": "@babylonjs/core",
    "factoryMethod": "CreateFullscreenUI",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "foreground",
      "type": "boolean",
      "optional": true
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }, {
      "name": "sampling",
      "type": "number",
      "optional": true
    }]
  };
  FiberADTFullscreenUI.Metadata = {
    "isTexture": true,
    "className": "FiberADTFullscreenUI"
  };
  return FiberADTFullscreenUI;
}();

var FiberRawTexture3DPropsHandler =
/** @class */
function () {
  function FiberRawTexture3DPropsHandler() {}

  FiberRawTexture3DPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.format, newProps.format, 'format', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberRawTexture3DPropsHandler;
}();
/**
 * Class used to store 3D textures containing user data
 *
 * This code has been generated
 */


var FiberRawTexture3D =
/** @class */
function () {
  function FiberRawTexture3D() {
    this.propsHandlers = [new FiberRawTexture3DPropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberRawTexture3D.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberRawTexture3D.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberRawTexture3D.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "RawTexture3D",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "data",
      "type": "ArrayBufferView",
      "optional": false
    }, {
      "name": "width",
      "type": "number",
      "optional": false
    }, {
      "name": "height",
      "type": "number",
      "optional": false
    }, {
      "name": "depth",
      "type": "number",
      "optional": false
    }, {
      "name": "format",
      "type": "number",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "generateMipMaps",
      "type": "boolean",
      "optional": true
    }, {
      "name": "invertY",
      "type": "boolean",
      "optional": true
    }, {
      "name": "samplingMode",
      "type": "number",
      "optional": true
    }, {
      "name": "textureType",
      "type": "number",
      "optional": true
    }]
  };
  FiberRawTexture3D.Metadata = {
    "isTexture": true,
    "className": "FiberRawTexture3D"
  };
  return FiberRawTexture3D;
}();

var FiberRawTexture2DArrayPropsHandler =
/** @class */
function () {
  function FiberRawTexture2DArrayPropsHandler() {}

  FiberRawTexture2DArrayPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.format, newProps.format, 'format', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberRawTexture2DArrayPropsHandler;
}();
/**
 * Class used to store 2D array textures containing user data
 *
 * This code has been generated
 */


var FiberRawTexture2DArray =
/** @class */
function () {
  function FiberRawTexture2DArray() {
    this.propsHandlers = [new FiberRawTexture2DArrayPropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberRawTexture2DArray.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberRawTexture2DArray.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberRawTexture2DArray.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "RawTexture2DArray",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "data",
      "type": "ArrayBufferView",
      "optional": false
    }, {
      "name": "width",
      "type": "number",
      "optional": false
    }, {
      "name": "height",
      "type": "number",
      "optional": false
    }, {
      "name": "depth",
      "type": "number",
      "optional": false
    }, {
      "name": "format",
      "type": "number",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "generateMipMaps",
      "type": "boolean",
      "optional": true
    }, {
      "name": "invertY",
      "type": "boolean",
      "optional": true
    }, {
      "name": "samplingMode",
      "type": "number",
      "optional": true
    }, {
      "name": "textureType",
      "type": "number",
      "optional": true
    }]
  };
  FiberRawTexture2DArray.Metadata = {
    "isTexture": true,
    "className": "FiberRawTexture2DArray"
  };
  return FiberRawTexture2DArray;
}();

var FiberColorGradingTexturePropsHandler =
/** @class */
function () {
  function FiberColorGradingTexturePropsHandler() {}

  FiberColorGradingTexturePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = []; // type: 'any' property (not coded) BabylonjsCoreColorGradingTexture.load3dlTexture.
    // type: 'any' property (not coded) BabylonjsCoreColorGradingTexture.loadTexture.

    checkPrimitiveDiff(oldProps.url, newProps.url, 'url', 'string', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberColorGradingTexturePropsHandler;
}();
/**
 * This represents a color grading texture. This acts as a lookup table LUT, useful during post process
 * It can help converting any input color in a desired output one. This can then be used to create effects
 * from sepia, black and white to sixties or futuristic rendering...
 *
 * The only supported format is currently 3dl.
 * More information on LUT: https://en.wikipedia.org/wiki/3D_lookup_table
 *
 * This code has been generated
 */


var FiberColorGradingTexture =
/** @class */
function () {
  function FiberColorGradingTexture() {
    this.propsHandlers = [new FiberColorGradingTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberColorGradingTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberColorGradingTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberColorGradingTexture.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "ColorGradingTexture",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "url",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberColorGradingTexture.Metadata = {
    "isTexture": true,
    "className": "FiberColorGradingTexture"
  };
  return FiberColorGradingTexture;
}();

var FiberEquiRectangularCubeTexturePropsHandler =
/** @class */
function () {
  function FiberEquiRectangularCubeTexturePropsHandler() {}

  FiberEquiRectangularCubeTexturePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.coordinatesMode, newProps.coordinatesMode, 'coordinatesMode', 'number', changedProps); // type: 'any' property (not coded) BabylonjsCoreEquiRectangularCubeTexture.getFloat32ArrayFromArrayBuffer.
    // type: 'any' property (not coded) BabylonjsCoreEquiRectangularCubeTexture.loadImage.
    // type: 'any' property (not coded) BabylonjsCoreEquiRectangularCubeTexture.loadTexture.

    checkPrimitiveDiff(oldProps.url, newProps.url, 'url', 'string', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberEquiRectangularCubeTexturePropsHandler;
}();
/**
 * This represents a texture coming from an equirectangular image supported by the web browser canvas.
 *
 * This code has been generated
 */


var FiberEquiRectangularCubeTexture =
/** @class */
function () {
  function FiberEquiRectangularCubeTexture() {
    this.propsHandlers = [new FiberEquiRectangularCubeTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberEquiRectangularCubeTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberEquiRectangularCubeTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberEquiRectangularCubeTexture.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "EquiRectangularCubeTexture",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "url",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "size",
      "type": "number",
      "optional": false
    }, {
      "name": "noMipmap",
      "type": "boolean",
      "optional": true
    }, {
      "name": "gammaSpace",
      "type": "boolean",
      "optional": true
    }, {
      "name": "onLoad",
      "type": "() => void",
      "optional": true
    }, {
      "name": "onError",
      "type": "(message?: string, exception?: any) => void",
      "optional": true
    }]
  };
  FiberEquiRectangularCubeTexture.Metadata = {
    "isTexture": true,
    "className": "FiberEquiRectangularCubeTexture"
  };
  return FiberEquiRectangularCubeTexture;
}();

var FiberHDRCubeTexturePropsHandler =
/** @class */
function () {
  function FiberHDRCubeTexturePropsHandler() {}

  FiberHDRCubeTexturePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkVector3Diff(oldProps.boundingBoxPosition, newProps.boundingBoxPosition, 'boundingBoxPosition', 'BabylonjsCoreVector3', changedProps);
    checkVector3Diff(oldProps.boundingBoxSize, newProps.boundingBoxSize, 'boundingBoxSize', 'BabylonjsCoreVector3', changedProps);
    checkPrimitiveDiff(oldProps.coordinatesMode, newProps.coordinatesMode, 'coordinatesMode', 'number', changedProps);
    checkPrimitiveDiff(oldProps.isBlocking, newProps.isBlocking, 'isBlocking', 'boolean', changedProps); // type: 'any' property (not coded) BabylonjsCoreHDRCubeTexture.loadTexture.

    checkPrimitiveDiff(oldProps.rotationY, newProps.rotationY, 'rotationY', 'number', changedProps);
    checkPrimitiveDiff(oldProps.url, newProps.url, 'url', 'string', changedProps);
    checkMethodDiff(oldProps.setReflectionTextureMatrix, newProps.setReflectionTextureMatrix, 'setReflectionTextureMatrix', '(value?: BabylonjsCoreMatrix) => void', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberHDRCubeTexturePropsHandler;
}();
/**
 * This represents a texture coming from an HDR input.
 *
 * The only supported format is currently panorama picture stored in RGBE format.
 * Example of such files can be found on HDRLib: http://hdrlib.com/
 *
 * This code has been generated
 */


var FiberHDRCubeTexture =
/** @class */
function () {
  function FiberHDRCubeTexture() {
    this.propsHandlers = [new FiberHDRCubeTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberHDRCubeTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberHDRCubeTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberHDRCubeTexture.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "HDRCubeTexture",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "url",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "size",
      "type": "number",
      "optional": false
    }, {
      "name": "noMipmap",
      "type": "boolean",
      "optional": true
    }, {
      "name": "generateHarmonics",
      "type": "boolean",
      "optional": true
    }, {
      "name": "gammaSpace",
      "type": "boolean",
      "optional": true
    }, {
      "name": "reserved",
      "type": "boolean",
      "optional": true
    }, {
      "name": "onLoad",
      "type": "() => void",
      "optional": true
    }, {
      "name": "onError",
      "type": "(message?: string, exception?: any) => void",
      "optional": true
    }]
  };
  FiberHDRCubeTexture.Metadata = {
    "isTexture": true,
    "className": "FiberHDRCubeTexture"
  };
  return FiberHDRCubeTexture;
}();

var FiberHtmlElementTexturePropsHandler =
/** @class */
function () {
  function FiberHtmlElementTexturePropsHandler() {}

  FiberHtmlElementTexturePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    // skipping type: 'HTMLVideoElement | HTMLCanvasElement' property (not coded) BabylonjsCoreHtmlElementTexture.element.
    return null; // no props to check
  };

  return FiberHtmlElementTexturePropsHandler;
}();
/**
 * This represents the smallest workload to use an already existing element (Canvas or Video) as a texture.
 * To be as efficient as possible depending on your constraints nothing aside the first upload
 * is automatically managed.
 * It is a cheap VideoTexture or DynamicTexture if you prefer to keep full control of the elements
 * in your application.
 *
 * As the update is not automatic, you need to call them manually.
 *
 * This code has been generated
 */


var FiberHtmlElementTexture =
/** @class */
function () {
  function FiberHtmlElementTexture() {
    this.propsHandlers = [new FiberHtmlElementTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberHtmlElementTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberHtmlElementTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberHtmlElementTexture.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "HtmlElementTexture",
    "namespace": "@babylonjs/core/Materials/Textures/baseTexture",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "element",
      "type": "HTMLVideoElement | HTMLCanvasElement",
      "optional": false
    }, {
      "name": "options",
      "type": "BabylonjsCoreIHtmlElementTextureOptions",
      "optional": false
    }]
  };
  FiberHtmlElementTexture.Metadata = {
    "isTexture": true,
    "className": "FiberHtmlElementTexture"
  };
  return FiberHtmlElementTexture;
}();

var FiberGUI3DManagerPropsHandler =
/** @class */
function () {
  function FiberGUI3DManagerPropsHandler() {}

  FiberGUI3DManagerPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkObservableDiff(oldProps.onPickedPointChangedObservable, newProps.onPickedPointChangedObservable, 'onPickedPointChangedObservable', 'BabylonjsCoreObservable<BabylonjsCoreVector3>', changedProps);
    checkMethodDiff(oldProps.addControl, newProps.addControl, 'addControl', '(control?: BabylonjsGuiControl3D) => BabylonjsGuiGUI3DManager', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberGUI3DManagerPropsHandler;
}();
/**
 * Class used to manage 3D user interface
 *
 * This code has been generated
 */


var FiberGUI3DManager =
/** @class */
function () {
  function FiberGUI3DManager() {
    this.propsHandlers = [new FiberGUI3DManagerPropsHandler()];
  }

  FiberGUI3DManager.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberGUI3DManager.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberGUI3DManager.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "GUI3DManager",
    "namespace": "@babylonjs/gui/3D/gui3DManager",
    "parameters": [{
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberGUI3DManager.Metadata = {
    "isGUI3DControl": true,
    "className": "FiberGUI3DManager"
  };
  return FiberGUI3DManager;
}();

var FiberShadowGeneratorPropsHandler =
/** @class */
function () {
  function FiberShadowGeneratorPropsHandler() {}

  FiberShadowGeneratorPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.bias, newProps.bias, 'bias', 'number', changedProps);
    checkPrimitiveDiff(oldProps.blurBoxOffset, newProps.blurBoxOffset, 'blurBoxOffset', 'number', changedProps);
    checkPrimitiveDiff(oldProps.blurKernel, newProps.blurKernel, 'blurKernel', 'number', changedProps);
    checkPrimitiveDiff(oldProps.blurScale, newProps.blurScale, 'blurScale', 'number', changedProps);
    checkPrimitiveDiff(oldProps.contactHardeningLightSizeUVRatio, newProps.contactHardeningLightSizeUVRatio, 'contactHardeningLightSizeUVRatio', 'number', changedProps); // type: 'BabylonjsCoreICustomShaderOptions' property (not coded) BabylonjsCoreShadowGenerator.customShaderOptions.

    checkPrimitiveDiff(oldProps.darkness, newProps.darkness, 'darkness', 'number', changedProps);
    checkPrimitiveDiff(oldProps.depthScale, newProps.depthScale, 'depthScale', 'number', changedProps);
    checkPrimitiveDiff(oldProps.filter, newProps.filter, 'filter', 'number', changedProps);
    checkPrimitiveDiff(oldProps.filteringQuality, newProps.filteringQuality, 'filteringQuality', 'number', changedProps);
    checkPrimitiveDiff(oldProps.forceBackFacesOnly, newProps.forceBackFacesOnly, 'forceBackFacesOnly', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.frustumEdgeFalloff, newProps.frustumEdgeFalloff, 'frustumEdgeFalloff', 'number', changedProps);
    checkPrimitiveDiff(oldProps.normalBias, newProps.normalBias, 'normalBias', 'number', changedProps);
    checkObservableDiff(oldProps.onAfterShadowMapRenderMeshObservable, newProps.onAfterShadowMapRenderMeshObservable, 'onAfterShadowMapRenderMeshObservable', 'BabylonjsCoreObservable<BabylonjsCoreMesh>', changedProps);
    checkObservableDiff(oldProps.onAfterShadowMapRenderObservable, newProps.onAfterShadowMapRenderObservable, 'onAfterShadowMapRenderObservable', 'BabylonjsCoreObservable<BabylonjsCoreEffect>', changedProps);
    checkObservableDiff(oldProps.onBeforeShadowMapRenderMeshObservable, newProps.onBeforeShadowMapRenderMeshObservable, 'onBeforeShadowMapRenderMeshObservable', 'BabylonjsCoreObservable<BabylonjsCoreMesh>', changedProps);
    checkObservableDiff(oldProps.onBeforeShadowMapRenderObservable, newProps.onBeforeShadowMapRenderObservable, 'onBeforeShadowMapRenderObservable', 'BabylonjsCoreObservable<BabylonjsCoreEffect>', changedProps);
    checkPrimitiveDiff(oldProps.transparencyShadow, newProps.transparencyShadow, 'transparencyShadow', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useBlurCloseExponentialShadowMap, newProps.useBlurCloseExponentialShadowMap, 'useBlurCloseExponentialShadowMap', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useBlurExponentialShadowMap, newProps.useBlurExponentialShadowMap, 'useBlurExponentialShadowMap', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useCloseExponentialShadowMap, newProps.useCloseExponentialShadowMap, 'useCloseExponentialShadowMap', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useContactHardeningShadow, newProps.useContactHardeningShadow, 'useContactHardeningShadow', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useExponentialShadowMap, newProps.useExponentialShadowMap, 'useExponentialShadowMap', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useKernelBlur, newProps.useKernelBlur, 'useKernelBlur', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.usePercentageCloserFiltering, newProps.usePercentageCloserFiltering, 'usePercentageCloserFiltering', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.usePoissonSampling, newProps.usePoissonSampling, 'usePoissonSampling', 'boolean', changedProps);
    checkMethodDiff(oldProps.addShadowCaster, newProps.addShadowCaster, 'addShadowCaster', '(mesh?: BabylonjsCoreAbstractMesh, includeDescendants?: boolean) => BabylonjsCoreShadowGenerator', changedProps);
    checkMethodDiff(oldProps.setDarkness, newProps.setDarkness, 'setDarkness', '(darkness?: number) => BabylonjsCoreShadowGenerator', changedProps);
    checkMethodDiff(oldProps.setTransparencyShadow, newProps.setTransparencyShadow, 'setTransparencyShadow', '(transparent?: boolean) => BabylonjsCoreShadowGenerator', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberShadowGeneratorPropsHandler;
}();
/**
 * Default implementation IShadowGenerator.
 * This is the main object responsible of generating shadows in the framework.
 * Documentation: https://doc.babylonjs.com/babylon101/shadows
 *
 * This code has been generated
 */


var FiberShadowGenerator =
/** @class */
function () {
  function FiberShadowGenerator() {
    this.propsHandlers = [new FiberShadowGeneratorPropsHandler()];
  }

  FiberShadowGenerator.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberShadowGenerator.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberShadowGenerator.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "ShadowGenerator",
    "namespace": "@babylonjs/core/Lights/Shadows/shadowGenerator",
    "parameters": [{
      "name": "mapSize",
      "type": "number",
      "optional": false
    }, {
      "name": "light",
      "type": "BabylonjsCoreIShadowLight",
      "optional": true
    }, {
      "name": "usefulFloatFirst",
      "type": "boolean",
      "optional": true
    }]
  };
  FiberShadowGenerator.Metadata = {
    "delayCreation": true,
    "className": "FiberShadowGenerator"
  };
  return FiberShadowGenerator;
}();

var FiberEnvironmentHelperPropsHandler =
/** @class */
function () {
  function FiberEnvironmentHelperPropsHandler() {}

  FiberEnvironmentHelperPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkObservableDiff(oldProps.onErrorObservable, newProps.onErrorObservable, 'onErrorObservable', 'BabylonjsCoreObservable<{ message?: string; exception?: any; }>', changedProps);
    checkMethodDiff(oldProps.setMainColor, newProps.setMainColor, 'setMainColor', '(color?: BabylonjsCoreColor3) => void', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberEnvironmentHelperPropsHandler;
}();
/**
 * The Environment helper class can be used to add a fully featuread none expensive background to your scene.
 * It includes by default a skybox and a ground relying on the BackgroundMaterial.
 * It also helps with the default setup of your imageProcessing configuration.
 *
 * This code has been generated
 */


var FiberEnvironmentHelper =
/** @class */
function () {
  function FiberEnvironmentHelper() {
    this.propsHandlers = [new FiberEnvironmentHelperPropsHandler()];
  }

  FiberEnvironmentHelper.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberEnvironmentHelper.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberEnvironmentHelper.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "EnvironmentHelper",
    "namespace": "@babylonjs/core/Helpers/environmentHelper",
    "parameters": [{
      "name": "options",
      "type": "Partial<BabylonjsCoreIEnvironmentHelperOptions>",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }]
  };
  FiberEnvironmentHelper.Metadata = {
    "isEnvironment": true,
    "className": "FiberEnvironmentHelper"
  };
  return FiberEnvironmentHelper;
}();

var FiberPhysicsImpostorPropsHandler =
/** @class */
function () {
  function FiberPhysicsImpostorPropsHandler() {}

  FiberPhysicsImpostorPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkLambdaDiff(oldProps.afterStep, newProps.afterStep, 'afterStep', '() => void', changedProps);
    checkLambdaDiff(oldProps.beforeStep, newProps.beforeStep, 'beforeStep', '() => void', changedProps);
    checkPrimitiveDiff(oldProps.friction, newProps.friction, 'friction', 'number', changedProps);
    checkPrimitiveDiff(oldProps.mass, newProps.mass, 'mass', 'number', changedProps); // type: 'BabylonjsCoreIPhysicsEnabledObject' property (not coded) BabylonjsCorePhysicsImpostor.object.

    checkLambdaDiff(oldProps.onCollide, newProps.onCollide, 'onCollide', '(e: { body: any; }) => void', changedProps);
    checkLambdaDiff(oldProps.onCollideEvent, newProps.onCollideEvent, 'onCollideEvent', '(collider: BabylonjsCorePhysicsImpostor, collidedWith: BabylonjsCorePhysicsImpostor) => void', changedProps); // type: 'BabylonjsCorePhysicsImpostor' property (not coded) BabylonjsCorePhysicsImpostor.parent.
    // type: 'any' property (not coded) BabylonjsCorePhysicsImpostor.physicsBody.

    checkPrimitiveDiff(oldProps.positionIterations, newProps.positionIterations, 'positionIterations', 'number', changedProps);
    checkPrimitiveDiff(oldProps.pressure, newProps.pressure, 'pressure', 'number', changedProps);
    checkPrimitiveDiff(oldProps.restitution, newProps.restitution, 'restitution', 'number', changedProps);
    checkPrimitiveDiff(oldProps.segments, newProps.segments, 'segments', 'number', changedProps);
    checkPrimitiveDiff(oldProps.soft, newProps.soft, 'soft', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.stiffness, newProps.stiffness, 'stiffness', 'number', changedProps);
    checkPrimitiveDiff(oldProps.type, newProps.type, 'type', 'number', changedProps);
    checkPrimitiveDiff(oldProps.uniqueId, newProps.uniqueId, 'uniqueId', 'number', changedProps);
    checkPrimitiveDiff(oldProps.velocityIterations, newProps.velocityIterations, 'velocityIterations', 'number', changedProps);
    checkMethodDiff(oldProps.addAnchor, newProps.addAnchor, 'addAnchor', '(otherImpostor?: BabylonjsCorePhysicsImpostor, width?: number, height?: number, influence?: number, noCollisionBetweenLinkedBodies?: boolean) => BabylonjsCorePhysicsImpostor', changedProps);
    checkMethodDiff(oldProps.addHook, newProps.addHook, 'addHook', '(otherImpostor?: BabylonjsCorePhysicsImpostor, length?: number, influence?: number, noCollisionBetweenLinkedBodies?: boolean) => BabylonjsCorePhysicsImpostor', changedProps);
    checkMethodDiff(oldProps.addJoint, newProps.addJoint, 'addJoint', '(otherImpostor?: BabylonjsCorePhysicsImpostor, joint?: BabylonjsCorePhysicsJoint) => BabylonjsCorePhysicsImpostor', changedProps);
    checkMethodDiff(oldProps.setAngularVelocity, newProps.setAngularVelocity, 'setAngularVelocity', '(velocity?: BabylonjsCoreVector3) => void', changedProps);
    checkMethodDiff(oldProps.setDeltaPosition, newProps.setDeltaPosition, 'setDeltaPosition', '(position?: BabylonjsCoreVector3) => void', changedProps);
    checkMethodDiff(oldProps.setDeltaRotation, newProps.setDeltaRotation, 'setDeltaRotation', '(rotation?: BabylonjsCoreQuaternion) => void', changedProps);
    checkMethodDiff(oldProps.setLinearVelocity, newProps.setLinearVelocity, 'setLinearVelocity', '(velocity?: BabylonjsCoreVector3) => void', changedProps);
    checkMethodDiff(oldProps.setMass, newProps.setMass, 'setMass', '(mass?: number) => void', changedProps);
    checkMethodDiff(oldProps.setParam, newProps.setParam, 'setParam', '(paramName?: string, value?: number) => void', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberPhysicsImpostorPropsHandler;
}();
/**
 * Represents a physics imposter
 *
 * This code has been generated
 */


var FiberPhysicsImpostor =
/** @class */
function () {
  function FiberPhysicsImpostor() {
    this.propsHandlers = [new FiberPhysicsImpostorPropsHandler()];
  }

  FiberPhysicsImpostor.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPhysicsImpostor.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPhysicsImpostor.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "PhysicsImpostor",
    "namespace": "@babylonjs/core/Physics/physicsImpostor",
    "parameters": [{
      "name": "object",
      "type": "BabylonjsCoreIPhysicsEnabledObject",
      "optional": true
    }, {
      "name": "type",
      "type": "number",
      "optional": false
    }, {
      "name": "_options",
      "type": "BabylonjsCorePhysicsImpostorParameters",
      "optional": true
    }, {
      "name": "_scene",
      "type": "BabylonjsCoreScene",
      "optional": true
    }]
  };
  FiberPhysicsImpostor.Metadata = {
    "delayCreation": true,
    "className": "FiberPhysicsImpostor"
  };
  return FiberPhysicsImpostor;
}();

var FiberVRExperienceHelperPropsHandler =
/** @class */
function () {
  function FiberVRExperienceHelperPropsHandler() {}

  FiberVRExperienceHelperPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = []; // type: 'any' property (not coded) BabylonjsCoreVRExperienceHelper.beforeRender.
    // type: 'any' property (not coded) BabylonjsCoreVRExperienceHelper.completeVRInit.

    checkPrimitiveDiff(oldProps.displayGaze, newProps.displayGaze, 'displayGaze', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.displayLaserPointer, newProps.displayLaserPointer, 'displayLaserPointer', 'boolean', changedProps); // type: 'any' property (not coded) BabylonjsCoreVRExperienceHelper.displayVRButton.

    checkPrimitiveDiff(oldProps.enableGazeEvenWhenNoPointerLock, newProps.enableGazeEvenWhenNoPointerLock, 'enableGazeEvenWhenNoPointerLock', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.exitVROnDoubleTap, newProps.exitVROnDoubleTap, 'exitVROnDoubleTap', 'boolean', changedProps); // type: 'BabylonjsCoreMesh' property (not coded) BabylonjsCoreVRExperienceHelper.gazeTrackerMesh.

    checkLambdaDiff(oldProps.meshSelectionPredicate, newProps.meshSelectionPredicate, 'meshSelectionPredicate', '(mesh: BabylonjsCoreAbstractMesh) => boolean', changedProps); // type: 'any' property (not coded) BabylonjsCoreVRExperienceHelper.moveButtonToBottomRight.

    checkObservableDiff(oldProps.onAfterCameraTeleport, newProps.onAfterCameraTeleport, 'onAfterCameraTeleport', 'BabylonjsCoreObservable<BabylonjsCoreVector3>', changedProps);
    checkObservableDiff(oldProps.onAfterEnteringVRObservable, newProps.onAfterEnteringVRObservable, 'onAfterEnteringVRObservable', 'BabylonjsCoreObservable<BabylonjsCoreOnAfterEnteringVRObservableEvent>', changedProps);
    checkObservableDiff(oldProps.onBeforeCameraTeleport, newProps.onBeforeCameraTeleport, 'onBeforeCameraTeleport', 'BabylonjsCoreObservable<BabylonjsCoreVector3>', changedProps);
    checkObservableDiff(oldProps.onControllerMeshLoadedObservable, newProps.onControllerMeshLoadedObservable, 'onControllerMeshLoadedObservable', 'BabylonjsCoreObservable<BabylonjsCoreWebVRController>', changedProps);
    checkObservableDiff(oldProps.onEnteringVRObservable, newProps.onEnteringVRObservable, 'onEnteringVRObservable', 'BabylonjsCoreObservable<BabylonjsCoreVRExperienceHelper>', changedProps);
    checkObservableDiff(oldProps.onExitingVRObservable, newProps.onExitingVRObservable, 'onExitingVRObservable', 'BabylonjsCoreObservable<BabylonjsCoreVRExperienceHelper>', changedProps);
    checkObservableDiff(oldProps.onMeshSelectedWithController, newProps.onMeshSelectedWithController, 'onMeshSelectedWithController', 'BabylonjsCoreObservable<{ mesh: BabylonjsCoreAbstractMesh; controller: BabylonjsCoreWebVRController; }>', changedProps);
    checkObservableDiff(oldProps.onNewMeshPicked, newProps.onNewMeshPicked, 'onNewMeshPicked', 'BabylonjsCoreObservable<BabylonjsCorePickingInfo>', changedProps);
    checkObservableDiff(oldProps.onNewMeshSelected, newProps.onNewMeshSelected, 'onNewMeshSelected', 'BabylonjsCoreObservable<BabylonjsCoreAbstractMesh>', changedProps);
    checkObservableDiff(oldProps.onSelectedMeshUnselected, newProps.onSelectedMeshUnselected, 'onSelectedMeshUnselected', 'BabylonjsCoreObservable<BabylonjsCoreAbstractMesh>', changedProps); // type: 'any' property (not coded) BabylonjsCoreVRExperienceHelper.onVRDisplayChanged.
    // type: 'any' property (not coded) BabylonjsCoreVRExperienceHelper.onVrDisplayPresentChange.

    checkVector3Diff(oldProps.position, newProps.position, 'position', 'BabylonjsCoreVector3', changedProps);
    checkLambdaDiff(oldProps.raySelectionPredicate, newProps.raySelectionPredicate, 'raySelectionPredicate', '(mesh: BabylonjsCoreAbstractMesh) => boolean', changedProps);
    checkPrimitiveDiff(oldProps.requestPointerLockOnFullScreen, newProps.requestPointerLockOnFullScreen, 'requestPointerLockOnFullScreen', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.teleportationEnabled, newProps.teleportationEnabled, 'teleportationEnabled', 'boolean', changedProps); // type: 'BabylonjsCoreMesh' property (not coded) BabylonjsCoreVRExperienceHelper.teleportationTarget.
    // type: 'any' property (not coded) BabylonjsCoreVRExperienceHelper.updateButtonVisibility.

    checkPrimitiveDiff(oldProps.updateControllerLaserColor, newProps.updateControllerLaserColor, 'updateControllerLaserColor', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.updateGazeTrackerColor, newProps.updateGazeTrackerColor, 'updateGazeTrackerColor', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.updateGazeTrackerScale, newProps.updateGazeTrackerScale, 'updateGazeTrackerScale', 'boolean', changedProps); // type: 'BabylonjsCoreVRExperienceHelperOptions' property (not coded) BabylonjsCoreVRExperienceHelper.webVROptions.
    // type: 'BabylonjsCoreWebXRDefaultExperience' property (not coded) BabylonjsCoreVRExperienceHelper.xr.

    checkPrimitiveDiff(oldProps.xrTestDone, newProps.xrTestDone, 'xrTestDone', 'boolean', changedProps);
    checkMethodDiff(oldProps.addFloorMesh, newProps.addFloorMesh, 'addFloorMesh', '(floorMesh?: BabylonjsCoreMesh) => void', changedProps);
    checkMethodDiff(oldProps.setGazeColor, newProps.setGazeColor, 'setGazeColor', '(color?: BabylonjsCoreColor3, pickedColor?: BabylonjsCoreColor3) => void', changedProps);
    checkMethodDiff(oldProps.setLaserColor, newProps.setLaserColor, 'setLaserColor', '(color?: BabylonjsCoreColor3, pickedColor?: BabylonjsCoreColor3) => void', changedProps);
    checkMethodDiff(oldProps.setLaserLightingState, newProps.setLaserLightingState, 'setLaserLightingState', '(enabled?: boolean) => void', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberVRExperienceHelperPropsHandler;
}();
/**
 * Helps to quickly add VR support to an existing scene.
 * See http://doc.babylonjs.com/how_to/webvr_helper
 *
 * This code has been generated
 */


var FiberVRExperienceHelper =
/** @class */
function () {
  function FiberVRExperienceHelper() {
    this.propsHandlers = [new FiberVRExperienceHelperPropsHandler()];
  }

  FiberVRExperienceHelper.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberVRExperienceHelper.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberVRExperienceHelper.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "VRExperienceHelper",
    "namespace": "@babylonjs/core/Cameras/VR/vrExperienceHelper",
    "parameters": [{
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "webVROptions",
      "type": "BabylonjsCoreVRExperienceHelperOptions",
      "optional": true
    }]
  };
  FiberVRExperienceHelper.Metadata = {
    "className": "FiberVRExperienceHelper"
  };
  return FiberVRExperienceHelper;
}();

var FiberDynamicTerrainPropsHandler =
/** @class */
function () {
  function FiberDynamicTerrainPropsHandler() {}

  FiberDynamicTerrainPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = []; // type: 'BabylonjsCoreCamera' property (not coded) ExtensionsDynamicTerrain.camera.

    checkPrimitiveDiff(oldProps.cameraLODCorrection, newProps.cameraLODCorrection, 'cameraLODCorrection', 'number', changedProps);
    checkPrimitiveDiff(oldProps.computeNormals, newProps.computeNormals, 'computeNormals', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.initialLOD, newProps.initialLOD, 'initialLOD', 'number', changedProps);
    checkPrimitiveDiff(oldProps.isAlwaysVisible, newProps.isAlwaysVisible, 'isAlwaysVisible', 'boolean', changedProps);
    checkNumericArrayDiff(oldProps.LODLimits, newProps.LODLimits, 'LODLimits', 'number[]', changedProps);
    checkPrimitiveDiff(oldProps.LODNegativeX, newProps.LODNegativeX, 'LODNegativeX', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.LODNegativeZ, newProps.LODNegativeZ, 'LODNegativeZ', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.LODPositiveX, newProps.LODPositiveX, 'LODPositiveX', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.LODPositiveZ, newProps.LODPositiveZ, 'LODPositiveZ', 'boolean', changedProps); // type: 'BabylonjsCoreFloatArray' property (not coded) ExtensionsDynamicTerrain.mapColors.
    // type: 'BabylonjsCoreFloatArray' property (not coded) ExtensionsDynamicTerrain.mapData.
    // type: 'BabylonjsCoreFloatArray' property (not coded) ExtensionsDynamicTerrain.mapNormals.

    checkPrimitiveDiff(oldProps.mapSubX, newProps.mapSubX, 'mapSubX', 'number', changedProps);
    checkPrimitiveDiff(oldProps.mapSubZ, newProps.mapSubZ, 'mapSubZ', 'number', changedProps); // type: 'BabylonjsCoreFloatArray' property (not coded) ExtensionsDynamicTerrain.mapUVs.

    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps);
    checkPrimitiveDiff(oldProps.precomputeNormalsFromMap, newProps.precomputeNormalsFromMap, 'precomputeNormalsFromMap', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.refreshEveryFrame, newProps.refreshEveryFrame, 'refreshEveryFrame', 'boolean', changedProps); // type: '{ x: number; z: number; }' property (not coded) ExtensionsDynamicTerrain.shiftFromCamera.

    checkPrimitiveDiff(oldProps.subToleranceX, newProps.subToleranceX, 'subToleranceX', 'number', changedProps);
    checkPrimitiveDiff(oldProps.subToleranceZ, newProps.subToleranceZ, 'subToleranceZ', 'number', changedProps);
    checkPrimitiveDiff(oldProps.useCustomVertexFunction, newProps.useCustomVertexFunction, 'useCustomVertexFunction', 'boolean', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberDynamicTerrainPropsHandler;
}();
/**
 * This code has been generated
 */


var FiberDynamicTerrain =
/** @class */
function () {
  function FiberDynamicTerrain() {
    this.propsHandlers = [new FiberDynamicTerrainPropsHandler()];
  }

  FiberDynamicTerrain.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberDynamicTerrain.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberDynamicTerrain.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "DynamicTerrain",
    "namespace": "./extensions/DynamicTerrain",
    "parameters": [{
      "name": "name",
      "type": "string",
      "optional": false
    }, {
      "name": "scene",
      "type": "BabylonjsCoreScene",
      "optional": false
    }, {
      "name": "options",
      "type": [{
        "name": "terrainSub",
        "type": "number",
        "optional": true
      }, {
        "name": "mapData",
        "type": "BabylonjsCoreFloatArray",
        "optional": true
      }, {
        "name": "mapSubX",
        "type": "number",
        "optional": true
      }, {
        "name": "mapSubZ",
        "type": "number",
        "optional": true
      }, {
        "name": "mapUVs",
        "type": "BabylonjsCoreFloatArray",
        "optional": true
      }, {
        "name": "mapColors",
        "type": "BabylonjsCoreFloatArray",
        "optional": true
      }, {
        "name": "mapNormals",
        "type": "BabylonjsCoreFloatArray",
        "optional": true
      }, {
        "name": "invertSide",
        "type": "boolean",
        "optional": true
      }, {
        "name": "camera",
        "type": "BabylonjsCoreCamera",
        "optional": true
      }, {
        "name": "SPmapData",
        "type": "number[][] | Float32Array[]",
        "optional": true
      }, {
        "name": "sps",
        "type": "BabylonjsCoreSolidParticleSystem",
        "optional": true
      }, {
        "name": "SPcolorData",
        "type": "number[][] | Float32Array[]",
        "optional": true
      }, {
        "name": "SPuvData",
        "type": "number[][] | Float32Array[]",
        "optional": true
      }, {
        "name": "intializedCallback",
        "type": "any",
        "optional": true
      }],
      "optional": true
    }]
  };
  FiberDynamicTerrain.Metadata = {
    "acceptsMaterials": true,
    "className": "FiberDynamicTerrain"
  };
  return FiberDynamicTerrain;
}();

var FiberAutoRotationBehaviorPropsHandler =
/** @class */
function () {
  function FiberAutoRotationBehaviorPropsHandler() {}

  FiberAutoRotationBehaviorPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.idleRotationSpeed, newProps.idleRotationSpeed, 'idleRotationSpeed', 'number', changedProps);
    checkPrimitiveDiff(oldProps.idleRotationSpinupTime, newProps.idleRotationSpinupTime, 'idleRotationSpinupTime', 'number', changedProps);
    checkPrimitiveDiff(oldProps.idleRotationWaitTime, newProps.idleRotationWaitTime, 'idleRotationWaitTime', 'number', changedProps);
    checkPrimitiveDiff(oldProps.zoomStopsAnimation, newProps.zoomStopsAnimation, 'zoomStopsAnimation', 'boolean', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberAutoRotationBehaviorPropsHandler;
}();
/**
 * The autoRotation behavior (AutoRotationBehavior) is designed to create a smooth rotation of an ArcRotateCamera when there is no user interaction.
 *
 * This code has been generated
 */


var FiberAutoRotationBehavior =
/** @class */
function () {
  function FiberAutoRotationBehavior() {
    this.propsHandlers = [new FiberAutoRotationBehaviorPropsHandler()];
  }

  FiberAutoRotationBehavior.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberAutoRotationBehavior.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberAutoRotationBehavior.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "AutoRotationBehavior",
    "namespace": "@babylonjs/core/Behaviors/Cameras/autoRotationBehavior",
    "parameters": []
  };
  FiberAutoRotationBehavior.Metadata = {
    "isBehavior": true,
    "className": "FiberAutoRotationBehavior"
  };
  return FiberAutoRotationBehavior;
}();

var FiberBouncingBehaviorPropsHandler =
/** @class */
function () {
  function FiberBouncingBehaviorPropsHandler() {}

  FiberBouncingBehaviorPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.autoTransitionRange, newProps.autoTransitionRange, 'autoTransitionRange', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.lowerRadiusTransitionRange, newProps.lowerRadiusTransitionRange, 'lowerRadiusTransitionRange', 'number', changedProps);
    checkPrimitiveDiff(oldProps.transitionDuration, newProps.transitionDuration, 'transitionDuration', 'number', changedProps);
    checkPrimitiveDiff(oldProps.upperRadiusTransitionRange, newProps.upperRadiusTransitionRange, 'upperRadiusTransitionRange', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberBouncingBehaviorPropsHandler;
}();
/**
 * Add a bouncing effect to an ArcRotateCamera when reaching a specified minimum and maximum radius
 *
 * This code has been generated
 */


var FiberBouncingBehavior =
/** @class */
function () {
  function FiberBouncingBehavior() {
    this.propsHandlers = [new FiberBouncingBehaviorPropsHandler()];
  }

  FiberBouncingBehavior.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberBouncingBehavior.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberBouncingBehavior.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "BouncingBehavior",
    "namespace": "@babylonjs/core/Behaviors/Cameras/bouncingBehavior",
    "parameters": []
  };
  FiberBouncingBehavior.Metadata = {
    "isBehavior": true,
    "className": "FiberBouncingBehavior"
  };
  return FiberBouncingBehavior;
}();

var FiberFramingBehaviorPropsHandler =
/** @class */
function () {
  function FiberFramingBehaviorPropsHandler() {}

  FiberFramingBehaviorPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.autoCorrectCameraLimitsAndSensibility, newProps.autoCorrectCameraLimitsAndSensibility, 'autoCorrectCameraLimitsAndSensibility', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.defaultElevation, newProps.defaultElevation, 'defaultElevation', 'number', changedProps);
    checkPrimitiveDiff(oldProps.elevationReturnTime, newProps.elevationReturnTime, 'elevationReturnTime', 'number', changedProps);
    checkPrimitiveDiff(oldProps.elevationReturnWaitTime, newProps.elevationReturnWaitTime, 'elevationReturnWaitTime', 'number', changedProps);
    checkPrimitiveDiff(oldProps.framingTime, newProps.framingTime, 'framingTime', 'number', changedProps);
    checkPrimitiveDiff(oldProps.mode, newProps.mode, 'mode', 'number', changedProps);
    checkPrimitiveDiff(oldProps.positionScale, newProps.positionScale, 'positionScale', 'number', changedProps);
    checkPrimitiveDiff(oldProps.radiusScale, newProps.radiusScale, 'radiusScale', 'number', changedProps);
    checkPrimitiveDiff(oldProps.zoomStopsAnimation, newProps.zoomStopsAnimation, 'zoomStopsAnimation', 'boolean', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberFramingBehaviorPropsHandler;
}();
/**
 * The framing behavior (FramingBehavior) is designed to automatically position an ArcRotateCamera when its target is set to a mesh. It is also useful if you want to prevent the camera to go under a virtual horizontal plane.
 *
 * This code has been generated
 */


var FiberFramingBehavior =
/** @class */
function () {
  function FiberFramingBehavior() {
    this.propsHandlers = [new FiberFramingBehaviorPropsHandler()];
  }

  FiberFramingBehavior.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberFramingBehavior.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberFramingBehavior.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "FramingBehavior",
    "namespace": "@babylonjs/core/Behaviors/Cameras/framingBehavior",
    "parameters": []
  };
  FiberFramingBehavior.Metadata = {
    "isBehavior": true,
    "className": "FiberFramingBehavior"
  };
  return FiberFramingBehavior;
}();

var FiberAttachToBoxBehaviorPropsHandler =
/** @class */
function () {
  function FiberAttachToBoxBehaviorPropsHandler() {}

  FiberAttachToBoxBehaviorPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.distanceAwayFromBottomOfFace, newProps.distanceAwayFromBottomOfFace, 'distanceAwayFromBottomOfFace', 'number', changedProps);
    checkPrimitiveDiff(oldProps.distanceAwayFromFace, newProps.distanceAwayFromFace, 'distanceAwayFromFace', 'number', changedProps);
    checkPrimitiveDiff(oldProps.name, newProps.name, 'name', 'string', changedProps); // type: 'any' property (not coded) BabylonjsCoreAttachToBoxBehavior.ui.

    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberAttachToBoxBehaviorPropsHandler;
}();
/**
 * A behavior that when attached to a mesh will will place a specified node on the meshes face pointing towards the camera
 *
 * This code has been generated
 */


var FiberAttachToBoxBehavior =
/** @class */
function () {
  function FiberAttachToBoxBehavior() {
    this.propsHandlers = [new FiberAttachToBoxBehaviorPropsHandler()];
  }

  FiberAttachToBoxBehavior.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberAttachToBoxBehavior.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberAttachToBoxBehavior.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "AttachToBoxBehavior",
    "namespace": "@babylonjs/core/Behaviors/Meshes/attachToBoxBehavior",
    "parameters": [{
      "name": "ui",
      "type": "BabylonjsCoreTransformNode",
      "optional": false
    }]
  };
  FiberAttachToBoxBehavior.Metadata = {
    "isBehavior": true,
    "className": "FiberAttachToBoxBehavior"
  };
  return FiberAttachToBoxBehavior;
}();

var FiberFadeInOutBehaviorPropsHandler =
/** @class */
function () {
  function FiberFadeInOutBehaviorPropsHandler() {}

  FiberFadeInOutBehaviorPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.delay, newProps.delay, 'delay', 'number', changedProps);
    checkPrimitiveDiff(oldProps.fadeInTime, newProps.fadeInTime, 'fadeInTime', 'number', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberFadeInOutBehaviorPropsHandler;
}();
/**
 * A behavior that when attached to a mesh will allow the mesh to fade in and out
 *
 * This code has been generated
 */


var FiberFadeInOutBehavior =
/** @class */
function () {
  function FiberFadeInOutBehavior() {
    this.propsHandlers = [new FiberFadeInOutBehaviorPropsHandler()];
  }

  FiberFadeInOutBehavior.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberFadeInOutBehavior.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberFadeInOutBehavior.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "FadeInOutBehavior",
    "namespace": "@babylonjs/core/Behaviors/Meshes/fadeInOutBehavior",
    "parameters": []
  };
  FiberFadeInOutBehavior.Metadata = {
    "isBehavior": true,
    "className": "FiberFadeInOutBehavior"
  };
  return FiberFadeInOutBehavior;
}();

var FiberMultiPointerScaleBehaviorPropsHandler =
/** @class */
function () {
  function FiberMultiPointerScaleBehaviorPropsHandler() {}

  FiberMultiPointerScaleBehaviorPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    return null; // no props to check
  };

  return FiberMultiPointerScaleBehaviorPropsHandler;
}();
/**
 * A behavior that when attached to a mesh will allow the mesh to be scaled
 *
 * This code has been generated
 */


var FiberMultiPointerScaleBehavior =
/** @class */
function () {
  function FiberMultiPointerScaleBehavior() {
    this.propsHandlers = [new FiberMultiPointerScaleBehaviorPropsHandler()];
  }

  FiberMultiPointerScaleBehavior.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberMultiPointerScaleBehavior.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberMultiPointerScaleBehavior.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "MultiPointerScaleBehavior",
    "namespace": "@babylonjs/core/Behaviors/Meshes/multiPointerScaleBehavior",
    "parameters": []
  };
  FiberMultiPointerScaleBehavior.Metadata = {
    "isBehavior": true,
    "className": "FiberMultiPointerScaleBehavior"
  };
  return FiberMultiPointerScaleBehavior;
}();

var FiberPointerDragBehaviorPropsHandler =
/** @class */
function () {
  function FiberPointerDragBehaviorPropsHandler() {}

  FiberPointerDragBehaviorPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = []; // type: 'BabylonjsCoreAbstractMesh' property (not coded) BabylonjsCorePointerDragBehavior.attachedNode.

    checkPrimitiveDiff(oldProps.currentDraggingPointerID, newProps.currentDraggingPointerID, 'currentDraggingPointerID', 'number', changedProps);
    checkPrimitiveDiff(oldProps.detachCameraControls, newProps.detachCameraControls, 'detachCameraControls', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.dragDeltaRatio, newProps.dragDeltaRatio, 'dragDeltaRatio', 'number', changedProps);
    checkPrimitiveDiff(oldProps.dragging, newProps.dragging, 'dragging', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.enabled, newProps.enabled, 'enabled', 'boolean', changedProps);
    checkVector3Diff(oldProps.lastDragPosition, newProps.lastDragPosition, 'lastDragPosition', 'BabylonjsCoreVector3', changedProps);
    checkPrimitiveDiff(oldProps.maxDragAngle, newProps.maxDragAngle, 'maxDragAngle', 'number', changedProps);
    checkPrimitiveDiff(oldProps.moveAttached, newProps.moveAttached, 'moveAttached', 'boolean', changedProps);
    checkObservableDiff(oldProps.onDragEndObservable, newProps.onDragEndObservable, 'onDragEndObservable', 'BabylonjsCoreObservable<{ dragPlanePoint: BabylonjsCoreVector3; pointerId: number; }>', changedProps);
    checkObservableDiff(oldProps.onDragObservable, newProps.onDragObservable, 'onDragObservable', 'BabylonjsCoreObservable<{ delta: BabylonjsCoreVector3; dragPlanePoint: BabylonjsCoreVector3; dragPlaneNormal: BabylonjsCoreVector3; dragDistance: number; pointerId: number; }>', changedProps);
    checkObservableDiff(oldProps.onDragStartObservable, newProps.onDragStartObservable, 'onDragStartObservable', 'BabylonjsCoreObservable<{ dragPlanePoint: BabylonjsCoreVector3; pointerId: number; }>', changedProps); // type: '{ dragAxis?: BabylonjsCoreVector3; dragPlaneNormal?: BabylonjsCoreVector3; }' property (not coded) BabylonjsCorePointerDragBehavior.options.

    checkPrimitiveDiff(oldProps.startAndReleaseDragOnPointerEvents, newProps.startAndReleaseDragOnPointerEvents, 'startAndReleaseDragOnPointerEvents', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.updateDragPlane, newProps.updateDragPlane, 'updateDragPlane', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useObjectOrientationForDragging, newProps.useObjectOrientationForDragging, 'useObjectOrientationForDragging', 'boolean', changedProps);
    checkLambdaDiff(oldProps.validateDrag, newProps.validateDrag, 'validateDrag', '(targetPosition: BabylonjsCoreVector3) => boolean', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberPointerDragBehaviorPropsHandler;
}();
/**
 * A behavior that when attached to a mesh will allow the mesh to be dragged around the screen based on pointer events
 *
 * This code has been generated
 */


var FiberPointerDragBehavior =
/** @class */
function () {
  function FiberPointerDragBehavior() {
    this.propsHandlers = [new FiberPointerDragBehaviorPropsHandler()];
  }

  FiberPointerDragBehavior.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPointerDragBehavior.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPointerDragBehavior.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "PointerDragBehavior",
    "namespace": "@babylonjs/core/Behaviors/Meshes/pointerDragBehavior",
    "parameters": [{
      "name": "options",
      "type": [{
        "name": "dragAxis",
        "type": "BabylonjsCoreVector3",
        "optional": true
      }, {
        "name": "dragPlaneNormal",
        "type": "BabylonjsCoreVector3",
        "optional": true
      }],
      "optional": true
    }]
  };
  FiberPointerDragBehavior.Metadata = {
    "isBehavior": true,
    "className": "FiberPointerDragBehavior"
  };
  return FiberPointerDragBehavior;
}();

var FiberSixDofDragBehaviorPropsHandler =
/** @class */
function () {
  function FiberSixDofDragBehaviorPropsHandler() {}

  FiberSixDofDragBehaviorPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = [];
    checkPrimitiveDiff(oldProps.currentDraggingPointerID, newProps.currentDraggingPointerID, 'currentDraggingPointerID', 'number', changedProps);
    checkPrimitiveDiff(oldProps.detachCameraControls, newProps.detachCameraControls, 'detachCameraControls', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.dragDeltaRatio, newProps.dragDeltaRatio, 'dragDeltaRatio', 'number', changedProps);
    checkPrimitiveDiff(oldProps.dragging, newProps.dragging, 'dragging', 'boolean', changedProps);
    checkObservableDiff(oldProps.onDragEndObservable, newProps.onDragEndObservable, 'onDragEndObservable', 'BabylonjsCoreObservable<{}>', changedProps);
    checkObservableDiff(oldProps.onDragStartObservable, newProps.onDragStartObservable, 'onDragStartObservable', 'BabylonjsCoreObservable<{}>', changedProps);
    checkPrimitiveDiff(oldProps.rotateDraggedObject, newProps.rotateDraggedObject, 'rotateDraggedObject', 'boolean', changedProps); // type: 'any' property (not coded) BabylonjsCoreSixDofDragBehavior.zDragFactor.

    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberSixDofDragBehaviorPropsHandler;
}();
/**
 * A behavior that when attached to a mesh will allow the mesh to be dragged around based on directions and origin of the pointer's ray
 *
 * This code has been generated
 */


var FiberSixDofDragBehavior =
/** @class */
function () {
  function FiberSixDofDragBehavior() {
    this.propsHandlers = [new FiberSixDofDragBehaviorPropsHandler()];
  }

  FiberSixDofDragBehavior.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberSixDofDragBehavior.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberSixDofDragBehavior.CreateInfo = {
    "creationType": "Constructor",
    "libraryLocation": "SixDofDragBehavior",
    "namespace": "@babylonjs/core/Behaviors/Meshes/sixDofDragBehavior",
    "parameters": []
  };
  FiberSixDofDragBehavior.Metadata = {
    "isBehavior": true,
    "className": "FiberSixDofDragBehavior"
  };
  return FiberSixDofDragBehavior;
}();

var FiberScenePropsHandler =
/** @class */
function () {
  function FiberScenePropsHandler() {}

  FiberScenePropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var changedProps = []; // type: 'BabylonjsCoreAbstractActionManager' property (not coded) BabylonjsCoreScene.actionManager.
    // type: 'BabylonjsCoreCamera' property (not coded) BabylonjsCoreScene.activeCamera.
    // type: 'BabylonjsCoreCamera[]' property (not coded) BabylonjsCoreScene.activeCameras.

    checkLambdaDiff(oldProps.afterCameraRender, newProps.afterCameraRender, 'afterCameraRender', '() => void', changedProps);
    checkLambdaDiff(oldProps.afterRender, newProps.afterRender, 'afterRender', '() => void', changedProps);
    checkColor3Diff(oldProps.ambientColor, newProps.ambientColor, 'ambientColor', 'BabylonjsCoreColor3', changedProps); // type: 'BabylonjsCoreAnimationPropertiesOverride' property (not coded) BabylonjsCoreScene.animationPropertiesOverride.

    checkPrimitiveDiff(oldProps.animationsEnabled, newProps.animationsEnabled, 'animationsEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.animationTimeScale, newProps.animationTimeScale, 'animationTimeScale', 'number', changedProps);
    checkPrimitiveDiff(oldProps.autoClear, newProps.autoClear, 'autoClear', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.autoClearDepthAndStencil, newProps.autoClearDepthAndStencil, 'autoClearDepthAndStencil', 'boolean', changedProps);
    checkLambdaDiff(oldProps.beforeCameraRender, newProps.beforeCameraRender, 'beforeCameraRender', '() => void', changedProps);
    checkLambdaDiff(oldProps.beforeRender, newProps.beforeRender, 'beforeRender', '() => void', changedProps);
    checkPrimitiveDiff(oldProps.blockfreeActiveMeshesAndRenderingGroups, newProps.blockfreeActiveMeshesAndRenderingGroups, 'blockfreeActiveMeshesAndRenderingGroups', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.blockMaterialDirtyMechanism, newProps.blockMaterialDirtyMechanism, 'blockMaterialDirtyMechanism', 'boolean', changedProps); // type: 'BabylonjsCoreCamera' property (not coded) BabylonjsCoreScene.cameraToUseForPointers.

    checkColor4Diff(oldProps.clearColor, newProps.clearColor, 'clearColor', 'BabylonjsCoreColor4', changedProps); // type: 'BabylonjsCorePlane' property (not coded) BabylonjsCoreScene.clipPlane.
    // type: 'BabylonjsCorePlane' property (not coded) BabylonjsCoreScene.clipPlane2.
    // type: 'BabylonjsCorePlane' property (not coded) BabylonjsCoreScene.clipPlane3.
    // type: 'BabylonjsCorePlane' property (not coded) BabylonjsCoreScene.clipPlane4.
    // type: 'BabylonjsCorePlane' property (not coded) BabylonjsCoreScene.clipPlane5.
    // type: 'BabylonjsCorePlane' property (not coded) BabylonjsCoreScene.clipPlane6.

    checkPrimitiveDiff(oldProps.collisionsEnabled, newProps.collisionsEnabled, 'collisionsEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.constantlyUpdateMeshUnderPointer, newProps.constantlyUpdateMeshUnderPointer, 'constantlyUpdateMeshUnderPointer', 'boolean', changedProps);
    checkLambdaDiff(oldProps.customLODSelector, newProps.customLODSelector, 'customLODSelector', '(mesh: BabylonjsCoreAbstractMesh, camera: BabylonjsCoreCamera) => BabylonjsCoreAbstractMesh', changedProps); // type: 'BabylonjsCoreRenderTargetTexture[]' property (not coded) BabylonjsCoreScene.customRenderTargets.

    checkPrimitiveDiff(oldProps.defaultCursor, newProps.defaultCursor, 'defaultCursor', 'string', changedProps); // type: 'BabylonjsCoreMaterial' property (not coded) BabylonjsCoreScene.defaultMaterial.
    // type: 'RegExp[]' property (not coded) BabylonjsCoreScene.disableOfflineSupportExceptionRules.

    checkPrimitiveDiff(oldProps.dispatchAllSubMeshesOfActiveMeshes, newProps.dispatchAllSubMeshesOfActiveMeshes, 'dispatchAllSubMeshesOfActiveMeshes', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.doNotHandleCursors, newProps.doNotHandleCursors, 'doNotHandleCursors', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.DoubleClickDelay, newProps.DoubleClickDelay, 'DoubleClickDelay', 'number', changedProps);
    checkPrimitiveDiff(oldProps.DragMovementThreshold, newProps.DragMovementThreshold, 'DragMovementThreshold', 'number', changedProps);
    checkPrimitiveDiff(oldProps.dumpNextRenderTargets, newProps.dumpNextRenderTargets, 'dumpNextRenderTargets', 'boolean', changedProps);
    checkTextureDiff(oldProps.environmentBRDFTexture, newProps.environmentBRDFTexture, 'environmentBRDFTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCoreScene.environmentBRDFTexture.

    checkPrimitiveDiff(oldProps.environmentIntensity, newProps.environmentIntensity, 'environmentIntensity', 'number', changedProps);
    checkTextureDiff(oldProps.environmentTexture, newProps.environmentTexture, 'environmentTexture', 'BabylonjsCoreBaseTexture', changedProps); // not found (default): 'BabylonjsCoreBaseTexture' property (not coded) BabylonjsCoreScene.environmentTexture.

    checkPrimitiveDiff(oldProps.ExclusiveDoubleClickMode, newProps.ExclusiveDoubleClickMode, 'ExclusiveDoubleClickMode', 'boolean', changedProps);
    checkColor3Diff(oldProps.fogColor, newProps.fogColor, 'fogColor', 'BabylonjsCoreColor3', changedProps);
    checkPrimitiveDiff(oldProps.fogDensity, newProps.fogDensity, 'fogDensity', 'number', changedProps);
    checkPrimitiveDiff(oldProps.fogEnabled, newProps.fogEnabled, 'fogEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.fogEnd, newProps.fogEnd, 'fogEnd', 'number', changedProps);
    checkPrimitiveDiff(oldProps.fogMode, newProps.fogMode, 'fogMode', 'number', changedProps);
    checkPrimitiveDiff(oldProps.fogStart, newProps.fogStart, 'fogStart', 'number', changedProps);
    checkPrimitiveDiff(oldProps.forcePointsCloud, newProps.forcePointsCloud, 'forcePointsCloud', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.forceWireframe, newProps.forceWireframe, 'forceWireframe', 'boolean', changedProps); // type: 'any' property (not coded) BabylonjsCoreScene.geometriesByUniqueId.

    checkLambdaDiff(oldProps.getActiveMeshCandidates, newProps.getActiveMeshCandidates, 'getActiveMeshCandidates', '() => BabylonjsCoreISmartArrayLike<BabylonjsCoreAbstractMesh>', changedProps);
    checkLambdaDiff(oldProps.getActiveSubMeshCandidates, newProps.getActiveSubMeshCandidates, 'getActiveSubMeshCandidates', '(mesh: BabylonjsCoreAbstractMesh) => BabylonjsCoreISmartArrayLike<BabylonjsCoreSubMesh>', changedProps);
    checkLambdaDiff(oldProps.getCollidingSubMeshCandidates, newProps.getCollidingSubMeshCandidates, 'getCollidingSubMeshCandidates', '(mesh: BabylonjsCoreAbstractMesh, collider: BabylonjsCoreCollider) => BabylonjsCoreISmartArrayLike<BabylonjsCoreSubMesh>', changedProps);
    checkLambdaDiff(oldProps.getDeterministicFrameTime, newProps.getDeterministicFrameTime, 'getDeterministicFrameTime', '() => number', changedProps);
    checkLambdaDiff(oldProps.getIntersectingSubMeshCandidates, newProps.getIntersectingSubMeshCandidates, 'getIntersectingSubMeshCandidates', '(mesh: BabylonjsCoreAbstractMesh, localRay: BabylonjsCoreRay) => BabylonjsCoreISmartArrayLike<BabylonjsCoreSubMesh>', changedProps);
    checkVector3Diff(oldProps.gravity, newProps.gravity, 'gravity', 'BabylonjsCoreVector3', changedProps);
    checkPrimitiveDiff(oldProps.hoverCursor, newProps.hoverCursor, 'hoverCursor', 'string', changedProps); // type: 'String[]' property (not coded) BabylonjsCoreScene.importedMeshesFiles.

    checkPrimitiveDiff(oldProps.lensFlaresEnabled, newProps.lensFlaresEnabled, 'lensFlaresEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.lightsEnabled, newProps.lightsEnabled, 'lightsEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.loadingPluginName, newProps.loadingPluginName, 'loadingPluginName', 'string', changedProps);
    checkPrimitiveDiff(oldProps.LongPressDelay, newProps.LongPressDelay, 'LongPressDelay', 'number', changedProps); // type: 'any' property (not coded) BabylonjsCoreScene.metadata.
    // type: 'BabylonjsCoreIOfflineProvider' property (not coded) BabylonjsCoreScene.offlineProvider.

    checkObservableDiff(oldProps.onActiveCameraChanged, newProps.onActiveCameraChanged, 'onActiveCameraChanged', 'BabylonjsCoreObservable<BabylonjsCoreScene>', changedProps);
    checkObservableDiff(oldProps.onAfterActiveMeshesEvaluationObservable, newProps.onAfterActiveMeshesEvaluationObservable, 'onAfterActiveMeshesEvaluationObservable', 'BabylonjsCoreObservable<BabylonjsCoreScene>', changedProps);
    checkObservableDiff(oldProps.onAfterAnimationsObservable, newProps.onAfterAnimationsObservable, 'onAfterAnimationsObservable', 'BabylonjsCoreObservable<BabylonjsCoreScene>', changedProps);
    checkObservableDiff(oldProps.onAfterCameraRenderObservable, newProps.onAfterCameraRenderObservable, 'onAfterCameraRenderObservable', 'BabylonjsCoreObservable<BabylonjsCoreCamera>', changedProps);
    checkObservableDiff(oldProps.onAfterDrawPhaseObservable, newProps.onAfterDrawPhaseObservable, 'onAfterDrawPhaseObservable', 'BabylonjsCoreObservable<BabylonjsCoreScene>', changedProps);
    checkObservableDiff(oldProps.onAfterParticlesRenderingObservable, newProps.onAfterParticlesRenderingObservable, 'onAfterParticlesRenderingObservable', 'BabylonjsCoreObservable<BabylonjsCoreScene>', changedProps);
    checkObservableDiff(oldProps.onAfterRenderCameraObservable, newProps.onAfterRenderCameraObservable, 'onAfterRenderCameraObservable', 'BabylonjsCoreObservable<BabylonjsCoreCamera>', changedProps);
    checkObservableDiff(oldProps.onAfterRenderingGroupObservable, newProps.onAfterRenderingGroupObservable, 'onAfterRenderingGroupObservable', 'BabylonjsCoreObservable<BabylonjsCoreRenderingGroupInfo>', changedProps);
    checkObservableDiff(oldProps.onAfterRenderObservable, newProps.onAfterRenderObservable, 'onAfterRenderObservable', 'BabylonjsCoreObservable<BabylonjsCoreScene>', changedProps);
    checkObservableDiff(oldProps.onAfterRenderTargetsRenderObservable, newProps.onAfterRenderTargetsRenderObservable, 'onAfterRenderTargetsRenderObservable', 'BabylonjsCoreObservable<BabylonjsCoreScene>', changedProps);
    checkObservableDiff(oldProps.onAfterStepObservable, newProps.onAfterStepObservable, 'onAfterStepObservable', 'BabylonjsCoreObservable<BabylonjsCoreScene>', changedProps);
    checkObservableDiff(oldProps.onAnimationFileImportedObservable, newProps.onAnimationFileImportedObservable, 'onAnimationFileImportedObservable', 'BabylonjsCoreObservable<BabylonjsCoreScene>', changedProps);
    checkObservableDiff(oldProps.onBeforeActiveMeshesEvaluationObservable, newProps.onBeforeActiveMeshesEvaluationObservable, 'onBeforeActiveMeshesEvaluationObservable', 'BabylonjsCoreObservable<BabylonjsCoreScene>', changedProps);
    checkObservableDiff(oldProps.onBeforeAnimationsObservable, newProps.onBeforeAnimationsObservable, 'onBeforeAnimationsObservable', 'BabylonjsCoreObservable<BabylonjsCoreScene>', changedProps);
    checkObservableDiff(oldProps.onBeforeCameraRenderObservable, newProps.onBeforeCameraRenderObservable, 'onBeforeCameraRenderObservable', 'BabylonjsCoreObservable<BabylonjsCoreCamera>', changedProps);
    checkObservableDiff(oldProps.onBeforeDrawPhaseObservable, newProps.onBeforeDrawPhaseObservable, 'onBeforeDrawPhaseObservable', 'BabylonjsCoreObservable<BabylonjsCoreScene>', changedProps);
    checkObservableDiff(oldProps.onBeforeParticlesRenderingObservable, newProps.onBeforeParticlesRenderingObservable, 'onBeforeParticlesRenderingObservable', 'BabylonjsCoreObservable<BabylonjsCoreScene>', changedProps);
    checkObservableDiff(oldProps.onBeforeRenderingGroupObservable, newProps.onBeforeRenderingGroupObservable, 'onBeforeRenderingGroupObservable', 'BabylonjsCoreObservable<BabylonjsCoreRenderingGroupInfo>', changedProps);
    checkObservableDiff(oldProps.onBeforeRenderObservable, newProps.onBeforeRenderObservable, 'onBeforeRenderObservable', 'BabylonjsCoreObservable<BabylonjsCoreScene>', changedProps);
    checkObservableDiff(oldProps.onBeforeRenderTargetsRenderObservable, newProps.onBeforeRenderTargetsRenderObservable, 'onBeforeRenderTargetsRenderObservable', 'BabylonjsCoreObservable<BabylonjsCoreScene>', changedProps);
    checkObservableDiff(oldProps.onBeforeStepObservable, newProps.onBeforeStepObservable, 'onBeforeStepObservable', 'BabylonjsCoreObservable<BabylonjsCoreScene>', changedProps);
    checkObservableDiff(oldProps.onCameraRemovedObservable, newProps.onCameraRemovedObservable, 'onCameraRemovedObservable', 'BabylonjsCoreObservable<BabylonjsCoreCamera>', changedProps);
    checkObservableDiff(oldProps.onDataLoadedObservable, newProps.onDataLoadedObservable, 'onDataLoadedObservable', 'BabylonjsCoreObservable<BabylonjsCoreScene>', changedProps);
    checkLambdaDiff(oldProps.onDispose, newProps.onDispose, 'onDispose', '() => void', changedProps);
    checkObservableDiff(oldProps.onDisposeObservable, newProps.onDisposeObservable, 'onDisposeObservable', 'BabylonjsCoreObservable<BabylonjsCoreScene>', changedProps);
    checkObservableDiff(oldProps.onGeometryRemovedObservable, newProps.onGeometryRemovedObservable, 'onGeometryRemovedObservable', 'BabylonjsCoreObservable<BabylonjsCoreGeometry>', changedProps);
    checkObservableDiff(oldProps.onKeyboardObservable, newProps.onKeyboardObservable, 'onKeyboardObservable', 'BabylonjsCoreObservable<BabylonjsCoreKeyboardInfo>', changedProps);
    checkObservableDiff(oldProps.onLightRemovedObservable, newProps.onLightRemovedObservable, 'onLightRemovedObservable', 'BabylonjsCoreObservable<BabylonjsCoreLight>', changedProps);
    checkObservableDiff(oldProps.onMaterialRemovedObservable, newProps.onMaterialRemovedObservable, 'onMaterialRemovedObservable', 'BabylonjsCoreObservable<BabylonjsCoreMaterial>', changedProps);
    checkObservableDiff(oldProps.onMeshImportedObservable, newProps.onMeshImportedObservable, 'onMeshImportedObservable', 'BabylonjsCoreObservable<BabylonjsCoreAbstractMesh>', changedProps);
    checkObservableDiff(oldProps.onMeshRemovedObservable, newProps.onMeshRemovedObservable, 'onMeshRemovedObservable', 'BabylonjsCoreObservable<BabylonjsCoreAbstractMesh>', changedProps);
    checkObservableDiff(oldProps.onNewCameraAddedObservable, newProps.onNewCameraAddedObservable, 'onNewCameraAddedObservable', 'BabylonjsCoreObservable<BabylonjsCoreCamera>', changedProps);
    checkObservableDiff(oldProps.onNewGeometryAddedObservable, newProps.onNewGeometryAddedObservable, 'onNewGeometryAddedObservable', 'BabylonjsCoreObservable<BabylonjsCoreGeometry>', changedProps);
    checkObservableDiff(oldProps.onNewLightAddedObservable, newProps.onNewLightAddedObservable, 'onNewLightAddedObservable', 'BabylonjsCoreObservable<BabylonjsCoreLight>', changedProps);
    checkObservableDiff(oldProps.onNewMaterialAddedObservable, newProps.onNewMaterialAddedObservable, 'onNewMaterialAddedObservable', 'BabylonjsCoreObservable<BabylonjsCoreMaterial>', changedProps);
    checkObservableDiff(oldProps.onNewMeshAddedObservable, newProps.onNewMeshAddedObservable, 'onNewMeshAddedObservable', 'BabylonjsCoreObservable<BabylonjsCoreAbstractMesh>', changedProps);
    checkObservableDiff(oldProps.onNewSkeletonAddedObservable, newProps.onNewSkeletonAddedObservable, 'onNewSkeletonAddedObservable', 'BabylonjsCoreObservable<BabylonjsCoreSkeleton>', changedProps);
    checkObservableDiff(oldProps.onNewTextureAddedObservable, newProps.onNewTextureAddedObservable, 'onNewTextureAddedObservable', 'BabylonjsCoreObservable<BabylonjsCoreBaseTexture>', changedProps);
    checkObservableDiff(oldProps.onNewTransformNodeAddedObservable, newProps.onNewTransformNodeAddedObservable, 'onNewTransformNodeAddedObservable', 'BabylonjsCoreObservable<BabylonjsCoreTransformNode>', changedProps);
    checkLambdaDiff(oldProps.onPointerDown, newProps.onPointerDown, 'onPointerDown', '(evt: PointerEvent, pickInfo: BabylonjsCorePickingInfo, type: BabylonjsCorePointerEventTypes) => void', changedProps);
    checkLambdaDiff(oldProps.onPointerMove, newProps.onPointerMove, 'onPointerMove', '(evt: PointerEvent, pickInfo: BabylonjsCorePickingInfo, type: BabylonjsCorePointerEventTypes) => void', changedProps);
    checkObservableDiff(oldProps.onPointerObservable, newProps.onPointerObservable, 'onPointerObservable', 'BabylonjsCoreObservable<BabylonjsCorePointerInfo>', changedProps);
    checkLambdaDiff(oldProps.onPointerPick, newProps.onPointerPick, 'onPointerPick', '(evt: PointerEvent, pickInfo: BabylonjsCorePickingInfo) => void', changedProps);
    checkLambdaDiff(oldProps.onPointerUp, newProps.onPointerUp, 'onPointerUp', '(evt: PointerEvent, pickInfo: BabylonjsCorePickingInfo, type: BabylonjsCorePointerEventTypes) => void', changedProps);
    checkObservableDiff(oldProps.onPreKeyboardObservable, newProps.onPreKeyboardObservable, 'onPreKeyboardObservable', 'BabylonjsCoreObservable<BabylonjsCoreKeyboardInfoPre>', changedProps);
    checkObservableDiff(oldProps.onPrePointerObservable, newProps.onPrePointerObservable, 'onPrePointerObservable', 'BabylonjsCoreObservable<BabylonjsCorePointerInfoPre>', changedProps);
    checkObservableDiff(oldProps.onReadyObservable, newProps.onReadyObservable, 'onReadyObservable', 'BabylonjsCoreObservable<BabylonjsCoreScene>', changedProps);
    checkObservableDiff(oldProps.onSkeletonRemovedObservable, newProps.onSkeletonRemovedObservable, 'onSkeletonRemovedObservable', 'BabylonjsCoreObservable<BabylonjsCoreSkeleton>', changedProps);
    checkObservableDiff(oldProps.onTextureRemovedObservable, newProps.onTextureRemovedObservable, 'onTextureRemovedObservable', 'BabylonjsCoreObservable<BabylonjsCoreBaseTexture>', changedProps);
    checkObservableDiff(oldProps.onTransformNodeRemovedObservable, newProps.onTransformNodeRemovedObservable, 'onTransformNodeRemovedObservable', 'BabylonjsCoreObservable<BabylonjsCoreTransformNode>', changedProps);
    checkPrimitiveDiff(oldProps.particlesEnabled, newProps.particlesEnabled, 'particlesEnabled', 'boolean', changedProps);
    checkLambdaDiff(oldProps.pointerDownPredicate, newProps.pointerDownPredicate, 'pointerDownPredicate', '(Mesh: BabylonjsCoreAbstractMesh) => boolean', changedProps);
    checkLambdaDiff(oldProps.pointerMovePredicate, newProps.pointerMovePredicate, 'pointerMovePredicate', '(Mesh: BabylonjsCoreAbstractMesh) => boolean', changedProps);
    checkLambdaDiff(oldProps.pointerUpPredicate, newProps.pointerUpPredicate, 'pointerUpPredicate', '(Mesh: BabylonjsCoreAbstractMesh) => boolean', changedProps);
    checkPrimitiveDiff(oldProps.pointerX, newProps.pointerX, 'pointerX', 'number', changedProps);
    checkPrimitiveDiff(oldProps.pointerY, newProps.pointerY, 'pointerY', 'number', changedProps); // type: 'BabylonjsCorePostProcess[]' property (not coded) BabylonjsCoreScene.postProcesses.

    checkPrimitiveDiff(oldProps.postProcessesEnabled, newProps.postProcessesEnabled, 'postProcessesEnabled', 'boolean', changedProps); // type: 'BabylonjsCorePostProcessManager' property (not coded) BabylonjsCoreScene.postProcessManager.

    checkPrimitiveDiff(oldProps.preventDefaultOnPointerDown, newProps.preventDefaultOnPointerDown, 'preventDefaultOnPointerDown', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.preventDefaultOnPointerUp, newProps.preventDefaultOnPointerUp, 'preventDefaultOnPointerUp', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.probesEnabled, newProps.probesEnabled, 'probesEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.proceduralTexturesEnabled, newProps.proceduralTexturesEnabled, 'proceduralTexturesEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.renderTargetsEnabled, newProps.renderTargetsEnabled, 'renderTargetsEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.requireLightSorting, newProps.requireLightSorting, 'requireLightSorting', 'boolean', changedProps); // type: 'any' property (not coded) BabylonjsCoreScene.reservedDataStore.

    checkPrimitiveDiff(oldProps.shadowsEnabled, newProps.shadowsEnabled, 'shadowsEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.skeletonsEnabled, newProps.skeletonsEnabled, 'skeletonsEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.skipFrustumClipping, newProps.skipFrustumClipping, 'skipFrustumClipping', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.spritesEnabled, newProps.spritesEnabled, 'spritesEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.texturesEnabled, newProps.texturesEnabled, 'texturesEnabled', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useConstantAnimationDeltaTime, newProps.useConstantAnimationDeltaTime, 'useConstantAnimationDeltaTime', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useDelayedTextureLoading, newProps.useDelayedTextureLoading, 'useDelayedTextureLoading', 'boolean', changedProps);
    checkPrimitiveDiff(oldProps.useRightHandedSystem, newProps.useRightHandedSystem, 'useRightHandedSystem', 'boolean', changedProps);
    checkMethodDiff(oldProps.addActionManager, newProps.addActionManager, 'addActionManager', '(newActionManager?: BabylonjsCoreAbstractActionManager) => void', changedProps);
    checkMethodDiff(oldProps.addAnimation, newProps.addAnimation, 'addAnimation', '(newAnimation?: BabylonjsCoreAnimation) => void', changedProps);
    checkMethodDiff(oldProps.addAnimationGroup, newProps.addAnimationGroup, 'addAnimationGroup', '(newAnimationGroup?: BabylonjsCoreAnimationGroup) => void', changedProps);
    checkMethodDiff(oldProps.addCamera, newProps.addCamera, 'addCamera', '(newCamera?: BabylonjsCoreCamera) => void', changedProps);
    checkMethodDiff(oldProps.addExternalData, newProps.addExternalData, 'addExternalData', '(key?: string, data?: T) => boolean', changedProps);
    checkMethodDiff(oldProps.addGeometry, newProps.addGeometry, 'addGeometry', '(newGeometry?: BabylonjsCoreGeometry) => void', changedProps);
    checkMethodDiff(oldProps.addLight, newProps.addLight, 'addLight', '(newLight?: BabylonjsCoreLight) => void', changedProps);
    checkMethodDiff(oldProps.addMaterial, newProps.addMaterial, 'addMaterial', '(newMaterial?: BabylonjsCoreMaterial) => void', changedProps);
    checkMethodDiff(oldProps.addMesh, newProps.addMesh, 'addMesh', '(newMesh?: BabylonjsCoreAbstractMesh, recursive?: boolean) => void', changedProps);
    checkMethodDiff(oldProps.addMorphTargetManager, newProps.addMorphTargetManager, 'addMorphTargetManager', '(newMorphTargetManager?: BabylonjsCoreMorphTargetManager) => void', changedProps);
    checkMethodDiff(oldProps.addMultiMaterial, newProps.addMultiMaterial, 'addMultiMaterial', '(newMultiMaterial?: BabylonjsCoreMultiMaterial) => void', changedProps);
    checkMethodDiff(oldProps.addParticleSystem, newProps.addParticleSystem, 'addParticleSystem', '(newParticleSystem?: BabylonjsCoreIParticleSystem) => void', changedProps);
    checkMethodDiff(oldProps.addSkeleton, newProps.addSkeleton, 'addSkeleton', '(newSkeleton?: BabylonjsCoreSkeleton) => void', changedProps);
    checkMethodDiff(oldProps.addTexture, newProps.addTexture, 'addTexture', '(newTexture?: BabylonjsCoreBaseTexture) => void', changedProps);
    checkMethodDiff(oldProps.addTransformNode, newProps.addTransformNode, 'addTransformNode', '(newTransformNode?: BabylonjsCoreTransformNode) => void', changedProps);
    checkMethodDiff(oldProps.setActiveCameraByID, newProps.setActiveCameraByID, 'setActiveCameraByID', '(id?: string) => BabylonjsCoreCamera', changedProps);
    checkMethodDiff(oldProps.setActiveCameraByName, newProps.setActiveCameraByName, 'setActiveCameraByName', '(name?: string) => BabylonjsCoreCamera', changedProps);
    checkMethodDiff(oldProps.setPointerOverMesh, newProps.setPointerOverMesh, 'setPointerOverMesh', '(mesh?: BabylonjsCoreAbstractMesh) => void', changedProps);
    checkMethodDiff(oldProps.setRenderingAutoClearDepthStencil, newProps.setRenderingAutoClearDepthStencil, 'setRenderingAutoClearDepthStencil', '(renderingGroupId?: number, autoClearDepthStencil?: boolean, depth?: boolean, stencil?: boolean) => void', changedProps);
    checkMethodDiff(oldProps.setRenderingOrder, newProps.setRenderingOrder, 'setRenderingOrder', '(renderingGroupId?: number, opaqueSortCompareFn?: (a: BabylonjsCoreSubMesh, b: BabylonjsCoreSubMesh) => number, alphaTestSortCompareFn?: (a: BabylonjsCoreSubMesh, b: BabylonjsCoreSubMesh) => number, transparentSortCompareFn?: (a: BabylonjsCoreSubMesh, b: BabylonjsCoreSubMesh) => number) => void', changedProps);
    checkMethodDiff(oldProps.setStepId, newProps.setStepId, 'setStepId', '(newStepId?: number) => void', changedProps);
    checkMethodDiff(oldProps.setTransformMatrix, newProps.setTransformMatrix, 'setTransformMatrix', '(viewL?: BabylonjsCoreMatrix, projectionL?: BabylonjsCoreMatrix, viewR?: BabylonjsCoreMatrix, projectionR?: BabylonjsCoreMatrix) => void', changedProps);
    return changedProps.length === 0 ? null : changedProps;
  };

  return FiberScenePropsHandler;
}();

var ADTForMesh = 'ADTForMesh',
    ADTFullscreenUI = 'ADTFullscreenUI',
    AbstractButton3D = 'AbstractButton3D',
    AbstractMesh = 'AbstractMesh',
    AdvancedDynamicTexture = 'AdvancedDynamicTexture',
    AnaglyphArcRotateCamera = 'AnaglyphArcRotateCamera',
    AnaglyphFreeCamera = 'AnaglyphFreeCamera',
    AnaglyphGamepadCamera = 'AnaglyphGamepadCamera',
    AnaglyphUniversalCamera = 'AnaglyphUniversalCamera',
    ArcFollowCamera = 'ArcFollowCamera',
    ArcRotateCamera = 'ArcRotateCamera',
    AttachToBoxBehavior = 'AttachToBoxBehavior',
    AutoRotationBehavior = 'AutoRotationBehavior',
    BackgroundMaterial = 'BackgroundMaterial',
    BaseSlider = 'BaseSlider',
    BaseTexture = 'BaseTexture',
    BouncingBehavior = 'BouncingBehavior',
    Box = 'Box',
    Button = 'Button',
    Button3D = 'Button3D',
    Camera = 'Camera',
    Checkbox = 'Checkbox',
    ColorGradingTexture = 'ColorGradingTexture',
    ColorPicker = 'ColorPicker',
    Container = 'Container',
    Container3D = 'Container3D',
    Control = 'Control',
    Control3D = 'Control3D',
    CubeTexture = 'CubeTexture',
    CustomProceduralTexture = 'CustomProceduralTexture',
    Cylinder = 'Cylinder',
    CylinderPanel = 'CylinderPanel',
    DashedLines = 'DashedLines',
    Decal = 'Decal',
    DeviceOrientationCamera = 'DeviceOrientationCamera',
    DirectionalLight = 'DirectionalLight',
    Disc = 'Disc',
    DisplayGrid = 'DisplayGrid',
    DynamicTerrain$1 = 'DynamicTerrain',
    DynamicTexture = 'DynamicTexture',
    EffectLayer = 'EffectLayer',
    Ellipse = 'Ellipse',
    EnvironmentHelper = 'EnvironmentHelper',
    EquiRectangularCubeTexture = 'EquiRectangularCubeTexture',
    ExtrudePolygon = 'ExtrudePolygon',
    ExtrudeShape = 'ExtrudeShape',
    ExtrudeShapeCustom = 'ExtrudeShapeCustom',
    FadeInOutBehavior = 'FadeInOutBehavior',
    FluentMaterial = 'FluentMaterial',
    FlyCamera = 'FlyCamera',
    FollowCamera = 'FollowCamera',
    FramingBehavior = 'FramingBehavior',
    FreeCamera = 'FreeCamera',
    GUI3DManager = 'GUI3DManager',
    GamepadCamera = 'GamepadCamera',
    GlowLayer = 'GlowLayer',
    Grid = 'Grid',
    Ground = 'Ground',
    GroundFromHeightMap = 'GroundFromHeightMap',
    HDRCubeTexture = 'HDRCubeTexture',
    HemisphericLight = 'HemisphericLight',
    HighlightLayer = 'HighlightLayer',
    HolographicButton = 'HolographicButton',
    HtmlElementTexture = 'HtmlElementTexture',
    IcoSphere = 'IcoSphere',
    Image = 'Image',
    ImageBasedSlider = 'ImageBasedSlider',
    ImageScrollBar = 'ImageScrollBar',
    InputPassword = 'InputPassword',
    InputText = 'InputText',
    Lathe = 'Lathe',
    Light = 'Light',
    Line = 'Line',
    LineSystem = 'LineSystem',
    Lines = 'Lines',
    Material = 'Material',
    Mesh = 'Mesh',
    MeshButton3D = 'MeshButton3D',
    MirrorTexture = 'MirrorTexture',
    Model = 'Model',
    MultiLine = 'MultiLine',
    MultiMaterial = 'MultiMaterial',
    MultiPointerScaleBehavior = 'MultiPointerScaleBehavior',
    MultiRenderTarget = 'MultiRenderTarget',
    MultiviewRenderTarget = 'MultiviewRenderTarget',
    Node = 'Node',
    NodeMaterial = 'NodeMaterial',
    NoiseProceduralTexture = 'NoiseProceduralTexture',
    PBRBaseMaterial = 'PBRBaseMaterial',
    PBRBaseSimpleMaterial = 'PBRBaseSimpleMaterial',
    PBRMaterial = 'PBRMaterial',
    PBRMetallicRoughnessMaterial = 'PBRMetallicRoughnessMaterial',
    PBRSpecularGlossinessMaterial = 'PBRSpecularGlossinessMaterial',
    PhysicsImpostor = 'PhysicsImpostor',
    Plane = 'Plane',
    PlanePanel = 'PlanePanel',
    PointLight = 'PointLight',
    PointerDragBehavior = 'PointerDragBehavior',
    Polygon = 'Polygon',
    Polyhedron = 'Polyhedron',
    ProceduralTexture = 'ProceduralTexture',
    PushMaterial = 'PushMaterial',
    RadioButton = 'RadioButton',
    RawCubeTexture = 'RawCubeTexture',
    RawTexture = 'RawTexture',
    RawTexture2DArray = 'RawTexture2DArray',
    RawTexture3D = 'RawTexture3D',
    Rectangle = 'Rectangle',
    RefractionTexture = 'RefractionTexture',
    RenderTargetTexture = 'RenderTargetTexture',
    Ribbon = 'Ribbon',
    ScatterPanel = 'ScatterPanel',
    ScrollBar = 'ScrollBar',
    ScrollViewer = 'ScrollViewer',
    SelectionPanel = 'SelectionPanel',
    ShaderMaterial = 'ShaderMaterial',
    ShadowGenerator = 'ShadowGenerator',
    ShadowLight = 'ShadowLight',
    SixDofDragBehavior = 'SixDofDragBehavior',
    Slider = 'Slider',
    Sphere = 'Sphere',
    SpherePanel = 'SpherePanel',
    SpotLight = 'SpotLight',
    StackPanel = 'StackPanel',
    StackPanel3D = 'StackPanel3D',
    StandardMaterial = 'StandardMaterial',
    StereoscopicArcRotateCamera = 'StereoscopicArcRotateCamera',
    StereoscopicFreeCamera = 'StereoscopicFreeCamera',
    StereoscopicGamepadCamera = 'StereoscopicGamepadCamera',
    StereoscopicUniversalCamera = 'StereoscopicUniversalCamera',
    TargetCamera = 'TargetCamera',
    TextBlock = 'TextBlock',
    Texture = 'Texture',
    TiledBox = 'TiledBox',
    TiledGround = 'TiledGround',
    TiledPlane = 'TiledPlane',
    Torus = 'Torus',
    TorusKnot = 'TorusKnot',
    TouchCamera = 'TouchCamera',
    TransformNode = 'TransformNode',
    Tube = 'Tube',
    UniversalCamera = 'UniversalCamera',
    VRDeviceOrientationArcRotateCamera = 'VRDeviceOrientationArcRotateCamera',
    VRDeviceOrientationFreeCamera = 'VRDeviceOrientationFreeCamera',
    VRDeviceOrientationGamepadCamera = 'VRDeviceOrientationGamepadCamera',
    VRExperienceHelper = 'VRExperienceHelper',
    VideoTexture = 'VideoTexture',
    VirtualJoysticksCamera = 'VirtualJoysticksCamera',
    VirtualKeyboard = 'VirtualKeyboard',
    VolumeBasedPanel = 'VolumeBasedPanel',
    WebVRFreeCamera = 'WebVRFreeCamera',
    WebXRCamera = 'WebXRCamera',
    _ScrollViewerWindow = '_ScrollViewerWindow';
var classesMap = {
  dynamicTerrain: DynamicTerrain,
  DynamicTerrain: DynamicTerrain,
  abstractScene: AbstractScene,
  AbstractScene: AbstractScene,
  node: Node$1,
  Node: Node$1,
  scene: Scene$2,
  Scene: Scene$2,
  camera: Camera$1,
  Camera: Camera$1,
  environmentHelper: EnvironmentHelper$1,
  EnvironmentHelper: EnvironmentHelper$1,
  effectLayer: EffectLayer$1,
  EffectLayer: EffectLayer$1,
  light: Light$1,
  Light: Light$1,
  material: Material$1,
  Material: Material$1,
  mesh: Mesh$2,
  Mesh: Mesh$2,
  meshBuilder: MeshBuilder$1,
  MeshBuilder: MeshBuilder$1,
  physicsImpostor: PhysicsImpostor$1,
  PhysicsImpostor: PhysicsImpostor$1,
  advancedDynamicTexture: AdvancedDynamicTexture$1,
  AdvancedDynamicTexture: AdvancedDynamicTexture$1,
  gui3DManager: GUI3DManager$1,
  GUI3DManager: GUI3DManager$1,
  autoRotationBehavior: AutoRotationBehavior$1,
  AutoRotationBehavior: AutoRotationBehavior$1,
  bouncingBehavior: BouncingBehavior$1,
  BouncingBehavior: BouncingBehavior$1,
  framingBehavior: FramingBehavior$1,
  FramingBehavior: FramingBehavior$1,
  attachToBoxBehavior: AttachToBoxBehavior$1,
  AttachToBoxBehavior: AttachToBoxBehavior$1,
  fadeInOutBehavior: FadeInOutBehavior$1,
  FadeInOutBehavior: FadeInOutBehavior$1,
  multiPointerScaleBehavior: MultiPointerScaleBehavior$1,
  MultiPointerScaleBehavior: MultiPointerScaleBehavior$1,
  pointerDragBehavior: PointerDragBehavior$1,
  PointerDragBehavior: PointerDragBehavior$1,
  sixDofDragBehavior: SixDofDragBehavior$1,
  SixDofDragBehavior: SixDofDragBehavior$1,
  vrExperienceHelper: VRExperienceHelper$1,
  VRExperienceHelper: VRExperienceHelper$1,
  shadowGenerator: ShadowGenerator$1,
  ShadowGenerator: ShadowGenerator$1,
  baseTexture: BaseTexture$1,
  BaseTexture: BaseTexture$1,
  control: Control$1,
  Control: Control$1,
  textBlock: TextBlock$1,
  TextBlock: TextBlock$1,
  control3D: Control3D$1,
  Control3D: Control3D$1,
  transformNode: TransformNode$1,
  TransformNode: TransformNode$1,
  abstractMesh: AbstractMesh$1,
  AbstractMesh: AbstractMesh$1,
  renderTargetTexture: RenderTargetTexture$1,
  RenderTargetTexture: RenderTargetTexture$1,
  targetCamera: TargetCamera$1,
  TargetCamera: TargetCamera$1,
  freeCamera: FreeCamera$1,
  FreeCamera: FreeCamera$1,
  touchCamera: TouchCamera$1,
  TouchCamera: TouchCamera$1,
  universalCamera: UniversalCamera$1,
  UniversalCamera: UniversalCamera$1,
  gamepadCamera: GamepadCamera$1,
  GamepadCamera: GamepadCamera$1,
  anaglyphGamepadCamera: AnaglyphGamepadCamera$1,
  AnaglyphGamepadCamera: AnaglyphGamepadCamera$1,
  stereoscopicGamepadCamera: StereoscopicGamepadCamera$1,
  StereoscopicGamepadCamera: StereoscopicGamepadCamera$1,
  anaglyphUniversalCamera: AnaglyphUniversalCamera$1,
  AnaglyphUniversalCamera: AnaglyphUniversalCamera$1,
  stereoscopicUniversalCamera: StereoscopicUniversalCamera$1,
  StereoscopicUniversalCamera: StereoscopicUniversalCamera$1,
  deviceOrientationCamera: DeviceOrientationCamera$1,
  DeviceOrientationCamera: DeviceOrientationCamera$1,
  vrDeviceOrientationFreeCamera: VRDeviceOrientationFreeCamera$1,
  VRDeviceOrientationFreeCamera: VRDeviceOrientationFreeCamera$1,
  vrDeviceOrientationGamepadCamera: VRDeviceOrientationGamepadCamera$1,
  VRDeviceOrientationGamepadCamera: VRDeviceOrientationGamepadCamera$1,
  anaglyphFreeCamera: AnaglyphFreeCamera$1,
  AnaglyphFreeCamera: AnaglyphFreeCamera$1,
  stereoscopicFreeCamera: StereoscopicFreeCamera$1,
  StereoscopicFreeCamera: StereoscopicFreeCamera$1,
  virtualJoysticksCamera: VirtualJoysticksCamera$1,
  VirtualJoysticksCamera: VirtualJoysticksCamera$1,
  webVrFreeCamera: WebVRFreeCamera$1,
  WebVRFreeCamera: WebVRFreeCamera$1,
  webXrCamera: WebXRCamera$1,
  WebXRCamera: WebXRCamera$1,
  arcRotateCamera: ArcRotateCamera$1,
  ArcRotateCamera: ArcRotateCamera$1,
  anaglyphArcRotateCamera: AnaglyphArcRotateCamera$1,
  AnaglyphArcRotateCamera: AnaglyphArcRotateCamera$1,
  stereoscopicArcRotateCamera: StereoscopicArcRotateCamera$1,
  StereoscopicArcRotateCamera: StereoscopicArcRotateCamera$1,
  vrDeviceOrientationArcRotateCamera: VRDeviceOrientationArcRotateCamera$1,
  VRDeviceOrientationArcRotateCamera: VRDeviceOrientationArcRotateCamera$1,
  flyCamera: FlyCamera$1,
  FlyCamera: FlyCamera$1,
  followCamera: FollowCamera$1,
  FollowCamera: FollowCamera$1,
  arcFollowCamera: ArcFollowCamera$1,
  ArcFollowCamera: ArcFollowCamera$1,
  shaderMaterial: ShaderMaterial$1,
  ShaderMaterial: ShaderMaterial$1,
  texture: Texture$1,
  Texture: Texture$1,
  multiMaterial: MultiMaterial$1,
  MultiMaterial: MultiMaterial$1,
  pushMaterial: PushMaterial$1,
  PushMaterial: PushMaterial$1,
  standardMaterial: StandardMaterial$1,
  StandardMaterial: StandardMaterial$1,
  backgroundMaterial: BackgroundMaterial$1,
  BackgroundMaterial: BackgroundMaterial$1,
  shadowLight: ShadowLight$1,
  ShadowLight: ShadowLight$1,
  pbrBaseMaterial: PBRBaseMaterial$1,
  PBRBaseMaterial: PBRBaseMaterial$1,
  pbrBaseSimpleMaterial: PBRBaseSimpleMaterial$1,
  PBRBaseSimpleMaterial: PBRBaseSimpleMaterial$1,
  pbrMetallicRoughnessMaterial: PBRMetallicRoughnessMaterial$1,
  PBRMetallicRoughnessMaterial: PBRMetallicRoughnessMaterial$1,
  pbrSpecularGlossinessMaterial: PBRSpecularGlossinessMaterial$1,
  PBRSpecularGlossinessMaterial: PBRSpecularGlossinessMaterial$1,
  pbrMaterial: PBRMaterial$1,
  PBRMaterial: PBRMaterial$1,
  nodeMaterial: NodeMaterial$1,
  NodeMaterial: NodeMaterial$1,
  fluentMaterial: FluentMaterial$1,
  FluentMaterial: FluentMaterial$1,
  directionalLight: DirectionalLight$1,
  DirectionalLight: DirectionalLight$1,
  pointLight: PointLight$1,
  PointLight: PointLight$1,
  spotLight: SpotLight$1,
  SpotLight: SpotLight$1,
  hemisphericLight: HemisphericLight$1,
  HemisphericLight: HemisphericLight$1,
  container: Container$1,
  Container: Container$1,
  rectangle: Rectangle$1,
  Rectangle: Rectangle$1,
  'babylon-button': Button$1,
  Button: Button$1,
  selectionPanel: SelectionPanel$1,
  SelectionPanel: SelectionPanel$1,
  scrollViewer: ScrollViewer$1,
  ScrollViewer: ScrollViewer$1,
  'babylon-image': Image$1,
  Image: Image$1,
  stackPanel: StackPanel$1,
  StackPanel: StackPanel$1,
  virtualKeyboard: VirtualKeyboard$1,
  VirtualKeyboard: VirtualKeyboard$1,
  'babylon-ellipse': Ellipse$1,
  Ellipse: Ellipse$1,
  grid: Grid$1,
  Grid: Grid$1,
  scrollViewerWindow: _ScrollViewerWindow$1,
  _ScrollViewerWindow: _ScrollViewerWindow$1,
  checkbox: Checkbox$1,
  Checkbox: Checkbox$1,
  colorPicker: ColorPicker$1,
  ColorPicker: ColorPicker$1,
  inputText: InputText$1,
  InputText: InputText$1,
  inputPassword: InputPassword$1,
  InputPassword: InputPassword$1,
  'babylon-line': Line$1,
  Line: Line$1,
  multiLine: MultiLine$1,
  MultiLine: MultiLine$1,
  radioButton: RadioButton$1,
  RadioButton: RadioButton$1,
  baseSlider: BaseSlider$1,
  BaseSlider: BaseSlider$1,
  scrollBar: ScrollBar$1,
  ScrollBar: ScrollBar$1,
  imageScrollBar: ImageScrollBar$1,
  ImageScrollBar: ImageScrollBar$1,
  slider: Slider$1,
  Slider: Slider$1,
  imageBasedSlider: ImageBasedSlider$1,
  ImageBasedSlider: ImageBasedSlider$1,
  displayGrid: DisplayGrid$1,
  DisplayGrid: DisplayGrid$1,
  container3D: Container3D$1,
  Container3D: Container3D$1,
  volumeBasedPanel: VolumeBasedPanel$1,
  VolumeBasedPanel: VolumeBasedPanel$1,
  cylinderPanel: CylinderPanel$1,
  CylinderPanel: CylinderPanel$1,
  planePanel: PlanePanel$1,
  PlanePanel: PlanePanel$1,
  scatterPanel: ScatterPanel$1,
  ScatterPanel: ScatterPanel$1,
  spherePanel: SpherePanel$1,
  SpherePanel: SpherePanel$1,
  stackPanel3D: StackPanel3D$1,
  StackPanel3D: StackPanel3D$1,
  abstractButton3D: AbstractButton3D$1,
  AbstractButton3D: AbstractButton3D$1,
  button3D: Button3D$1,
  Button3D: Button3D$1,
  holographicButton: HolographicButton$1,
  HolographicButton: HolographicButton$1,
  meshButton3D: MeshButton3D$1,
  MeshButton3D: MeshButton3D$1,
  glowLayer: GlowLayer$1,
  GlowLayer: GlowLayer$1,
  highlightLayer: HighlightLayer$1,
  HighlightLayer: HighlightLayer$1,
  cubeTexture: CubeTexture$1,
  CubeTexture: CubeTexture$1,
  rawCubeTexture: RawCubeTexture$1,
  RawCubeTexture: RawCubeTexture$1,
  rawTexture: RawTexture$1,
  RawTexture: RawTexture$1,
  proceduralTexture: ProceduralTexture$1,
  ProceduralTexture: ProceduralTexture$1,
  customProceduralTexture: CustomProceduralTexture$1,
  CustomProceduralTexture: CustomProceduralTexture$1,
  noiseProceduralTexture: NoiseProceduralTexture$1,
  NoiseProceduralTexture: NoiseProceduralTexture$1,
  mirrorTexture: MirrorTexture$1,
  MirrorTexture: MirrorTexture$1,
  multiRenderTarget: MultiRenderTarget$1,
  MultiRenderTarget: MultiRenderTarget$1,
  refractionTexture: RefractionTexture$1,
  RefractionTexture: RefractionTexture$1,
  multiviewRenderTarget: MultiviewRenderTarget$1,
  MultiviewRenderTarget: MultiviewRenderTarget$1,
  videoTexture: VideoTexture$1,
  VideoTexture: VideoTexture$1,
  dynamicTexture: DynamicTexture$1,
  DynamicTexture: DynamicTexture$1,
  rawTexture3D: RawTexture3D$1,
  RawTexture3D: RawTexture3D$1,
  rawTexture2DArray: RawTexture2DArray$1,
  RawTexture2DArray: RawTexture2DArray$1,
  colorGradingTexture: ColorGradingTexture$1,
  ColorGradingTexture: ColorGradingTexture$1,
  equiRectangularCubeTexture: EquiRectangularCubeTexture$1,
  EquiRectangularCubeTexture: EquiRectangularCubeTexture$1,
  hdrCubeTexture: HDRCubeTexture$1,
  HDRCubeTexture: HDRCubeTexture$1,
  htmlElementTexture: HtmlElementTexture$1,
  HtmlElementTexture: HtmlElementTexture$1
};
var intrinsicClassMap = {
  dynamicTerrain: 'DynamicTerrain',
  abstractScene: 'AbstractScene',
  node: 'Node',
  scene: 'Scene',
  camera: 'Camera',
  environmentHelper: 'EnvironmentHelper',
  effectLayer: 'EffectLayer',
  light: 'Light',
  material: 'Material',
  mesh: 'Mesh',
  meshBuilder: 'MeshBuilder',
  physicsImpostor: 'PhysicsImpostor',
  advancedDynamicTexture: 'AdvancedDynamicTexture',
  gui3DManager: 'GUI3DManager',
  autoRotationBehavior: 'AutoRotationBehavior',
  bouncingBehavior: 'BouncingBehavior',
  framingBehavior: 'FramingBehavior',
  attachToBoxBehavior: 'AttachToBoxBehavior',
  fadeInOutBehavior: 'FadeInOutBehavior',
  multiPointerScaleBehavior: 'MultiPointerScaleBehavior',
  pointerDragBehavior: 'PointerDragBehavior',
  sixDofDragBehavior: 'SixDofDragBehavior',
  vrExperienceHelper: 'VRExperienceHelper',
  shadowGenerator: 'ShadowGenerator',
  baseTexture: 'BaseTexture',
  control: 'Control',
  textBlock: 'TextBlock',
  control3D: 'Control3D',
  transformNode: 'TransformNode',
  abstractMesh: 'AbstractMesh',
  renderTargetTexture: 'RenderTargetTexture',
  targetCamera: 'TargetCamera',
  freeCamera: 'FreeCamera',
  touchCamera: 'TouchCamera',
  universalCamera: 'UniversalCamera',
  gamepadCamera: 'GamepadCamera',
  anaglyphGamepadCamera: 'AnaglyphGamepadCamera',
  stereoscopicGamepadCamera: 'StereoscopicGamepadCamera',
  anaglyphUniversalCamera: 'AnaglyphUniversalCamera',
  stereoscopicUniversalCamera: 'StereoscopicUniversalCamera',
  deviceOrientationCamera: 'DeviceOrientationCamera',
  vrDeviceOrientationFreeCamera: 'VRDeviceOrientationFreeCamera',
  vrDeviceOrientationGamepadCamera: 'VRDeviceOrientationGamepadCamera',
  anaglyphFreeCamera: 'AnaglyphFreeCamera',
  stereoscopicFreeCamera: 'StereoscopicFreeCamera',
  virtualJoysticksCamera: 'VirtualJoysticksCamera',
  webVrFreeCamera: 'WebVRFreeCamera',
  webXrCamera: 'WebXRCamera',
  arcRotateCamera: 'ArcRotateCamera',
  anaglyphArcRotateCamera: 'AnaglyphArcRotateCamera',
  stereoscopicArcRotateCamera: 'StereoscopicArcRotateCamera',
  vrDeviceOrientationArcRotateCamera: 'VRDeviceOrientationArcRotateCamera',
  flyCamera: 'FlyCamera',
  followCamera: 'FollowCamera',
  arcFollowCamera: 'ArcFollowCamera',
  shaderMaterial: 'ShaderMaterial',
  texture: 'Texture',
  multiMaterial: 'MultiMaterial',
  pushMaterial: 'PushMaterial',
  standardMaterial: 'StandardMaterial',
  backgroundMaterial: 'BackgroundMaterial',
  shadowLight: 'ShadowLight',
  pbrBaseMaterial: 'PBRBaseMaterial',
  pbrBaseSimpleMaterial: 'PBRBaseSimpleMaterial',
  pbrMetallicRoughnessMaterial: 'PBRMetallicRoughnessMaterial',
  pbrSpecularGlossinessMaterial: 'PBRSpecularGlossinessMaterial',
  pbrMaterial: 'PBRMaterial',
  nodeMaterial: 'NodeMaterial',
  fluentMaterial: 'FluentMaterial',
  directionalLight: 'DirectionalLight',
  pointLight: 'PointLight',
  spotLight: 'SpotLight',
  hemisphericLight: 'HemisphericLight',
  container: 'Container',
  rectangle: 'Rectangle',
  'babylon-button': 'Button',
  selectionPanel: 'SelectionPanel',
  scrollViewer: 'ScrollViewer',
  'babylon-image': 'Image',
  stackPanel: 'StackPanel',
  virtualKeyboard: 'VirtualKeyboard',
  'babylon-ellipse': 'Ellipse',
  grid: 'Grid',
  scrollViewerWindow: '_ScrollViewerWindow',
  checkbox: 'Checkbox',
  colorPicker: 'ColorPicker',
  inputText: 'InputText',
  inputPassword: 'InputPassword',
  'babylon-line': 'Line',
  multiLine: 'MultiLine',
  radioButton: 'RadioButton',
  baseSlider: 'BaseSlider',
  scrollBar: 'ScrollBar',
  imageScrollBar: 'ImageScrollBar',
  slider: 'Slider',
  imageBasedSlider: 'ImageBasedSlider',
  displayGrid: 'DisplayGrid',
  container3D: 'Container3D',
  volumeBasedPanel: 'VolumeBasedPanel',
  cylinderPanel: 'CylinderPanel',
  planePanel: 'PlanePanel',
  scatterPanel: 'ScatterPanel',
  spherePanel: 'SpherePanel',
  stackPanel3D: 'StackPanel3D',
  abstractButton3D: 'AbstractButton3D',
  button3D: 'Button3D',
  holographicButton: 'HolographicButton',
  meshButton3D: 'MeshButton3D',
  glowLayer: 'GlowLayer',
  highlightLayer: 'HighlightLayer',
  cubeTexture: 'CubeTexture',
  rawCubeTexture: 'RawCubeTexture',
  rawTexture: 'RawTexture',
  proceduralTexture: 'ProceduralTexture',
  customProceduralTexture: 'CustomProceduralTexture',
  noiseProceduralTexture: 'NoiseProceduralTexture',
  mirrorTexture: 'MirrorTexture',
  multiRenderTarget: 'MultiRenderTarget',
  refractionTexture: 'RefractionTexture',
  multiviewRenderTarget: 'MultiviewRenderTarget',
  videoTexture: 'VideoTexture',
  dynamicTexture: 'DynamicTexture',
  rawTexture3D: 'RawTexture3D',
  rawTexture2DArray: 'RawTexture2DArray',
  colorGradingTexture: 'ColorGradingTexture',
  equiRectangularCubeTexture: 'EquiRectangularCubeTexture',
  hdrCubeTexture: 'HDRCubeTexture',
  htmlElementTexture: 'HtmlElementTexture',
  adtForMesh: 'ADTForMesh',
  adtFullscreenUi: 'ADTFullscreenUI',
  box: 'Box',
  cylinder: 'Cylinder',
  dashedLines: 'DashedLines',
  decal: 'Decal',
  disc: 'Disc',
  extrudePolygon: 'ExtrudePolygon',
  extrudeShape: 'ExtrudeShape',
  extrudeShapeCustom: 'ExtrudeShapeCustom',
  ground: 'Ground',
  groundFromHeightMap: 'GroundFromHeightMap',
  icoSphere: 'IcoSphere',
  lathe: 'Lathe',
  lines: 'Lines',
  lineSystem: 'LineSystem',
  plane: 'Plane',
  'babylon-polygon': 'Polygon',
  polyhedron: 'Polyhedron',
  ribbon: 'Ribbon',
  sphere: 'Sphere',
  tiledBox: 'TiledBox',
  tiledGround: 'TiledGround',
  tiledPlane: 'TiledPlane',
  torus: 'Torus',
  torusKnot: 'TorusKnot',
  tube: 'Tube'
};

function babylonClassFactory(importAlias) {
  return classesMap[importAlias];
}

var GENERATED = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FiberNodePropsHandler: FiberNodePropsHandler,
  FiberNode: FiberNode,
  FiberTransformNodePropsHandler: FiberTransformNodePropsHandler,
  FiberTransformNode: FiberTransformNode,
  FiberAbstractMeshPropsHandler: FiberAbstractMeshPropsHandler,
  FiberAbstractMesh: FiberAbstractMesh,
  FiberMeshPropsHandler: FiberMeshPropsHandler,
  FiberMesh: FiberMesh,
  FiberCameraPropsHandler: FiberCameraPropsHandler,
  FiberCamera: FiberCamera,
  FiberTargetCameraPropsHandler: FiberTargetCameraPropsHandler,
  FiberTargetCamera: FiberTargetCamera,
  FiberFreeCameraPropsHandler: FiberFreeCameraPropsHandler,
  FiberFreeCamera: FiberFreeCamera,
  FiberTouchCameraPropsHandler: FiberTouchCameraPropsHandler,
  FiberTouchCamera: FiberTouchCamera,
  FiberUniversalCameraPropsHandler: FiberUniversalCameraPropsHandler,
  FiberUniversalCamera: FiberUniversalCamera,
  FiberGamepadCameraPropsHandler: FiberGamepadCameraPropsHandler,
  FiberGamepadCamera: FiberGamepadCamera,
  FiberAnaglyphGamepadCameraPropsHandler: FiberAnaglyphGamepadCameraPropsHandler,
  FiberAnaglyphGamepadCamera: FiberAnaglyphGamepadCamera,
  FiberStereoscopicGamepadCameraPropsHandler: FiberStereoscopicGamepadCameraPropsHandler,
  FiberStereoscopicGamepadCamera: FiberStereoscopicGamepadCamera,
  FiberAnaglyphUniversalCameraPropsHandler: FiberAnaglyphUniversalCameraPropsHandler,
  FiberAnaglyphUniversalCamera: FiberAnaglyphUniversalCamera,
  FiberStereoscopicUniversalCameraPropsHandler: FiberStereoscopicUniversalCameraPropsHandler,
  FiberStereoscopicUniversalCamera: FiberStereoscopicUniversalCamera,
  FiberDeviceOrientationCameraPropsHandler: FiberDeviceOrientationCameraPropsHandler,
  FiberDeviceOrientationCamera: FiberDeviceOrientationCamera,
  FiberVRDeviceOrientationFreeCameraPropsHandler: FiberVRDeviceOrientationFreeCameraPropsHandler,
  FiberVRDeviceOrientationFreeCamera: FiberVRDeviceOrientationFreeCamera,
  FiberVRDeviceOrientationGamepadCameraPropsHandler: FiberVRDeviceOrientationGamepadCameraPropsHandler,
  FiberVRDeviceOrientationGamepadCamera: FiberVRDeviceOrientationGamepadCamera,
  FiberAnaglyphFreeCameraPropsHandler: FiberAnaglyphFreeCameraPropsHandler,
  FiberAnaglyphFreeCamera: FiberAnaglyphFreeCamera,
  FiberStereoscopicFreeCameraPropsHandler: FiberStereoscopicFreeCameraPropsHandler,
  FiberStereoscopicFreeCamera: FiberStereoscopicFreeCamera,
  FiberVirtualJoysticksCameraPropsHandler: FiberVirtualJoysticksCameraPropsHandler,
  FiberVirtualJoysticksCamera: FiberVirtualJoysticksCamera,
  FiberWebVRFreeCameraPropsHandler: FiberWebVRFreeCameraPropsHandler,
  FiberWebVRFreeCamera: FiberWebVRFreeCamera,
  FiberWebXRCameraPropsHandler: FiberWebXRCameraPropsHandler,
  FiberWebXRCamera: FiberWebXRCamera,
  FiberArcRotateCameraPropsHandler: FiberArcRotateCameraPropsHandler,
  FiberArcRotateCamera: FiberArcRotateCamera,
  FiberAnaglyphArcRotateCameraPropsHandler: FiberAnaglyphArcRotateCameraPropsHandler,
  FiberAnaglyphArcRotateCamera: FiberAnaglyphArcRotateCamera,
  FiberStereoscopicArcRotateCameraPropsHandler: FiberStereoscopicArcRotateCameraPropsHandler,
  FiberStereoscopicArcRotateCamera: FiberStereoscopicArcRotateCamera,
  FiberVRDeviceOrientationArcRotateCameraPropsHandler: FiberVRDeviceOrientationArcRotateCameraPropsHandler,
  FiberVRDeviceOrientationArcRotateCamera: FiberVRDeviceOrientationArcRotateCamera,
  FiberFlyCameraPropsHandler: FiberFlyCameraPropsHandler,
  FiberFlyCamera: FiberFlyCamera,
  FiberFollowCameraPropsHandler: FiberFollowCameraPropsHandler,
  FiberFollowCamera: FiberFollowCamera,
  FiberArcFollowCameraPropsHandler: FiberArcFollowCameraPropsHandler,
  FiberArcFollowCamera: FiberArcFollowCamera,
  FiberBox: FiberBox,
  FiberTiledBox: FiberTiledBox,
  FiberSphere: FiberSphere,
  FiberDisc: FiberDisc,
  FiberIcoSphere: FiberIcoSphere,
  FiberRibbon: FiberRibbon,
  FiberCylinder: FiberCylinder,
  FiberTorus: FiberTorus,
  FiberTorusKnot: FiberTorusKnot,
  FiberLineSystem: FiberLineSystem,
  FiberLines: FiberLines,
  FiberDashedLines: FiberDashedLines,
  FiberExtrudeShape: FiberExtrudeShape,
  FiberExtrudeShapeCustom: FiberExtrudeShapeCustom,
  FiberLathe: FiberLathe,
  FiberTiledPlane: FiberTiledPlane,
  FiberPlane: FiberPlane,
  FiberGround: FiberGround,
  FiberTiledGround: FiberTiledGround,
  FiberGroundFromHeightMap: FiberGroundFromHeightMap,
  FiberPolygon: FiberPolygon,
  FiberExtrudePolygon: FiberExtrudePolygon,
  FiberTube: FiberTube,
  FiberPolyhedron: FiberPolyhedron,
  FiberDecal: FiberDecal,
  FiberMaterialPropsHandler: FiberMaterialPropsHandler,
  FiberMaterial: FiberMaterial,
  FiberShaderMaterialPropsHandler: FiberShaderMaterialPropsHandler,
  FiberShaderMaterial: FiberShaderMaterial,
  FiberMultiMaterialPropsHandler: FiberMultiMaterialPropsHandler,
  FiberMultiMaterial: FiberMultiMaterial,
  FiberPushMaterialPropsHandler: FiberPushMaterialPropsHandler,
  FiberPushMaterial: FiberPushMaterial,
  FiberStandardMaterialPropsHandler: FiberStandardMaterialPropsHandler,
  FiberStandardMaterial: FiberStandardMaterial,
  FiberBackgroundMaterialPropsHandler: FiberBackgroundMaterialPropsHandler,
  FiberBackgroundMaterial: FiberBackgroundMaterial,
  FiberPBRBaseMaterialPropsHandler: FiberPBRBaseMaterialPropsHandler,
  FiberPBRBaseMaterial: FiberPBRBaseMaterial,
  FiberPBRBaseSimpleMaterialPropsHandler: FiberPBRBaseSimpleMaterialPropsHandler,
  FiberPBRBaseSimpleMaterial: FiberPBRBaseSimpleMaterial,
  FiberPBRMetallicRoughnessMaterialPropsHandler: FiberPBRMetallicRoughnessMaterialPropsHandler,
  FiberPBRMetallicRoughnessMaterial: FiberPBRMetallicRoughnessMaterial,
  FiberPBRSpecularGlossinessMaterialPropsHandler: FiberPBRSpecularGlossinessMaterialPropsHandler,
  FiberPBRSpecularGlossinessMaterial: FiberPBRSpecularGlossinessMaterial,
  FiberPBRMaterialPropsHandler: FiberPBRMaterialPropsHandler,
  FiberPBRMaterial: FiberPBRMaterial,
  FiberNodeMaterialPropsHandler: FiberNodeMaterialPropsHandler,
  FiberNodeMaterial: FiberNodeMaterial,
  FiberFluentMaterialPropsHandler: FiberFluentMaterialPropsHandler,
  FiberFluentMaterial: FiberFluentMaterial,
  FiberLightPropsHandler: FiberLightPropsHandler,
  FiberLight: FiberLight,
  FiberShadowLightPropsHandler: FiberShadowLightPropsHandler,
  FiberShadowLight: FiberShadowLight,
  FiberDirectionalLightPropsHandler: FiberDirectionalLightPropsHandler,
  FiberDirectionalLight: FiberDirectionalLight,
  FiberPointLightPropsHandler: FiberPointLightPropsHandler,
  FiberPointLight: FiberPointLight,
  FiberSpotLightPropsHandler: FiberSpotLightPropsHandler,
  FiberSpotLight: FiberSpotLight,
  FiberHemisphericLightPropsHandler: FiberHemisphericLightPropsHandler,
  FiberHemisphericLight: FiberHemisphericLight,
  FiberControlPropsHandler: FiberControlPropsHandler,
  FiberControl: FiberControl,
  FiberContainerPropsHandler: FiberContainerPropsHandler,
  FiberContainer: FiberContainer,
  FiberRectanglePropsHandler: FiberRectanglePropsHandler,
  FiberRectangle: FiberRectangle,
  FiberButtonPropsHandler: FiberButtonPropsHandler,
  FiberButton: FiberButton,
  FiberSelectionPanelPropsHandler: FiberSelectionPanelPropsHandler,
  FiberSelectionPanel: FiberSelectionPanel,
  FiberScrollViewerPropsHandler: FiberScrollViewerPropsHandler,
  FiberScrollViewer: FiberScrollViewer,
  FiberStackPanelPropsHandler: FiberStackPanelPropsHandler,
  FiberStackPanel: FiberStackPanel,
  FiberVirtualKeyboardPropsHandler: FiberVirtualKeyboardPropsHandler,
  FiberVirtualKeyboard: FiberVirtualKeyboard,
  FiberEllipsePropsHandler: FiberEllipsePropsHandler,
  FiberEllipse: FiberEllipse,
  FiberGridPropsHandler: FiberGridPropsHandler,
  FiberGrid: FiberGrid,
  Fiber_ScrollViewerWindowPropsHandler: Fiber_ScrollViewerWindowPropsHandler,
  Fiber_ScrollViewerWindow: Fiber_ScrollViewerWindow,
  FiberTextBlockPropsHandler: FiberTextBlockPropsHandler,
  FiberTextBlock: FiberTextBlock,
  FiberImagePropsHandler: FiberImagePropsHandler,
  FiberImage: FiberImage,
  FiberCheckboxPropsHandler: FiberCheckboxPropsHandler,
  FiberCheckbox: FiberCheckbox,
  FiberColorPickerPropsHandler: FiberColorPickerPropsHandler,
  FiberColorPicker: FiberColorPicker,
  FiberInputTextPropsHandler: FiberInputTextPropsHandler,
  FiberInputText: FiberInputText,
  FiberInputPasswordPropsHandler: FiberInputPasswordPropsHandler,
  FiberInputPassword: FiberInputPassword,
  FiberLinePropsHandler: FiberLinePropsHandler,
  FiberLine: FiberLine,
  FiberMultiLinePropsHandler: FiberMultiLinePropsHandler,
  FiberMultiLine: FiberMultiLine,
  FiberRadioButtonPropsHandler: FiberRadioButtonPropsHandler,
  FiberRadioButton: FiberRadioButton,
  FiberBaseSliderPropsHandler: FiberBaseSliderPropsHandler,
  FiberBaseSlider: FiberBaseSlider,
  FiberScrollBarPropsHandler: FiberScrollBarPropsHandler,
  FiberScrollBar: FiberScrollBar,
  FiberImageScrollBarPropsHandler: FiberImageScrollBarPropsHandler,
  FiberImageScrollBar: FiberImageScrollBar,
  FiberSliderPropsHandler: FiberSliderPropsHandler,
  FiberSlider: FiberSlider,
  FiberImageBasedSliderPropsHandler: FiberImageBasedSliderPropsHandler,
  FiberImageBasedSlider: FiberImageBasedSlider,
  FiberDisplayGridPropsHandler: FiberDisplayGridPropsHandler,
  FiberDisplayGrid: FiberDisplayGrid,
  FiberControl3DPropsHandler: FiberControl3DPropsHandler,
  FiberControl3D: FiberControl3D,
  FiberContainer3DPropsHandler: FiberContainer3DPropsHandler,
  FiberContainer3D: FiberContainer3D,
  FiberVolumeBasedPanelPropsHandler: FiberVolumeBasedPanelPropsHandler,
  FiberVolumeBasedPanel: FiberVolumeBasedPanel,
  FiberCylinderPanelPropsHandler: FiberCylinderPanelPropsHandler,
  FiberCylinderPanel: FiberCylinderPanel,
  FiberPlanePanelPropsHandler: FiberPlanePanelPropsHandler,
  FiberPlanePanel: FiberPlanePanel,
  FiberScatterPanelPropsHandler: FiberScatterPanelPropsHandler,
  FiberScatterPanel: FiberScatterPanel,
  FiberSpherePanelPropsHandler: FiberSpherePanelPropsHandler,
  FiberSpherePanel: FiberSpherePanel,
  FiberStackPanel3DPropsHandler: FiberStackPanel3DPropsHandler,
  FiberStackPanel3D: FiberStackPanel3D,
  FiberAbstractButton3DPropsHandler: FiberAbstractButton3DPropsHandler,
  FiberAbstractButton3D: FiberAbstractButton3D,
  FiberButton3DPropsHandler: FiberButton3DPropsHandler,
  FiberButton3D: FiberButton3D,
  FiberHolographicButtonPropsHandler: FiberHolographicButtonPropsHandler,
  FiberHolographicButton: FiberHolographicButton,
  FiberMeshButton3DPropsHandler: FiberMeshButton3DPropsHandler,
  FiberMeshButton3D: FiberMeshButton3D,
  FiberEffectLayerPropsHandler: FiberEffectLayerPropsHandler,
  FiberEffectLayer: FiberEffectLayer,
  FiberGlowLayerPropsHandler: FiberGlowLayerPropsHandler,
  FiberGlowLayer: FiberGlowLayer,
  FiberHighlightLayerPropsHandler: FiberHighlightLayerPropsHandler,
  FiberHighlightLayer: FiberHighlightLayer,
  FiberBaseTexturePropsHandler: FiberBaseTexturePropsHandler,
  FiberBaseTexture: FiberBaseTexture,
  FiberCubeTexturePropsHandler: FiberCubeTexturePropsHandler,
  FiberCubeTexture: FiberCubeTexture,
  FiberRawCubeTexturePropsHandler: FiberRawCubeTexturePropsHandler,
  FiberRawCubeTexture: FiberRawCubeTexture,
  FiberTexturePropsHandler: FiberTexturePropsHandler,
  FiberTexture: FiberTexture,
  FiberRawTexturePropsHandler: FiberRawTexturePropsHandler,
  FiberRawTexture: FiberRawTexture,
  FiberProceduralTexturePropsHandler: FiberProceduralTexturePropsHandler,
  FiberProceduralTexture: FiberProceduralTexture,
  FiberCustomProceduralTexturePropsHandler: FiberCustomProceduralTexturePropsHandler,
  FiberCustomProceduralTexture: FiberCustomProceduralTexture,
  FiberNoiseProceduralTexturePropsHandler: FiberNoiseProceduralTexturePropsHandler,
  FiberNoiseProceduralTexture: FiberNoiseProceduralTexture,
  FiberRenderTargetTexturePropsHandler: FiberRenderTargetTexturePropsHandler,
  FiberRenderTargetTexture: FiberRenderTargetTexture,
  FiberMirrorTexturePropsHandler: FiberMirrorTexturePropsHandler,
  FiberMirrorTexture: FiberMirrorTexture,
  FiberMultiRenderTargetPropsHandler: FiberMultiRenderTargetPropsHandler,
  FiberMultiRenderTarget: FiberMultiRenderTarget,
  FiberRefractionTexturePropsHandler: FiberRefractionTexturePropsHandler,
  FiberRefractionTexture: FiberRefractionTexture,
  FiberMultiviewRenderTargetPropsHandler: FiberMultiviewRenderTargetPropsHandler,
  FiberMultiviewRenderTarget: FiberMultiviewRenderTarget,
  FiberVideoTexturePropsHandler: FiberVideoTexturePropsHandler,
  FiberVideoTexture: FiberVideoTexture,
  FiberDynamicTexturePropsHandler: FiberDynamicTexturePropsHandler,
  FiberDynamicTexture: FiberDynamicTexture,
  FiberAdvancedDynamicTexturePropsHandler: FiberAdvancedDynamicTexturePropsHandler,
  FiberAdvancedDynamicTexture: FiberAdvancedDynamicTexture,
  FiberADTForMesh: FiberADTForMesh,
  FiberADTFullscreenUI: FiberADTFullscreenUI,
  FiberRawTexture3DPropsHandler: FiberRawTexture3DPropsHandler,
  FiberRawTexture3D: FiberRawTexture3D,
  FiberRawTexture2DArrayPropsHandler: FiberRawTexture2DArrayPropsHandler,
  FiberRawTexture2DArray: FiberRawTexture2DArray,
  FiberColorGradingTexturePropsHandler: FiberColorGradingTexturePropsHandler,
  FiberColorGradingTexture: FiberColorGradingTexture,
  FiberEquiRectangularCubeTexturePropsHandler: FiberEquiRectangularCubeTexturePropsHandler,
  FiberEquiRectangularCubeTexture: FiberEquiRectangularCubeTexture,
  FiberHDRCubeTexturePropsHandler: FiberHDRCubeTexturePropsHandler,
  FiberHDRCubeTexture: FiberHDRCubeTexture,
  FiberHtmlElementTexturePropsHandler: FiberHtmlElementTexturePropsHandler,
  FiberHtmlElementTexture: FiberHtmlElementTexture,
  FiberGUI3DManagerPropsHandler: FiberGUI3DManagerPropsHandler,
  FiberGUI3DManager: FiberGUI3DManager,
  FiberShadowGeneratorPropsHandler: FiberShadowGeneratorPropsHandler,
  FiberShadowGenerator: FiberShadowGenerator,
  FiberEnvironmentHelperPropsHandler: FiberEnvironmentHelperPropsHandler,
  FiberEnvironmentHelper: FiberEnvironmentHelper,
  FiberPhysicsImpostorPropsHandler: FiberPhysicsImpostorPropsHandler,
  FiberPhysicsImpostor: FiberPhysicsImpostor,
  FiberVRExperienceHelperPropsHandler: FiberVRExperienceHelperPropsHandler,
  FiberVRExperienceHelper: FiberVRExperienceHelper,
  FiberDynamicTerrainPropsHandler: FiberDynamicTerrainPropsHandler,
  FiberDynamicTerrain: FiberDynamicTerrain,
  FiberAutoRotationBehaviorPropsHandler: FiberAutoRotationBehaviorPropsHandler,
  FiberAutoRotationBehavior: FiberAutoRotationBehavior,
  FiberBouncingBehaviorPropsHandler: FiberBouncingBehaviorPropsHandler,
  FiberBouncingBehavior: FiberBouncingBehavior,
  FiberFramingBehaviorPropsHandler: FiberFramingBehaviorPropsHandler,
  FiberFramingBehavior: FiberFramingBehavior,
  FiberAttachToBoxBehaviorPropsHandler: FiberAttachToBoxBehaviorPropsHandler,
  FiberAttachToBoxBehavior: FiberAttachToBoxBehavior,
  FiberFadeInOutBehaviorPropsHandler: FiberFadeInOutBehaviorPropsHandler,
  FiberFadeInOutBehavior: FiberFadeInOutBehavior,
  FiberMultiPointerScaleBehaviorPropsHandler: FiberMultiPointerScaleBehaviorPropsHandler,
  FiberMultiPointerScaleBehavior: FiberMultiPointerScaleBehavior,
  FiberPointerDragBehaviorPropsHandler: FiberPointerDragBehaviorPropsHandler,
  FiberPointerDragBehavior: FiberPointerDragBehavior,
  FiberSixDofDragBehaviorPropsHandler: FiberSixDofDragBehaviorPropsHandler,
  FiberSixDofDragBehavior: FiberSixDofDragBehavior,
  FiberScenePropsHandler: FiberScenePropsHandler,
  ADTForMesh: ADTForMesh,
  ADTFullscreenUI: ADTFullscreenUI,
  AbstractButton3D: AbstractButton3D,
  AbstractMesh: AbstractMesh,
  AdvancedDynamicTexture: AdvancedDynamicTexture,
  AnaglyphArcRotateCamera: AnaglyphArcRotateCamera,
  AnaglyphFreeCamera: AnaglyphFreeCamera,
  AnaglyphGamepadCamera: AnaglyphGamepadCamera,
  AnaglyphUniversalCamera: AnaglyphUniversalCamera,
  ArcFollowCamera: ArcFollowCamera,
  ArcRotateCamera: ArcRotateCamera,
  AttachToBoxBehavior: AttachToBoxBehavior,
  AutoRotationBehavior: AutoRotationBehavior,
  BackgroundMaterial: BackgroundMaterial,
  BaseSlider: BaseSlider,
  BaseTexture: BaseTexture,
  BouncingBehavior: BouncingBehavior,
  Box: Box,
  Button: Button,
  Button3D: Button3D,
  Camera: Camera,
  Checkbox: Checkbox,
  ColorGradingTexture: ColorGradingTexture,
  ColorPicker: ColorPicker,
  Container: Container,
  Container3D: Container3D,
  Control: Control,
  Control3D: Control3D,
  CubeTexture: CubeTexture,
  CustomProceduralTexture: CustomProceduralTexture,
  Cylinder: Cylinder,
  CylinderPanel: CylinderPanel,
  DashedLines: DashedLines,
  Decal: Decal,
  DeviceOrientationCamera: DeviceOrientationCamera,
  DirectionalLight: DirectionalLight,
  Disc: Disc,
  DisplayGrid: DisplayGrid,
  DynamicTerrain: DynamicTerrain$1,
  DynamicTexture: DynamicTexture,
  EffectLayer: EffectLayer,
  Ellipse: Ellipse,
  EnvironmentHelper: EnvironmentHelper,
  EquiRectangularCubeTexture: EquiRectangularCubeTexture,
  ExtrudePolygon: ExtrudePolygon,
  ExtrudeShape: ExtrudeShape,
  ExtrudeShapeCustom: ExtrudeShapeCustom,
  FadeInOutBehavior: FadeInOutBehavior,
  FluentMaterial: FluentMaterial,
  FlyCamera: FlyCamera,
  FollowCamera: FollowCamera,
  FramingBehavior: FramingBehavior,
  FreeCamera: FreeCamera,
  GUI3DManager: GUI3DManager,
  GamepadCamera: GamepadCamera,
  GlowLayer: GlowLayer,
  Grid: Grid,
  Ground: Ground,
  GroundFromHeightMap: GroundFromHeightMap,
  HDRCubeTexture: HDRCubeTexture,
  HemisphericLight: HemisphericLight,
  HighlightLayer: HighlightLayer,
  HolographicButton: HolographicButton,
  HtmlElementTexture: HtmlElementTexture,
  IcoSphere: IcoSphere,
  Image: Image,
  ImageBasedSlider: ImageBasedSlider,
  ImageScrollBar: ImageScrollBar,
  InputPassword: InputPassword,
  InputText: InputText,
  Lathe: Lathe,
  Light: Light,
  Line: Line,
  LineSystem: LineSystem,
  Lines: Lines,
  Material: Material,
  Mesh: Mesh,
  MeshButton3D: MeshButton3D,
  MirrorTexture: MirrorTexture,
  Model: Model,
  MultiLine: MultiLine,
  MultiMaterial: MultiMaterial,
  MultiPointerScaleBehavior: MultiPointerScaleBehavior,
  MultiRenderTarget: MultiRenderTarget,
  MultiviewRenderTarget: MultiviewRenderTarget,
  Node: Node,
  NodeMaterial: NodeMaterial,
  NoiseProceduralTexture: NoiseProceduralTexture,
  PBRBaseMaterial: PBRBaseMaterial,
  PBRBaseSimpleMaterial: PBRBaseSimpleMaterial,
  PBRMaterial: PBRMaterial,
  PBRMetallicRoughnessMaterial: PBRMetallicRoughnessMaterial,
  PBRSpecularGlossinessMaterial: PBRSpecularGlossinessMaterial,
  PhysicsImpostor: PhysicsImpostor,
  Plane: Plane,
  PlanePanel: PlanePanel,
  PointLight: PointLight,
  PointerDragBehavior: PointerDragBehavior,
  Polygon: Polygon,
  Polyhedron: Polyhedron,
  ProceduralTexture: ProceduralTexture,
  PushMaterial: PushMaterial,
  RadioButton: RadioButton,
  RawCubeTexture: RawCubeTexture,
  RawTexture: RawTexture,
  RawTexture2DArray: RawTexture2DArray,
  RawTexture3D: RawTexture3D,
  Rectangle: Rectangle,
  RefractionTexture: RefractionTexture,
  RenderTargetTexture: RenderTargetTexture,
  Ribbon: Ribbon,
  ScatterPanel: ScatterPanel,
  ScrollBar: ScrollBar,
  ScrollViewer: ScrollViewer,
  SelectionPanel: SelectionPanel,
  ShaderMaterial: ShaderMaterial,
  ShadowGenerator: ShadowGenerator,
  ShadowLight: ShadowLight,
  SixDofDragBehavior: SixDofDragBehavior,
  Slider: Slider,
  Sphere: Sphere,
  SpherePanel: SpherePanel,
  SpotLight: SpotLight,
  StackPanel: StackPanel,
  StackPanel3D: StackPanel3D,
  StandardMaterial: StandardMaterial,
  StereoscopicArcRotateCamera: StereoscopicArcRotateCamera,
  StereoscopicFreeCamera: StereoscopicFreeCamera,
  StereoscopicGamepadCamera: StereoscopicGamepadCamera,
  StereoscopicUniversalCamera: StereoscopicUniversalCamera,
  TargetCamera: TargetCamera,
  TextBlock: TextBlock,
  Texture: Texture,
  TiledBox: TiledBox,
  TiledGround: TiledGround,
  TiledPlane: TiledPlane,
  Torus: Torus,
  TorusKnot: TorusKnot,
  TouchCamera: TouchCamera,
  TransformNode: TransformNode,
  Tube: Tube,
  UniversalCamera: UniversalCamera,
  VRDeviceOrientationArcRotateCamera: VRDeviceOrientationArcRotateCamera,
  VRDeviceOrientationFreeCamera: VRDeviceOrientationFreeCamera,
  VRDeviceOrientationGamepadCamera: VRDeviceOrientationGamepadCamera,
  VRExperienceHelper: VRExperienceHelper,
  VideoTexture: VideoTexture,
  VirtualJoysticksCamera: VirtualJoysticksCamera,
  VirtualKeyboard: VirtualKeyboard,
  VolumeBasedPanel: VolumeBasedPanel,
  WebVRFreeCamera: WebVRFreeCamera,
  WebXRCamera: WebXRCamera,
  _ScrollViewerWindow: _ScrollViewerWindow,
  intrinsicClassMap: intrinsicClassMap,
  babylonClassFactory: babylonClassFactory
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
} // TODO: build a fallback mechanism when typeof React.createContext !== 'function'
// this will allow (16.0 <= react versions < 16.3) to work.


var BabylonJSContext = createContext({
  engine: null,
  canvas: null
});

function withBabylonJS(Component) {
  return function BoundComponent(props) {
    return React.createElement(BabylonJSContext.Consumer, null, function (ctx) {
      return React.createElement(Component, _assign({}, props, {
        babylonJSContext: ctx
      }));
    });
  };
}

var useBabylonEngine = function useBabylonEngine() {
  return useContext(BabylonJSContext).engine;
};

var useBabylonCanvas = function useBabylonCanvas() {
  return useContext(BabylonJSContext).canvas;
};

var Engine =
/** @class */
function (_super) {
  __extends(Engine, _super);

  function Engine(props) {
    var _this = _super.call(this, props) || this;

    _this._engine = null;
    _this._canvas = null;

    _this.onCanvasRef = function (c) {
      // We are not using the react.createPortal(...), as it adds a ReactDOM dependency, but also
      // it was not flowing the context through to HOCs properly.
      if (_this.props.portalCanvas) {
        _this._canvas = document.getElementById('portal-canvas');
        console.error('set canvas', _this._canvas);
      } else {
        if (c) {
          // null when called from unmountComponent()
          // c.addEventListener('mouseover', this.focus)
          // c.addEventListener('mouseout', this.blur)
          _this._canvas = c;
        }
      } // console.error('onCanvas:', c); // trying to diagnose why HMR keep rebuilding entire Scene!  Look at ProxyComponent v4.

    };

    _this.onResizeWindow = function () {
      if (_this._engine) {
        _this._engine.resize();
      }
    };

    _this.state = {
      canRender: false
    };
    return _this;
  }

  Engine.prototype.componentDidMount = function () {
    var _this = this;

    this._engine = new Engine$1(this._canvas, this.props.antialias === true ? true : false, // default false
    this.props.engineOptions, this.props.adaptToDeviceRatio === true ? true : false // default false
    );

    this._engine.runRenderLoop(function () {
      _this._engine.scenes.forEach(function (scene) {
        scene.render();
      });
    });

    this._engine.onContextLostObservable.add(function (eventData) {
      console.log('context loss observable from Engine: ', eventData);
    });

    window.addEventListener('resize', this.onResizeWindow);
    this.setState({
      canRender: true
    });
  };

  Engine.prototype.componentWillUnmount = function () {
    window.removeEventListener('resize', this.onResizeWindow);
  };

  Engine.prototype.render = function () {
    if (this.state.canRender === false && this.props.noSSR !== undefined && this.props.noSSR !== false) {
      if (typeof this.props.noSSR === 'boolean') {
        return null;
      }

      return this.props.noSSR;
    }

    var _a = this.props,
        touchActionNone = _a.touchActionNone,
        width = _a.width,
        height = _a.height,
        canvasStyle = _a.canvasStyle,
        canvasId = _a.canvasId,
        rest = __rest(_a, ["touchActionNone", "width", "height", "canvasStyle", "canvasId"]);

    var opts = {};

    if (touchActionNone !== false) {
      opts['touch-action'] = 'none';
    }

    if (width !== undefined && height !== undefined) {
      opts.width = width;
      opts.height = height;
    }

    if (canvasId) {
      opts.id = canvasId;
    }

    if (canvasStyle) {
      opts.style = canvasStyle;
    } // TODO: this.props.portalCanvas does not need to render a canvas.


    return React.createElement(BabylonJSContext.Provider, {
      value: {
        engine: this._engine,
        canvas: this._canvas
      }
    }, React.createElement("canvas", _assign({}, opts, {
      ref: this.onCanvasRef
    }), this._engine !== null && this.props.children));
  };

  return Engine;
}(React.Component);

var applyUpdateToInstance = function applyUpdateToInstance(hostInstance, update, type) {
  var target = update.target !== undefined ? hostInstance[update.target] : hostInstance;

  switch (update.changeType) {
    case PropChangeType.Primitive:
    case PropChangeType.FresnelParameters:
    case PropChangeType.LambdaExpression:
    case PropChangeType.Texture:
      // console.log(` > ${type}: updating ${update.type} on ${update.propertyName} to ${update.value}`)
      target[update.propertyName] = update.value;
      break;

    case PropChangeType.Vector3:
      if (target[update.propertyName]) {
        target[update.propertyName].copyFrom(update.value);
      } else if (update.value) {
        target[update.propertyName] = update.value.clone();
      } else {
        target[update.propertyName] = update.value; // ie: undefined/null?
      }

      break;

    case PropChangeType.Color3:
    case PropChangeType.Color4:
      if (target[update.propertyName]) {
        switch (update.changeType) {
          case PropChangeType.Color3:
            target[update.propertyName].copyFrom(update.value);
            break;

          case PropChangeType.Color4:
            target[update.propertyName].copyFrom(update.value);
            break;
        }
      } else if (update.value) {
        target[update.propertyName] = update.value.clone();
      } else {
        target[update.propertyName] = update.value;
      }

      break;

    case PropChangeType.Control:
      target[update.propertyName] = update.value;
      break;

    case PropChangeType.NumericArray:
      target[update.propertyName] = update.value;
      break;

    case PropChangeType.Observable:
      target[update.propertyName].add(update.value);
      break;

    case PropChangeType.Method:
      if (typeof target[update.propertyName] === "function") {
        if (Array.isArray(update.value)) {
          target[update.propertyName].apply(target, update.value);
        } else if (Object(update.value) !== update.value) {
          // primitive, undefined & null.  Comparison is 7x slower than instanceof check,
          // TODO: should be: update.value === undefined || typeof(update.value) === 'number' || ...
          target[update.propertyName](update.value);
        } else {
          // TODO: there is a bug here in that setTarget={new Vector3(0, 1, 0)} will throw an exception...
          console.error('need to make sure this isn\'t something like a Vector3 before destructuring');
          target[update.propertyName].apply(target, Object.values(update.value));
        }
      } else {
        console.error("Cannot call [not a function] " + update.propertyName + "(...) on:", update.type, target);
      }

      break;

    default:
      console.error("Unhandled property update of type " + update.changeType + " -> " + update.type);
      break;
  }
};
/**
 * Only applied in this way immediately after instantiation (not on deltas)
 *
 * @param instance
 * @param props
 * @param scene
 */


var applyInitialPropsToInstance = function applyInitialPropsToInstance(instance, props, scene) {
  if (!instance.propsHandlers) {
    return;
  }

  var initPayload = [];
  instance.propsHandlers.getPropsHandlers().forEach(function (propHandler) {
    // NOTE: this can actually be WRONG, because here we want to compare the props with the object.
    // This is only needed right after object instantiation.
    var handlerUpdates = propHandler.getPropertyUpdates({}, // Here we will reapply things like 'name', so we could get default props from 'babylonObject'.
    props);

    if (handlerUpdates !== null) {
      initPayload.push.apply(initPayload, handlerUpdates);
    }
  });

  if (initPayload.length > 0) {
    initPayload.forEach(function (update) {
      applyUpdateToInstance(instance.hostInstance, update, instance.metadata.className);
    });
  }
};

var BABYLONEXT = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DynamicTerrain: DynamicTerrain
});
/**
 * This is a host component.  Much like a span or div for ReactDOM.render();
 */

var HostWithEventsFiber =
/** @class */
function () {
  function HostWithEventsFiber(scene, engine, props) {
    this._scene = scene;
    this._engine = engine;

    if (props.onParented && typeof props.onParented === "function") {
      this._onParented = props.onParented;
    }

    if (props.onChildAdded && typeof props.onChildAdded === "function") {
      this._onChildAdded = props.onChildAdded;
    }

    if (props.onMount && typeof props.onMount === "function") {
      this._onMount = props.onMount;
    }

    if (props.onUnmount && typeof props.onUnmount === "function") {
      this._onUnmount = props.onUnmount;
    }
  }

  HostWithEventsFiber.prototype.onParented = function (parent) {
    if (parent !== undefined && this._onParented !== undefined) {
      this._hostContextData = this._onParented(this._scene, this._engine, parent);
    }
  };

  HostWithEventsFiber.prototype.onChildAdded = function (child) {
    if (this._onChildAdded) {
      this._hostContextData = this._onChildAdded(this._scene, this._engine, child, this._hostContextData);
    }
  };

  HostWithEventsFiber.prototype.onMount = function (instance) {
    if (this._onMount) {
      this._hostContextData = this._onMount(this._scene, this._engine, instance, this._hostContextData);
    }
  };

  HostWithEventsFiber.prototype.dispose = function () {
    if (this._onUnmount) {
      this._onUnmount(this._scene, this._engine, this._hostContextData);
    }
  };

  HostWithEventsFiber.prototype.onUnmount = function () {};

  return HostWithEventsFiber;
}(); // These are only used by the reconciler.  We export them as strings (as we do for all generated code as well)


var HostWithEvents = "HostWithEvents";
var CUSTOM_HOSTS = /*#__PURE__*/Object.freeze({
  __proto__: null,
  HostWithEvents: HostWithEvents,
  HostWithEventsFiber: HostWithEventsFiber
});

var AdvancedDynamicTextureLifecycleListener =
/** @class */
function () {
  function AdvancedDynamicTextureLifecycleListener(scene, props) {
    this.scene = scene;
    this.props = props;
  }

  AdvancedDynamicTextureLifecycleListener.prototype.onParented = function (parent, child) {};

  AdvancedDynamicTextureLifecycleListener.prototype.onChildAdded = function (child, parent) {};

  AdvancedDynamicTextureLifecycleListener.prototype.onMount = function (instance) {
    this.addControls(instance);

    if (instance.customProps.createForParentMesh) {
      // console.log('for parent mesh', instance.parent ? instance.parent.babylonJsObject : 'error: no parent object')
      var mesh = instance.parent.hostInstance; // should crawl parent hierarchy for a mesh
      // console.error('we will be attaching the mesh:', mesh.name, mesh);

      var material = new StandardMaterial$2("AdvancedDynamicTextureMaterial", mesh.getScene());
      material.backFaceCulling = false;
      material.diffuseColor = Color3$1.Black();
      material.specularColor = Color3$1.Black();

      if (instance.hostInstance === undefined) {
        console.error('missing instance');
      } else {
        if (this.props.hasAlpha) {
          material.diffuseTexture = instance.hostInstance;
          material.emissiveTexture = instance.hostInstance;
          instance.hostInstance.hasAlpha = true;
        } else {
          material.emissiveTexture = instance.hostInstance;
          material.opacityTexture = instance.hostInstance;
        }
      }

      mesh.material = material; // set to true unless explicitly not wanted.
      // connects the texture to a hosting mesh to enable interactions

      var supportPointerMove = this.props.supportPointerMove !== false ? true : false;
      instance.hostInstance.attachToMesh(mesh, supportPointerMove);
    }
  };

  AdvancedDynamicTextureLifecycleListener.prototype.addControls = function (instance) {
    var _this = this; // When there is a panel, it must be added before the children. Otherwise there is no UtilityLayer to attach to.
    // This project before 'react-reconciler' was added from parent up the tree.  'react-reconciler' wants to do the opposite.


    instance.children.forEach(function (child) {
      if (child.metadata.isGUI2DControl === true) {
        instance.hostInstance.addControl(child.hostInstance);
        child.state = {
          added: true
        };
      }
    });

    if (instance.customProps.connectControlNames !== undefined && Array.isArray(instance.customProps.connectControlNames)) {
      var controlNames = instance.customProps.connectControlNames;
      var root = instance;

      while (root.parent !== null) {
        root = root.parent;
      }

      this.connect(instance, root, controlNames);
    }

    instance.children.forEach(function (child) {
      _this.addControls(child);
    });
  };

  AdvancedDynamicTextureLifecycleListener.prototype.connect = function (keyboard, searchInstance, controlNames) {
    var _this = this;

    if (searchInstance.metadata.isGUI2DControl && searchInstance.hostInstance && controlNames.indexOf(searchInstance.hostInstance.name) !== -1) {
      // console.log(keyboard.hostInstance, '.connect(->', searchInstance.hostInstance)
      keyboard.hostInstance.connect(searchInstance.hostInstance);
    }

    searchInstance.children.forEach(function (child) {
      return _this.connect(keyboard, child, controlNames);
    });
  };

  AdvancedDynamicTextureLifecycleListener.prototype.onUnmount = function () {};

  return AdvancedDynamicTextureLifecycleListener;
}();

var ADTFullscreenUILifecycleListener =
/** @class */
function (_super) {
  __extends(ADTFullscreenUILifecycleListener, _super);

  function ADTFullscreenUILifecycleListener(scene, props) {
    return _super.call(this, scene, props) || this;
  }

  return ADTFullscreenUILifecycleListener;
}(AdvancedDynamicTextureLifecycleListener);

var CameraLifecycleListener =
/** @class */
function () {
  function CameraLifecycleListener(scene, props, canvas) {
    this.props = props;
    this.canvas = canvas;
    this.scene = scene;
  }

  CameraLifecycleListener.prototype.onParented = function (parent, child) {
    if (parent.metadata.isNode && child.metadata.isNode) {
      // TODO: consider add option for setParent(), which parents and maintains mesh pos/rot in world space
      // child.hostInstance.setParent(parent.hostInstance)
      child.hostInstance.parent = parent.hostInstance;
    }
  };

  CameraLifecycleListener.prototype.onChildAdded = function (child, parent) {};

  CameraLifecycleListener.prototype.onMount = function (instance) {
    if (instance.hostInstance === undefined) {
      console.error('Missing instance');
      return;
    } // prevent default unless explicitly specified.


    var camera = instance.hostInstance;
    var noPreventDefault = this.props.noPreventDefault === false ? false : true; // console.log("camera.attachControl:", camera, this.canvas, noPreventDefault)
    // should be a custom property for autoAttaching?  Will be an issue for multiple cameras.

    camera.attachControl(this.canvas, noPreventDefault);

    if (instance.metadata.isTargetable && this.props.lockedTargetMeshName) {
      if (this.scene === null) {
        console.error("no scene for targeting");
      } else {
        var targetCamera = camera;
        targetCamera.lockedTarget = this.scene.getMeshByName(this.props.lockedTargetMeshName);
      }
    }
  };

  CameraLifecycleListener.prototype.onUnmount = function () {};

  return CameraLifecycleListener;
}();

var EnvironmentHelperLifecycleListener =
/** @class */
function () {
  function EnvironmentHelperLifecycleListener(scene, props) {
    this.scene = scene;
    this.props = props;
  }

  EnvironmentHelperLifecycleListener.prototype.onParented = function (parent, child) {};

  EnvironmentHelperLifecycleListener.prototype.onChildAdded = function (child, parent) {};

  EnvironmentHelperLifecycleListener.prototype.onMount = function (instance) {
    if (instance.hostInstance === undefined) {
      console.error('Missing instance');
      return;
    } // for TypeScript people use <... setMainColor={[mainColor]} />


    if (this.props.mainColor) {
      instance.hostInstance.setMainColor(this.props.mainColor);
    }

    if (this.props.teleportEnvironmentGround) {
      console.error("need to enable teleportation to ground (also from VRExperienceHelper, so call order has no impact.");
    }
  };

  EnvironmentHelperLifecycleListener.prototype.onUnmount = function () {};

  return EnvironmentHelperLifecycleListener;
}();

var GUI2DControlLifecycleListener =
/** @class */
function () {
  function GUI2DControlLifecycleListener() {}

  GUI2DControlLifecycleListener.prototype.onParented = function (parent, child) {};

  GUI2DControlLifecycleListener.prototype.onChildAdded = function (child, parent) {};

  GUI2DControlLifecycleListener.prototype.onMount = function (instance) {
    if (instance === undefined) {
      console.error('Missing instance');
      return;
    }

    if (instance.customProps.defaultKeyboard === true) {
      if (instance.hostInstance instanceof VirtualKeyboard$1) {
        // TODO: Generate from factory method.  VirtualKeyboard.CreateDefaultLayout()
        instance.hostInstance.addKeysRow(["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "\u2190"]);
        instance.hostInstance.addKeysRow(["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"]);
        instance.hostInstance.addKeysRow(["a", "s", "d", "f", "g", "h", "j", "k", "l", ";", "'", "\u21B5"]);
        instance.hostInstance.addKeysRow(["\u21E7", "z", "x", "c", "v", "b", "n", "m", ",", ".", "/"]);
        instance.hostInstance.addKeysRow([" "], [{
          width: "200px"
        }]);
      }
    }

    if (instance.state && instance.state.added === true) {
      return;
    }

    var addedParent = null;
    var tmp = instance.parent;

    while (tmp) {
      if (tmp.metadata.isGUI2DControl) {
        if (tmp.state && tmp.state.added === true) {
          addedParent = tmp;
          break;
        }
      }

      tmp = tmp.parent;
    }

    if (addedParent) {
      this.addControls(addedParent);
    }
  };

  GUI2DControlLifecycleListener.prototype.addControls = function (instance) {
    var _this = this;

    instance.children.forEach(function (child) {
      if (child.metadata.isGUI2DControl === true) {
        // console.warn("calling ", instance.hostInstance.name, ".addControl(", child.hostInstance.name, ")")
        instance.hostInstance.addControl(child.hostInstance);
        child.state = {
          added: true
        };
      }
    });

    if (instance.customProps.connectControlNames !== undefined && Array.isArray(instance.customProps.connectControlNames)) {
      // let controlNames: string[] = instance.customProps.connectControlNames
      var root = instance;

      while (root.parent !== null) {
        root = root.parent;
      }
    }

    instance.children.forEach(function (child) {
      _this.addControls(child);
    });
  };

  GUI2DControlLifecycleListener.prototype.onUnmount = function () {};

  return GUI2DControlLifecycleListener;
}();

var GUI3DControlLifecycleListener =
/** @class */
function () {
  function GUI3DControlLifecycleListener(scene) {
    this.scene = scene;
  }

  GUI3DControlLifecycleListener.prototype.onParented = function (parent, child) {};

  GUI3DControlLifecycleListener.prototype.onChildAdded = function (child, parent) {};

  GUI3DControlLifecycleListener.prototype.onMount = function (instance) {
    if (instance.state && instance.state.added === true) {
      return;
    }

    var addedParent = null;
    var tmp = instance.parent;

    while (tmp) {
      if (tmp.metadata.isGUI3DControl === true) {
        if (tmp.state && tmp.state.added === true) {
          addedParent = tmp;
          break;
        }
      }

      tmp = tmp.parent;
    }

    if (addedParent) {
      this.addControls(addedParent, addedParent);
    }
  };

  GUI3DControlLifecycleListener.prototype.addControls = function (instance, last3DGuiControl) {
    var _this = this;

    var last3d = instance.metadata.isGUI3DControl === true ? instance : last3DGuiControl;
    instance.children.forEach(function (child) {
      if (last3d.customProps.childrenAsContent === true) {
        last3d.hostInstance.content = child.hostInstance; // child.hostInstance will be GUI.Control (ie: 2D)

        child.state = {
          added: true,
          content: true
        };
      } else if (child.metadata.isGUI3DControl === true) {
        last3d.hostInstance.addControl(child.hostInstance); // NOTE: this must be called after .addControl(child.hostInstance).

        if (child.customProps.linkToTransformNodeByName) {
          var toLinkTo = _this.scene.getMeshByName(child.customProps.linkToTransformNodeByName);

          if (toLinkTo !== null) {
            child.hostInstance.linkToTransformNode(toLinkTo); // toLinkTo.computeWorldMatrix()
          } else {
            console.error("linkToTransformNode cannot find Mesh:", instance.customProps.linkToTransformNodeByName, " and does not have a scene listener for added meshes." + " Declare Mesh earlier or add an issue on github (TransformNode does not work).");
          }
        }

        child.state = {
          added: true
        };
      }
    });

    if (instance.children.length > 0) {
      instance.children.forEach(function (child) {
        if (!child.state || child.state.content !== true) {
          if (child.state && child.state.added === true && child.customProps.onControlAdded) {
            child.customProps.onControlAdded(child);
          }

          _this.addControls(child, last3d);
        }
      });
    }
  };

  GUI3DControlLifecycleListener.prototype.onUnmount = function () {};

  return GUI3DControlLifecycleListener;
}();

var GUI3DManagerLifecycleListener =
/** @class */
function () {
  function GUI3DManagerLifecycleListener(scene) {
    this.scene = scene;
  }

  GUI3DManagerLifecycleListener.prototype.onParented = function (parent) {};

  GUI3DManagerLifecycleListener.prototype.onChildAdded = function (child) {};

  GUI3DManagerLifecycleListener.prototype.onMount = function (instance) {
    if (instance === undefined) {
      console.error('Missing instance');
      return;
    }

    this.addControls(instance, instance);
  };
  /**
   * We may have BoundComponents inbetween gui3d controls.
   */


  GUI3DManagerLifecycleListener.prototype.addControls = function (instance, last3DGuiControl) {
    var _this = this; // When there is a panel, it must be added before the children. Otherwise there is no UtilityLayer to attach to.
    // This project before 'react-reconciler' was added from parent up the tree.  'react-reconciler' wants to do the opposite.


    instance.children.forEach(function (child) {
      if (child.metadata.isGUI3DControl === true) {
        if (last3DGuiControl.customProps.childrenAsContent === true) {
          last3DGuiControl.hostInstance.content = child.hostInstance;
          child.state = {
            added: true,
            content: true
          };
        } else {
          last3DGuiControl.hostInstance.addControl(child.hostInstance);
          child.state = {
            added: true
          }; // NOTE: this must be called after .addControl(child.hostInstance).

          if (child.customProps.linkToTransformNodeByName) {
            var toLinkTo = _this.scene.getMeshByName(child.customProps.linkToTransformNodeByName);

            if (toLinkTo !== null) {
              child.hostInstance.linkToTransformNode(toLinkTo);
            } else {
              console.error("linkToTransformNode cannot find ", instance.customProps.linkToTransformNodeByName, " and does not have a scene listener for added meshes.  Declare earlier or add an issue on github.");
            }
          }
        }
      }

      if (child.state && child.state.added === true && child.customProps.onControlAdded) {
        child.customProps.onControlAdded(child);
      }

      if (!child.state || child.state.content !== true) {
        var last3d = child.metadata.isGUI3DControl === true ? child : last3DGuiControl;

        _this.addControls(child, last3d);
      }
    }); // Here we can now do a transform with an anchor point.

    console.error("transform gui3dmanager anchor missing");
  };

  GUI3DManagerLifecycleListener.prototype.onUnmount = function () {};

  return GUI3DManagerLifecycleListener;
}();

var MaterialsLifecycleListener =
/** @class */
function () {
  function MaterialsLifecycleListener() {}

  MaterialsLifecycleListener.prototype.onCreated = function (instance, scene) {
    if (instance.customProps.attachToMeshesByName) {
      if (!Array.isArray(instance.customProps.attachToMeshesByName)) {
        console.error("AttachToMeshesByName must be an array (of strings).", instance.customProps.attachToMeshesByName);
        return;
      }

      if (instance.hostInstance === undefined) {
        console.error('instance not assigned');
        return;
      }

      var meshNamesToAttachTo_1 = instance.customProps.attachToMeshesByName.slice(0); // TODO: also need a listener for models or if we want to add a predicate:

      scene.onNewMeshAddedObservable.add(function (mesh) {
        if (meshNamesToAttachTo_1.indexOf(mesh.name) >= 0) {
          setTimeout(function () {
            mesh.material = instance.hostInstance;
          }, 0);
        }
      });
      scene.meshes.forEach(function (mesh) {
        if (meshNamesToAttachTo_1.indexOf(mesh.name) >= 0) {
          mesh.material = instance.hostInstance;
        }
      });
    }
  };

  MaterialsLifecycleListener.prototype.onParented = function (parent) {};

  MaterialsLifecycleListener.prototype.onChildAdded = function (child) {};

  MaterialsLifecycleListener.prototype.onMount = function (instance) {
    if (instance === undefined) {
      console.error('Missing instance');
      return;
    }

    if (!instance.customProps.attachToMeshesByName) {
      var material_1 = instance.hostInstance;
      var tmp = instance.parent;

      var _loop_1 = function _loop_1() {
        if (tmp.metadata && tmp.metadata.acceptsMaterials === true) {
          if (instance.customProps.assignTo) {
            var propsList_1 = instance.customProps.assignTo.split('.');
            var propToAssign_1 = tmp.hostInstance;
            propsList_1.forEach(function (prop, index) {
              if (propToAssign_1[prop] === undefined) {
                // create property if it doesn't exist.
                console.warn('Assign to created property', prop, 'on', propToAssign_1);
                propToAssign_1[prop] = {};
              }

              if (index === propsList_1.length - 1) {
                propToAssign_1[prop] = material_1;
              } else {
                propToAssign_1 = propToAssign_1[prop];
              }
            });
          } else {
            tmp.hostInstance.material = material_1;
          }

          return "break";
        }

        tmp = tmp.parent;
      };

      while (tmp !== null) {
        var state_1 = _loop_1();

        if (state_1 === "break") break;
      }
    }
  };

  MaterialsLifecycleListener.prototype.onUnmount = function () {};

  return MaterialsLifecycleListener;
}();

var LoaderStatus;

(function (LoaderStatus) {
  LoaderStatus[LoaderStatus["Loading"] = 0] = "Loading";
  LoaderStatus[LoaderStatus["Loaded"] = 1] = "Loaded";
  LoaderStatus[LoaderStatus["Error"] = 2] = "Error";
})(LoaderStatus || (LoaderStatus = {}));

var LoadedModel =
/** @class */
function () {
  function LoadedModel() {}

  Object.defineProperty(LoadedModel.prototype, "boundingInfo", {
    get: function get() {
      if (!this.rootMesh) {
        return null;
      } // meshes are already parented to root mesh, so we do not need to look further.


      var min = null;
      var max = null;
      this.rootMesh.getChildMeshes().forEach(function (childMesh) {
        var _a = childMesh.getBoundingInfo().boundingBox,
            minimumWorld = _a.minimumWorld,
            maximumWorld = _a.maximumWorld;

        if (min === null) {
          min = minimumWorld;
        } else {
          min = Vector3$1.Minimize(min, minimumWorld);
        }

        if (max === null) {
          max = maximumWorld;
        } else {
          max = Vector3$1.Maximize(max, maximumWorld);
        }
      });

      if (min !== null && max != null) {
        return new BoundingInfo(min, max);
      }

      return null;
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Clean up all resources.
   */

  LoadedModel.prototype.dispose = function () {
    if (this.meshes) {
      this.meshes.forEach(function (mesh) {
        mesh.dispose(false
        /* not recursive */
        , true
        /* materials + textures */
        );
      });
      this.meshes = [];
    }

    if (this.particleSystems) {
      this.particleSystems.forEach(function (ps) {
        // ps.stop();
        ps.dispose();
      });
      this.particleSystems = [];
    }

    if (this.skeletons) {
      this.skeletons.forEach(function (skeleton) {
        return skeleton.dispose();
      });
      this.skeletons = [];
    }

    if (this.animationGroups) {
      this.animationGroups.forEach(function (animationGroup) {
        return animationGroup.dispose();
      });
      this.animationGroups = [];
    }
  };

  return LoadedModel;
}();
/**
 * TODO: Integrate this into the generated code, which duplicates for every class.
 */


var BasePropsHandler =
/** @class */
function () {
  function BasePropsHandler(propsHandlers) {
    this.propsHandlers = propsHandlers;
  }

  BasePropsHandler.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  BasePropsHandler.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  return BasePropsHandler;
}();

var FiberModel =
/** @class */
function (_super) {
  __extends(FiberModel, _super);

  function FiberModel() {
    return _super.call(this, [new ModelPropsHandler()]) || this;
  }

  return FiberModel;
}(BasePropsHandler);

var ModelPropsHandler =
/** @class */
function () {
  function ModelPropsHandler() {}

  ModelPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
    var meshUpdates = [];
    propsHandlers.forEach(function (propHandler) {
      // NOTE: this is actually WRONG, because here we want to compare the props with the object.
      var handlerUpdates = propHandler.getPropertyUpdates(oldProps, newProps);

      if (handlerUpdates !== null) {
        meshUpdates.push.apply(meshUpdates, handlerUpdates);
      }
    });

    if (meshUpdates.length === 0) {
      return null;
    } // add target


    meshUpdates.forEach(function (propertyUpdate) {
      return propertyUpdate.target = "rootMesh";
    });
    return meshUpdates;
  };

  return ModelPropsHandler;
}();
/**
 * This listener has no underlying babylonjs type.  We are handling loading a 3D model with underlying mesh(es).
 */


var ModelLifecycleListener =
/** @class */
function () {
  function ModelLifecycleListener(scene, props) {
    this.props = props;
    this.scene = scene;
  }

  ModelLifecycleListener.prototype.onParented = function (parent, child) {};

  ModelLifecycleListener.prototype.onChildAdded = function (child, parent) {};

  ModelLifecycleListener.prototype.onMount = function (instance) {
    var _this = this;

    var loadedModel = new LoadedModel();
    loadedModel.status = LoaderStatus.Loading;
    instance.hostInstance = loadedModel;
    var loader = SceneLoader.ImportMesh(undefined, this.props.rootUrl, this.props.sceneFilename, this.scene, function (meshes, particleSystems, skeletons, animationGroups) {
      loadedModel.rootMesh = new AbstractMesh$2(_this.props.sceneFilename + "-root-model", _this.scene);
      loadedModel.rootMesh.alwaysSelectAsActiveMesh = true;
      loadedModel.meshes = [];
      meshes.forEach(function (mesh) {
        loadedModel.meshes.push(mesh); // leave meshes already parented to maintain model hierarchy:

        if (!mesh.parent) {
          mesh.parent = loadedModel.rootMesh;
        }

        if (_this.props.receiveShadows === true) {
          mesh.receiveShadows = true;
        }
      });
      loadedModel.particleSystems = particleSystems;
      loadedModel.skeletons = skeletons;
      loadedModel.animationGroups = animationGroups;

      if (_this.props.onModelLoaded) {
        _this.props.onModelLoaded(loadedModel);
      }

      loadedModel.status = LoaderStatus.Loaded; // we want to trigger after mesh is loaded (ie: position/rotation)

      var updates = new ModelPropsHandler().getPropertyUpdates({
        rootUrl: "",
        sceneFilename: ""
      }, _this.props);

      if (updates !== null) {
        updates.forEach(function (update) {
          return applyUpdateToInstance(instance.hostInstance, update);
        });
      }

      if (_this.props.scaleToDimension && loadedModel && loadedModel.scaleToDimension !== _this.props.scaleToDimension) {
        var boundingInfo = loadedModel.boundingInfo; // will be null when no meshes are loaded

        if (boundingInfo) {
          var longestDimension = Math.max(Math.abs(boundingInfo.minimum.x - boundingInfo.maximum.x), Math.abs(boundingInfo.minimum.y - boundingInfo.maximum.y), Math.abs(boundingInfo.minimum.z - boundingInfo.maximum.z));
          var dimension = _this.props.scaleToDimension / longestDimension;
          loadedModel.rootMesh.scaling.scaleInPlace(dimension);
          loadedModel.scaleToDimension = _this.props.scaleToDimension;
        }
      }
    }, function (event) {
      if (_this.props.onLoadProgress) {
        _this.props.onLoadProgress(event);
      }
    }, function (scene, message, exception) {
      loadedModel.status = LoaderStatus.Error;
      loadedModel.errorMessage = "error: " + message + " -> " + (exception ? exception.message : "no exception");

      if (_this.props.onModelError) {
        _this.props.onModelError(loadedModel);
      }
    }, this.props.pluginExtension);

    if (loader) {
      loadedModel.loaderName = loader.name;
    } else {
      loadedModel.loaderName = "no loader found";
    }
  };

  ModelLifecycleListener.prototype.onUnmount = function () {};

  return ModelLifecycleListener;
}();

var DeferredCreationLifecycleListener =
/** @class */
function () {
  function DeferredCreationLifecycleListener(scene, props) {
    this.scene = scene;
    this.props = props;
  }

  DeferredCreationLifecycleListener.prototype.onMount = function (instance) {
    var createdInstance = this.createInstance(instance, this.scene, this.props);

    if (createdInstance === undefined) {
      console.warn('was unable to create deferred instance');
    } else {
      // Meed to assign deferred props (from delayed creation) or they are lost:
      if (instance.deferredCreationProps && instance.propsHandlers) {
        applyInitialPropsToInstance(instance, instance.deferredCreationProps, this.scene);
      } else {
        console.warn('cannot assign deferred props.  they are lost.');
      }

      instance.deferredCreationProps = undefined;
    }
  };

  return DeferredCreationLifecycleListener;
}();
/**
 * There is a lot going on in the PhysicsImpostor constructor, so we delay instantiation so that we have a target
 * 'object' before creation.
 */


var PhysicsImpostorLifecycleListener =
/** @class */
function (_super) {
  __extends(PhysicsImpostorLifecycleListener, _super);

  function PhysicsImpostorLifecycleListener(scene, props) {
    var _this = _super.call(this, scene, props) || this;

    _this.createInstance = function (instance, scene, props) {
      if (!_this._parent) {
        return null;
      } // these should be set from the props handler.  TODO: test.


      var options = props._options; // constructor has a default { mass: 0 }

      instance.hostInstance = new PhysicsImpostor$2(_this._parent, props.type, options, _this.scene);
      instance.hostInstance.object = _this._parent;
      _this._parent.physicsImpostor = instance.hostInstance; // TODO: need to assign deferredCreationProps (@see ShadowGeneratorLifecycleListener).

      return instance.hostInstance;
    };

    return _this;
  }

  PhysicsImpostorLifecycleListener.prototype.onParented = function (parent, child) {
    // IPhysicsEnabledObject requires only position and rotationQuaternion
    if (parent.hostInstance.position === undefined || parent.hostInstance.rotationQuaternion === undefined) {
      console.warn('PhysicsImpostor is parented to an element that does not appear to implement IPhysicsEnabledObject');
    }

    this._parent = parent.hostInstance;
  };

  PhysicsImpostorLifecycleListener.prototype.onChildAdded = function (child, parent) {};

  PhysicsImpostorLifecycleListener.prototype.onUnmount = function () {};

  return PhysicsImpostorLifecycleListener;
}(DeferredCreationLifecycleListener);

var ShadowGeneratorLifecycleListener =
/** @class */
function (_super) {
  __extends(ShadowGeneratorLifecycleListener, _super);

  function ShadowGeneratorLifecycleListener(scene, props) {
    var _this = _super.call(this, scene, props) || this;

    _this.onMeshAddedObservable = null;
    _this.onMeshRemovedObservable = null;

    _this.createInstance = function (instance, scene, props) {
      var tmp = instance.parent;
      var result = null;

      while (tmp !== null) {
        if (tmp.metadata.isShadowLight) {
          // console.log("Creating ShadowGenerator.  size:", this.props.mapSize, "light", tmp.hostInstance)
          instance.hostInstance = result = new ShadowGenerator$2(props.mapSize, tmp.hostInstance, props.useFullFloatFirst);
          break;
        }

        tmp = tmp.parent;
      }

      if (instance.hostInstance === undefined) {
        console.error("ShadowGenerator has no light source.");
        return null;
      }

      if (instance.customProps.shadowCasters) {
        if (!Array.isArray(instance.customProps.shadowCasters)) {
          console.error("Shadow casters must be an array (of strings).", instance.customProps.shadowCasters);
          return null;
        }

        var shadowCasters_1 = instance.customProps.shadowCasters; // TODO: also need a listener for models or if we want to add a predicate:

        _this.onMeshAddedObservable = scene.onNewMeshAddedObservable.add(function (mesh) {
          if (shadowCasters_1.indexOf(mesh.name) >= 0) {
            instance.hostInstance.addShadowCaster(mesh);
          }
        });
        _this.onMeshRemovedObservable = scene.onMeshRemovedObservable.add(function (mesh) {
          if (shadowCasters_1.indexOf(mesh.name) >= 0) {
            instance.hostInstance.removeShadowCaster(mesh);
          }
        });
        scene.meshes.forEach(function (mesh) {
          if (shadowCasters_1.indexOf(mesh.name) >= 0) {
            instance.hostInstance.addShadowCaster(mesh);
          }
        });
      } else if (instance.customProps.shadowCastersExcluding) {
        if (!Array.isArray(instance.customProps.shadowCastersExcluding)) {
          console.error("Shadow casters excluding must be an array (of strings).", instance.customProps.shadowCastersExcluding);
        } else {
          var shadowCastersExcluding_1 = instance.customProps.shadowCastersExcluding; // TODO: also need a listener for models or if we want to add a predicate:

          _this.onMeshAddedObservable = scene.onNewMeshAddedObservable.add(function (mesh) {
            if (shadowCastersExcluding_1.indexOf(mesh.name) === -1) {
              instance.hostInstance.addShadowCaster(mesh);
            }
          });
          _this.onMeshRemovedObservable = scene.onMeshRemovedObservable.add(function (mesh) {
            if (shadowCastersExcluding_1.indexOf(mesh.name) === -1) {
              instance.hostInstance.removeShadowCaster(mesh);
            }
          });
          scene.meshes.forEach(function (mesh) {
            if (shadowCastersExcluding_1.indexOf(mesh.name) === -1) {
              instance.hostInstance.addShadowCaster(mesh);
            }
          });
        }
      }

      return result;
    };

    return _this;
  }

  ShadowGeneratorLifecycleListener.prototype.onParented = function (parent, child) {};

  ShadowGeneratorLifecycleListener.prototype.onChildAdded = function (child, parent) {};

  ShadowGeneratorLifecycleListener.prototype.onUnmount = function () {
    if (this.onMeshAddedObservable !== null) {
      this.scene.onNewMeshAddedObservable.remove(this.onMeshAddedObservable);
      this.onMeshAddedObservable = null;
    }

    if (this.onMeshRemovedObservable !== null) {
      this.scene.onMeshRemovedObservable.remove(this.onMeshRemovedObservable);
      this.onMeshRemovedObservable = null;
    }
  };

  return ShadowGeneratorLifecycleListener;
}(DeferredCreationLifecycleListener);

var Skybox = function Skybox(props) {
  var _a;

  return React.createElement("box", {
    name: name ? "skybox-" + name : 'skybox',
    size: (_a = props.size) !== null && _a !== void 0 ? _a : 100,
    infiniteDistance: true,
    renderingGroupId: 0
  }, React.createElement("standardMaterial", {
    name: name ? "skybox-material-" + name : 'skybox-material',
    backFaceCulling: false,
    disableLighting: true
  }, React.createElement("cubeTexture", {
    key: "cube-texture-" + props.rootUrl,
    rootUrl: props.rootUrl,
    coordinatesMode: Texture$2.SKYBOX_MODE,
    assignTo: 'reflectionTexture'
  })));
}; // This does not work when declared component with "lockedTargetMeshName" is before the mesh with that name.
// Need to wait for full commit mount of entire tree, so use in conjunction with LifecycleListner is best option.


var TargetPropsHandler =
/** @class */
function () {
  function TargetPropsHandler(scene) {
    this.scene = scene;
  }

  TargetPropsHandler.prototype.getPropertyUpdates = function (oldProps, newProps) {
    var propertyUpdates = [];

    if (!oldProps.lockedTargetMeshName || oldProps.lockedTargetMeshName !== newProps.lockedTargetMeshName) {
      if (typeof newProps.lockedTargetMeshName === "string") {
        propertyUpdates.push({
          type: "BabylonjsCoreMesh",
          value: this.scene.getMeshByName(newProps.lockedTargetMeshName),
          changeType: PropChangeType.Primitive,
          propertyName: "lockedTarget"
        });
      }
    }

    return propertyUpdates;
  };

  return TargetPropsHandler;
}();
/**
 * Assign value to an object property
 *
 * @param value: What you are assigning
 * @param target: Target to assign value to
 * @param propertyPath Where to assign value to on target (path to assign.  ie: "baseTexture" or "mesh.material")
 *
 */


function assignProperty(value, target, propertyPath) {
  var propsList = propertyPath.split('.');
  propsList.forEach(function (prop, index) {
    if (target[prop] === undefined) {
      // create property if it doesn't exist.
      console.warn("Created property " + prop + " on: (from " + propsList + ")", target);
      target[prop] = {};
    }

    if (index === propsList.length - 1) {
      target[prop] = value;
    } else {
      target = target[prop];
    }
  });
}

var TexturesLifecycleListener =
/** @class */
function () {
  function TexturesLifecycleListener() {}

  TexturesLifecycleListener.prototype.onParented = function (parent) {};

  TexturesLifecycleListener.prototype.onChildAdded = function (child) {};

  TexturesLifecycleListener.prototype.onMount = function (instance) {
    var assignTo = instance.customProps.assignTo;
    var texture = instance.hostInstance;
    var tmp = instance.parent;

    while (tmp !== null) {
      if (tmp.metadata && tmp.metadata.isMaterial === true) {
        if (assignTo) {
          assignProperty(texture, tmp.hostInstance, assignTo);
        } else {
          // maybe below case is more common, so let it default
          tmp.hostInstance.diffuseTexture = texture;
        }

        break;
      }

      tmp = tmp.parent;
    }
  };

  TexturesLifecycleListener.prototype.onUnmount = function () {};

  return TexturesLifecycleListener;
}();

var VRExperienceHelperLifecycleListener =
/** @class */
function () {
  function VRExperienceHelperLifecycleListener(props) {
    this.props = props;
  }

  VRExperienceHelperLifecycleListener.prototype.onParented = function (parent, child) {};

  VRExperienceHelperLifecycleListener.prototype.onChildAdded = function (child, parent) {};

  VRExperienceHelperLifecycleListener.prototype.onMount = function (instance) {
    if (this.props.enableInteractions) {
      instance.hostInstance.enableInteractions();
    }
  };

  VRExperienceHelperLifecycleListener.prototype.onUnmount = function () {};

  return VRExperienceHelperLifecycleListener;
}();

var NodeLifecycleListener =
/** @class */
function () {
  function NodeLifecycleListener() {}

  NodeLifecycleListener.prototype.onParented = function (parent, child) {
    if (parent.metadata.isNode && child.metadata.isNode) {
      // TODO: consider add option for setParent(), which parents and maintains mesh pos/rot in world space
      // child.hostInstance.setParent(parent.hostInstance)
      child.hostInstance.parent = parent.hostInstance;
    }
  };

  NodeLifecycleListener.prototype.onChildAdded = function (parent, child) {};

  NodeLifecycleListener.prototype.onMount = function (instance) {};

  NodeLifecycleListener.prototype.onUnmount = function () {};

  return NodeLifecycleListener;
}();

var BehaviorLifecycleListener =
/** @class */
function () {
  function BehaviorLifecycleListener() {
    this.behaviorAware = null;
    this.behavior = null;
  }

  BehaviorLifecycleListener.prototype.onParented = function (parent, child) {
    var _a;

    if (parent.metadata.isNode && ((_a = parent.hostInstance) === null || _a === void 0 ? void 0 : _a.addBehavior)
    /* TODO: verify if this needs to be a mesh */
    && child.metadata.isBehavior
    /* always true? */
    ) {
        parent.hostInstance.addBehavior(child.hostInstance);
        this.behaviorAware = parent.hostInstance;
        this.behavior = child.hostInstance;
      } else {
      console.warn('Could not locate IBehaviorAware on Behavior parent.');
    }
  };

  BehaviorLifecycleListener.prototype.onChildAdded = function (parent, child) {};

  BehaviorLifecycleListener.prototype.onMount = function (instance) {};

  BehaviorLifecycleListener.prototype.onUnmount = function () {
    if (this.behaviorAware) {
      this.behaviorAware.removeBehavior(this.behavior);
    }
  };

  return BehaviorLifecycleListener;
}();

var CUSTOM_COMPONENTS = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AdvancedDynamicTextureLifecycleListener: AdvancedDynamicTextureLifecycleListener,
  ADTFullscreenUILifecycleListener: ADTFullscreenUILifecycleListener,
  CameraLifecycleListener: CameraLifecycleListener,
  EnvironmentHelperLifecycleListener: EnvironmentHelperLifecycleListener,
  GUI2DControlLifecycleListener: GUI2DControlLifecycleListener,
  GUI3DControlLifecycleListener: GUI3DControlLifecycleListener,
  GUI3DManagerLifecycleListener: GUI3DManagerLifecycleListener,
  MaterialsLifecycleListener: MaterialsLifecycleListener,
  ModelLifecycleListener: ModelLifecycleListener,
  PhysicsImpostorLifecycleListener: PhysicsImpostorLifecycleListener,
  ShadowGeneratorLifecycleListener: ShadowGeneratorLifecycleListener,
  Skybox: Skybox,
  TargetPropsHandler: TargetPropsHandler,
  TexturesLifecycleListener: TexturesLifecycleListener,
  VRExperienceHelperLifecycleListener: VRExperienceHelperLifecycleListener,
  NodeLifecycleListener: NodeLifecycleListener,
  BehaviorLifecycleListener: BehaviorLifecycleListener
});

var CreationType =
/** @class */
function () {
  function CreationType() {}

  CreationType.FactoryMethod = "FactoryMethod";
  CreationType.Constructor = "Constructor";
  return CreationType;
}();

function createCreatedInstance(className, hostInstance, propsHandlers, metadata, customProps, lifecycleListener) {
  var createdMetadata = metadata; // TODO: move how this is generated as a boolean to a metadata on objects themselves (and the next 3 lines!).

  if (propsHandlers.isTargetable === true) {
    createdMetadata.isTargetable = true;
  }

  return {
    hostInstance: hostInstance,
    metadata: createdMetadata,
    parent: null,
    children: [],
    propsHandlers: propsHandlers,
    lifecycleListener: lifecycleListener,
    customProps: customProps
  };
}
/**
 * remove instance's children recursively
 *
 * @param parentInstance
 * @param child
 */


function removeChild(parentInstance, child) {
  if (child) {
    var hostInstance = child.hostInstance;

    if (child.lifecycleListener) {
      child.lifecycleListener.onUnmount();
    }

    if (child.metadata.isNode) {
      hostInstance.parent = null;
    } else if (child.metadata.isGUI3DControl === true) {
      console.error("3D remove control not implemented.");
    }

    if (parentInstance.metadata && parentInstance.metadata.isGUI2DControl === true && child.metadata.isGUI2DControl === true) {
      // NOTE: the if statement should be || and we may need to walk the tree to remove.
      parentInstance.hostInstance.removeControl(child.hostInstance);
    }

    if (child.children) {
      removeRecursive(child.children, child);
    }

    if (typeof child.hostInstance.dispose === "function") {
      hostInstance.dispose(); // TODO: Consider adding metadata/descriptors as some dispose methods have optional args.
    } // fix: old version rootInstance.children was not cleaned, so the children array maybe huge over time


    parentInstance.children = parentInstance.children.filter(function (ci) {
      return ci !== child;
    });
    child.parent = null;
  }
}
/**
 * remove child recursive
 */


function removeRecursive(array, parent, clone) {
  if (clone === void 0) {
    clone = false;
  }

  if (array) {
    var target = clone ? __spreadArrays(array) : array;
    target.forEach(function (child) {
      return removeChild(parent, child);
    });
  }
}

var ReactBabylonJSHostConfig = {
  // This has the reconciler include in call chain ie: appendChild, removeChild
  get supportsMutation() {
    return true;
  },

  now: function now() {
    return Date.now(); // TODO: use performance.now
  },

  // multiple renderers concurrently render using the same context objects. E.g. React DOM and React ART on the
  // same page. DOM is the primary renderer; ART is the secondary renderer.
  get isPrimaryRenderer() {
    return false;
  },

  get supportsPersistence() {
    return false;
  },

  // TODO: see if this will allow ie: improved HMR support.  Need to implement a lot of currently optional methods.
  get supportsHydration() {
    return false;
  },

  // this enables refs
  getPublicInstance: function getPublicInstance(instance) {
    return instance;
  },
  getRootHostContext: function getRootHostContext(rootContainerInstance) {
    // this is the context you pass to your chilren, as parameter 'parentHostContext' from "root".
    // So, opportunity to share context here via HostConfig further up tree.
    return {
      canvas: rootContainerInstance.canvas,
      engine: rootContainerInstance.engine,
      scene: rootContainerInstance.scene,
      rootInstance: {
        hostInstance: undefined,
        metadata: {
          className: "rootContainer",
          namespace: "ignore"
        },
        parent: null,
        children: [],
        customProps: {}
      }
    };
  },
  // this is the context you pass down to children.  without this root will not be available to attach to in appendChildToContainer.
  getChildHostContext: function getChildHostContext(parentHostContext, type, rootContainerInstance) {
    return parentHostContext;
  },
  prepareUpdate: function prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, hostContext) {
    if (!instance || instance.metadata && instance.metadata.customType === true) {
      return null;
    }

    var updatePayload = []; // Only custom types will not have a fiber object to handle props changes

    instance.propsHandlers.getPropsHandlers().forEach(function (propHandler) {
      var handlerUpdates = propHandler.getPropertyUpdates(oldProps, newProps);

      if (handlerUpdates !== null) {
        updatePayload.push.apply(updatePayload, handlerUpdates);
      }
    });
    return updatePayload.length === 0 ? null : updatePayload;
  },

  /**
   * This is called when something is dynamically added to root (not on initial appendChildToContainer)
   */
  insertInContainerBefore: function insertInContainerBefore(container, child, beforeChild) {
    // same implementation as appendChildToContainer
    if (child) {
      // doubly link child to root.  we don't care about order - ie: 'beforeChild'
      container.rootInstance.children.push(child);
      child.parent = container.rootInstance;
    } else {
      console.error("insertInContainerBefore. No child:", child);
    }
  },
  createInstance: function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
    var _a, _b; // TODO: Make a registry like React Native host config or just build a map in /customHosts/index.ts.


    var customTypes = [HostWithEvents]; // TODO: Check source for difference between hostContext and rootContainerInstance.

    var canvas = rootContainerInstance.canvas,
        engine = rootContainerInstance.engine,
        scene = rootContainerInstance.scene;

    if (customTypes.indexOf(type) !== -1) {
      var metadata_1 = _assign({
        className: type,
        customType: true
      }, props.metadata);

      var createdInstance = {
        hostInstance: null,
        metadata: metadata_1,
        parent: null,
        children: [],
        propsHandlers: undefined,
        customProps: {},
        lifecycleListener: new CUSTOM_HOSTS[type + "Fiber"](scene, engine, props)
      }; // onCreated and other lifecycle hooks are not called for built-in host

      return createdInstance;
    } // so far this is the only non-babylonJS host component, but otherwise a more generic solution will be needed:


    if (type.toLowerCase() === "model") {
      var createdInstance = {
        hostInstance: new LoadedModel()
        /* this is reassigned in Lifecycle Listener */
        ,
        metadata: {
          className: "Model"
        },
        parent: null,
        children: [],
        propsHandlers: new FiberModel(),
        lifecycleListener: new ModelLifecycleListener(scene
        /* should always be available */
        , props),
        customProps: {}
      }; // onCreated and other lifecycle hooks are not called for built-in host

      return createdInstance;
    } // some types (ie: button) are called 'babylonjs-button'.


    var underlyingClassName = intrinsicClassMap[type] || type;
    var classDefinition = GENERATED["Fiber" + underlyingClassName];

    if (classDefinition === undefined) {
      throw new Error("Cannot generate type '" + type + "/" + underlyingClassName + "' inside 'react-babylonjs' (ie: no DOM rendering on HTMLCanvas)");
    }

    var createInfoArgs = classDefinition.CreateInfo;
    var metadata = classDefinition.Metadata; // console.log(`creating: ${createInfoArgs.namespace}.${type}`)

    var generatedParameters = createInfoArgs.parameters; // console.log("generated params:", generatedParameters)

    var args = generatedParameters.map(function (generatedParameter) {
      if (Array.isArray(generatedParameter.type)) {
        // TODO: if all props are missing, warn if main prop (ie: options) is required.
        var newParameter_1 = {};
        generatedParameter.type.forEach(function (subParameter) {
          var subPropValue = props[subParameter.name];

          if (subPropValue === undefined && subParameter.optional === false && generatedParameter.optional === false) {
            console.warn("Missing a required secondary property:", subParameter.name);
          } else {
            newParameter_1[subParameter.name] = subPropValue;
          }
        });
        return newParameter_1;
      } else {
        var value = props[generatedParameter.name];

        if (value === undefined) {
          // NOTE: we removed the hosted Scene component, which needs (generatedParameter.type == "BabylonjsCoreEngine")
          // SceneOrEngine type is Scene
          if (generatedParameter.type.includes("BabylonjsCoreScene") || generatedParameter.type === "any" && generatedParameter.name === "scene") {
            // MeshBuild.createSphere(name: string, options: {...}, scene: any)
            // console.log('Assigning scene to:', type, generatedParameter)
            value = scene;
          } else if (generatedParameter.optional === false) {
            console.warn("required parameter for " + type + " unassigned -> " + generatedParameter.name + ":" + generatedParameter.type);
          }
        }

        if (value === undefined && generatedParameter.optional === false) {
          console.warn("On " + type + " you are missing a non-optional parameter '" + generatedParameter.name + "' of type '" + generatedParameter.type + "'");
        }

        return value;
      }
    });
    var babylonObject = undefined;

    if (createInfoArgs.creationType === CreationType.FactoryMethod) {
      // console.warn(`creating from Factory: ${createInfoArgs.libraryLocation}.${createInfoArgs.factoryMethod}(...args).  args:`, args)
      babylonObject = (_a = babylonClassFactory(createInfoArgs.libraryLocation))[createInfoArgs.factoryMethod].apply(_a, args);
    } else {
      if (metadata.delayCreation !== true) {
        if (createInfoArgs.namespace.startsWith('@babylonjs/')) {
          var clazz = babylonClassFactory(type);

          if (clazz === undefined) {
            throw new Error("Cannot generate '" + type + "' (react-babylonjs):");
          }

          babylonObject = new (clazz.bind.apply(clazz, __spreadArrays([void 0], args)))();
        } else if (createInfoArgs.namespace.startsWith('./extensions/')) {
          var extClassName = intrinsicClassMap[type] || type;
          babylonObject = new ((_b = BABYLONEXT[extClassName]).bind.apply(_b, __spreadArrays([void 0], args)))();
        } else {
          console.error("metadata defines (or does not) a namespace that is known", createInfoArgs.namespace);
        }
      }
    } // Developer accessible lifecycle phase.  ie: access propery/method exposed in props.


    if (typeof props.onCreated === "function") {
      props.onCreated(babylonObject);
    }

    var fiberObject = new GENERATED["Fiber" + underlyingClassName]();
    var lifecycleListener = undefined; // TODO: Add these to just the 'type' of component they apply to.

    var customProps = {
      childrenAsContent: props.childrenAsContent === true,
      createForParentMesh: props.createForParentMesh === true,
      onControlAdded: typeof props.onControlAdded === "function" ? props.onControlAdded : undefined,
      connectControlNames: props.connectControlNames,
      defaultKeyboard: props.defaultKeyboard === true,
      linkToTransformNodeByName: props.linkToTransformNodeByName,
      shadowCasters: props.shadowCasters,
      shadowCastersExcluding: props.shadowCastersExcluding,
      attachToMeshesByName: props.attachToMeshesByName,
      assignTo: props.assignTo // here a lifecycle listener can dynamically attach to another property (ie: Mesh to DynamicTerrain -> 'mesh.material')

    }; // Consider these being dynamically attached to a list, much like PropsHandlers<T>

    if (metadata.isMaterial === true) {
      lifecycleListener = new MaterialsLifecycleListener();
    } else if (metadata.isGUI3DControl === true) {
      lifecycleListener = new GUI3DControlLifecycleListener(scene);
    } else if (metadata.isGUI2DControl === true) {
      lifecycleListener = new GUI2DControlLifecycleListener();
    } else if (metadata.isTexture === true) {
      lifecycleListener = new TexturesLifecycleListener();
    } else if (metadata.isCamera === true) {
      lifecycleListener = new CameraLifecycleListener(scene, props, canvas);
    } else if (metadata.isNode) {
      lifecycleListener = new NodeLifecycleListener();
    } else if (metadata.isBehavior) {
      lifecycleListener = new BehaviorLifecycleListener();
    } // here we dynamically assign listeners for specific types.
    // TODO: need to double-check because we are using 'camelCase'


    if (CUSTOM_COMPONENTS[underlyingClassName + "LifecycleListener"] !== undefined) {
      lifecycleListener = new CUSTOM_COMPONENTS[underlyingClassName + "LifecycleListener"](scene, props);
    }

    var createdReference = createCreatedInstance(underlyingClassName, babylonObject, fiberObject, metadata, customProps, lifecycleListener);

    if (lifecycleListener && lifecycleListener.onCreated) {
      lifecycleListener.onCreated(createdReference, scene);
    } // Here we dynamically attach known props handlers.  Will be adding more in code generation for GUI - also for lifecycle mgmt.


    if (createdReference.metadata && createdReference.metadata.isTargetable === true) {
      fiberObject.addPropsHandler(new TargetPropsHandler(scene));
    }

    if (metadata.delayCreation !== true) {
      applyInitialPropsToInstance(createdReference, props);
    } else {
      createdReference.deferredCreationProps = props;
    }

    return createdReference;
  },
  shouldDeprioritizeSubtree: function shouldDeprioritizeSubtree(type, props) {
    return false;
  },
  createTextInstance: function createTextInstance() {
    return undefined;
  },
  scheduleDeferredCallback: function scheduleDeferredCallback(callback, opts) {
    return window.requestIdleCallback(callback, opts); // ReactDOMHostConfig has: unstable_scheduleCallback as scheduleDeferredCallback
  },
  cancelDeferredCallback: function cancelDeferredCallback(handle) {
    return window.cancelIdleCallback(handle);
  },
  setTimeout: function setTimeout(handler, timeout) {
    return window.setTimeout(handler);
  },
  clearTimeout: function clearTimeout(handle) {
    window.clearTimeout(handle);
  },
  // https://github.com/facebook/react/blob/master/packages/react-dom/src/client/ReactDOMHostConfig.js#L288
  noTimeout: -1,
  // Called based on return value of: finalizeInitialChildren.  in-memory render tree created, but not yet attached.
  prepareForCommit: function prepareForCommit(containerInfo) {},
  // Called after the in-memory tree has been committed (ie: after attaching again to root element)
  resetAfterCommit: function resetAfterCommit(containerInfo) {},
  appendInitialChild: function appendInitialChild(parent, child) {
    // Here we are traversing downwards.  Beyond parent has not been initialized, but all children have been.
    if (parent) {
      if (!child) {
        console.error('undefined child', parent);
      } else {
        // doubly linking child to parent
        parent.children.push(child); // TODO: need to remove from children as well when removing.

        child.parent = parent;
      }
    }

    if (child && child.lifecycleListener && child.lifecycleListener.onParented) {
      child.lifecycleListener.onParented(parent, child);
    }

    if (parent && parent.lifecycleListener && parent.lifecycleListener.onChildAdded) {
      parent.lifecycleListener.onChildAdded(child, parent);
    }
  },
  appendChild: function appendChild(parent, child) {
    parent.children.push(child);
    child.parent = parent;
  },
  canHydrateInstance: function canHydrateInstance(instance, type, props) {
    // console.log("canHydrateInstance", instance, type, props)
    return null;
  },
  // The parent of this node has not yet been instantiated.  The reconciler will continue by calling:
  // createInstance → appendInitialChild → finalizeInitialChildren on the parent.
  // When that has reached the top of the recursion tree (root), then prepareForCommit() will be called.
  // NOTE: All children of this component, however, HAVE been initialized.
  finalizeInitialChildren: function finalizeInitialChildren() {
    return true;
    /* callCommitMountForThisInstance */
  },
  commitMount: function commitMount(instance, type, newProps, internalInstanceHandle) {
    if (instance && instance.lifecycleListener && instance.lifecycleListener.onMount) {
      instance.lifecycleListener.onMount(instance);
    }
  },
  // NOTE: only called if supportsMutation = true;
  // ReactDOM uses this for attaching child nodes to root DOM.  For us we want to link the all parts of tree together for tree crawling.
  // same implementation as insertInContainerBefore
  appendChildToContainer: function appendChildToContainer(container, child) {
    if (child) {
      // doubly link child to root
      container.rootInstance.children.push(child);
      child.parent = container.rootInstance;
    }
  },
  commitUpdate: function commitUpdate(instance, updatePayload, type
  /* old + new props are extra params here */
  ) {
    if (updatePayload !== null) {
      updatePayload.forEach(function (update) {
        applyUpdateToInstance(instance.hostInstance, update);
      });
    }
  },
  removeChildFromContainer: function removeChildFromContainer(container, child) {
    /**
     * To fix two bugs when toggle meshes:
     * 1.  model's mesh can't be destroyed.
     * 2. `removeChildFromContainer()` only destroy babylon instance.
     * The model is rootAbstractMesh's and Parent's child.
     * `container.rootInstance.children` will be very large after few toggles.
     */
    if (child) {
      removeChild(container.rootInstance, child);
    }
  },
  removeChild: removeChild,
  // text-content nodes are not used.  treated as a leaf node.  children are not traversed.  calls methods like createTextInstance(...)
  shouldSetTextContent: function shouldSetTextContent(type, props) {
    return false;
  }
};
/**
 * react-babylonjs
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// TODO: build a fallback mechanism when typeof React.createContext !== 'function'

var SceneContext = createContext({
  engine: null,
  canvas: null,
  scene: null,
  sceneReady: false
});

var useBabylonScene = function useBabylonScene() {
  return useContext(SceneContext).scene;
};

function withScene(Component) {
  return function BoundComponent(props) {
    return React.createElement(SceneContext.Consumer, null, function (ctx) {
      return React.createElement(Component, _assign({}, props, {
        sceneContext: ctx
      }));
    });
  };
}

var Scene = function Scene(props, context) {
  var engine = useContext(BabylonJSContext).engine;
  var propsHandler = useState(new FiberScenePropsHandler())[0];

  var _a = useState(false),
      sceneReady = _a[0],
      setSceneReady = _a[1];

  var _b = useState(null),
      scene = _b[0],
      setScene = _b[1];

  var _c = useState(null),
      fiberRoot = _c[0],
      setFiberRoot = _c[1]; // TODO: make this strongly typed


  var _d = useState(null),
      renderer = _d[0],
      setRenderer = _d[1];

  var prevPropsRef = useRef({}); // initialize babylon scene

  useEffect(function () {
    // const onSceneReady = (eventData: BabylonJSScene, eventState: EventState) => {
    //   setSceneReady(true);
    // }
    var scene = new Scene$3(engine, props.sceneOptions); // const onReadyObservable: Nullable<Observer<BabylonJSScene>> = scene.onReadyObservable.add(onSceneReady);

    if (scene.isReady()) {
      // scene.onReadyObservable.remove(onReadyObservable);
      setSceneReady(true);
    } else {
      console.error('Scene is not ready. Report issue in react-babylonjs repo');
    }

    setScene(scene);
    var isAsync = false; // Disables experimental async rendering

    var container = {
      engine: props.babylonJSContext.engine,
      canvas: props.babylonJSContext.canvas,
      scene: scene,
      rootInstance: {
        hostInstance: null,
        children: [],
        parent: null,
        metadata: {
          className: "root"
        },
        customProps: {}
      }
    };
    var renderer = ReactReconciler(ReactBabylonJSHostConfig);
    setRenderer(renderer);
    var fiberRoot = renderer.createContainer(container, isAsync, false
    /* hydrate true == better HMR? */
    );
    setFiberRoot(fiberRoot);
    renderer.injectIntoDevTools({
      bundleType: process.env.NODE_ENV === 'production' ? 0 : 1,
      version: '2.0.0',
      rendererPackageName: 'react-babylonjs'
    });
    var pointerDownObservable = scene.onPointerObservable.add(function (evt) {
      if (typeof props.onScenePointerDown === 'function') {
        props.onScenePointerDown(evt, scene);
      }

      if (evt && evt.pickInfo && evt.pickInfo.hit && evt.pickInfo.pickedMesh) {
        var mesh = evt.pickInfo.pickedMesh;

        if (typeof props.onMeshPicked === 'function') {
          props.onMeshPicked(mesh, scene);
        }
      }
    }, PointerEventTypes.POINTERDOWN); // can only be assigned on init

    var pointerUpObservable = null;

    if (typeof props.onScenePointerUp === 'function') {
      pointerUpObservable = scene.onPointerObservable.add(function (evt) {
        props.onScenePointerUp(evt, scene);
      }, PointerEventTypes.POINTERUP);
    } // can only be assigned on init


    var pointerMoveObservable = null;

    if (typeof props.onScenePointerMove === 'function') {
      pointerMoveObservable = scene.onPointerObservable.add(function (evt) {
        props.onScenePointerMove(evt, scene);
      }, PointerEventTypes.POINTERMOVE);
    }

    if (typeof props.onSceneMount === 'function') {
      props.onSceneMount({
        scene: scene,
        canvas: scene.getEngine().getRenderingCanvas()
      }); // TODO: console.error if canvas is not attached. runRenderLoop() is expected to be part of onSceneMount().
    } // TODO: change enable physics to 'usePhysics' taking an object with a Vector3 and 'any'.
    // NOTE: must be enabled for updating container (cannot add impostors w/o physics enabled)


    if (Array.isArray(props.enablePhysics)) {
      scene.enablePhysics(props.enablePhysics[0], props.enablePhysics[1]);
    } // update the root Container


    renderer.updateContainer(React.createElement(SceneContext.Provider, {
      value: {
        engine: props.babylonJSContext.engine,
        canvas: props.babylonJSContext.canvas,
        scene: scene,
        sceneReady: sceneReady
      }
    }, props.children), fiberRoot, undefined, function () {});
    return function () {
      if (pointerDownObservable) {
        scene.onPointerObservable.remove(pointerDownObservable);
      }

      if (pointerUpObservable) {
        scene.onPointerObservable.remove(pointerUpObservable);
      }

      if (pointerMoveObservable) {
        scene.onPointerObservable.remove(pointerMoveObservable);
      }

      scene.dispose();
    };
  }, [
    /* no deps, so called only on un/mount */
  ]); // update babylon scene

  useEffect(function () {
    if (engine === null || scene === null || renderer === null) {
      return;
    }

    var prevProps = prevPropsRef.current;
    var updates = propsHandler.getPropertyUpdates(prevProps, props);

    if (updates !== null) {
      updates.forEach(function (propertyUpdate) {
        applyUpdateToInstance(scene, propertyUpdate);
      });
    }

    renderer.updateContainer(React.createElement(SceneContext.Provider, {
      value: {
        engine: props.babylonJSContext.engine,
        canvas: props.babylonJSContext.canvas,
        scene: scene,
        sceneReady: sceneReady
      }
    }, props.children), fiberRoot, undefined, function () {});
    prevPropsRef.current = props;
  });
  return null;
};

var Scene$1 = withBabylonJS(Scene);

function useBeforeRender(callback, mask, insertFirst, callOnce) {
  var _a = useContext(SceneContext),
      scene = _a.scene,
      sceneReady = _a.sceneReady;

  useEffect(function () {
    if (sceneReady !== true || scene === null) {
      return;
    }

    var unregisterOnFirstCall = callOnce === true;
    var sceneObserver = scene.onBeforeRenderObservable.add(callback, mask, insertFirst, undefined, unregisterOnFirstCall);

    if (unregisterOnFirstCall !== true) {
      return function () {
        scene.onBeforeRenderObservable.remove(sceneObserver);
      };
    }
  });
}

export { ADTForMesh, ADTFullscreenUI, ADTFullscreenUILifecycleListener, AbstractButton3D, AbstractMesh, AdvancedDynamicTexture, AdvancedDynamicTextureLifecycleListener, AnaglyphArcRotateCamera, AnaglyphFreeCamera, AnaglyphGamepadCamera, AnaglyphUniversalCamera, ArcFollowCamera, ArcRotateCamera, AttachToBoxBehavior, AutoRotationBehavior, BabylonJSContext, BackgroundMaterial, BaseSlider, BaseTexture, BehaviorLifecycleListener, BouncingBehavior, Box, Button, Button3D, Camera, CameraLifecycleListener, Checkbox, ColorGradingTexture, ColorPicker, Container, Container3D, Control, Control3D, CubeTexture, CustomProceduralTexture, Cylinder, CylinderPanel, DashedLines, Decal, DeviceOrientationCamera, DirectionalLight, Disc, DisplayGrid, DynamicTerrain$1 as DynamicTerrain, DynamicTexture, EffectLayer, Ellipse, Engine, EnvironmentHelper, EnvironmentHelperLifecycleListener, EquiRectangularCubeTexture, ExtrudePolygon, ExtrudeShape, ExtrudeShapeCustom, FadeInOutBehavior, FiberADTForMesh, FiberADTFullscreenUI, FiberAbstractButton3D, FiberAbstractButton3DPropsHandler, FiberAbstractMesh, FiberAbstractMeshPropsHandler, FiberAdvancedDynamicTexture, FiberAdvancedDynamicTexturePropsHandler, FiberAnaglyphArcRotateCamera, FiberAnaglyphArcRotateCameraPropsHandler, FiberAnaglyphFreeCamera, FiberAnaglyphFreeCameraPropsHandler, FiberAnaglyphGamepadCamera, FiberAnaglyphGamepadCameraPropsHandler, FiberAnaglyphUniversalCamera, FiberAnaglyphUniversalCameraPropsHandler, FiberArcFollowCamera, FiberArcFollowCameraPropsHandler, FiberArcRotateCamera, FiberArcRotateCameraPropsHandler, FiberAttachToBoxBehavior, FiberAttachToBoxBehaviorPropsHandler, FiberAutoRotationBehavior, FiberAutoRotationBehaviorPropsHandler, FiberBackgroundMaterial, FiberBackgroundMaterialPropsHandler, FiberBaseSlider, FiberBaseSliderPropsHandler, FiberBaseTexture, FiberBaseTexturePropsHandler, FiberBouncingBehavior, FiberBouncingBehaviorPropsHandler, FiberBox, FiberButton, FiberButton3D, FiberButton3DPropsHandler, FiberButtonPropsHandler, FiberCamera, FiberCameraPropsHandler, FiberCheckbox, FiberCheckboxPropsHandler, FiberColorGradingTexture, FiberColorGradingTexturePropsHandler, FiberColorPicker, FiberColorPickerPropsHandler, FiberContainer, FiberContainer3D, FiberContainer3DPropsHandler, FiberContainerPropsHandler, FiberControl, FiberControl3D, FiberControl3DPropsHandler, FiberControlPropsHandler, FiberCubeTexture, FiberCubeTexturePropsHandler, FiberCustomProceduralTexture, FiberCustomProceduralTexturePropsHandler, FiberCylinder, FiberCylinderPanel, FiberCylinderPanelPropsHandler, FiberDashedLines, FiberDecal, FiberDeviceOrientationCamera, FiberDeviceOrientationCameraPropsHandler, FiberDirectionalLight, FiberDirectionalLightPropsHandler, FiberDisc, FiberDisplayGrid, FiberDisplayGridPropsHandler, FiberDynamicTerrain, FiberDynamicTerrainPropsHandler, FiberDynamicTexture, FiberDynamicTexturePropsHandler, FiberEffectLayer, FiberEffectLayerPropsHandler, FiberEllipse, FiberEllipsePropsHandler, FiberEnvironmentHelper, FiberEnvironmentHelperPropsHandler, FiberEquiRectangularCubeTexture, FiberEquiRectangularCubeTexturePropsHandler, FiberExtrudePolygon, FiberExtrudeShape, FiberExtrudeShapeCustom, FiberFadeInOutBehavior, FiberFadeInOutBehaviorPropsHandler, FiberFluentMaterial, FiberFluentMaterialPropsHandler, FiberFlyCamera, FiberFlyCameraPropsHandler, FiberFollowCamera, FiberFollowCameraPropsHandler, FiberFramingBehavior, FiberFramingBehaviorPropsHandler, FiberFreeCamera, FiberFreeCameraPropsHandler, FiberGUI3DManager, FiberGUI3DManagerPropsHandler, FiberGamepadCamera, FiberGamepadCameraPropsHandler, FiberGlowLayer, FiberGlowLayerPropsHandler, FiberGrid, FiberGridPropsHandler, FiberGround, FiberGroundFromHeightMap, FiberHDRCubeTexture, FiberHDRCubeTexturePropsHandler, FiberHemisphericLight, FiberHemisphericLightPropsHandler, FiberHighlightLayer, FiberHighlightLayerPropsHandler, FiberHolographicButton, FiberHolographicButtonPropsHandler, FiberHtmlElementTexture, FiberHtmlElementTexturePropsHandler, FiberIcoSphere, FiberImage, FiberImageBasedSlider, FiberImageBasedSliderPropsHandler, FiberImagePropsHandler, FiberImageScrollBar, FiberImageScrollBarPropsHandler, FiberInputPassword, FiberInputPasswordPropsHandler, FiberInputText, FiberInputTextPropsHandler, FiberLathe, FiberLight, FiberLightPropsHandler, FiberLine, FiberLinePropsHandler, FiberLineSystem, FiberLines, FiberMaterial, FiberMaterialPropsHandler, FiberMesh, FiberMeshButton3D, FiberMeshButton3DPropsHandler, FiberMeshPropsHandler, FiberMirrorTexture, FiberMirrorTexturePropsHandler, FiberMultiLine, FiberMultiLinePropsHandler, FiberMultiMaterial, FiberMultiMaterialPropsHandler, FiberMultiPointerScaleBehavior, FiberMultiPointerScaleBehaviorPropsHandler, FiberMultiRenderTarget, FiberMultiRenderTargetPropsHandler, FiberMultiviewRenderTarget, FiberMultiviewRenderTargetPropsHandler, FiberNode, FiberNodeMaterial, FiberNodeMaterialPropsHandler, FiberNodePropsHandler, FiberNoiseProceduralTexture, FiberNoiseProceduralTexturePropsHandler, FiberPBRBaseMaterial, FiberPBRBaseMaterialPropsHandler, FiberPBRBaseSimpleMaterial, FiberPBRBaseSimpleMaterialPropsHandler, FiberPBRMaterial, FiberPBRMaterialPropsHandler, FiberPBRMetallicRoughnessMaterial, FiberPBRMetallicRoughnessMaterialPropsHandler, FiberPBRSpecularGlossinessMaterial, FiberPBRSpecularGlossinessMaterialPropsHandler, FiberPhysicsImpostor, FiberPhysicsImpostorPropsHandler, FiberPlane, FiberPlanePanel, FiberPlanePanelPropsHandler, FiberPointLight, FiberPointLightPropsHandler, FiberPointerDragBehavior, FiberPointerDragBehaviorPropsHandler, FiberPolygon, FiberPolyhedron, FiberProceduralTexture, FiberProceduralTexturePropsHandler, FiberPushMaterial, FiberPushMaterialPropsHandler, FiberRadioButton, FiberRadioButtonPropsHandler, FiberRawCubeTexture, FiberRawCubeTexturePropsHandler, FiberRawTexture, FiberRawTexture2DArray, FiberRawTexture2DArrayPropsHandler, FiberRawTexture3D, FiberRawTexture3DPropsHandler, FiberRawTexturePropsHandler, FiberRectangle, FiberRectanglePropsHandler, FiberRefractionTexture, FiberRefractionTexturePropsHandler, FiberRenderTargetTexture, FiberRenderTargetTexturePropsHandler, FiberRibbon, FiberScatterPanel, FiberScatterPanelPropsHandler, FiberScenePropsHandler, FiberScrollBar, FiberScrollBarPropsHandler, FiberScrollViewer, FiberScrollViewerPropsHandler, FiberSelectionPanel, FiberSelectionPanelPropsHandler, FiberShaderMaterial, FiberShaderMaterialPropsHandler, FiberShadowGenerator, FiberShadowGeneratorPropsHandler, FiberShadowLight, FiberShadowLightPropsHandler, FiberSixDofDragBehavior, FiberSixDofDragBehaviorPropsHandler, FiberSlider, FiberSliderPropsHandler, FiberSphere, FiberSpherePanel, FiberSpherePanelPropsHandler, FiberSpotLight, FiberSpotLightPropsHandler, FiberStackPanel, FiberStackPanel3D, FiberStackPanel3DPropsHandler, FiberStackPanelPropsHandler, FiberStandardMaterial, FiberStandardMaterialPropsHandler, FiberStereoscopicArcRotateCamera, FiberStereoscopicArcRotateCameraPropsHandler, FiberStereoscopicFreeCamera, FiberStereoscopicFreeCameraPropsHandler, FiberStereoscopicGamepadCamera, FiberStereoscopicGamepadCameraPropsHandler, FiberStereoscopicUniversalCamera, FiberStereoscopicUniversalCameraPropsHandler, FiberTargetCamera, FiberTargetCameraPropsHandler, FiberTextBlock, FiberTextBlockPropsHandler, FiberTexture, FiberTexturePropsHandler, FiberTiledBox, FiberTiledGround, FiberTiledPlane, FiberTorus, FiberTorusKnot, FiberTouchCamera, FiberTouchCameraPropsHandler, FiberTransformNode, FiberTransformNodePropsHandler, FiberTube, FiberUniversalCamera, FiberUniversalCameraPropsHandler, FiberVRDeviceOrientationArcRotateCamera, FiberVRDeviceOrientationArcRotateCameraPropsHandler, FiberVRDeviceOrientationFreeCamera, FiberVRDeviceOrientationFreeCameraPropsHandler, FiberVRDeviceOrientationGamepadCamera, FiberVRDeviceOrientationGamepadCameraPropsHandler, FiberVRExperienceHelper, FiberVRExperienceHelperPropsHandler, FiberVideoTexture, FiberVideoTexturePropsHandler, FiberVirtualJoysticksCamera, FiberVirtualJoysticksCameraPropsHandler, FiberVirtualKeyboard, FiberVirtualKeyboardPropsHandler, FiberVolumeBasedPanel, FiberVolumeBasedPanelPropsHandler, FiberWebVRFreeCamera, FiberWebVRFreeCameraPropsHandler, FiberWebXRCamera, FiberWebXRCameraPropsHandler, Fiber_ScrollViewerWindow, Fiber_ScrollViewerWindowPropsHandler, FluentMaterial, FlyCamera, FollowCamera, FramingBehavior, FreeCamera, GUI2DControlLifecycleListener, GUI3DControlLifecycleListener, GUI3DManager, GUI3DManagerLifecycleListener, GamepadCamera, GlowLayer, Grid, Ground, GroundFromHeightMap, HDRCubeTexture, HemisphericLight, HighlightLayer, HolographicButton, HostWithEvents, HtmlElementTexture, IcoSphere, Image, ImageBasedSlider, ImageScrollBar, InputPassword, InputText, Lathe, Light, Line, LineSystem, Lines, Material, MaterialsLifecycleListener, Mesh, MeshButton3D, MirrorTexture, Model, ModelLifecycleListener, MultiLine, MultiMaterial, MultiPointerScaleBehavior, MultiRenderTarget, MultiviewRenderTarget, Node, NodeLifecycleListener, NodeMaterial, NoiseProceduralTexture, PBRBaseMaterial, PBRBaseSimpleMaterial, PBRMaterial, PBRMetallicRoughnessMaterial, PBRSpecularGlossinessMaterial, PhysicsImpostor, PhysicsImpostorLifecycleListener, Plane, PlanePanel, PointLight, PointerDragBehavior, Polygon, Polyhedron, ProceduralTexture, PushMaterial, RadioButton, RawCubeTexture, RawTexture, RawTexture2DArray, RawTexture3D, Rectangle, RefractionTexture, RenderTargetTexture, Ribbon, ScatterPanel, Scene$1 as Scene, SceneContext, ScrollBar, ScrollViewer, SelectionPanel, ShaderMaterial, ShadowGenerator, ShadowGeneratorLifecycleListener, ShadowLight, SixDofDragBehavior, Skybox, Slider, Sphere, SpherePanel, SpotLight, StackPanel, StackPanel3D, StandardMaterial, StereoscopicArcRotateCamera, StereoscopicFreeCamera, StereoscopicGamepadCamera, StereoscopicUniversalCamera, TargetCamera, TargetPropsHandler, TextBlock, Texture, TexturesLifecycleListener, TiledBox, TiledGround, TiledPlane, Torus, TorusKnot, TouchCamera, TransformNode, Tube, UniversalCamera, VRDeviceOrientationArcRotateCamera, VRDeviceOrientationFreeCamera, VRDeviceOrientationGamepadCamera, VRExperienceHelper, VRExperienceHelperLifecycleListener, VideoTexture, VirtualJoysticksCamera, VirtualKeyboard, VolumeBasedPanel, WebVRFreeCamera, WebXRCamera, _ScrollViewerWindow, babylonClassFactory, intrinsicClassMap, useBabylonCanvas, useBabylonEngine, useBabylonScene, useBeforeRender, withBabylonJS, withScene };